//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { getAccessTokenFromLocalStorage } from 'utilities/token-util';
export class BaseClient {
    public async transformOptions(options: RequestInit): Promise<RequestInit> {
        const token = getAccessTokenFromLocalStorage();
        const headerData = token ? ({
            ...options.headers,
            Authorization: 'Bearer ' + token
        }) : ({
            ...options.headers
        });
        return Object.assign({}, options, {
            headers: headerData
        });
    }
}

export class AdministrationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getWeightUnitDtos(): Promise<DeviceIdWeightIdDto[]> {
        let url_ = this.baseUrl + "/api/Administration/GetWeightUnitDtos";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWeightUnitDtos(_response);
        });
    }

    protected processGetWeightUnitDtos(response: Response): Promise<DeviceIdWeightIdDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceIdWeightIdDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceIdWeightIdDto[]>(null as any);
    }
}

export class BaleStorageClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    createBaleStorage(dto: BaleStorageDto): Promise<BaleStorageDto> {
        let url_ = this.baseUrl + "/api/BaleStorage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateBaleStorage(_response);
        });
    }

    protected processCreateBaleStorage(response: Response): Promise<BaleStorageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaleStorageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaleStorageDto>(null as any);
    }

    updateBaleStorage(dto: BaleStorageDto): Promise<BaleStorageDto> {
        let url_ = this.baseUrl + "/api/BaleStorage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateBaleStorage(_response);
        });
    }

    protected processUpdateBaleStorage(response: Response): Promise<BaleStorageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BaleStorageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BaleStorageDto>(null as any);
    }
}

export class CodegenClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    errorIds(errorIdBaler: ErrorIdBaler | undefined, errorIdCompactor: ErrorIdCompactor | undefined, errorIdLink: ErrorIdLink | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Codegen/ErrorIds?";
        if (errorIdBaler === null)
            throw new Error("The parameter 'errorIdBaler' cannot be null.");
        else if (errorIdBaler !== undefined)
            url_ += "errorIdBaler=" + encodeURIComponent("" + errorIdBaler) + "&";
        if (errorIdCompactor === null)
            throw new Error("The parameter 'errorIdCompactor' cannot be null.");
        else if (errorIdCompactor !== undefined)
            url_ += "errorIdCompactor=" + encodeURIComponent("" + errorIdCompactor) + "&";
        if (errorIdLink === null)
            throw new Error("The parameter 'errorIdLink' cannot be null.");
        else if (errorIdLink !== undefined)
            url_ += "errorIdLink=" + encodeURIComponent("" + errorIdLink) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processErrorIds(_response);
        });
    }

    protected processErrorIds(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ContainerClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    hasSerialNumber(serialNumber: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Container/HasSerialNumber?";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHasSerialNumber(_response);
        });
    }

    protected processHasSerialNumber(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class DashboardClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    get(): Promise<DashboardBaseDto[]> {
        let url_ = this.baseUrl + "/api/Dashboard";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<DashboardBaseDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardBaseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardBaseDto[]>(null as any);
    }

    post(bases: DashboardBase[]): Promise<DashboardBaseDto[]> {
        let url_ = this.baseUrl + "/api/Dashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bases);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<DashboardBaseDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardBaseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardBaseDto[]>(null as any);
    }

    put(bases: DashboardBase[]): Promise<DashboardBase[]> {
        let url_ = this.baseUrl + "/api/Dashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bases);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<DashboardBase[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DashboardBase.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardBase[]>(null as any);
    }

    delete(dashboardBase: DashboardBase): Promise<void> {
        let url_ = this.baseUrl + "/api/Dashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dashboardBase);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getById(id: number | undefined): Promise<DashboardBaseDto> {
        let url_ = this.baseUrl + "/api/Dashboard/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<DashboardBaseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardBaseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardBaseDto>(null as any);
    }

    createLocationTile(settingsDto: LocationTileSettingsDto): Promise<DashboardBaseDto> {
        let url_ = this.baseUrl + "/api/Dashboard/CreateLocationTile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settingsDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateLocationTile(_response);
        });
    }

    protected processCreateLocationTile(response: Response): Promise<DashboardBaseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardBaseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardBaseDto>(null as any);
    }

    createReportTile(settingsDto: CreateReportTileSettingsDto): Promise<DashboardBaseDto> {
        let url_ = this.baseUrl + "/api/Dashboard/CreateReportTile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settingsDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateReportTile(_response);
        });
    }

    protected processCreateReportTile(response: Response): Promise<DashboardBaseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardBaseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DashboardBaseDto>(null as any);
    }

    getReportTilePreview(settingsDto: CreateReportTileSettingsDto): Promise<ReportTileDto> {
        let url_ = this.baseUrl + "/api/Dashboard/GetReportTilePreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settingsDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReportTilePreview(_response);
        });
    }

    protected processGetReportTilePreview(response: Response): Promise<ReportTileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportTileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportTileDto>(null as any);
    }
}

export class DebtorClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getByGroupId(groupId: number | undefined): Promise<GetDebtorDto> {
        let url_ = this.baseUrl + "/api/Debtor/GetByGroupId?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByGroupId(_response);
        });
    }

    protected processGetByGroupId(response: Response): Promise<GetDebtorDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDebtorDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDebtorDto>(null as any);
    }

    getCompanyImage(groupId: number | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Debtor/CompanyImage?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCompanyImage(_response);
        });
    }

    protected processGetCompanyImage(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    postCompanyImage(groupId: number | undefined, file: FileParameter | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Debtor/CompanyImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (groupId === null || groupId === undefined)
            throw new Error("The parameter 'groupId' cannot be null.");
        else
            content_.append("GroupId", groupId.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostCompanyImage(_response);
        });
    }

    protected processPostCompanyImage(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class DocumentClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getByFileName(fileName: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Document/GetByFileName?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByFileName(_response);
        });
    }

    protected processGetByFileName(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getByFileNameAsDownload(fileName: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Document/GetByFileNameAsDownload?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByFileNameAsDownload(_response);
        });
    }

    protected processGetByFileNameAsDownload(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getUserManual(unitIdSelected: string | null | undefined, countryCode: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Document/GetUserManual?";
        if (unitIdSelected !== undefined && unitIdSelected !== null)
            url_ += "unitIdSelected=" + encodeURIComponent("" + unitIdSelected) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserManual(_response);
        });
    }

    protected processGetUserManual(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getElectricalDiagram(unitIdSelected: string | null | undefined, countryCode: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Document/GetElectricalDiagram?";
        if (unitIdSelected !== undefined && unitIdSelected !== null)
            url_ += "unitIdSelected=" + encodeURIComponent("" + unitIdSelected) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetElectricalDiagram(_response);
        });
    }

    protected processGetElectricalDiagram(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getHydraulicsDiagram(unitIdSelected: string | null | undefined, countryCode: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Document/GetHydraulicsDiagram?";
        if (unitIdSelected !== undefined && unitIdSelected !== null)
            url_ += "unitIdSelected=" + encodeURIComponent("" + unitIdSelected) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHydraulicsDiagram(_response);
        });
    }

    protected processGetHydraulicsDiagram(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getQuickGuides(unitIdSelected: string | null | undefined, countryCode: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Document/GetQuickGuides?";
        if (unitIdSelected !== undefined && unitIdSelected !== null)
            url_ += "unitIdSelected=" + encodeURIComponent("" + unitIdSelected) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQuickGuides(_response);
        });
    }

    protected processGetQuickGuides(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getSparePartsManual(unitIdSelected: string | null | undefined, countryCode: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Document/GetSparePartsManual?";
        if (unitIdSelected !== undefined && unitIdSelected !== null)
            url_ += "unitIdSelected=" + encodeURIComponent("" + unitIdSelected) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSparePartsManual(_response);
        });
    }

    protected processGetSparePartsManual(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getDiagrams(unitIdSelected: string | null | undefined, countryCode: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Document/GetDiagrams?";
        if (unitIdSelected !== undefined && unitIdSelected !== null)
            url_ += "unitIdSelected=" + encodeURIComponent("" + unitIdSelected) + "&";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDiagrams(_response);
        });
    }

    protected processGetDiagrams(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class FavoriteDevicesClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    createFavoriteDevice(deviceId: number): Promise<FavoriteUnit> {
        let url_ = this.baseUrl + "/api/FavoriteDevices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateFavoriteDevice(_response);
        });
    }

    protected processCreateFavoriteDevice(response: Response): Promise<FavoriteUnit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FavoriteUnit.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FavoriteUnit>(null as any);
    }

    deleteFavoriteDevice(deviceId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/FavoriteDevices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(deviceId);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteFavoriteDevice(_response);
        });
    }

    protected processDeleteFavoriteDevice(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getFavoriteDevices(): Promise<FavoriteUnit[]> {
        let url_ = this.baseUrl + "/api/FavoriteDevices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFavoriteDevices(_response);
        });
    }

    protected processGetFavoriteDevices(response: Response): Promise<FavoriteUnit[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FavoriteUnit.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FavoriteUnit[]>(null as any);
    }
}

export class GatewayClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getServiceToolAccessForDevice(machineId: string, userId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Gateway/device/access/{machineId}/{userId}";
        if (machineId === undefined || machineId === null)
            throw new Error("The parameter 'machineId' must be defined.");
        url_ = url_.replace("{machineId}", encodeURIComponent("" + machineId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetServiceToolAccessForDevice(_response);
        });
    }

    protected processGetServiceToolAccessForDevice(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class GPSHistoryClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getGPSHistoryByDeviceId(serialNumber: string | null | undefined, startDate: Date | undefined, endDate: Date | undefined): Promise<GPSHistoryDto[]> {
        let url_ = this.baseUrl + "/api/GPSHistory/GetHistoryByDeviceId?";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGPSHistoryByDeviceId(_response);
        });
    }

    protected processGetGPSHistoryByDeviceId(response: Response): Promise<GPSHistoryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GPSHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GPSHistoryDto[]>(null as any);
    }
}

export class GroupsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getChildTreeByUserId(minRolesType: RolesType | null | undefined): Promise<GroupsDto[]> {
        let url_ = this.baseUrl + "/api/Groups/GetChildTreeByUserId?";
        if (minRolesType !== undefined && minRolesType !== null)
            url_ += "minRolesType=" + encodeURIComponent("" + minRolesType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetChildTreeByUserId(_response);
        });
    }

    protected processGetChildTreeByUserId(response: Response): Promise<GroupsDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupsDto[]>(null as any);
    }

    getAdminChildTreeByUserId(): Promise<GroupsDto[]> {
        let url_ = this.baseUrl + "/api/Groups/GetAdminChildTreeByUserId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAdminChildTreeByUserId(_response);
        });
    }

    protected processGetAdminChildTreeByUserId(response: Response): Promise<GroupsDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupsDto[]>(null as any);
    }

    getCountryAdminChildTreeByUserId(): Promise<GroupsDto[]> {
        let url_ = this.baseUrl + "/api/Groups/GetCountryAdminChildTreeByUserId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCountryAdminChildTreeByUserId(_response);
        });
    }

    protected processGetCountryAdminChildTreeByUserId(response: Response): Promise<GroupsDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupsDto[]>(null as any);
    }

    getSuperAdminChildTreeByUserId(): Promise<GroupsDto[]> {
        let url_ = this.baseUrl + "/api/Groups/GetSuperAdminChildTreeByUserId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSuperAdminChildTreeByUserId(_response);
        });
    }

    protected processGetSuperAdminChildTreeByUserId(response: Response): Promise<GroupsDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupsDto[]>(null as any);
    }

    createChildGroup(dto: CreateGroupsDto): Promise<GroupsDto> {
        let url_ = this.baseUrl + "/api/Groups/CreateChildGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateChildGroup(_response);
        });
    }

    protected processCreateChildGroup(response: Response): Promise<GroupsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupsDto>(null as any);
    }

    delete(id: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Groups?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    editGroup(dto: EditGroupsDto): Promise<GroupsDto> {
        let url_ = this.baseUrl + "/api/Groups/EditGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditGroup(_response);
        });
    }

    protected processEditGroup(response: Response): Promise<GroupsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupsDto>(null as any);
    }

    editGroupDebtor(dto: EditGroupsDebtorDto): Promise<GroupsDto> {
        let url_ = this.baseUrl + "/api/Groups/EditGroupDebtor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEditGroupDebtor(_response);
        });
    }

    protected processEditGroupDebtor(response: Response): Promise<GroupsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupsDto>(null as any);
    }

    hasMachines(groupId: number | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/Groups/HasMachines?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHasMachines(_response);
        });
    }

    protected processHasMachines(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    getGroupNameById(groupId: number | undefined): Promise<GroupsNameIdDto> {
        let url_ = this.baseUrl + "/api/Groups/GetGroupNameById?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGroupNameById(_response);
        });
    }

    protected processGetGroupNameById(response: Response): Promise<GroupsNameIdDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupsNameIdDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupsNameIdDto>(null as any);
    }

    getUsersByGroupId(groupId: number | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Groups/GetUsersByGroupId?";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUsersByGroupId(_response);
        });
    }

    protected processGetUsersByGroupId(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class MachineLearningExtractionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getMlData(serialNumber: string | null | undefined, startDate: Date | undefined, endDate: Date | undefined): Promise<MachineLearningTrainingDataDto[]> {
        let url_ = this.baseUrl + "/api/MachineLearningExtraction/GetMlData?";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMlData(_response);
        });
    }

    protected processGetMlData(response: Response): Promise<MachineLearningTrainingDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MachineLearningTrainingDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MachineLearningTrainingDataDto[]>(null as any);
    }

    getUnitSerialNumbers(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/MachineLearningExtraction/GetUnitSerialNumbers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnitSerialNumbers(_response);
        });
    }

    protected processGetUnitSerialNumbers(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getMlInferenceData(): Promise<MachineLearningInferenceDataDto[]> {
        let url_ = this.baseUrl + "/api/MachineLearningExtraction/GetMlInferenceData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMlInferenceData(_response);
        });
    }

    protected processGetMlInferenceData(response: Response): Promise<MachineLearningInferenceDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MachineLearningInferenceDataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MachineLearningInferenceDataDto[]>(null as any);
    }

    insertPredictions(predictions: PredictionDto[]): Promise<void> {
        let url_ = this.baseUrl + "/api/MachineLearningExtraction/InsertPredictions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(predictions);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInsertPredictions(_response);
        });
    }

    protected processInsertPredictions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getPredictionsBySerialNumber(serialNumber: string | null | undefined): Promise<PredictionGroupingDto[]> {
        let url_ = this.baseUrl + "/api/MachineLearningExtraction/GetPredictionsBySerialNumber?";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPredictionsBySerialNumber(_response);
        });
    }

    protected processGetPredictionsBySerialNumber(response: Response): Promise<PredictionGroupingDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PredictionGroupingDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PredictionGroupingDto[]>(null as any);
    }

    getPredictions(): Promise<PredictionGroupingDto[]> {
        let url_ = this.baseUrl + "/api/MachineLearningExtraction/GetPredictions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPredictions(_response);
        });
    }

    protected processGetPredictions(response: Response): Promise<PredictionGroupingDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PredictionGroupingDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PredictionGroupingDto[]>(null as any);
    }
}

export class MonitoringClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    get(): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Monitoring";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class NavImportUnitsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    navImportMachines(units: NavUnitFromCsvDto[]): Promise<NavFileResult[]> {
        let url_ = this.baseUrl + "/api/NavImportUnits/NavImportMachines";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(units);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNavImportMachines(_response);
        });
    }

    protected processNavImportMachines(response: Response): Promise<NavFileResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NavFileResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NavFileResult[]>(null as any);
    }

    navGetDocuments(): Promise<NavUnitDocumentDto> {
        let url_ = this.baseUrl + "/api/NavImportUnits/NavGetDocuments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNavGetDocuments(_response);
        });
    }

    protected processNavGetDocuments(response: Response): Promise<NavUnitDocumentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NavUnitDocumentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NavUnitDocumentDto>(null as any);
    }

    navGetTechnical(): Promise<NavUnitTechnicalDto> {
        let url_ = this.baseUrl + "/api/NavImportUnits/NavGetTechnical";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNavGetTechnical(_response);
        });
    }

    protected processNavGetTechnical(response: Response): Promise<NavUnitTechnicalDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NavUnitTechnicalDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NavUnitTechnicalDto>(null as any);
    }
}

export class NotificationCustomMessageClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getNotificationCustomMessage(serialNumber: string | null | undefined): Promise<NotificationCustomMessage[]> {
        let url_ = this.baseUrl + "/api/NotificationCustomMessage?";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNotificationCustomMessage(_response);
        });
    }

    protected processGetNotificationCustomMessage(response: Response): Promise<NotificationCustomMessage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationCustomMessage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationCustomMessage[]>(null as any);
    }

    saveNotificationCustomMessage(serialNumber: string | null | undefined, customMessages: NotificationCustomMessage[]): Promise<NotificationCustomMessage[]> {
        let url_ = this.baseUrl + "/api/NotificationCustomMessage?";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customMessages);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveNotificationCustomMessage(_response);
        });
    }

    protected processSaveNotificationCustomMessage(response: Response): Promise<NotificationCustomMessage[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationCustomMessage.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationCustomMessage[]>(null as any);
    }
}

export class NotificationDefinitionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getByFilter(filter: FilterDto): Promise<NotificationDefinitionDto[]> {
        let url_ = this.baseUrl + "/api/NotificationDefinition/GetByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByFilter(_response);
        });
    }

    protected processGetByFilter(response: Response): Promise<NotificationDefinitionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationDefinitionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationDefinitionDto[]>(null as any);
    }

    getBySerialNumber(serialNumber: string | null | undefined): Promise<NotificationDefinitionDto[]> {
        let url_ = this.baseUrl + "/api/NotificationDefinition/GetBySerialNumber?";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBySerialNumber(_response);
        });
    }

    protected processGetBySerialNumber(response: Response): Promise<NotificationDefinitionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationDefinitionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationDefinitionDto[]>(null as any);
    }

    post(dto: NotificationDefinitionDto): Promise<NotificationDefinitionDto> {
        let url_ = this.baseUrl + "/api/NotificationDefinition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<NotificationDefinitionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationDefinitionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationDefinitionDto>(null as any);
    }

    delete(dto: NotificationDefinitionDto): Promise<void> {
        let url_ = this.baseUrl + "/api/NotificationDefinition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    postWithValidation(dto: NotificationDefinitionDto): Promise<NotificationDefinitionDto> {
        let url_ = this.baseUrl + "/api/NotificationDefinition/PostWithValidation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostWithValidation(_response);
        });
    }

    protected processPostWithValidation(response: Response): Promise<NotificationDefinitionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationDefinitionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationDefinitionDto>(null as any);
    }

    getById(id: number | undefined): Promise<NotificationDefinitionDto> {
        let url_ = this.baseUrl + "/api/NotificationDefinition/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: Response): Promise<NotificationDefinitionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationDefinitionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationDefinitionDto>(null as any);
    }
}

export class NotificationEmailClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    sendExampleEmail(emailAddress: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/NotificationEmail/SendExampleEmail?";
        if (emailAddress !== undefined && emailAddress !== null)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendExampleEmail(_response);
        });
    }

    protected processSendExampleEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    pickupOrdered(orderPickupDto: OrderPickupDto): Promise<void> {
        let url_ = this.baseUrl + "/api/NotificationEmail/PickupOrdered";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderPickupDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPickupOrdered(_response);
        });
    }

    protected processPickupOrdered(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    pickupOnDateOrdered(orderPickupOnDateDto: OrderPickupOnDateDto): Promise<void> {
        let url_ = this.baseUrl + "/api/NotificationEmail/PickupOnDateOrdered";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(orderPickupOnDateDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPickupOnDateOrdered(_response);
        });
    }

    protected processPickupOnDateOrdered(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class NotificationFunctionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getBySerialNumberUnsafe(serialNumber: string): Promise<NotificationDefinitionDto[]> {
        let url_ = this.baseUrl + "/api/NotificationFunction/GetBySerialNumberUnsafe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(serialNumber);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBySerialNumberUnsafe(_response);
        });
    }

    protected processGetBySerialNumberUnsafe(response: Response): Promise<NotificationDefinitionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationDefinitionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationDefinitionDto[]>(null as any);
    }

    getUnsubscribe(dto: UnsubscribeNotificationDto): Promise<string> {
        let url_ = this.baseUrl + "/api/NotificationFunction/GetUnsubscribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnsubscribe(_response);
        });
    }

    protected processGetUnsubscribe(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getUnitDataUnsafe(serialNumber: string): Promise<NotificationUnitDto> {
        let url_ = this.baseUrl + "/api/NotificationFunction/GetUnitDataUnsafe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(serialNumber);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnitDataUnsafe(_response);
        });
    }

    protected processGetUnitDataUnsafe(response: Response): Promise<NotificationUnitDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationUnitDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationUnitDto>(null as any);
    }

    saveNotificationHistories(notificationHistories: NotificationHistory[]): Promise<void> {
        let url_ = this.baseUrl + "/api/NotificationFunction/SaveNotificationHistories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notificationHistories);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveNotificationHistories(_response);
        });
    }

    protected processSaveNotificationHistories(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDateSpecificAdvancedNotificationsUnsafe(): Promise<NotificationDefinitionDto[]> {
        let url_ = this.baseUrl + "/api/NotificationFunction/GetDateSpecificAdvancedNotificationsUnsafe";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDateSpecificAdvancedNotificationsUnsafe(_response);
        });
    }

    protected processGetDateSpecificAdvancedNotificationsUnsafe(response: Response): Promise<NotificationDefinitionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationDefinitionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationDefinitionDto[]>(null as any);
    }

    getXtelNotificationsUnsafe(unitId: number | undefined): Promise<BramidanNotificationInfoWithNotifyInfo[]> {
        let url_ = this.baseUrl + "/api/NotificationFunction/GetXtelNotificationsUnsafe?";
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetXtelNotificationsUnsafe(_response);
        });
    }

    protected processGetXtelNotificationsUnsafe(response: Response): Promise<BramidanNotificationInfoWithNotifyInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BramidanNotificationInfoWithNotifyInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BramidanNotificationInfoWithNotifyInfo[]>(null as any);
    }

    getOfflineTooLongNotificationsUnsafe(serialNumber: string | null | undefined): Promise<BramidanNotificationInfoWithNotifyInfo[]> {
        let url_ = this.baseUrl + "/api/NotificationFunction/GetOfflineTooLongNotificationsUnsafe?";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOfflineTooLongNotificationsUnsafe(_response);
        });
    }

    protected processGetOfflineTooLongNotificationsUnsafe(response: Response): Promise<BramidanNotificationInfoWithNotifyInfo[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BramidanNotificationInfoWithNotifyInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BramidanNotificationInfoWithNotifyInfo[]>(null as any);
    }

    getBramidanNotificationInfo(): Promise<BramidanNotificationInfo> {
        let url_ = this.baseUrl + "/api/NotificationFunction/DummyBramidanNotificationInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBramidanNotificationInfo(_response);
        });
    }

    protected processGetBramidanNotificationInfo(response: Response): Promise<BramidanNotificationInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BramidanNotificationInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BramidanNotificationInfo>(null as any);
    }
}

export class NotificationHistoryClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getHistoryBySerialNumber(serialNumber: string | null | undefined, startDate: Date | undefined, endDate: Date | undefined): Promise<NotificationHistoryDto[]> {
        let url_ = this.baseUrl + "/api/NotificationHistory/GetHistoryBySerialNumber?";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHistoryBySerialNumber(_response);
        });
    }

    protected processGetHistoryBySerialNumber(response: Response): Promise<NotificationHistoryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationHistoryDto[]>(null as any);
    }

    getHistoryByUser(): Promise<NotificationUserHistoryDto[]> {
        let url_ = this.baseUrl + "/api/NotificationHistory/GetHistoryByUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHistoryByUser(_response);
        });
    }

    protected processGetHistoryByUser(response: Response): Promise<NotificationUserHistoryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationUserHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationUserHistoryDto[]>(null as any);
    }

    getPickUpDateByUnitId(unitId: number | null | undefined): Promise<OrderPickUpDateDto> {
        let url_ = this.baseUrl + "/api/NotificationHistory/GetPickUpDateByUnitId?";
        if (unitId !== undefined && unitId !== null)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPickUpDateByUnitId(_response);
        });
    }

    protected processGetPickUpDateByUnitId(response: Response): Promise<OrderPickUpDateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderPickUpDateDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderPickUpDateDto>(null as any);
    }

    putPickUpAmount(notificationHistoryId: number | null | undefined, pickUpAmount: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/NotificationHistory/PutPickUpAmount?";
        if (notificationHistoryId !== undefined && notificationHistoryId !== null)
            url_ += "notificationHistoryId=" + encodeURIComponent("" + notificationHistoryId) + "&";
        if (pickUpAmount === null)
            throw new Error("The parameter 'pickUpAmount' cannot be null.");
        else if (pickUpAmount !== undefined)
            url_ += "pickUpAmount=" + encodeURIComponent("" + pickUpAmount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPutPickUpAmount(_response);
        });
    }

    protected processPutPickUpAmount(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class NotificationTypeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    get(): Promise<NotificationTypeDto[]> {
        let url_ = this.baseUrl + "/api/NotificationType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<NotificationTypeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationTypeDto[]>(null as any);
    }
}

export class NotificationUnsubscribeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    deleteUserFromNotification(encryptedUnsubscribe: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/NotificationUnsubscribe/DeleteUserFromNotification?";
        if (encryptedUnsubscribe !== undefined && encryptedUnsubscribe !== null)
            url_ += "encryptedUnsubscribe=" + encodeURIComponent("" + encryptedUnsubscribe) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteUserFromNotification(_response);
        });
    }

    protected processDeleteUserFromNotification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PartnerAreaClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getRootFolderContent(): Promise<FileDirectoryDto> {
        let url_ = this.baseUrl + "/api/PartnerArea/GetRootFolderContent";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRootFolderContent(_response);
        });
    }

    protected processGetRootFolderContent(response: Response): Promise<FileDirectoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDirectoryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDirectoryDto>(null as any);
    }

    getFileTree(): Promise<FileDirectoryDto> {
        let url_ = this.baseUrl + "/api/PartnerArea/GetFileTree";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFileTree(_response);
        });
    }

    protected processGetFileTree(response: Response): Promise<FileDirectoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDirectoryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDirectoryDto>(null as any);
    }

    getFileTreeByPath(path: string | null | undefined): Promise<FileDirectoryDto> {
        let url_ = this.baseUrl + "/api/PartnerArea/GetFileTreeByPath?";
        if (path !== undefined && path !== null)
            url_ += "path=" + encodeURIComponent("" + path) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFileTreeByPath(_response);
        });
    }

    protected processGetFileTreeByPath(response: Response): Promise<FileDirectoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDirectoryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDirectoryDto>(null as any);
    }

    getByFileName(fullFilePath: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PartnerArea/GetByFileName?";
        if (fullFilePath !== undefined && fullFilePath !== null)
            url_ += "fullFilePath=" + encodeURIComponent("" + fullFilePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByFileName(_response);
        });
    }

    protected processGetByFileName(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getPreviewByFileName(fullFilePath: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/PartnerArea/GetPreviewByFileName?";
        if (fullFilePath !== undefined && fullFilePath !== null)
            url_ += "fullFilePath=" + encodeURIComponent("" + fullFilePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPreviewByFileName(_response);
        });
    }

    protected processGetPreviewByFileName(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    deleteByFileName(fullFilePath: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PartnerArea/DeleteByFileName?";
        if (fullFilePath !== undefined && fullFilePath !== null)
            url_ += "fullFilePath=" + encodeURIComponent("" + fullFilePath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteByFileName(_response);
        });
    }

    protected processDeleteByFileName(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteByFolderName(fullFolderPath: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/PartnerArea/DeleteByFolderName?";
        if (fullFolderPath !== undefined && fullFolderPath !== null)
            url_ += "fullFolderPath=" + encodeURIComponent("" + fullFolderPath) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteByFolderName(_response);
        });
    }

    protected processDeleteByFolderName(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ProfileClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    updateProfile(profileDto: ProfileDto): Promise<ProfileDto> {
        let url_ = this.baseUrl + "/api/Profile/UpdateProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profileDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateProfile(_response);
        });
    }

    protected processUpdateProfile(response: Response): Promise<ProfileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProfileDto>(null as any);
    }
}

export class ReleaseNoteClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    get(): Promise<GetReleaseNoteDto[]> {
        let url_ = this.baseUrl + "/api/ReleaseNote";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<GetReleaseNoteDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetReleaseNoteDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetReleaseNoteDto[]>(null as any);
    }

    getReleaseNoteImage(fileName: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ReleaseNote/ReleaseNoteImage?";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReleaseNoteImage(_response);
        });
    }

    protected processGetReleaseNoteImage(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    postNote(note: GetReleaseNoteDto): Promise<GetReleaseNoteDto> {
        let url_ = this.baseUrl + "/api/ReleaseNote/Note";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(note);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostNote(_response);
        });
    }

    protected processPostNote(response: Response): Promise<GetReleaseNoteDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReleaseNoteDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetReleaseNoteDto>(null as any);
    }

    updateNote(note: GetReleaseNoteDto): Promise<GetReleaseNoteDto> {
        let url_ = this.baseUrl + "/api/ReleaseNote/Note";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(note);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateNote(_response);
        });
    }

    protected processUpdateNote(response: Response): Promise<GetReleaseNoteDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReleaseNoteDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetReleaseNoteDto>(null as any);
    }

    postNoteImage(releaseNoteId: number | null | undefined, file: FileParameter | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/ReleaseNote/NoteImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (releaseNoteId !== null && releaseNoteId !== undefined)
            content_.append("ReleaseNoteId", releaseNoteId.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostNoteImage(_response);
        });
    }

    protected processPostNoteImage(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    deleteNote(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/ReleaseNote/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteNote(_response);
        });
    }

    protected processDeleteNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    postLog(readNotes: number[]): Promise<number[]> {
        let url_ = this.baseUrl + "/api/ReleaseNote/Log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(readNotes);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPostLog(_response);
        });
    }

    protected processPostLog(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }
}

export class ReportsExcelClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    downloadFileByFilter(filter: FilterDto, dataType: DataTypes | undefined, dateType: DateTypes | undefined, startDate: Date | undefined, endDate: Date | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ReportsExcel/DownloadFileByFilter?";
        if (dataType === null)
            throw new Error("The parameter 'dataType' cannot be null.");
        else if (dataType !== undefined)
            url_ += "dataType=" + encodeURIComponent("" + dataType) + "&";
        if (dateType === null)
            throw new Error("The parameter 'dateType' cannot be null.");
        else if (dateType !== undefined)
            url_ += "dateType=" + encodeURIComponent("" + dateType) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadFileByFilter(_response);
        });
    }

    protected processDownloadFileByFilter(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    downloadFileByUnitIds(unitIds: number[], dataType: DataTypes | undefined, dateType: DateTypes | undefined, startDate: Date | undefined, endDate: Date | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ReportsExcel/DownloadFileByMachineIds?";
        if (dataType === null)
            throw new Error("The parameter 'dataType' cannot be null.");
        else if (dataType !== undefined)
            url_ += "dataType=" + encodeURIComponent("" + dataType) + "&";
        if (dateType === null)
            throw new Error("The parameter 'dateType' cannot be null.");
        else if (dateType !== undefined)
            url_ += "dateType=" + encodeURIComponent("" + dateType) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(unitIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadFileByUnitIds(_response);
        });
    }

    protected processDownloadFileByUnitIds(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ServiceToolCodeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getServiceToolCode(machineId: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/ServiceToolCode/GetServiceToolCode?";
        if (machineId !== undefined && machineId !== null)
            url_ += "machineId=" + encodeURIComponent("" + machineId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetServiceToolCode(_response);
        });
    }

    protected processGetServiceToolCode(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ServiceToolClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getServiceToolAccess(): Promise<ServiceToolDevicesDto> {
        let url_ = this.baseUrl + "/api/ServiceTool/devices/access";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetServiceToolAccess(_response);
        });
    }

    protected processGetServiceToolAccess(response: Response): Promise<ServiceToolDevicesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceToolDevicesDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceToolDevicesDto>(null as any);
    }

    getDeviceTwin(machineId: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ServiceTool/devicetwin/{machineId}";
        if (machineId === undefined || machineId === null)
            throw new Error("The parameter 'machineId' must be defined.");
        url_ = url_.replace("{machineId}", encodeURIComponent("" + machineId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDeviceTwin(_response);
        });
    }

    protected processGetDeviceTwin(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    updateDeviceTwin(machineId: string, desiredProperties: any): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ServiceTool/desired/{machineId}";
        if (machineId === undefined || machineId === null)
            throw new Error("The parameter 'machineId' must be defined.");
        url_ = url_.replace("{machineId}", encodeURIComponent("" + machineId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(desiredProperties);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateDeviceTwin(_response);
        });
    }

    protected processUpdateDeviceTwin(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    invokeDeviceMethod(machineId: string, directMethod: any): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ServiceTool/invoke/{machineId}";
        if (machineId === undefined || machineId === null)
            throw new Error("The parameter 'machineId' must be defined.");
        url_ = url_.replace("{machineId}", encodeURIComponent("" + machineId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(directMethod);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInvokeDeviceMethod(_response);
        });
    }

    protected processInvokeDeviceMethod(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    registerMachineOnSignalR(connectionInfoDto: SignalRConnectionInfoDto): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ServiceTool/event/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(connectionInfoDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegisterMachineOnSignalR(_response);
        });
    }

    protected processRegisterMachineOnSignalR(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    unRegisterMachineOnSignalR(connectionInfoDto: SignalRConnectionInfoDto): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ServiceTool/event/unregister";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(connectionInfoDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnRegisterMachineOnSignalR(_response);
        });
    }

    protected processUnRegisterMachineOnSignalR(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getServiceToolAccessOptions(): Promise<ServiceToolOptionsDto> {
        let url_ = this.baseUrl + "/api/ServiceTool/servicetool/access";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetServiceToolAccessOptions(_response);
        });
    }

    protected processGetServiceToolAccessOptions(response: Response): Promise<ServiceToolOptionsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceToolOptionsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceToolOptionsDto>(null as any);
    }

    getAvailableServiceTools(): Promise<ServiceToolControllerTypes> {
        let url_ = this.baseUrl + "/api/ServiceTool/GetUserAvailableServiceTools";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAvailableServiceTools(_response);
        });
    }

    protected processGetAvailableServiceTools(response: Response): Promise<ServiceToolControllerTypes> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceToolControllerTypes.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceToolControllerTypes>(null as any);
    }
}

export class ServiceVideoClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    get(): Promise<ServiceVideoDto[]> {
        let url_ = this.baseUrl + "/api/ServiceVideo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ServiceVideoDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceVideoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceVideoDto[]>(null as any);
    }

    post(serviceVideoDto: ServiceVideoDto): Promise<ServiceVideoDto> {
        let url_ = this.baseUrl + "/api/ServiceVideo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(serviceVideoDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<ServiceVideoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceVideoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceVideoDto>(null as any);
    }

    delete(serviceVideoDto: ServiceVideoDto): Promise<void> {
        let url_ = this.baseUrl + "/api/ServiceVideo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(serviceVideoDto);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getByMachineType(machineTypeName: string | null | undefined): Promise<ServiceVideoDto[]> {
        let url_ = this.baseUrl + "/api/ServiceVideo/GetByMachineType?";
        if (machineTypeName !== undefined && machineTypeName !== null)
            url_ += "machineTypeName=" + encodeURIComponent("" + machineTypeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByMachineType(_response);
        });
    }

    protected processGetByMachineType(response: Response): Promise<ServiceVideoDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceVideoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ServiceVideoDto[]>(null as any);
    }
}

export class TableSettingsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    get(tableId: TableId | undefined): Promise<TableSettings> {
        let url_ = this.baseUrl + "/api/TableSettings?";
        if (tableId === null)
            throw new Error("The parameter 'tableId' cannot be null.");
        else if (tableId !== undefined)
            url_ += "tableId=" + encodeURIComponent("" + tableId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<TableSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TableSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TableSettings>(null as any);
    }

    post(tableSettings: TableSettings): Promise<TableSettings> {
        let url_ = this.baseUrl + "/api/TableSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tableSettings);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: Response): Promise<TableSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TableSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TableSettings>(null as any);
    }

    put(tableSettings: TableSettings): Promise<TableSettings> {
        let url_ = this.baseUrl + "/api/TableSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tableSettings);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<TableSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TableSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TableSettings>(null as any);
    }

    delete(id: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/TableSettings?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAllMachineTableSettings(): Promise<TableSettings[]> {
        let url_ = this.baseUrl + "/api/TableSettings/GetAllMachineTableSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllMachineTableSettings(_response);
        });
    }

    protected processGetAllMachineTableSettings(response: Response): Promise<TableSettings[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TableSettings.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TableSettings[]>(null as any);
    }

    setDefaultTableSettings(): Promise<void> {
        let url_ = this.baseUrl + "/api/TableSettings/SetDefaultTableSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetDefaultTableSettings(_response);
        });
    }

    protected processSetDefaultTableSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UnitTrackerClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    createUnitTracker(unitId: number | undefined, trackerId: string | null | undefined): Promise<UnitTracker> {
        let url_ = this.baseUrl + "/api/UnitTracker/CreateUnitTracker?";
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&";
        if (trackerId !== undefined && trackerId !== null)
            url_ += "trackerId=" + encodeURIComponent("" + trackerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateUnitTracker(_response);
        });
    }

    protected processCreateUnitTracker(response: Response): Promise<UnitTracker> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitTracker.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitTracker>(null as any);
    }

    getUnitTracker(serialNumber: string | null | undefined): Promise<UnitTracker> {
        let url_ = this.baseUrl + "/api/UnitTracker/GetUnitTracker?";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnitTracker(_response);
        });
    }

    protected processGetUnitTracker(response: Response): Promise<UnitTracker> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitTracker.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitTracker>(null as any);
    }

    getUnitTrackers(): Promise<UnitTracker[]> {
        let url_ = this.baseUrl + "/api/UnitTracker/GetUnitTrackers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnitTrackers(_response);
        });
    }

    protected processGetUnitTrackers(response: Response): Promise<UnitTracker[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitTracker.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitTracker[]>(null as any);
    }

    updateUnitTrackerId(unitId: number | undefined, trackerId: string | null | undefined): Promise<UnitTracker> {
        let url_ = this.baseUrl + "/api/UnitTracker/UpdateUnitTrackerId?";
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&";
        if (trackerId !== undefined && trackerId !== null)
            url_ += "trackerId=" + encodeURIComponent("" + trackerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUnitTrackerId(_response);
        });
    }

    protected processUpdateUnitTrackerId(response: Response): Promise<UnitTracker> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitTracker.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitTracker>(null as any);
    }

    deleteUnitTracker(unitId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UnitTracker/DeleteUnitTracker?";
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteUnitTracker(_response);
        });
    }

    protected processDeleteUnitTracker(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class IoTHubDuplicateDecommissionClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getDuplicates(): Promise<IoTHubDuplicateDecommissionDto[]> {
        let url_ = this.baseUrl + "/api/IoTHubDuplicateDecommission/GetDuplicates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDuplicates(_response);
        });
    }

    protected processGetDuplicates(response: Response): Promise<IoTHubDuplicateDecommissionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IoTHubDuplicateDecommissionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IoTHubDuplicateDecommissionDto[]>(null as any);
    }

    deleteDuplicate(iotHubDeviceId: string | null | undefined, duplicateDecommission: IoTHubDuplicateDecommissionDto): Promise<IoTHubDuplicateDecommissionDto[]> {
        let url_ = this.baseUrl + "/api/IoTHubDuplicateDecommission/DeleteDuplicate?";
        if (iotHubDeviceId !== undefined && iotHubDeviceId !== null)
            url_ += "iotHubDeviceId=" + encodeURIComponent("" + iotHubDeviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(duplicateDecommission);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteDuplicate(_response);
        });
    }

    protected processDeleteDuplicate(response: Response): Promise<IoTHubDuplicateDecommissionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IoTHubDuplicateDecommissionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IoTHubDuplicateDecommissionDto[]>(null as any);
    }
}

export class UnitClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getByFilter(filter: FilterDto, skip: number | null | undefined, take: number | null | undefined, columnName: string | null | undefined, direction: string | null | undefined): Promise<UnitsDto[]> {
        let url_ = this.baseUrl + "/api/Unit/GetByFilter?";
        if (skip !== undefined && skip !== null)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take !== undefined && take !== null)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        if (columnName !== undefined && columnName !== null)
            url_ += "columnName=" + encodeURIComponent("" + columnName) + "&";
        if (direction !== undefined && direction !== null)
            url_ += "direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByFilter(_response);
        });
    }

    protected processGetByFilter(response: Response): Promise<UnitsDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitsDto[]>(null as any);
    }

    getMachineCount(filter: FilterDto): Promise<number> {
        let url_ = this.baseUrl + "/api/Unit/MachineCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMachineCount(_response);
        });
    }

    protected processGetMachineCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteMachine(machineId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Unit/DeleteMachine?";
        if (machineId === null)
            throw new Error("The parameter 'machineId' cannot be null.");
        else if (machineId !== undefined)
            url_ += "machineId=" + encodeURIComponent("" + machineId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteMachine(_response);
        });
    }

    protected processDeleteMachine(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getUnitsByDeviceIds(unitIds: number[]): Promise<UnitsDto[]> {
        let url_ = this.baseUrl + "/api/Unit/GetUnitsByDeviceIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(unitIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnitsByDeviceIds(_response);
        });
    }

    protected processGetUnitsByDeviceIds(response: Response): Promise<UnitsDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitsDto[]>(null as any);
    }

    getUnitsWithDocumentsByCountryCode(countryCode: string | null | undefined, unitIdSelected: string | null | undefined): Promise<UnitWithDocumentsDto> {
        let url_ = this.baseUrl + "/api/Unit/GetMachinesWithDocumentsByCountryCode?";
        if (countryCode !== undefined && countryCode !== null)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (unitIdSelected !== undefined && unitIdSelected !== null)
            url_ += "unitIdSelected=" + encodeURIComponent("" + unitIdSelected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnitsWithDocumentsByCountryCode(_response);
        });
    }

    protected processGetUnitsWithDocumentsByCountryCode(response: Response): Promise<UnitWithDocumentsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitWithDocumentsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitWithDocumentsDto>(null as any);
    }

    getFilterOptions(): Promise<FilterOptionDto> {
        let url_ = this.baseUrl + "/api/Unit/FilterOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFilterOptions(_response);
        });
    }

    protected processGetFilterOptions(response: Response): Promise<FilterOptionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FilterOptionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FilterOptionDto>(null as any);
    }

    updateUnitOwnerGroup(moveUnitDto: MoveUnitDto): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Unit/UpdateUnitOwnerGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(moveUnitDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUnitOwnerGroup(_response);
        });
    }

    protected processUpdateUnitOwnerGroup(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    createUnit(createUnitDto: CreateUnitDto): Promise<CreateUnitDto> {
        let url_ = this.baseUrl + "/api/Unit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createUnitDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateUnit(_response);
        });
    }

    protected processCreateUnit(response: Response): Promise<CreateUnitDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateUnitDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateUnitDto>(null as any);
    }
}

export class UnitDetailsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    get(serialNumber: string | null | undefined): Promise<UnitDetailsDto> {
        let url_ = this.baseUrl + "/api/UnitDetails?";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<UnitDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitDetailsDto>(null as any);
    }

    put(unitDetailsDto: UnitDetailsDto, updateCoordinatesFromAddress: boolean | undefined): Promise<UnitDetailsDto> {
        let url_ = this.baseUrl + "/api/UnitDetails?";
        if (updateCoordinatesFromAddress === null)
            throw new Error("The parameter 'updateCoordinatesFromAddress' cannot be null.");
        else if (updateCoordinatesFromAddress !== undefined)
            url_ += "updateCoordinatesFromAddress=" + encodeURIComponent("" + updateCoordinatesFromAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(unitDetailsDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: Response): Promise<UnitDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitDetailsDto>(null as any);
    }

    getByLanguage(serialNumber: string | null | undefined, language: SelectedLanguage | undefined): Promise<UnitDetailsDto> {
        let url_ = this.baseUrl + "/api/UnitDetails/GetByLanguage?";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        if (language === null)
            throw new Error("The parameter 'language' cannot be null.");
        else if (language !== undefined)
            url_ += "language=" + encodeURIComponent("" + language) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByLanguage(_response);
        });
    }

    protected processGetByLanguage(response: Response): Promise<UnitDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitDetailsDto>(null as any);
    }

    putBasicUser(unitDetailsDto: UnitDetailsDto): Promise<UnitDetailsDto> {
        let url_ = this.baseUrl + "/api/UnitDetails/PutBasicUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(unitDetailsDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPutBasicUser(_response);
        });
    }

    protected processPutBasicUser(response: Response): Promise<UnitDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitDetailsDto>(null as any);
    }

    getDropDownData(): Promise<DropdownDataDto> {
        let url_ = this.baseUrl + "/api/UnitDetails/GetDropDownData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetDropDownData(_response);
        });
    }

    protected processGetDropDownData(response: Response): Promise<DropdownDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DropdownDataDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DropdownDataDto>(null as any);
    }

    downloadWasteEmptyingsForTimeRange(serialNumber: string | null | undefined, beforeOptimizeProjectStart: Date | undefined, beforeOptimizeProjectEnd: Date | undefined, afterOptimizeProjectStart: Date | undefined, afterOptimizeProjectEnd: Date | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/UnitDetails/DownloadWasteEmptyingsForTimeRange?";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        if (beforeOptimizeProjectStart === null)
            throw new Error("The parameter 'beforeOptimizeProjectStart' cannot be null.");
        else if (beforeOptimizeProjectStart !== undefined)
            url_ += "beforeOptimizeProjectStart=" + encodeURIComponent(beforeOptimizeProjectStart ? "" + beforeOptimizeProjectStart.toISOString() : "") + "&";
        if (beforeOptimizeProjectEnd === null)
            throw new Error("The parameter 'beforeOptimizeProjectEnd' cannot be null.");
        else if (beforeOptimizeProjectEnd !== undefined)
            url_ += "beforeOptimizeProjectEnd=" + encodeURIComponent(beforeOptimizeProjectEnd ? "" + beforeOptimizeProjectEnd.toISOString() : "") + "&";
        if (afterOptimizeProjectStart === null)
            throw new Error("The parameter 'afterOptimizeProjectStart' cannot be null.");
        else if (afterOptimizeProjectStart !== undefined)
            url_ += "afterOptimizeProjectStart=" + encodeURIComponent(afterOptimizeProjectStart ? "" + afterOptimizeProjectStart.toISOString() : "") + "&";
        if (afterOptimizeProjectEnd === null)
            throw new Error("The parameter 'afterOptimizeProjectEnd' cannot be null.");
        else if (afterOptimizeProjectEnd !== undefined)
            url_ += "afterOptimizeProjectEnd=" + encodeURIComponent(afterOptimizeProjectEnd ? "" + afterOptimizeProjectEnd.toISOString() : "") + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadWasteEmptyingsForTimeRange(_response);
        });
    }

    protected processDownloadWasteEmptyingsForTimeRange(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    getLinkedUnitExtraInfoByIds(ids: number[]): Promise<LinkedUnitExtraInfoDto[]> {
        let url_ = this.baseUrl + "/api/UnitDetails/GetLinkedUnitExtraInfoByIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLinkedUnitExtraInfoByIds(_response);
        });
    }

    protected processGetLinkedUnitExtraInfoByIds(response: Response): Promise<LinkedUnitExtraInfoDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LinkedUnitExtraInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LinkedUnitExtraInfoDto[]>(null as any);
    }
}

export class UnitExcelClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    downloadFile(machineExcelQuery: MachineExcelQuery, columnsActive: string[] | null | undefined, timeZoneId: string | null | undefined, lang: string | null | undefined, columnName: string | null | undefined, direction: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/UnitExcel?";
        if (columnsActive !== undefined && columnsActive !== null)
            columnsActive && columnsActive.forEach(item => { url_ += "columnsActive=" + encodeURIComponent("" + item) + "&"; });
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (columnName !== undefined && columnName !== null)
            url_ += "columnName=" + encodeURIComponent("" + columnName) + "&";
        if (direction !== undefined && direction !== null)
            url_ += "direction=" + encodeURIComponent("" + direction) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(machineExcelQuery);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadFile(_response);
        });
    }

    protected processDownloadFile(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class UnitImageClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getMultiple(imageDtos: UnitImageDto[]): Promise<UnitImageDto[]> {
        let url_ = this.baseUrl + "/api/UnitImage/GetMultiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(imageDtos);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMultiple(_response);
        });
    }

    protected processGetMultiple(response: Response): Promise<UnitImageDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitImageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitImageDto[]>(null as any);
    }

    addUserImageToUnit(unitImageDto: UnitImageDto): Promise<UnitImageDto> {
        let url_ = this.baseUrl + "/api/UnitImage/AddUserImageToUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(unitImageDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddUserImageToUnit(_response);
        });
    }

    protected processAddUserImageToUnit(response: Response): Promise<UnitImageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitImageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitImageDto>(null as any);
    }
}

export class UnitLocationClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getMachinesWithLocations(unitIds: number[]): Promise<UnitWithLocationDto[]> {
        let url_ = this.baseUrl + "/api/UnitLocation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(unitIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMachinesWithLocations(_response);
        });
    }

    protected processGetMachinesWithLocations(response: Response): Promise<UnitWithLocationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitWithLocationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitWithLocationDto[]>(null as any);
    }

    getMachinesWithLocationsFiltered(filter: FilterDto): Promise<UnitWithLocationDto[]> {
        let url_ = this.baseUrl + "/api/UnitLocation/GetByFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMachinesWithLocationsFiltered(_response);
        });
    }

    protected processGetMachinesWithLocationsFiltered(response: Response): Promise<UnitWithLocationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitWithLocationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitWithLocationDto[]>(null as any);
    }
}

export class UnitManufacturerClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getUnitManufacturers(): Promise<UnitManufacturerDto[]> {
        let url_ = this.baseUrl + "/api/UnitManufacturer/GetUnitManufacturers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnitManufacturers(_response);
        });
    }

    protected processGetUnitManufacturers(response: Response): Promise<UnitManufacturerDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitManufacturerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitManufacturerDto[]>(null as any);
    }

    createUnitManufacturer(dto: UnitManufacturerDto): Promise<UnitManufacturerDto> {
        let url_ = this.baseUrl + "/api/UnitManufacturer/CreateUnitManufacturer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateUnitManufacturer(_response);
        });
    }

    protected processCreateUnitManufacturer(response: Response): Promise<UnitManufacturerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitManufacturerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitManufacturerDto>(null as any);
    }

    updateUnitManufacturer(dto: UnitManufacturerDto): Promise<UnitManufacturerDto> {
        let url_ = this.baseUrl + "/api/UnitManufacturer/UpdateUnitManufacturer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUnitManufacturer(_response);
        });
    }

    protected processUpdateUnitManufacturer(response: Response): Promise<UnitManufacturerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitManufacturerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitManufacturerDto>(null as any);
    }

    deleteUnitManufacturer(dto: UnitManufacturerDto): Promise<void> {
        let url_ = this.baseUrl + "/api/UnitManufacturer/DeleteUnitManufacturer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteUnitManufacturer(_response);
        });
    }

    protected processDeleteUnitManufacturer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UnitModelCodeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getUnitModelCodes(): Promise<UnitModelCodeDto[]> {
        let url_ = this.baseUrl + "/api/UnitModelCode/GetUnitModelCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnitModelCodes(_response);
        });
    }

    protected processGetUnitModelCodes(response: Response): Promise<UnitModelCodeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitModelCodeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitModelCodeDto[]>(null as any);
    }
}

export class UnitModelClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getUnitModels(): Promise<UnitModelDto[]> {
        let url_ = this.baseUrl + "/api/UnitModel/GetUnitModels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnitModels(_response);
        });
    }

    protected processGetUnitModels(response: Response): Promise<UnitModelDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitModelDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitModelDto[]>(null as any);
    }

    createUnitModel(dto: UnitModelDto): Promise<UnitModelDto> {
        let url_ = this.baseUrl + "/api/UnitModel/CreateUnitModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateUnitModel(_response);
        });
    }

    protected processCreateUnitModel(response: Response): Promise<UnitModelDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitModelDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitModelDto>(null as any);
    }

    updateUnitModel(dto: UnitModelDto): Promise<UnitModelDto> {
        let url_ = this.baseUrl + "/api/UnitModel/UpdateUnitModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUnitModel(_response);
        });
    }

    protected processUpdateUnitModel(response: Response): Promise<UnitModelDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitModelDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitModelDto>(null as any);
    }

    deleteUnitModel(dto: UnitModelDto): Promise<void> {
        let url_ = this.baseUrl + "/api/UnitModel/DeleteUnitModel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteUnitModel(_response);
        });
    }

    protected processDeleteUnitModel(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UnitReportsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getReportByFilter(filter: FilterDto, startDate: Date | undefined, endDate: Date | undefined, dateType: DateTypes | undefined, dataType: DataTypes | undefined): Promise<UnitReportDto> {
        let url_ = this.baseUrl + "/api/UnitReports/GetReportByFilter?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (dateType === null)
            throw new Error("The parameter 'dateType' cannot be null.");
        else if (dateType !== undefined)
            url_ += "dateType=" + encodeURIComponent("" + dateType) + "&";
        if (dataType === null)
            throw new Error("The parameter 'dataType' cannot be null.");
        else if (dataType !== undefined)
            url_ += "dataType=" + encodeURIComponent("" + dataType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReportByFilter(_response);
        });
    }

    protected processGetReportByFilter(response: Response): Promise<UnitReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitReportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitReportDto>(null as any);
    }

    getReportByUnitIds(unitIds: number[], startDate: Date | undefined, endDate: Date | undefined, dateType: DateTypes | undefined, dataType: DataTypes | undefined): Promise<UnitReportDto> {
        let url_ = this.baseUrl + "/api/UnitReports/GetReportByIds?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (dateType === null)
            throw new Error("The parameter 'dateType' cannot be null.");
        else if (dateType !== undefined)
            url_ += "dateType=" + encodeURIComponent("" + dateType) + "&";
        if (dataType === null)
            throw new Error("The parameter 'dataType' cannot be null.");
        else if (dataType !== undefined)
            url_ += "dataType=" + encodeURIComponent("" + dataType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(unitIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReportByUnitIds(_response);
        });
    }

    protected processGetReportByUnitIds(response: Response): Promise<UnitReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitReportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitReportDto>(null as any);
    }

    getReportGraph(): Promise<GraphReportDto> {
        let url_ = this.baseUrl + "/api/UnitReports/GetReportGraph";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReportGraph(_response);
        });
    }

    protected processGetReportGraph(response: Response): Promise<GraphReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GraphReportDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GraphReportDto>(null as any);
    }

    getReportTable(): Promise<TableReportDto[]> {
        let url_ = this.baseUrl + "/api/UnitReports/GetReportTableByFilter";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetReportTable(_response);
        });
    }

    protected processGetReportTable(response: Response): Promise<TableReportDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TableReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TableReportDto[]>(null as any);
    }
}

export class UnitSelectedClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getByFilter(filter: FilterDto): Promise<UnitSelectedDto[]> {
        let url_ = this.baseUrl + "/api/UnitSelected";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByFilter(_response);
        });
    }

    protected processGetByFilter(response: Response): Promise<UnitSelectedDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitSelectedDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitSelectedDto[]>(null as any);
    }
}

export class UnitStateHistoryClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getFilteredByDates(serialNumber: string | null | undefined, startDate: Date | undefined, endDate: Date | undefined): Promise<UnitStateHistoryDto[]> {
        let url_ = this.baseUrl + "/api/UnitStateHistory/GetFilteredByDates?";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFilteredByDates(_response);
        });
    }

    protected processGetFilteredByDates(response: Response): Promise<UnitStateHistoryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitStateHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitStateHistoryDto[]>(null as any);
    }

    getInfo(serialNumber: string | null | undefined): Promise<UnitHistoryInfoDto> {
        let url_ = this.baseUrl + "/api/UnitStateHistory/GetInfo?";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInfo(_response);
        });
    }

    protected processGetInfo(response: Response): Promise<UnitHistoryInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitHistoryInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitHistoryInfoDto>(null as any);
    }

    putHistoryRow(serialNumber: string | null | undefined, rowDto: UnitStateHistoryDto): Promise<UnitStateHistoryDto> {
        let url_ = this.baseUrl + "/api/UnitStateHistory/PutHistoryRow?";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rowDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPutHistoryRow(_response);
        });
    }

    protected processPutHistoryRow(response: Response): Promise<UnitStateHistoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitStateHistoryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitStateHistoryDto>(null as any);
    }

    getPressureChart(serialNumber: string | null | undefined, cycleId: string | undefined, timestamp: Date | undefined): Promise<PressureChartDto> {
        let url_ = this.baseUrl + "/api/UnitStateHistory/GetPressureChart?";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        if (cycleId === null)
            throw new Error("The parameter 'cycleId' cannot be null.");
        else if (cycleId !== undefined)
            url_ += "cycleId=" + encodeURIComponent("" + cycleId) + "&";
        if (timestamp === null)
            throw new Error("The parameter 'timestamp' cannot be null.");
        else if (timestamp !== undefined)
            url_ += "timestamp=" + encodeURIComponent(timestamp ? "" + timestamp.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPressureChart(_response);
        });
    }

    protected processGetPressureChart(response: Response): Promise<PressureChartDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PressureChartDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PressureChartDto>(null as any);
    }

    getUnitCyclesFilteredByDates(serialNumber: string | null | undefined, startDate: Date | undefined, endDate: Date | undefined): Promise<UnitCycleDto[]> {
        let url_ = this.baseUrl + "/api/UnitStateHistory/GetUnitCyclesFilteredByDates?";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnitCyclesFilteredByDates(_response);
        });
    }

    protected processGetUnitCyclesFilteredByDates(response: Response): Promise<UnitCycleDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitCycleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitCycleDto[]>(null as any);
    }
}

export class UnitStateHistoryExcelClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    downloadFileByMachineIds(serialNumber: string | null | undefined, startDate: Date | undefined, endDate: Date | undefined, timeZoneId: string | null | undefined, filterOnFillLevelChanged: boolean | undefined, filterOnFull: boolean | undefined, lang: string | null | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/UnitStateHistoryExcel/DownloadFileBySerialNumber?";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (timeZoneId !== undefined && timeZoneId !== null)
            url_ += "timeZoneId=" + encodeURIComponent("" + timeZoneId) + "&";
        if (filterOnFillLevelChanged === null)
            throw new Error("The parameter 'filterOnFillLevelChanged' cannot be null.");
        else if (filterOnFillLevelChanged !== undefined)
            url_ += "filterOnFillLevelChanged=" + encodeURIComponent("" + filterOnFillLevelChanged) + "&";
        if (filterOnFull === null)
            throw new Error("The parameter 'filterOnFull' cannot be null.");
        else if (filterOnFull !== undefined)
            url_ += "filterOnFull=" + encodeURIComponent("" + filterOnFull) + "&";
        if (lang !== undefined && lang !== null)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadFileByMachineIds(_response);
        });
    }

    protected processDownloadFileByMachineIds(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class UnitTypeClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getUnitTypes(): Promise<UnitTypeDto[]> {
        let url_ = this.baseUrl + "/api/UnitType/GetUnitTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnitTypes(_response);
        });
    }

    protected processGetUnitTypes(response: Response): Promise<UnitTypeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitTypeDto[]>(null as any);
    }
}

export class UnitWeightClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    createUnitWeight(unitId: number | undefined, weightSerialNumber: string | null | undefined): Promise<UnitWeightDto> {
        let url_ = this.baseUrl + "/api/UnitWeight/CreateUnitWeight?";
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&";
        if (weightSerialNumber !== undefined && weightSerialNumber !== null)
            url_ += "weightSerialNumber=" + encodeURIComponent("" + weightSerialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateUnitWeight(_response);
        });
    }

    protected processCreateUnitWeight(response: Response): Promise<UnitWeightDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitWeightDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitWeightDto>(null as any);
    }

    getUnitWeight(serialNumber: string | null | undefined): Promise<UnitWeightDto> {
        let url_ = this.baseUrl + "/api/UnitWeight/GetUnitWeight?";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnitWeight(_response);
        });
    }

    protected processGetUnitWeight(response: Response): Promise<UnitWeightDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitWeightDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitWeightDto>(null as any);
    }

    updateUnitWeight(unitId: number | undefined, weightSerialNumber: string | null | undefined): Promise<UnitWeightDto> {
        let url_ = this.baseUrl + "/api/UnitWeight/UpdateUnitWeight?";
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&";
        if (weightSerialNumber !== undefined && weightSerialNumber !== null)
            url_ += "weightSerialNumber=" + encodeURIComponent("" + weightSerialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUnitWeight(_response);
        });
    }

    protected processUpdateUnitWeight(response: Response): Promise<UnitWeightDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitWeightDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitWeightDto>(null as any);
    }

    deleteUnitWeight(unitId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UnitWeight/DeleteUnitWeight?";
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteUnitWeight(_response);
        });
    }

    protected processDeleteUnitWeight(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserGroupPermissionsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getByUserId(): Promise<UserGroupPermission[]> {
        let url_ = this.baseUrl + "/api/UserGroupPermissions/GetByUserId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByUserId(_response);
        });
    }

    protected processGetByUserId(response: Response): Promise<UserGroupPermission[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserGroupPermission.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroupPermission[]>(null as any);
    }

    getByGroupIds(groupIds: number[]): Promise<UserGroupPermission[]> {
        let url_ = this.baseUrl + "/api/UserGroupPermissions/GetByGroupIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByGroupIds(_response);
        });
    }

    protected processGetByGroupIds(response: Response): Promise<UserGroupPermission[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserGroupPermission.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroupPermission[]>(null as any);
    }

    getWithConfirmationStatusByGroupIds(groupIds: number[]): Promise<UserGroupPermissionsDto[]> {
        let url_ = this.baseUrl + "/api/UserGroupPermissions/GetWithConfirmationStatusByGroupIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetWithConfirmationStatusByGroupIds(_response);
        });
    }

    protected processGetWithConfirmationStatusByGroupIds(response: Response): Promise<UserGroupPermissionsDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserGroupPermissionsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroupPermissionsDto[]>(null as any);
    }

    updateUserGroupPermission(userGroupPermission: UserGroupPermissionsDto, previousGroupId: number | undefined): Promise<UserGroupPermissionsDto> {
        let url_ = this.baseUrl + "/api/UserGroupPermissions/UpdateUserGroupPermission?";
        if (previousGroupId === null)
            throw new Error("The parameter 'previousGroupId' cannot be null.");
        else if (previousGroupId !== undefined)
            url_ += "previousGroupId=" + encodeURIComponent("" + previousGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userGroupPermission);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateUserGroupPermission(_response);
        });
    }

    protected processUpdateUserGroupPermission(response: Response): Promise<UserGroupPermissionsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserGroupPermissionsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroupPermissionsDto>(null as any);
    }

    createUserGroupPermission(userGroupPermission: UserGroupPermissionsDto): Promise<UserGroupPermissionsDto> {
        let url_ = this.baseUrl + "/api/UserGroupPermissions/CreateUserGroupPermission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userGroupPermission);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateUserGroupPermission(_response);
        });
    }

    protected processCreateUserGroupPermission(response: Response): Promise<UserGroupPermissionsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserGroupPermissionsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroupPermissionsDto>(null as any);
    }

    removeUserGroupPermission(userId: string | null | undefined, groupId: number, roleType: RolesType | undefined): Promise<UserGroupPermissionsDto> {
        let url_ = this.baseUrl + "/api/UserGroupPermissions/RemoveUserGroupPermission?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (roleType === null)
            throw new Error("The parameter 'roleType' cannot be null.");
        else if (roleType !== undefined)
            url_ += "roleType=" + encodeURIComponent("" + roleType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupId);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRemoveUserGroupPermission(_response);
        });
    }

    protected processRemoveUserGroupPermission(response: Response): Promise<UserGroupPermissionsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserGroupPermissionsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGroupPermissionsDto>(null as any);
    }

    resendConfirmationEmail(userId: string | null | undefined, groupId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/UserGroupPermissions/ResendConfirmationEmail?";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (groupId === null)
            throw new Error("The parameter 'groupId' cannot be null.");
        else if (groupId !== undefined)
            url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResendConfirmationEmail(_response);
        });
    }

    protected processResendConfirmationEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UserSettingsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getByUserId(): Promise<UserSettings> {
        let url_ = this.baseUrl + "/api/UserSettings/GetByUserId";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByUserId(_response);
        });
    }

    protected processGetByUserId(response: Response): Promise<UserSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSettings>(null as any);
    }

    upsertUserSettings(userSettings: UserSettings): Promise<UserSettings> {
        let url_ = this.baseUrl + "/api/UserSettings/UpsertUserSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userSettings);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpsertUserSettings(_response);
        });
    }

    protected processUpsertUserSettings(response: Response): Promise<UserSettings> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserSettings.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserSettings>(null as any);
    }
}

export class WasteHandlerClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getByUnitId(unitId: number | undefined): Promise<WasteHandlerDto> {
        let url_ = this.baseUrl + "/api/WasteHandler/GetByUnitId?";
        if (unitId === null)
            throw new Error("The parameter 'unitId' cannot be null.");
        else if (unitId !== undefined)
            url_ += "unitId=" + encodeURIComponent("" + unitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetByUnitId(_response);
        });
    }

    protected processGetByUnitId(response: Response): Promise<WasteHandlerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WasteHandlerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WasteHandlerDto>(null as any);
    }

    updateWasteHandler(dto: WasteHandlerDto): Promise<WasteHandlerDto> {
        let url_ = this.baseUrl + "/api/WasteHandler";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateWasteHandler(_response);
        });
    }

    protected processUpdateWasteHandler(response: Response): Promise<WasteHandlerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WasteHandlerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WasteHandlerDto>(null as any);
    }
}

export class WasteHandlersImportClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    importWasteEmptyings(emptyings: WasteHandlersDto[]): Promise<WasteHandlersFileResult[]> {
        let url_ = this.baseUrl + "/api/WasteHandlersImport/WasteHandlersImport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(emptyings);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImportWasteEmptyings(_response);
        });
    }

    protected processImportWasteEmptyings(response: Response): Promise<WasteHandlersFileResult[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WasteHandlersFileResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WasteHandlersFileResult[]>(null as any);
    }
}

export class WasteManagementClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    /**
     * @deprecated
     */
    getMachines(): Promise<UnitMetadataDto[]> {
        let url_ = this.baseUrl + "/api/WasteManagement/GetMachines";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMachines(_response);
        });
    }

    protected processGetMachines(response: Response): Promise<UnitMetadataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitMetadataDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitMetadataDto[]>(null as any);
    }

    /**
     * @deprecated
     */
    getData(machineIds: number[]): Promise<UnitWasteManagementDto[]> {
        let url_ = this.baseUrl + "/api/WasteManagement/GetData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(machineIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetData(_response);
        });
    }

    protected processGetData(response: Response): Promise<UnitWasteManagementDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitWasteManagementDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitWasteManagementDto[]>(null as any);
    }
}

export class WasteManagementV2Client extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    getUnits(): Promise<UnitMetadataDtoV2[]> {
        let url_ = this.baseUrl + "/api/WasteManagementV2/GetUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUnits(_response);
        });
    }

    protected processGetUnits(response: Response): Promise<UnitMetadataDtoV2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitMetadataDtoV2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitMetadataDtoV2[]>(null as any);
    }

    getData(unitIds: number[]): Promise<UnitWasteManagementDtoV2[]> {
        let url_ = this.baseUrl + "/api/WasteManagementV2/GetData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(unitIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetData(_response);
        });
    }

    protected processGetData(response: Response): Promise<UnitWasteManagementDtoV2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitWasteManagementDtoV2.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnitWasteManagementDtoV2[]>(null as any);
    }
}

export class XtelUnitTrackerClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:56789";
    }

    createXtelUnitTracker(deviceId: number | undefined, trackerId: string | null | undefined, message: string | null | undefined): Promise<CreateXtelUnitTrackerDto> {
        let url_ = this.baseUrl + "/api/XtelUnitTracker/CreateXtelUnitTracker?";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (trackerId !== undefined && trackerId !== null)
            url_ += "trackerId=" + encodeURIComponent("" + trackerId) + "&";
        if (message !== undefined && message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateXtelUnitTracker(_response);
        });
    }

    protected processCreateXtelUnitTracker(response: Response): Promise<CreateXtelUnitTrackerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateXtelUnitTrackerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateXtelUnitTrackerDto>(null as any);
    }

    getXtelUnitTracker(serialNumber: string | null | undefined): Promise<GetXtelUnitTrackerDto> {
        let url_ = this.baseUrl + "/api/XtelUnitTracker/GetXtelUnitTracker?";
        if (serialNumber !== undefined && serialNumber !== null)
            url_ += "serialNumber=" + encodeURIComponent("" + serialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetXtelUnitTracker(_response);
        });
    }

    protected processGetXtelUnitTracker(response: Response): Promise<GetXtelUnitTrackerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetXtelUnitTrackerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetXtelUnitTrackerDto>(null as any);
    }

    getXtelUnitTrackers(): Promise<GetXtelUnitTrackerDto[]> {
        let url_ = this.baseUrl + "/api/XtelUnitTracker";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetXtelUnitTrackers(_response);
        });
    }

    protected processGetXtelUnitTrackers(response: Response): Promise<GetXtelUnitTrackerDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetXtelUnitTrackerDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetXtelUnitTrackerDto[]>(null as any);
    }

    updateXtelUnitTrackerId(deviceId: number | undefined, trackerId: string | null | undefined, message: string | null | undefined): Promise<CreateXtelUnitTrackerDto> {
        let url_ = this.baseUrl + "/api/XtelUnitTracker/UpdateXtelUnitTrackerId?";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (trackerId !== undefined && trackerId !== null)
            url_ += "trackerId=" + encodeURIComponent("" + trackerId) + "&";
        if (message !== undefined && message !== null)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateXtelUnitTrackerId(_response);
        });
    }

    protected processUpdateXtelUnitTrackerId(response: Response): Promise<CreateXtelUnitTrackerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateXtelUnitTrackerDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateXtelUnitTrackerDto>(null as any);
    }

    deleteXtelUnitTracker(deviceId: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/XtelUnitTracker/DeleteXtelUnitTracker?";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteXtelUnitTracker(_response);
        });
    }

    protected processDeleteXtelUnitTracker(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class DeviceIdWeightIdDto implements IDeviceIdWeightIdDto {
    serialNumber?: string | undefined;
    weightSerialNumber?: string | undefined;
    createdDate!: Date;

    constructor(data?: IDeviceIdWeightIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"];
            this.weightSerialNumber = _data["weightSerialNumber"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceIdWeightIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceIdWeightIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        data["weightSerialNumber"] = this.weightSerialNumber;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IDeviceIdWeightIdDto {
    serialNumber?: string | undefined;
    weightSerialNumber?: string | undefined;
    createdDate: Date;
}

export class BaleStorageDto implements IBaleStorageDto {
    baleStorageId!: number;
    unitIds?: number[] | undefined;
    storageSize!: number;
    calculateAutomatically?: boolean | undefined;
    balesOnSite!: number;

    constructor(data?: IBaleStorageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baleStorageId = _data["baleStorageId"];
            if (Array.isArray(_data["unitIds"])) {
                this.unitIds = [] as any;
                for (let item of _data["unitIds"])
                    this.unitIds!.push(item);
            }
            this.storageSize = _data["storageSize"];
            this.calculateAutomatically = _data["calculateAutomatically"];
            this.balesOnSite = _data["balesOnSite"];
        }
    }

    static fromJS(data: any): BaleStorageDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaleStorageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baleStorageId"] = this.baleStorageId;
        if (Array.isArray(this.unitIds)) {
            data["unitIds"] = [];
            for (let item of this.unitIds)
                data["unitIds"].push(item);
        }
        data["storageSize"] = this.storageSize;
        data["calculateAutomatically"] = this.calculateAutomatically;
        data["balesOnSite"] = this.balesOnSite;
        return data;
    }
}

export interface IBaleStorageDto {
    baleStorageId: number;
    unitIds?: number[] | undefined;
    storageSize: number;
    calculateAutomatically?: boolean | undefined;
    balesOnSite: number;
}

export enum ErrorIdBaler {
    DoorIsOpen = 0,
    Service = 1,
    DoorTamperCheck = 2,
    MotorThermo = 3,
    OilTemperature = 4,
    Safety = 5,
    Leakage = 6,
    PressureSensor = 7,
    TemperatureSensor = 8,
    K1K2FeedbackFail = 9,
    ButtonHanging = 10,
    CycleTiming = 11,
    MaxReturnPressureReached = 12,
    TopSwitchFail = 13,
    OtherSafetyRelatedError = 14,
    CycleStrokeError = 15,
    ADMotionFailure = 16,
    Motor2Thermo = 17,
    JE911SafetyChecks = 18,
    OutputFbError = 19,
    EncoderFailure = 20,
    JE911Estop = 21,
    ExternalInputFailure = 22,
    WireHasRunOut = 23,
    Error25 = 24,
    Error26 = 25,
    Error27 = 26,
    Error28 = 27,
    Error29 = 28,
    Error30 = 29,
    Error31 = 30,
    Error32 = 31,
}

export enum ErrorIdCompactor {
    STATUS_FSMP_ALL_OPERATION_BLOCKED = 0,
    STATUS_FSMP_START_BUTTON_BLOCKED = 1,
    STATUS_FSMP_RAM_OPERATION_BLOCKED = 2,
    STATUS_FSMP_ESTOP_PRESSED = 3,
    STATUS_FSMP_BEFREIUNG_PRESSED = 4,
    STATUS_FSMP_OIL_LEVEL_ERROR = 5,
    STATUS_FSMP_FEEDBACK_FAILURE = 6,
    STATUS_FSMP_PARAMS_UNSAFE = 7,
    STATUS_FSMP_BAD_DYN_ANALOG_SETUP = 8,
    STATUS_FSMP_MOTOR_THERMO_NOT_OK = 9,
    STATUS_FSMP_MORE_THAN_1_BTN_ACTIVE = 10,
    STATUS_FSMP_OIL_TEMPERATURE_ERROR = 11,
    STATUS_FSMP_GUILLOTINE_SENSOR_ERROR = 12,
    STATUS_FSMP_DOOR_OPEN_SW_ERROR = 13,
    STATUS_FSMP_DOOR_FULLY_OPEN_SW_ERROR = 14,
    STATUS_FSMP_DOOR_FULLY_OPEN_ERROR = 15,
    STATUS_FSMP_CONTAINER_NOT_PRESENT = 16,
    STATUS_FSMP_DOOR_FULLY_OPEN_SW_SETUP = 17,
    STATUS_FSMP_MACHINE_IS_FULL = 18,
    STATUS_FSMP_MACHINE_IS_OVERFULL = 19,
    STATUS_FSMP_FRONT_BLOCK_ERROR = 20,
    STATUS_FSMP_CLOSE_NON_CRITICAL_DOOR = 21,
    STATUS_FSMP_OIL_LEAKAGE_DETECTED = 22,
    STATUS_FSMP_PROP_FUNCTION_IS_ACTIVE = 23,
    STATUS_FSMP_DOOR_OPEN_SW_ACTIVE = 24,
    STATUS_FSMP_DOOR_FULLY_OPEN_SW_ACTIVE = 25,
    STATUS_FSMP_UNSAFE_STATE_ACTIVE = 26,
    STATUS_FSMP_TOP_GATE_IS_DOWN = 27,
    STATUS_FSMP_TOP_GATE_IS_UP = 28,
    STATUS_FSMP_TOP_GATE_IS_MOVING = 29,
    STATUS_FSMP_TIPPING_ARM_IS_DOWN = 30,
    STATUS_FSMP_TIPPING_ARM_IS_UP = 31,
    STATUS_FSMP_TIPPING_ARM_IS_MOVING = 32,
    STATUS_FSMP_BIN_IS_LOCKED = 33,
    STATUS_FSMP_BIN_LOCK_IS_MOVING = 34,
    STATUS_OSSD_TEST_FAILED = 35,
    STATUS_CPU2_FLASH_CRC_VALIDATION_FAILED = 36,
    STATUS_MACHINE_IS_ALMOST_FULL = 37,
    STATUS_POWER_RAIL_FAILURE = 38,
    STATUS_POWER_OFF_SIGNAL_FAILURE = 39,
    STATUS_CONTACTOR_FAILURE = 40,
    STATUS_TRAVEL_TIMES_ERROR = 41,
    STATUS_READY_FOR_BALEOUT = 42,
    STATUS_INDICATE_READY = 43,
    STATUS_INDICATE_FULL = 44,
    STATUS_INDICATE_2HAND = 45,
    STATUS_INDICATE_ERROR = 46,
    STATUS_SERVICE_MODE_ACTIVE = 47,
    STATUS_REBOOT_PENDING_CPU2 = 48,
    STATUS_ALWAYS_TRUE = 49,
    STATUS_OIL_TRANSDUCER_ERROR = 50,
    STATUS_TOO_FULL_TO_BALE_OUT = 51,
    STATUS_WAITING_FOR_RESET_AFTER_ESTOP = 52,
    STATUS_FILL_LEVEL_1_ACTIVE = 53,
    STATUS_FILL_LEVEL_2_ACTIVE = 54,
    STATUS_FILL_LEVEL_3_ACTIVE = 55,
    STATUS_SERVICE_IS_DUE = 56,
    STATUS_FRONT_BLOCK_REPAIR_CYCLE = 57,
    STATUS_PHASE_DETECT_OPERATION_BLOCKED = 58,
    STATUS_TANK_FILL_LEVEL_1_ACTIVE = 59,
    STATUS_TANK_FILL_LEVEL_2_ACTIVE = 60,
    STATUS_TANK_FILL_LEVEL_3_ACTIVE = 61,
    STATUS_TANK_IS_ALMOST_FULL = 62,
    STATUS_TANK_IS_FULL = 63,
    STATUS_MAX_VALVE_CURRENT_ERROR = 64,
    STATUS_RAM_IS_MOVING = 65,
    STATUS_BLOCK_OPERATION_HOURS_ACTIVE = 66,
    STATUS_AUTOSTART_AWAITING_MANUAL_START = 67,
    STATUS_READY_FOR_BALEOUT_RELEASE = 68,
    STATUS_BALEOUT_RELEASE_IS_RUNNING = 69,
    STATUS_GP_TIMER_OUTPUT_ACTIVE = 70,
    STATUS_BACK_SWITCH_INACTIVE_AT_BACK = 71,
    STATUS_BACK_SWITCH_ACTIVE_AT_FRONT = 72,
    STATUS_RUNNING_PRECOMPRESSION = 73,
    STATUS_GUILLOTINE_IS_UP = 74,
    STATUS_GUILLOTINE_IS_DOWN = 75,
    STATUS_BALEOUT_IS_RUNNING = 76,
    STATUS_MODE_2_ACTIVE = 77,
    STATUS_POST_PRESS_CYCLE = 78,
    STATUS_SHARK_LOADING_BIN_READY = 79,
    STATUS_SHARK_LOADING_BIN_MOVING = 80,
    STATUS_SHARK_LOADING_BIN_ALMOST_CLOSED = 81,
    STATUS_SHARK_LOADING_BIN_CLOSED = 82,
    STATUS_SHARK_LOADING_BIN_ERROR = 83,
    STATUS_SHARK_PRESSING_RAM_ERROR = 84,
    STATUS_SOFT_STARTER_AFTER_RUN_ACTIVE = 85,
    STATUS_SOFT_STARTER_COOLING_DOWN = 86,
    BACK_BLOCK_DETECT_ACTIVE = 87,
    BACK_BLOCK_DETECT_WARNING = 88,
    BACK_BLOCK_DETECT_ERROR = 89,
    MULTIPLE_ENABLE_CONTROLS_ACTIVE = 90,
    INPUT_TIMING_WARNING = 91,
    BALE_OUT_MAX_PRESSURE_REACHED = 92,
    INPUT_TIMING_ERROR = 93,
    CT_SCRAPE_ERROR = 94,
    CT_SCRAPE_ACTIVE = 95,
    CT_SCRAPE_AUTO_COMPLETED = 96,
    CT_GATE_OPENING = 97,
    CONTAINER_RETURNED = 98,
    ACCEPTED_BTN_CMD_1 = 99,
    ACCEPTED_BTN_CMD_2 = 100,
    ACCEPTED_BTN_CMD_3 = 101,
    ACCEPTED_BTN_CMD_4 = 102,
    ACCEPTED_BTN_CMD_5 = 103,
    ACCEPTED_BTN_CMD_6 = 104,
    ACCEPTED_BTN_CMD_7 = 105,
    TIPPING_ARM_UP_STOPPED_ON_MAX_PRESSURE = 106,
    SHARK_READY_FOR_AUTOMATIC_RUN = 107,
    MTS_MH_MEASUREMENT_AGE_ERROR = 108,
    AUGER_ERROR_START_INPUT_HANGING = 109,
    AUGER_ERROR_OVERLOAD = 110,
    AUGER_ERROR_NO_LOAD = 111,
    SHARK_HOLD2RUN_NO_LONGER_NEEDED = 112,
    PRESTO_AUGER_TEST_LUBRICATION_PENDING = 113,
    PRESTO_AUGER_LUBRICATION_ERROR = 114,
    PRESTO_AUGER_LUBRICATION_WARNING = 115,
    PRESTO_AUGER_FEEDER_MOTOR_PROTECT = 116,
    PRESTO_AUGER_FEEDER_ERROR_OVERLOAD = 117,
    Reserved118 = 118,
    Reserved119 = 119,
    FEEDING_RAM_IS_MOVING = 120,
    FEEDING_RAM_IS_AWAITING_RESET = 121,
    FEEDING_RAM_REACHED_MAX_PRESSURE = 122,
    AUGER_FEEDER_ERROR_NO_LOAD = 123,
    AUTOSTART_REACHED_MAX_CONTINUOUS_TIME = 124,
    DO_NOT_RUN_FOREVER_TIMER_EXPIRED = 125,
    MOTOR_ERROR = 126,
    BIN_LOCK_FULLY_RELEASED = 127,
    Reserved128 = 128,
    Reserved129 = 129,
    AUTO_CLOSE_TIME_LIMIT = 140,
    UNLOCK_TIME_LIMIT = 141,
    UNEXPECTED_BIN_ALMOST_CLOSED_SIGNAL = 142,
    UNEXPECTED_BIN_CLOSED_SIGNAL = 143,
    BIN_ALMOST_CLOSED_SIGNAL_MISSING = 144,
    BIN_ALMOST_CLOSED_SWITCH_HANGING = 145,
    BIN_CLOSED_SWITCH_HANGING = 146,
    MAX_PRESSURE_REACHED_RETURN = 160,
    MAX_PRESSURE_REACHED_PRESS = 161,
    END_POS_SW_ACTIVE_AT_TURNING_POINT = 162,
    WRONG_CYLINDER_TURNED_FIRST = 163,
    LEAD_CYL_TURNING_POINT_SW_ERROR = 164,
    TAIL_CYL_TURNING_POINT_SW_ERROR = 165,
    LEAD_CYL_TURN_SIGNAL_SETUP_ERROR = 166,
    TAIL_CYL_TURN_SIGNAL_SETUP_ERROR = 167,
    LEAD_CYL_DID_NOT_TURN_BEFORE_END_SW = 168,
    TAIL_CYL_DID_NOT_TURN_BEFORE_END_SW = 169,
}

export enum ErrorIdLink {
    MS_MACHINE_IS_ALMOST_FULL = 0,
    MS_MACHINE_IS_FULL = 1,
    MS_MACHINE_IS_OVERFULL = 2,
    MS_OIL_TEMPERATURE_HIGH_ERROR = 3,
    MS_CONTAINER_NOT_PRESENT = 4,
    MS_RAM_IS_MOVING = 5,
    MS_WATCHDOG_REBOOT_DETECTED = 6,
    MS_ESTOP_PRESSED = 7,
    MS_PARAMS_UNSAFE = 8,
    MS_SERVICE_IS_DUE = 9,
    MS_OIL_LEVEL_AND_TEMP_ERROR = 10,
    MS_MOTOR_PROTECTION_ERROR = 11,
    MS_START_BUTTON_IS_PRESSED = 12,
    MS_MACHINE_IS_READY = 13,
    MS_EXT_FULL_LAMP_ACTIVE = 14,
    MS_EXT_ALMOST_FULL_LAMP_ACTIVE = 15,
    MS_EXT_FILL_LEVEL_PRESSURE_SW_ACTIVE = 16,
    MS_MOTOR_IS_RUNNING = 17,
    MS_STOP_BUTTON_PRESSED = 18,
    MS_MODE_BUTTON_PRESSED = 19,
    MS_BARRIER_OPEN_INPUT_ACTIVE = 20,
    MS_MOTOR_THERMO_ERROR = 21,
    MS_DOOR_FULLY_OPEN_SW_ACTIVE = 22,
    MS_RAM_IS_BACK_SW_ACTIVE = 23,
    MS_OIL_LEVEL_LOW = 24,
    MS_ENABLE_CONTROL = 25,
    MS_NON_CRITICAL_DOOR_OPEN = 26,
    MS_BEFREIUNG_PUSHED = 27,
    MS_WIRE_RUN_OUT_INPUT_ACTIVE = 28,
    MS_NUMBER_OF_BALES_INPUT_ACTIVE = 29,
    MS_NUMBER_OF_PUSHES_INPUT_ACTIVE = 30,
    MS_MACHINE_FAULT_INPUT = 31,
    MS_CONTAINER_BEING_EMPTYING_INPUT_ACTIVE = 32,
    MS_CUSTOM_INPUT1_ACTIVE = 33,
    MS_CUSTOM_INPUT2_ACTIVE = 34,
    MS_CUSTOM_INPUT3_ACTIVE = 35,
    MS_CUSTOM_INPUT4_ACTIVE = 36,
    MS_CUSTOM_INPUT5_ACTIVE = 37,
    MS_CUSTOM_INPUT6_ACTIVE = 38,
    MS_CUSTOM_INPUT7_ACTIVE = 39,
    MS_CUSTOM_INPUT8_ACTIVE = 40,
}

export class DashboardBaseDto implements IDashboardBaseDto {
    dashboardBase?: DashboardBase | undefined;

    protected _discriminator: string;

    constructor(data?: IDashboardBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "DashboardBaseDto";
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardBase = _data["dashboardBase"] ? DashboardBase.fromJS(_data["dashboardBase"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DashboardBaseDto {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "ReportTileDto") {
            let result = new ReportTileDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "PortfolioTileDto") {
            let result = new PortfolioTileDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "KPIFillLevelTileDto") {
            let result = new KPIFillLevelTileDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "KPIServiceTileDto") {
            let result = new KPIServiceTileDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "UnitsPerUnitModelsTileDto") {
            let result = new UnitsPerUnitModelsTileDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FillLevelPerUnitModelsTileDto") {
            let result = new FillLevelPerUnitModelsTileDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ServiceContractTileDto") {
            let result = new ServiceContractTileDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "CriticalErrorsTileDto") {
            let result = new CriticalErrorsTileDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "RecordedPickUpsTileDto") {
            let result = new RecordedPickUpsTileDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "Last10BalesTileDto") {
            let result = new Last10BalesTileDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "LocationTileDto") {
            let result = new LocationTileDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "BalesProducedTileDto") {
            let result = new BalesProducedTileDto();
            result.init(data);
            return result;
        }
        let result = new DashboardBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["dashboardBase"] = this.dashboardBase ? this.dashboardBase.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDashboardBaseDto {
    dashboardBase?: DashboardBase | undefined;
}

export class ModelBase implements IModelBase {
    createdDate!: Date;
    updatedDate!: Date;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted!: boolean;

    constructor(data?: IModelBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.updatedBy = _data["updatedBy"];
            this.isDeleted = _data["isDeleted"];
        }
    }

    static fromJS(data: any): ModelBase {
        data = typeof data === 'object' ? data : {};
        let result = new ModelBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["updatedBy"] = this.updatedBy;
        data["isDeleted"] = this.isDeleted;
        return data;
    }
}

export interface IModelBase {
    createdDate: Date;
    updatedDate: Date;
    createdBy?: string | undefined;
    updatedBy?: string | undefined;
    isDeleted: boolean;
}

export class ModelBaseId extends ModelBase implements IModelBaseId {
    id!: number;

    constructor(data?: IModelBaseId) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
        }
    }

    static override fromJS(data: any): ModelBaseId {
        data = typeof data === 'object' ? data : {};
        let result = new ModelBaseId();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IModelBaseId extends IModelBase {
    id: number;
}

export class DashboardBase extends ModelBaseId implements IDashboardBase {
    userId?: string | undefined;
    type!: DashboardTileType;
    x_location!: number;
    y_location!: number;
    reportTileSettings?: DashboardReportTileSettings | undefined;
    staticMapTileSettings?: DashboardStaticMapTileSettings | undefined;

    constructor(data?: IDashboardBase) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"];
            this.type = _data["type"];
            this.x_location = _data["x_location"];
            this.y_location = _data["y_location"];
            this.reportTileSettings = _data["reportTileSettings"] ? DashboardReportTileSettings.fromJS(_data["reportTileSettings"]) : <any>undefined;
            this.staticMapTileSettings = _data["staticMapTileSettings"] ? DashboardStaticMapTileSettings.fromJS(_data["staticMapTileSettings"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): DashboardBase {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardBase();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["type"] = this.type;
        data["x_location"] = this.x_location;
        data["y_location"] = this.y_location;
        data["reportTileSettings"] = this.reportTileSettings ? this.reportTileSettings.toJSON() : <any>undefined;
        data["staticMapTileSettings"] = this.staticMapTileSettings ? this.staticMapTileSettings.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDashboardBase extends IModelBaseId {
    userId?: string | undefined;
    type: DashboardTileType;
    x_location: number;
    y_location: number;
    reportTileSettings?: DashboardReportTileSettings | undefined;
    staticMapTileSettings?: DashboardStaticMapTileSettings | undefined;
}

export enum DashboardTileType {
    Portfolio = 0,
    KPIFillLevel = 1,
    KPIService = 2,
    UnitsPerUnitModels = 3,
    FillLevelPerUnitModels = 4,
    ServiceContract = 5,
    CriticalErrors = 6,
    RecordedPickUps = 7,
    Last10Bales = 8,
    StaticMap = 9,
    EditableStaticMap = 10,
    ReportPrintout = 11,
    BalesProduced = 12,
}

export class DashboardReportTileSettings extends ModelBaseId implements IDashboardReportTileSettings {
    tileName!: string;
    filter?: FilterDto | undefined;
    dataType!: DataTypes;
    dateType!: DateTypes;
    dashboardBase?: DashboardBase | undefined;
    units?: Unit[] | undefined;

    constructor(data?: IDashboardReportTileSettings) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.tileName = _data["tileName"];
            this.filter = _data["filter"] ? FilterDto.fromJS(_data["filter"]) : <any>undefined;
            this.dataType = _data["dataType"];
            this.dateType = _data["dateType"];
            this.dashboardBase = _data["dashboardBase"] ? DashboardBase.fromJS(_data["dashboardBase"]) : <any>undefined;
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(Unit.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DashboardReportTileSettings {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardReportTileSettings();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tileName"] = this.tileName;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["dataType"] = this.dataType;
        data["dateType"] = this.dateType;
        data["dashboardBase"] = this.dashboardBase ? this.dashboardBase.toJSON() : <any>undefined;
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDashboardReportTileSettings extends IModelBaseId {
    tileName: string;
    filter?: FilterDto | undefined;
    dataType: DataTypes;
    dateType: DateTypes;
    dashboardBase?: DashboardBase | undefined;
    units?: Unit[] | undefined;
}

export class FilterDto implements IFilterDto {
    machineGroupsSelected?: string[] | undefined;
    machineIdsSelected?: string[] | undefined;
    machineTypesSelected?: string[] | undefined;
    postalCodeFrom?: string | undefined;
    postalCodeTo?: string | undefined;
    statusSelected?: string[] | undefined;
    fillLevelSelected?: number[] | undefined;
    wasteTypesSelected?: string[] | undefined;
    onlineStatusSelected?: string[] | undefined;
    groupIdSelected?: number | undefined;
    containerSizeSelected?: number[] | undefined;
    isFavourite?: boolean[] | undefined;

    constructor(data?: IFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["machineGroupsSelected"])) {
                this.machineGroupsSelected = [] as any;
                for (let item of _data["machineGroupsSelected"])
                    this.machineGroupsSelected!.push(item);
            }
            if (Array.isArray(_data["machineIdsSelected"])) {
                this.machineIdsSelected = [] as any;
                for (let item of _data["machineIdsSelected"])
                    this.machineIdsSelected!.push(item);
            }
            if (Array.isArray(_data["machineTypesSelected"])) {
                this.machineTypesSelected = [] as any;
                for (let item of _data["machineTypesSelected"])
                    this.machineTypesSelected!.push(item);
            }
            this.postalCodeFrom = _data["postalCodeFrom"];
            this.postalCodeTo = _data["postalCodeTo"];
            if (Array.isArray(_data["statusSelected"])) {
                this.statusSelected = [] as any;
                for (let item of _data["statusSelected"])
                    this.statusSelected!.push(item);
            }
            if (Array.isArray(_data["fillLevelSelected"])) {
                this.fillLevelSelected = [] as any;
                for (let item of _data["fillLevelSelected"])
                    this.fillLevelSelected!.push(item);
            }
            if (Array.isArray(_data["wasteTypesSelected"])) {
                this.wasteTypesSelected = [] as any;
                for (let item of _data["wasteTypesSelected"])
                    this.wasteTypesSelected!.push(item);
            }
            if (Array.isArray(_data["onlineStatusSelected"])) {
                this.onlineStatusSelected = [] as any;
                for (let item of _data["onlineStatusSelected"])
                    this.onlineStatusSelected!.push(item);
            }
            this.groupIdSelected = _data["groupIdSelected"];
            if (Array.isArray(_data["containerSizeSelected"])) {
                this.containerSizeSelected = [] as any;
                for (let item of _data["containerSizeSelected"])
                    this.containerSizeSelected!.push(item);
            }
            if (Array.isArray(_data["isFavourite"])) {
                this.isFavourite = [] as any;
                for (let item of _data["isFavourite"])
                    this.isFavourite!.push(item);
            }
        }
    }

    static fromJS(data: any): FilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.machineGroupsSelected)) {
            data["machineGroupsSelected"] = [];
            for (let item of this.machineGroupsSelected)
                data["machineGroupsSelected"].push(item);
        }
        if (Array.isArray(this.machineIdsSelected)) {
            data["machineIdsSelected"] = [];
            for (let item of this.machineIdsSelected)
                data["machineIdsSelected"].push(item);
        }
        if (Array.isArray(this.machineTypesSelected)) {
            data["machineTypesSelected"] = [];
            for (let item of this.machineTypesSelected)
                data["machineTypesSelected"].push(item);
        }
        data["postalCodeFrom"] = this.postalCodeFrom;
        data["postalCodeTo"] = this.postalCodeTo;
        if (Array.isArray(this.statusSelected)) {
            data["statusSelected"] = [];
            for (let item of this.statusSelected)
                data["statusSelected"].push(item);
        }
        if (Array.isArray(this.fillLevelSelected)) {
            data["fillLevelSelected"] = [];
            for (let item of this.fillLevelSelected)
                data["fillLevelSelected"].push(item);
        }
        if (Array.isArray(this.wasteTypesSelected)) {
            data["wasteTypesSelected"] = [];
            for (let item of this.wasteTypesSelected)
                data["wasteTypesSelected"].push(item);
        }
        if (Array.isArray(this.onlineStatusSelected)) {
            data["onlineStatusSelected"] = [];
            for (let item of this.onlineStatusSelected)
                data["onlineStatusSelected"].push(item);
        }
        data["groupIdSelected"] = this.groupIdSelected;
        if (Array.isArray(this.containerSizeSelected)) {
            data["containerSizeSelected"] = [];
            for (let item of this.containerSizeSelected)
                data["containerSizeSelected"].push(item);
        }
        if (Array.isArray(this.isFavourite)) {
            data["isFavourite"] = [];
            for (let item of this.isFavourite)
                data["isFavourite"].push(item);
        }
        return data;
    }
}

export interface IFilterDto {
    machineGroupsSelected?: string[] | undefined;
    machineIdsSelected?: string[] | undefined;
    machineTypesSelected?: string[] | undefined;
    postalCodeFrom?: string | undefined;
    postalCodeTo?: string | undefined;
    statusSelected?: string[] | undefined;
    fillLevelSelected?: number[] | undefined;
    wasteTypesSelected?: string[] | undefined;
    onlineStatusSelected?: string[] | undefined;
    groupIdSelected?: number | undefined;
    containerSizeSelected?: number[] | undefined;
    isFavourite?: boolean[] | undefined;
}

export enum DataTypes {
    BaleOutput = 0,
    NoEmptyings = 1,
    FillRate = 2,
}

export enum DateTypes {
    Week = 0,
    Month = 1,
    Year = 2,
    Day = 3,
    All = 4,
}

export class Unit extends ModelBaseId implements IUnit {
    serialNumber?: string | undefined;
    controller?: string | undefined;
    containerSize?: number | undefined;
    unitModelId!: number;
    groupId!: number;
    baleStorageId?: number | undefined;
    unitTrackerId?: string | undefined;
    unitServiceContractTypeId?: number | undefined;
    unitOwnershipId?: number | undefined;
    unitWasteTypeId?: number | undefined;
    wasteHandlerId?: number | undefined;
    unitPickupSystemId?: number | undefined;
    unitModel?: UnitModel | undefined;
    group?: Group | undefined;
    unitPickupSystem?: UnitPickupSystem | undefined;
    baleStorage?: BaleStorage | undefined;
    unitState?: UnitState | undefined;
    unitMetadata?: UnitMetadata | undefined;
    unitServiceContractType?: UnitServiceContractType | undefined;
    unitOwnership?: UnitOwnership | undefined;
    unitWasteType?: UnitWasteType | undefined;
    wasteHandler?: WasteHandler | undefined;
    wasteHandlersUnit?: WasteHandlersUnit | undefined;
    notificationCustomXtelMessage?: NotificationCustomXtelMessage | undefined;
    telemetryLast30Days?: TelemetryLast30Days | undefined;
    xtelUnitTrackers?: XtelUnitTracker[] | undefined;
    unitTrackers?: UnitTracker[] | undefined;
    unitWeights?: UnitWeight[] | undefined;
    unitDocuments?: UnitDocument[] | undefined;
    notificationDefinitionUnits?: NotificationDefinitionUnit[] | undefined;
    baleStorageHistories?: BaleStorageHistory[] | undefined;
    wasteHandlerEmptyings?: WasteHandlersEmptying[] | undefined;
    favoriteUnits?: FavoriteUnit[] | undefined;
    notificationCustomMessages?: NotificationCustomMessage[] | undefined;
    dashboardStaticMapTileSettings?: DashboardStaticMapTileSettings[] | undefined;
    dashboardReportTileSettings?: DashboardReportTileSettings[] | undefined;
    telemetryAggregates?: TelemetryAggregates[] | undefined;
    telemetryAggregatesDailies?: TelemetryAggregatesDaily[] | undefined;
    predictionGroupings?: PredictionGrouping[] | undefined;

    constructor(data?: IUnit) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.serialNumber = _data["serialNumber"];
            this.controller = _data["controller"];
            this.containerSize = _data["containerSize"];
            this.unitModelId = _data["unitModelId"];
            this.groupId = _data["groupId"];
            this.baleStorageId = _data["baleStorageId"];
            this.unitTrackerId = _data["unitTrackerId"];
            this.unitServiceContractTypeId = _data["unitServiceContractTypeId"];
            this.unitOwnershipId = _data["unitOwnershipId"];
            this.unitWasteTypeId = _data["unitWasteTypeId"];
            this.wasteHandlerId = _data["wasteHandlerId"];
            this.unitPickupSystemId = _data["unitPickupSystemId"];
            this.unitModel = _data["unitModel"] ? UnitModel.fromJS(_data["unitModel"]) : <any>undefined;
            this.group = _data["group"] ? Group.fromJS(_data["group"]) : <any>undefined;
            this.unitPickupSystem = _data["unitPickupSystem"] ? UnitPickupSystem.fromJS(_data["unitPickupSystem"]) : <any>undefined;
            this.baleStorage = _data["baleStorage"] ? BaleStorage.fromJS(_data["baleStorage"]) : <any>undefined;
            this.unitState = _data["unitState"] ? UnitState.fromJS(_data["unitState"]) : <any>undefined;
            this.unitMetadata = _data["unitMetadata"] ? UnitMetadata.fromJS(_data["unitMetadata"]) : <any>undefined;
            this.unitServiceContractType = _data["unitServiceContractType"] ? UnitServiceContractType.fromJS(_data["unitServiceContractType"]) : <any>undefined;
            this.unitOwnership = _data["unitOwnership"] ? UnitOwnership.fromJS(_data["unitOwnership"]) : <any>undefined;
            this.unitWasteType = _data["unitWasteType"] ? UnitWasteType.fromJS(_data["unitWasteType"]) : <any>undefined;
            this.wasteHandler = _data["wasteHandler"] ? WasteHandler.fromJS(_data["wasteHandler"]) : <any>undefined;
            this.wasteHandlersUnit = _data["wasteHandlersUnit"] ? WasteHandlersUnit.fromJS(_data["wasteHandlersUnit"]) : <any>undefined;
            this.notificationCustomXtelMessage = _data["notificationCustomXtelMessage"] ? NotificationCustomXtelMessage.fromJS(_data["notificationCustomXtelMessage"]) : <any>undefined;
            this.telemetryLast30Days = _data["telemetryLast30Days"] ? TelemetryLast30Days.fromJS(_data["telemetryLast30Days"]) : <any>undefined;
            if (Array.isArray(_data["xtelUnitTrackers"])) {
                this.xtelUnitTrackers = [] as any;
                for (let item of _data["xtelUnitTrackers"])
                    this.xtelUnitTrackers!.push(XtelUnitTracker.fromJS(item));
            }
            if (Array.isArray(_data["unitTrackers"])) {
                this.unitTrackers = [] as any;
                for (let item of _data["unitTrackers"])
                    this.unitTrackers!.push(UnitTracker.fromJS(item));
            }
            if (Array.isArray(_data["unitWeights"])) {
                this.unitWeights = [] as any;
                for (let item of _data["unitWeights"])
                    this.unitWeights!.push(UnitWeight.fromJS(item));
            }
            if (Array.isArray(_data["unitDocuments"])) {
                this.unitDocuments = [] as any;
                for (let item of _data["unitDocuments"])
                    this.unitDocuments!.push(UnitDocument.fromJS(item));
            }
            if (Array.isArray(_data["notificationDefinitionUnits"])) {
                this.notificationDefinitionUnits = [] as any;
                for (let item of _data["notificationDefinitionUnits"])
                    this.notificationDefinitionUnits!.push(NotificationDefinitionUnit.fromJS(item));
            }
            if (Array.isArray(_data["baleStorageHistories"])) {
                this.baleStorageHistories = [] as any;
                for (let item of _data["baleStorageHistories"])
                    this.baleStorageHistories!.push(BaleStorageHistory.fromJS(item));
            }
            if (Array.isArray(_data["wasteHandlerEmptyings"])) {
                this.wasteHandlerEmptyings = [] as any;
                for (let item of _data["wasteHandlerEmptyings"])
                    this.wasteHandlerEmptyings!.push(WasteHandlersEmptying.fromJS(item));
            }
            if (Array.isArray(_data["favoriteUnits"])) {
                this.favoriteUnits = [] as any;
                for (let item of _data["favoriteUnits"])
                    this.favoriteUnits!.push(FavoriteUnit.fromJS(item));
            }
            if (Array.isArray(_data["notificationCustomMessages"])) {
                this.notificationCustomMessages = [] as any;
                for (let item of _data["notificationCustomMessages"])
                    this.notificationCustomMessages!.push(NotificationCustomMessage.fromJS(item));
            }
            if (Array.isArray(_data["dashboardStaticMapTileSettings"])) {
                this.dashboardStaticMapTileSettings = [] as any;
                for (let item of _data["dashboardStaticMapTileSettings"])
                    this.dashboardStaticMapTileSettings!.push(DashboardStaticMapTileSettings.fromJS(item));
            }
            if (Array.isArray(_data["dashboardReportTileSettings"])) {
                this.dashboardReportTileSettings = [] as any;
                for (let item of _data["dashboardReportTileSettings"])
                    this.dashboardReportTileSettings!.push(DashboardReportTileSettings.fromJS(item));
            }
            if (Array.isArray(_data["telemetryAggregates"])) {
                this.telemetryAggregates = [] as any;
                for (let item of _data["telemetryAggregates"])
                    this.telemetryAggregates!.push(TelemetryAggregates.fromJS(item));
            }
            if (Array.isArray(_data["telemetryAggregatesDailies"])) {
                this.telemetryAggregatesDailies = [] as any;
                for (let item of _data["telemetryAggregatesDailies"])
                    this.telemetryAggregatesDailies!.push(TelemetryAggregatesDaily.fromJS(item));
            }
            if (Array.isArray(_data["predictionGroupings"])) {
                this.predictionGroupings = [] as any;
                for (let item of _data["predictionGroupings"])
                    this.predictionGroupings!.push(PredictionGrouping.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Unit {
        data = typeof data === 'object' ? data : {};
        let result = new Unit();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        data["controller"] = this.controller;
        data["containerSize"] = this.containerSize;
        data["unitModelId"] = this.unitModelId;
        data["groupId"] = this.groupId;
        data["baleStorageId"] = this.baleStorageId;
        data["unitTrackerId"] = this.unitTrackerId;
        data["unitServiceContractTypeId"] = this.unitServiceContractTypeId;
        data["unitOwnershipId"] = this.unitOwnershipId;
        data["unitWasteTypeId"] = this.unitWasteTypeId;
        data["wasteHandlerId"] = this.wasteHandlerId;
        data["unitPickupSystemId"] = this.unitPickupSystemId;
        data["unitModel"] = this.unitModel ? this.unitModel.toJSON() : <any>undefined;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["unitPickupSystem"] = this.unitPickupSystem ? this.unitPickupSystem.toJSON() : <any>undefined;
        data["baleStorage"] = this.baleStorage ? this.baleStorage.toJSON() : <any>undefined;
        data["unitState"] = this.unitState ? this.unitState.toJSON() : <any>undefined;
        data["unitMetadata"] = this.unitMetadata ? this.unitMetadata.toJSON() : <any>undefined;
        data["unitServiceContractType"] = this.unitServiceContractType ? this.unitServiceContractType.toJSON() : <any>undefined;
        data["unitOwnership"] = this.unitOwnership ? this.unitOwnership.toJSON() : <any>undefined;
        data["unitWasteType"] = this.unitWasteType ? this.unitWasteType.toJSON() : <any>undefined;
        data["wasteHandler"] = this.wasteHandler ? this.wasteHandler.toJSON() : <any>undefined;
        data["wasteHandlersUnit"] = this.wasteHandlersUnit ? this.wasteHandlersUnit.toJSON() : <any>undefined;
        data["notificationCustomXtelMessage"] = this.notificationCustomXtelMessage ? this.notificationCustomXtelMessage.toJSON() : <any>undefined;
        data["telemetryLast30Days"] = this.telemetryLast30Days ? this.telemetryLast30Days.toJSON() : <any>undefined;
        if (Array.isArray(this.xtelUnitTrackers)) {
            data["xtelUnitTrackers"] = [];
            for (let item of this.xtelUnitTrackers)
                data["xtelUnitTrackers"].push(item.toJSON());
        }
        if (Array.isArray(this.unitTrackers)) {
            data["unitTrackers"] = [];
            for (let item of this.unitTrackers)
                data["unitTrackers"].push(item.toJSON());
        }
        if (Array.isArray(this.unitWeights)) {
            data["unitWeights"] = [];
            for (let item of this.unitWeights)
                data["unitWeights"].push(item.toJSON());
        }
        if (Array.isArray(this.unitDocuments)) {
            data["unitDocuments"] = [];
            for (let item of this.unitDocuments)
                data["unitDocuments"].push(item.toJSON());
        }
        if (Array.isArray(this.notificationDefinitionUnits)) {
            data["notificationDefinitionUnits"] = [];
            for (let item of this.notificationDefinitionUnits)
                data["notificationDefinitionUnits"].push(item.toJSON());
        }
        if (Array.isArray(this.baleStorageHistories)) {
            data["baleStorageHistories"] = [];
            for (let item of this.baleStorageHistories)
                data["baleStorageHistories"].push(item.toJSON());
        }
        if (Array.isArray(this.wasteHandlerEmptyings)) {
            data["wasteHandlerEmptyings"] = [];
            for (let item of this.wasteHandlerEmptyings)
                data["wasteHandlerEmptyings"].push(item.toJSON());
        }
        if (Array.isArray(this.favoriteUnits)) {
            data["favoriteUnits"] = [];
            for (let item of this.favoriteUnits)
                data["favoriteUnits"].push(item.toJSON());
        }
        if (Array.isArray(this.notificationCustomMessages)) {
            data["notificationCustomMessages"] = [];
            for (let item of this.notificationCustomMessages)
                data["notificationCustomMessages"].push(item.toJSON());
        }
        if (Array.isArray(this.dashboardStaticMapTileSettings)) {
            data["dashboardStaticMapTileSettings"] = [];
            for (let item of this.dashboardStaticMapTileSettings)
                data["dashboardStaticMapTileSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.dashboardReportTileSettings)) {
            data["dashboardReportTileSettings"] = [];
            for (let item of this.dashboardReportTileSettings)
                data["dashboardReportTileSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.telemetryAggregates)) {
            data["telemetryAggregates"] = [];
            for (let item of this.telemetryAggregates)
                data["telemetryAggregates"].push(item.toJSON());
        }
        if (Array.isArray(this.telemetryAggregatesDailies)) {
            data["telemetryAggregatesDailies"] = [];
            for (let item of this.telemetryAggregatesDailies)
                data["telemetryAggregatesDailies"].push(item.toJSON());
        }
        if (Array.isArray(this.predictionGroupings)) {
            data["predictionGroupings"] = [];
            for (let item of this.predictionGroupings)
                data["predictionGroupings"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUnit extends IModelBaseId {
    serialNumber?: string | undefined;
    controller?: string | undefined;
    containerSize?: number | undefined;
    unitModelId: number;
    groupId: number;
    baleStorageId?: number | undefined;
    unitTrackerId?: string | undefined;
    unitServiceContractTypeId?: number | undefined;
    unitOwnershipId?: number | undefined;
    unitWasteTypeId?: number | undefined;
    wasteHandlerId?: number | undefined;
    unitPickupSystemId?: number | undefined;
    unitModel?: UnitModel | undefined;
    group?: Group | undefined;
    unitPickupSystem?: UnitPickupSystem | undefined;
    baleStorage?: BaleStorage | undefined;
    unitState?: UnitState | undefined;
    unitMetadata?: UnitMetadata | undefined;
    unitServiceContractType?: UnitServiceContractType | undefined;
    unitOwnership?: UnitOwnership | undefined;
    unitWasteType?: UnitWasteType | undefined;
    wasteHandler?: WasteHandler | undefined;
    wasteHandlersUnit?: WasteHandlersUnit | undefined;
    notificationCustomXtelMessage?: NotificationCustomXtelMessage | undefined;
    telemetryLast30Days?: TelemetryLast30Days | undefined;
    xtelUnitTrackers?: XtelUnitTracker[] | undefined;
    unitTrackers?: UnitTracker[] | undefined;
    unitWeights?: UnitWeight[] | undefined;
    unitDocuments?: UnitDocument[] | undefined;
    notificationDefinitionUnits?: NotificationDefinitionUnit[] | undefined;
    baleStorageHistories?: BaleStorageHistory[] | undefined;
    wasteHandlerEmptyings?: WasteHandlersEmptying[] | undefined;
    favoriteUnits?: FavoriteUnit[] | undefined;
    notificationCustomMessages?: NotificationCustomMessage[] | undefined;
    dashboardStaticMapTileSettings?: DashboardStaticMapTileSettings[] | undefined;
    dashboardReportTileSettings?: DashboardReportTileSettings[] | undefined;
    telemetryAggregates?: TelemetryAggregates[] | undefined;
    telemetryAggregatesDailies?: TelemetryAggregatesDaily[] | undefined;
    predictionGroupings?: PredictionGrouping[] | undefined;
}

export class UnitModel extends ModelBaseId implements IUnitModel {
    name?: string | undefined;
    isUserSelectable!: boolean;
    unitTypeId?: number | undefined;
    unitManufacturerId?: number | undefined;
    unitModelCodeId?: number | undefined;
    unitType?: UnitType | undefined;
    unitManufacturer?: UnitManufacturer | undefined;
    unitModelCode?: UnitModelCode | undefined;
    unitImages?: UnitImage[] | undefined;
    units?: Unit[] | undefined;
    containerDetails?: ContainerDetail[] | undefined;
    serviceVideos?: ServiceVideo[] | undefined;

    constructor(data?: IUnitModel) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.isUserSelectable = _data["isUserSelectable"];
            this.unitTypeId = _data["unitTypeId"];
            this.unitManufacturerId = _data["unitManufacturerId"];
            this.unitModelCodeId = _data["unitModelCodeId"];
            this.unitType = _data["unitType"] ? UnitType.fromJS(_data["unitType"]) : <any>undefined;
            this.unitManufacturer = _data["unitManufacturer"] ? UnitManufacturer.fromJS(_data["unitManufacturer"]) : <any>undefined;
            this.unitModelCode = _data["unitModelCode"] ? UnitModelCode.fromJS(_data["unitModelCode"]) : <any>undefined;
            if (Array.isArray(_data["unitImages"])) {
                this.unitImages = [] as any;
                for (let item of _data["unitImages"])
                    this.unitImages!.push(UnitImage.fromJS(item));
            }
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(Unit.fromJS(item));
            }
            if (Array.isArray(_data["containerDetails"])) {
                this.containerDetails = [] as any;
                for (let item of _data["containerDetails"])
                    this.containerDetails!.push(ContainerDetail.fromJS(item));
            }
            if (Array.isArray(_data["serviceVideos"])) {
                this.serviceVideos = [] as any;
                for (let item of _data["serviceVideos"])
                    this.serviceVideos!.push(ServiceVideo.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): UnitModel {
        data = typeof data === 'object' ? data : {};
        let result = new UnitModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isUserSelectable"] = this.isUserSelectable;
        data["unitTypeId"] = this.unitTypeId;
        data["unitManufacturerId"] = this.unitManufacturerId;
        data["unitModelCodeId"] = this.unitModelCodeId;
        data["unitType"] = this.unitType ? this.unitType.toJSON() : <any>undefined;
        data["unitManufacturer"] = this.unitManufacturer ? this.unitManufacturer.toJSON() : <any>undefined;
        data["unitModelCode"] = this.unitModelCode ? this.unitModelCode.toJSON() : <any>undefined;
        if (Array.isArray(this.unitImages)) {
            data["unitImages"] = [];
            for (let item of this.unitImages)
                data["unitImages"].push(item.toJSON());
        }
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        if (Array.isArray(this.containerDetails)) {
            data["containerDetails"] = [];
            for (let item of this.containerDetails)
                data["containerDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.serviceVideos)) {
            data["serviceVideos"] = [];
            for (let item of this.serviceVideos)
                data["serviceVideos"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUnitModel extends IModelBaseId {
    name?: string | undefined;
    isUserSelectable: boolean;
    unitTypeId?: number | undefined;
    unitManufacturerId?: number | undefined;
    unitModelCodeId?: number | undefined;
    unitType?: UnitType | undefined;
    unitManufacturer?: UnitManufacturer | undefined;
    unitModelCode?: UnitModelCode | undefined;
    unitImages?: UnitImage[] | undefined;
    units?: Unit[] | undefined;
    containerDetails?: ContainerDetail[] | undefined;
    serviceVideos?: ServiceVideo[] | undefined;
}

export class UnitType extends ModelBaseId implements IUnitType {
    nameTranslationKey?: string | undefined;
    unitModels?: UnitModel[] | undefined;

    constructor(data?: IUnitType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nameTranslationKey = _data["nameTranslationKey"];
            if (Array.isArray(_data["unitModels"])) {
                this.unitModels = [] as any;
                for (let item of _data["unitModels"])
                    this.unitModels!.push(UnitModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): UnitType {
        data = typeof data === 'object' ? data : {};
        let result = new UnitType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameTranslationKey"] = this.nameTranslationKey;
        if (Array.isArray(this.unitModels)) {
            data["unitModels"] = [];
            for (let item of this.unitModels)
                data["unitModels"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUnitType extends IModelBaseId {
    nameTranslationKey?: string | undefined;
    unitModels?: UnitModel[] | undefined;
}

export class UnitManufacturer extends ModelBaseId implements IUnitManufacturer {
    name?: string | undefined;
    unitModels?: UnitModel[] | undefined;

    constructor(data?: IUnitManufacturer) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["unitModels"])) {
                this.unitModels = [] as any;
                for (let item of _data["unitModels"])
                    this.unitModels!.push(UnitModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): UnitManufacturer {
        data = typeof data === 'object' ? data : {};
        let result = new UnitManufacturer();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.unitModels)) {
            data["unitModels"] = [];
            for (let item of this.unitModels)
                data["unitModels"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUnitManufacturer extends IModelBaseId {
    name?: string | undefined;
    unitModels?: UnitModel[] | undefined;
}

export class UnitModelCode extends ModelBaseId implements IUnitModelCode {
    name?: string | undefined;
    unitModels?: UnitModel[] | undefined;

    constructor(data?: IUnitModelCode) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["unitModels"])) {
                this.unitModels = [] as any;
                for (let item of _data["unitModels"])
                    this.unitModels!.push(UnitModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): UnitModelCode {
        data = typeof data === 'object' ? data : {};
        let result = new UnitModelCode();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.unitModels)) {
            data["unitModels"] = [];
            for (let item of this.unitModels)
                data["unitModels"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUnitModelCode extends IModelBaseId {
    name?: string | undefined;
    unitModels?: UnitModel[] | undefined;
}

export class UnitImage extends ModelBaseId implements IUnitImage {
    imageName?: string | undefined;
    version!: number;
    unitModelId!: number;
    unitModel?: UnitModel | undefined;

    constructor(data?: IUnitImage) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.imageName = _data["imageName"];
            this.version = _data["version"];
            this.unitModelId = _data["unitModelId"];
            this.unitModel = _data["unitModel"] ? UnitModel.fromJS(_data["unitModel"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): UnitImage {
        data = typeof data === 'object' ? data : {};
        let result = new UnitImage();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageName"] = this.imageName;
        data["version"] = this.version;
        data["unitModelId"] = this.unitModelId;
        data["unitModel"] = this.unitModel ? this.unitModel.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUnitImage extends IModelBaseId {
    imageName?: string | undefined;
    version: number;
    unitModelId: number;
    unitModel?: UnitModel | undefined;
}

export class ContainerDetail extends ModelBaseId implements IContainerDetail {
    containerSize!: number;
    unitModels?: UnitModel[] | undefined;

    constructor(data?: IContainerDetail) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.containerSize = _data["containerSize"];
            if (Array.isArray(_data["unitModels"])) {
                this.unitModels = [] as any;
                for (let item of _data["unitModels"])
                    this.unitModels!.push(UnitModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ContainerDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerDetail();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["containerSize"] = this.containerSize;
        if (Array.isArray(this.unitModels)) {
            data["unitModels"] = [];
            for (let item of this.unitModels)
                data["unitModels"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IContainerDetail extends IModelBaseId {
    containerSize: number;
    unitModels?: UnitModel[] | undefined;
}

export class ServiceVideo extends ModelBaseId implements IServiceVideo {
    title?: string | undefined;
    vimeoVideoId?: string | undefined;
    unitModels?: UnitModel[] | undefined;

    constructor(data?: IServiceVideo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["title"];
            this.vimeoVideoId = _data["vimeoVideoId"];
            if (Array.isArray(_data["unitModels"])) {
                this.unitModels = [] as any;
                for (let item of _data["unitModels"])
                    this.unitModels!.push(UnitModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ServiceVideo {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceVideo();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["vimeoVideoId"] = this.vimeoVideoId;
        if (Array.isArray(this.unitModels)) {
            data["unitModels"] = [];
            for (let item of this.unitModels)
                data["unitModels"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IServiceVideo extends IModelBaseId {
    title?: string | undefined;
    vimeoVideoId?: string | undefined;
    unitModels?: UnitModel[] | undefined;
}

export class Group extends ModelBaseId implements IGroup {
    groupName?: string | undefined;
    debtorNumber?: string | undefined;
    countryCode?: string | undefined;
    isDistributor!: boolean;
    parentGroupId?: number | undefined;
    parentGroup?: Group | undefined;
    childGroups?: Group[] | undefined;
    units?: Unit[] | undefined;
    userGroupPermissions?: UserGroupPermission[] | undefined;
    groupPermissionTVF?: GroupPermissionTVF[] | undefined;
    debtor?: Debtor | undefined;
    wasteManager?: WasteManager | undefined;

    constructor(data?: IGroup) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.groupName = _data["groupName"];
            this.debtorNumber = _data["debtorNumber"];
            this.countryCode = _data["countryCode"];
            this.isDistributor = _data["isDistributor"];
            this.parentGroupId = _data["parentGroupId"];
            this.parentGroup = _data["parentGroup"] ? Group.fromJS(_data["parentGroup"]) : <any>undefined;
            if (Array.isArray(_data["childGroups"])) {
                this.childGroups = [] as any;
                for (let item of _data["childGroups"])
                    this.childGroups!.push(Group.fromJS(item));
            }
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(Unit.fromJS(item));
            }
            if (Array.isArray(_data["userGroupPermissions"])) {
                this.userGroupPermissions = [] as any;
                for (let item of _data["userGroupPermissions"])
                    this.userGroupPermissions!.push(UserGroupPermission.fromJS(item));
            }
            if (Array.isArray(_data["groupPermissionTVF"])) {
                this.groupPermissionTVF = [] as any;
                for (let item of _data["groupPermissionTVF"])
                    this.groupPermissionTVF!.push(GroupPermissionTVF.fromJS(item));
            }
            this.debtor = _data["debtor"] ? Debtor.fromJS(_data["debtor"]) : <any>undefined;
            this.wasteManager = _data["wasteManager"] ? WasteManager.fromJS(_data["wasteManager"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): Group {
        data = typeof data === 'object' ? data : {};
        let result = new Group();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        data["debtorNumber"] = this.debtorNumber;
        data["countryCode"] = this.countryCode;
        data["isDistributor"] = this.isDistributor;
        data["parentGroupId"] = this.parentGroupId;
        data["parentGroup"] = this.parentGroup ? this.parentGroup.toJSON() : <any>undefined;
        if (Array.isArray(this.childGroups)) {
            data["childGroups"] = [];
            for (let item of this.childGroups)
                data["childGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        if (Array.isArray(this.userGroupPermissions)) {
            data["userGroupPermissions"] = [];
            for (let item of this.userGroupPermissions)
                data["userGroupPermissions"].push(item.toJSON());
        }
        if (Array.isArray(this.groupPermissionTVF)) {
            data["groupPermissionTVF"] = [];
            for (let item of this.groupPermissionTVF)
                data["groupPermissionTVF"].push(item.toJSON());
        }
        data["debtor"] = this.debtor ? this.debtor.toJSON() : <any>undefined;
        data["wasteManager"] = this.wasteManager ? this.wasteManager.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IGroup extends IModelBaseId {
    groupName?: string | undefined;
    debtorNumber?: string | undefined;
    countryCode?: string | undefined;
    isDistributor: boolean;
    parentGroupId?: number | undefined;
    parentGroup?: Group | undefined;
    childGroups?: Group[] | undefined;
    units?: Unit[] | undefined;
    userGroupPermissions?: UserGroupPermission[] | undefined;
    groupPermissionTVF?: GroupPermissionTVF[] | undefined;
    debtor?: Debtor | undefined;
    wasteManager?: WasteManager | undefined;
}

export class UserGroupPermission extends ModelBaseId implements IUserGroupPermission {
    groupId!: number;
    userId?: string | undefined;
    roleType!: RolesType;
    isServiceTechnician!: boolean;
    isServiceToolCode!: boolean;
    isServiceTool!: boolean;
    isPartnerArea!: boolean;
    isAssemblyLine!: boolean;
    group?: Group | undefined;

    constructor(data?: IUserGroupPermission) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.groupId = _data["groupId"];
            this.userId = _data["userId"];
            this.roleType = _data["roleType"];
            this.isServiceTechnician = _data["isServiceTechnician"];
            this.isServiceToolCode = _data["isServiceToolCode"];
            this.isServiceTool = _data["isServiceTool"];
            this.isPartnerArea = _data["isPartnerArea"];
            this.isAssemblyLine = _data["isAssemblyLine"];
            this.group = _data["group"] ? Group.fromJS(_data["group"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): UserGroupPermission {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupPermission();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["userId"] = this.userId;
        data["roleType"] = this.roleType;
        data["isServiceTechnician"] = this.isServiceTechnician;
        data["isServiceToolCode"] = this.isServiceToolCode;
        data["isServiceTool"] = this.isServiceTool;
        data["isPartnerArea"] = this.isPartnerArea;
        data["isAssemblyLine"] = this.isAssemblyLine;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUserGroupPermission extends IModelBaseId {
    groupId: number;
    userId?: string | undefined;
    roleType: RolesType;
    isServiceTechnician: boolean;
    isServiceToolCode: boolean;
    isServiceTool: boolean;
    isPartnerArea: boolean;
    isAssemblyLine: boolean;
    group?: Group | undefined;
}

export enum RolesType {
    SuperAdmin = 0,
    CountryAdmin = 5,
    Admin = 10,
    BasicUser = 20,
    AppUser = 30,
    NonRegisteredAppUser = 40,
    NoUnits = 50,
    DataOutOfRange = 99,
}

export class GroupPermissionTVF implements IGroupPermissionTVF {
    group?: Group | undefined;
    groupId!: number;
    groupName?: string | undefined;
    parentGroupId?: number | undefined;
    debtorNumber?: string | undefined;
    countryCode?: string | undefined;
    isDistributor!: boolean;
    userId?: string | undefined;
    roleType!: RolesType;
    isServiceToolCode!: boolean;
    isServiceTool!: boolean;
    isServiceTechnician!: boolean;
    isAssemblyLine!: boolean;
    level!: number;
    rank?: number | undefined;

    constructor(data?: IGroupPermissionTVF) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.group = _data["group"] ? Group.fromJS(_data["group"]) : <any>undefined;
            this.groupId = _data["groupId"];
            this.groupName = _data["groupName"];
            this.parentGroupId = _data["parentGroupId"];
            this.debtorNumber = _data["debtorNumber"];
            this.countryCode = _data["countryCode"];
            this.isDistributor = _data["isDistributor"];
            this.userId = _data["userId"];
            this.roleType = _data["roleType"];
            this.isServiceToolCode = _data["isServiceToolCode"];
            this.isServiceTool = _data["isServiceTool"];
            this.isServiceTechnician = _data["isServiceTechnician"];
            this.isAssemblyLine = _data["isAssemblyLine"];
            this.level = _data["level"];
            this.rank = _data["rank"];
        }
    }

    static fromJS(data: any): GroupPermissionTVF {
        data = typeof data === 'object' ? data : {};
        let result = new GroupPermissionTVF();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        data["groupId"] = this.groupId;
        data["groupName"] = this.groupName;
        data["parentGroupId"] = this.parentGroupId;
        data["debtorNumber"] = this.debtorNumber;
        data["countryCode"] = this.countryCode;
        data["isDistributor"] = this.isDistributor;
        data["userId"] = this.userId;
        data["roleType"] = this.roleType;
        data["isServiceToolCode"] = this.isServiceToolCode;
        data["isServiceTool"] = this.isServiceTool;
        data["isServiceTechnician"] = this.isServiceTechnician;
        data["isAssemblyLine"] = this.isAssemblyLine;
        data["level"] = this.level;
        data["rank"] = this.rank;
        return data;
    }
}

export interface IGroupPermissionTVF {
    group?: Group | undefined;
    groupId: number;
    groupName?: string | undefined;
    parentGroupId?: number | undefined;
    debtorNumber?: string | undefined;
    countryCode?: string | undefined;
    isDistributor: boolean;
    userId?: string | undefined;
    roleType: RolesType;
    isServiceToolCode: boolean;
    isServiceTool: boolean;
    isServiceTechnician: boolean;
    isAssemblyLine: boolean;
    level: number;
    rank?: number | undefined;
}

export class Debtor extends ModelBaseId implements IDebtor {
    imageFileName?: string | undefined;
    website?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    phoneNumberSales?: string | undefined;
    orderServiceLink?: string | undefined;
    orderStrappingLink?: string | undefined;
    groupId!: number;
    group?: Group | undefined;

    constructor(data?: IDebtor) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.imageFileName = _data["imageFileName"];
            this.website = _data["website"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.phoneNumberSales = _data["phoneNumberSales"];
            this.orderServiceLink = _data["orderServiceLink"];
            this.orderStrappingLink = _data["orderStrappingLink"];
            this.groupId = _data["groupId"];
            this.group = _data["group"] ? Group.fromJS(_data["group"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): Debtor {
        data = typeof data === 'object' ? data : {};
        let result = new Debtor();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageFileName"] = this.imageFileName;
        data["website"] = this.website;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["phoneNumberSales"] = this.phoneNumberSales;
        data["orderServiceLink"] = this.orderServiceLink;
        data["orderStrappingLink"] = this.orderStrappingLink;
        data["groupId"] = this.groupId;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDebtor extends IModelBaseId {
    imageFileName?: string | undefined;
    website?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    phoneNumberSales?: string | undefined;
    orderServiceLink?: string | undefined;
    orderStrappingLink?: string | undefined;
    groupId: number;
    group?: Group | undefined;
}

export class WasteManager extends ModelBaseId implements IWasteManager {
    groupId!: number;
    wasteManagerName?: string | undefined;
    group?: Group | undefined;

    constructor(data?: IWasteManager) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.groupId = _data["groupId"];
            this.wasteManagerName = _data["wasteManagerName"];
            this.group = _data["group"] ? Group.fromJS(_data["group"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): WasteManager {
        data = typeof data === 'object' ? data : {};
        let result = new WasteManager();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["wasteManagerName"] = this.wasteManagerName;
        data["group"] = this.group ? this.group.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IWasteManager extends IModelBaseId {
    groupId: number;
    wasteManagerName?: string | undefined;
    group?: Group | undefined;
}

export class UnitPickupSystem extends ModelBaseId implements IUnitPickupSystem {
    nameTranslationKey?: string | undefined;

    constructor(data?: IUnitPickupSystem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nameTranslationKey = _data["nameTranslationKey"];
        }
    }

    static override fromJS(data: any): UnitPickupSystem {
        data = typeof data === 'object' ? data : {};
        let result = new UnitPickupSystem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameTranslationKey"] = this.nameTranslationKey;
        super.toJSON(data);
        return data;
    }
}

export interface IUnitPickupSystem extends IModelBaseId {
    nameTranslationKey?: string | undefined;
}

export class BaleStorage extends ModelBaseId implements IBaleStorage {
    storageSize!: number;
    baleCountAtLastPickup!: number;
    calculateAutomatically!: boolean;
    currentBaleCount!: number;
    linkedBalerCount!: number;
    units?: Unit[] | undefined;
    baleStorageHistory?: BaleStorageHistory[] | undefined;

    constructor(data?: IBaleStorage) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.storageSize = _data["storageSize"];
            this.baleCountAtLastPickup = _data["baleCountAtLastPickup"];
            this.calculateAutomatically = _data["calculateAutomatically"];
            this.currentBaleCount = _data["currentBaleCount"];
            this.linkedBalerCount = _data["linkedBalerCount"];
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(Unit.fromJS(item));
            }
            if (Array.isArray(_data["baleStorageHistory"])) {
                this.baleStorageHistory = [] as any;
                for (let item of _data["baleStorageHistory"])
                    this.baleStorageHistory!.push(BaleStorageHistory.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): BaleStorage {
        data = typeof data === 'object' ? data : {};
        let result = new BaleStorage();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storageSize"] = this.storageSize;
        data["baleCountAtLastPickup"] = this.baleCountAtLastPickup;
        data["calculateAutomatically"] = this.calculateAutomatically;
        data["currentBaleCount"] = this.currentBaleCount;
        data["linkedBalerCount"] = this.linkedBalerCount;
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        if (Array.isArray(this.baleStorageHistory)) {
            data["baleStorageHistory"] = [];
            for (let item of this.baleStorageHistory)
                data["baleStorageHistory"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IBaleStorage extends IModelBaseId {
    storageSize: number;
    baleCountAtLastPickup: number;
    calculateAutomatically: boolean;
    currentBaleCount: number;
    linkedBalerCount: number;
    units?: Unit[] | undefined;
    baleStorageHistory?: BaleStorageHistory[] | undefined;
}

export class BaleStorageHistory extends ModelBaseId implements IBaleStorageHistory {
    storageSize!: number;
    baleCount!: number;
    calculateAutomatically!: boolean;
    baleStorageId!: number;
    baleStorage?: BaleStorage | undefined;
    units?: Unit[] | undefined;

    constructor(data?: IBaleStorageHistory) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.storageSize = _data["storageSize"];
            this.baleCount = _data["baleCount"];
            this.calculateAutomatically = _data["calculateAutomatically"];
            this.baleStorageId = _data["baleStorageId"];
            this.baleStorage = _data["baleStorage"] ? BaleStorage.fromJS(_data["baleStorage"]) : <any>undefined;
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(Unit.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): BaleStorageHistory {
        data = typeof data === 'object' ? data : {};
        let result = new BaleStorageHistory();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storageSize"] = this.storageSize;
        data["baleCount"] = this.baleCount;
        data["calculateAutomatically"] = this.calculateAutomatically;
        data["baleStorageId"] = this.baleStorageId;
        data["baleStorage"] = this.baleStorage ? this.baleStorage.toJSON() : <any>undefined;
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IBaleStorageHistory extends IModelBaseId {
    storageSize: number;
    baleCount: number;
    calculateAutomatically: boolean;
    baleStorageId: number;
    baleStorage?: BaleStorage | undefined;
    units?: Unit[] | undefined;
}

export class UnitState extends ModelBaseId implements IUnitState {
    lastestChange?: Date | undefined;
    isOnline!: boolean;
    isOnlineDate?: Date | undefined;
    pressCycles!: number;
    pressCyclesDate?: Date | undefined;
    pressSeries!: number;
    pressSeriesDate?: Date | undefined;
    pressSeriesSinceLastOutput!: number;
    pressSeriesSinceLastOutputDate?: Date | undefined;
    pressCyclesSinceEmpty!: number;
    pressCyclesSinceEmptyDate?: Date | undefined;
    deviceId?: string | undefined;
    deviceIdDate?: Date | undefined;
    signalQuality!: number;
    signalQualityDate?: Date | undefined;
    firmware?: number | undefined;
    firmwareDate?: Date | undefined;
    emptyCounter!: number;
    emptyCounterDate?: Date | undefined;
    motorRunSec!: number;
    motorRunSecDate?: Date | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    latLngDate?: Date | undefined;
    fillLevel?: number | undefined;
    fillLevelDate?: Date | undefined;
    predictedFullDate?: Date | undefined;
    dateOfPrediction?: Date | undefined;
    modem?: string | undefined;
    modemFirmwareVersion?: string | undefined;
    unit?: Unit | undefined;
    unitId!: number;
    unitStateActiveErrors?: UnitStateActiveError[] | undefined;
    unitCustomInputFuncs?: UnitCustomInputFunc | undefined;
    getUnitBaleCounter?: UnitBaleCounter | undefined;

    constructor(data?: IUnitState) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lastestChange = _data["lastestChange"] ? new Date(_data["lastestChange"].toString()) : <any>undefined;
            this.isOnline = _data["isOnline"];
            this.isOnlineDate = _data["isOnlineDate"] ? new Date(_data["isOnlineDate"].toString()) : <any>undefined;
            this.pressCycles = _data["pressCycles"];
            this.pressCyclesDate = _data["pressCyclesDate"] ? new Date(_data["pressCyclesDate"].toString()) : <any>undefined;
            this.pressSeries = _data["pressSeries"];
            this.pressSeriesDate = _data["pressSeriesDate"] ? new Date(_data["pressSeriesDate"].toString()) : <any>undefined;
            this.pressSeriesSinceLastOutput = _data["pressSeriesSinceLastOutput"];
            this.pressSeriesSinceLastOutputDate = _data["pressSeriesSinceLastOutputDate"] ? new Date(_data["pressSeriesSinceLastOutputDate"].toString()) : <any>undefined;
            this.pressCyclesSinceEmpty = _data["pressCyclesSinceEmpty"];
            this.pressCyclesSinceEmptyDate = _data["pressCyclesSinceEmptyDate"] ? new Date(_data["pressCyclesSinceEmptyDate"].toString()) : <any>undefined;
            this.deviceId = _data["deviceId"];
            this.deviceIdDate = _data["deviceIdDate"] ? new Date(_data["deviceIdDate"].toString()) : <any>undefined;
            this.signalQuality = _data["signalQuality"];
            this.signalQualityDate = _data["signalQualityDate"] ? new Date(_data["signalQualityDate"].toString()) : <any>undefined;
            this.firmware = _data["firmware"];
            this.firmwareDate = _data["firmwareDate"] ? new Date(_data["firmwareDate"].toString()) : <any>undefined;
            this.emptyCounter = _data["emptyCounter"];
            this.emptyCounterDate = _data["emptyCounterDate"] ? new Date(_data["emptyCounterDate"].toString()) : <any>undefined;
            this.motorRunSec = _data["motorRunSec"];
            this.motorRunSecDate = _data["motorRunSecDate"] ? new Date(_data["motorRunSecDate"].toString()) : <any>undefined;
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.latLngDate = _data["latLngDate"] ? new Date(_data["latLngDate"].toString()) : <any>undefined;
            this.fillLevel = _data["fillLevel"];
            this.fillLevelDate = _data["fillLevelDate"] ? new Date(_data["fillLevelDate"].toString()) : <any>undefined;
            this.predictedFullDate = _data["predictedFullDate"] ? new Date(_data["predictedFullDate"].toString()) : <any>undefined;
            this.dateOfPrediction = _data["dateOfPrediction"] ? new Date(_data["dateOfPrediction"].toString()) : <any>undefined;
            this.modem = _data["modem"];
            this.modemFirmwareVersion = _data["modemFirmwareVersion"];
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : <any>undefined;
            this.unitId = _data["unitId"];
            if (Array.isArray(_data["unitStateActiveErrors"])) {
                this.unitStateActiveErrors = [] as any;
                for (let item of _data["unitStateActiveErrors"])
                    this.unitStateActiveErrors!.push(UnitStateActiveError.fromJS(item));
            }
            this.unitCustomInputFuncs = _data["unitCustomInputFuncs"] ? UnitCustomInputFunc.fromJS(_data["unitCustomInputFuncs"]) : <any>undefined;
            this.getUnitBaleCounter = _data["getUnitBaleCounter"] ? UnitBaleCounter.fromJS(_data["getUnitBaleCounter"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): UnitState {
        data = typeof data === 'object' ? data : {};
        let result = new UnitState();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastestChange"] = this.lastestChange ? this.lastestChange.toISOString() : <any>undefined;
        data["isOnline"] = this.isOnline;
        data["isOnlineDate"] = this.isOnlineDate ? this.isOnlineDate.toISOString() : <any>undefined;
        data["pressCycles"] = this.pressCycles;
        data["pressCyclesDate"] = this.pressCyclesDate ? this.pressCyclesDate.toISOString() : <any>undefined;
        data["pressSeries"] = this.pressSeries;
        data["pressSeriesDate"] = this.pressSeriesDate ? this.pressSeriesDate.toISOString() : <any>undefined;
        data["pressSeriesSinceLastOutput"] = this.pressSeriesSinceLastOutput;
        data["pressSeriesSinceLastOutputDate"] = this.pressSeriesSinceLastOutputDate ? this.pressSeriesSinceLastOutputDate.toISOString() : <any>undefined;
        data["pressCyclesSinceEmpty"] = this.pressCyclesSinceEmpty;
        data["pressCyclesSinceEmptyDate"] = this.pressCyclesSinceEmptyDate ? this.pressCyclesSinceEmptyDate.toISOString() : <any>undefined;
        data["deviceId"] = this.deviceId;
        data["deviceIdDate"] = this.deviceIdDate ? this.deviceIdDate.toISOString() : <any>undefined;
        data["signalQuality"] = this.signalQuality;
        data["signalQualityDate"] = this.signalQualityDate ? this.signalQualityDate.toISOString() : <any>undefined;
        data["firmware"] = this.firmware;
        data["firmwareDate"] = this.firmwareDate ? this.firmwareDate.toISOString() : <any>undefined;
        data["emptyCounter"] = this.emptyCounter;
        data["emptyCounterDate"] = this.emptyCounterDate ? this.emptyCounterDate.toISOString() : <any>undefined;
        data["motorRunSec"] = this.motorRunSec;
        data["motorRunSecDate"] = this.motorRunSecDate ? this.motorRunSecDate.toISOString() : <any>undefined;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["latLngDate"] = this.latLngDate ? this.latLngDate.toISOString() : <any>undefined;
        data["fillLevel"] = this.fillLevel;
        data["fillLevelDate"] = this.fillLevelDate ? this.fillLevelDate.toISOString() : <any>undefined;
        data["predictedFullDate"] = this.predictedFullDate ? this.predictedFullDate.toISOString() : <any>undefined;
        data["dateOfPrediction"] = this.dateOfPrediction ? this.dateOfPrediction.toISOString() : <any>undefined;
        data["modem"] = this.modem;
        data["modemFirmwareVersion"] = this.modemFirmwareVersion;
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        data["unitId"] = this.unitId;
        if (Array.isArray(this.unitStateActiveErrors)) {
            data["unitStateActiveErrors"] = [];
            for (let item of this.unitStateActiveErrors)
                data["unitStateActiveErrors"].push(item.toJSON());
        }
        data["unitCustomInputFuncs"] = this.unitCustomInputFuncs ? this.unitCustomInputFuncs.toJSON() : <any>undefined;
        data["getUnitBaleCounter"] = this.getUnitBaleCounter ? this.getUnitBaleCounter.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUnitState extends IModelBaseId {
    lastestChange?: Date | undefined;
    isOnline: boolean;
    isOnlineDate?: Date | undefined;
    pressCycles: number;
    pressCyclesDate?: Date | undefined;
    pressSeries: number;
    pressSeriesDate?: Date | undefined;
    pressSeriesSinceLastOutput: number;
    pressSeriesSinceLastOutputDate?: Date | undefined;
    pressCyclesSinceEmpty: number;
    pressCyclesSinceEmptyDate?: Date | undefined;
    deviceId?: string | undefined;
    deviceIdDate?: Date | undefined;
    signalQuality: number;
    signalQualityDate?: Date | undefined;
    firmware?: number | undefined;
    firmwareDate?: Date | undefined;
    emptyCounter: number;
    emptyCounterDate?: Date | undefined;
    motorRunSec: number;
    motorRunSecDate?: Date | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    latLngDate?: Date | undefined;
    fillLevel?: number | undefined;
    fillLevelDate?: Date | undefined;
    predictedFullDate?: Date | undefined;
    dateOfPrediction?: Date | undefined;
    modem?: string | undefined;
    modemFirmwareVersion?: string | undefined;
    unit?: Unit | undefined;
    unitId: number;
    unitStateActiveErrors?: UnitStateActiveError[] | undefined;
    unitCustomInputFuncs?: UnitCustomInputFunc | undefined;
    getUnitBaleCounter?: UnitBaleCounter | undefined;
}

export class UnitStateActiveError extends ModelBaseId implements IUnitStateActiveError {
    errorId?: number | undefined;
    severity?: StatusSeverity | undefined;
    readableError?: string | undefined;
    timestamp!: Date;
    unitState?: UnitState | undefined;
    unitStateId!: number;

    constructor(data?: IUnitStateActiveError) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.errorId = _data["errorId"];
            this.severity = _data["severity"];
            this.readableError = _data["readableError"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.unitState = _data["unitState"] ? UnitState.fromJS(_data["unitState"]) : <any>undefined;
            this.unitStateId = _data["unitStateId"];
        }
    }

    static override fromJS(data: any): UnitStateActiveError {
        data = typeof data === 'object' ? data : {};
        let result = new UnitStateActiveError();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorId"] = this.errorId;
        data["severity"] = this.severity;
        data["readableError"] = this.readableError;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["unitState"] = this.unitState ? this.unitState.toJSON() : <any>undefined;
        data["unitStateId"] = this.unitStateId;
        super.toJSON(data);
        return data;
    }
}

export interface IUnitStateActiveError extends IModelBaseId {
    errorId?: number | undefined;
    severity?: StatusSeverity | undefined;
    readableError?: string | undefined;
    timestamp: Date;
    unitState?: UnitState | undefined;
    unitStateId: number;
}

export enum StatusSeverity {
    Error = 0,
    Warning = 1,
    Message = 2,
}

export class UnitCustomInputFunc extends ModelBaseId implements IUnitCustomInputFunc {
    customInputFuncCounter1?: number | undefined;
    customInputFuncCounter2?: number | undefined;
    customInputFuncCounter3?: number | undefined;
    customInputFuncCounter4?: number | undefined;
    customInputFuncCounter5?: number | undefined;
    customInputFuncCounter6?: number | undefined;
    customInputFuncCounter7?: number | undefined;
    customInputFuncCounter8?: number | undefined;
    customInputFuncCounter9?: number | undefined;
    customInputFuncCounter10?: number | undefined;
    customInputFuncCounter11?: number | undefined;
    customInputFuncCounter12?: number | undefined;
    customInputFuncCounter13?: number | undefined;
    customInputFuncCounter14?: number | undefined;
    customInputFuncCounter15?: number | undefined;
    customInputFuncCounter16?: number | undefined;
    customInputFuncIndex1?: number | undefined;
    customInputFuncIndex2?: number | undefined;
    customInputFuncIndex3?: number | undefined;
    customInputFuncIndex4?: number | undefined;
    customInputFuncIndex5?: number | undefined;
    customInputFuncIndex6?: number | undefined;
    customInputFuncIndex7?: number | undefined;
    customInputFuncIndex8?: number | undefined;
    customInputFuncIndex9?: number | undefined;
    customInputFuncIndex10?: number | undefined;
    customInputFuncIndex11?: number | undefined;
    customInputFuncIndex12?: number | undefined;
    customInputFuncIndex13?: number | undefined;
    customInputFuncIndex14?: number | undefined;
    customInputFuncIndex15?: number | undefined;
    customInputFuncIndex16?: number | undefined;
    unitState?: UnitState | undefined;
    unitStateId!: number;

    constructor(data?: IUnitCustomInputFunc) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customInputFuncCounter1 = _data["customInputFuncCounter1"];
            this.customInputFuncCounter2 = _data["customInputFuncCounter2"];
            this.customInputFuncCounter3 = _data["customInputFuncCounter3"];
            this.customInputFuncCounter4 = _data["customInputFuncCounter4"];
            this.customInputFuncCounter5 = _data["customInputFuncCounter5"];
            this.customInputFuncCounter6 = _data["customInputFuncCounter6"];
            this.customInputFuncCounter7 = _data["customInputFuncCounter7"];
            this.customInputFuncCounter8 = _data["customInputFuncCounter8"];
            this.customInputFuncCounter9 = _data["customInputFuncCounter9"];
            this.customInputFuncCounter10 = _data["customInputFuncCounter10"];
            this.customInputFuncCounter11 = _data["customInputFuncCounter11"];
            this.customInputFuncCounter12 = _data["customInputFuncCounter12"];
            this.customInputFuncCounter13 = _data["customInputFuncCounter13"];
            this.customInputFuncCounter14 = _data["customInputFuncCounter14"];
            this.customInputFuncCounter15 = _data["customInputFuncCounter15"];
            this.customInputFuncCounter16 = _data["customInputFuncCounter16"];
            this.customInputFuncIndex1 = _data["customInputFuncIndex1"];
            this.customInputFuncIndex2 = _data["customInputFuncIndex2"];
            this.customInputFuncIndex3 = _data["customInputFuncIndex3"];
            this.customInputFuncIndex4 = _data["customInputFuncIndex4"];
            this.customInputFuncIndex5 = _data["customInputFuncIndex5"];
            this.customInputFuncIndex6 = _data["customInputFuncIndex6"];
            this.customInputFuncIndex7 = _data["customInputFuncIndex7"];
            this.customInputFuncIndex8 = _data["customInputFuncIndex8"];
            this.customInputFuncIndex9 = _data["customInputFuncIndex9"];
            this.customInputFuncIndex10 = _data["customInputFuncIndex10"];
            this.customInputFuncIndex11 = _data["customInputFuncIndex11"];
            this.customInputFuncIndex12 = _data["customInputFuncIndex12"];
            this.customInputFuncIndex13 = _data["customInputFuncIndex13"];
            this.customInputFuncIndex14 = _data["customInputFuncIndex14"];
            this.customInputFuncIndex15 = _data["customInputFuncIndex15"];
            this.customInputFuncIndex16 = _data["customInputFuncIndex16"];
            this.unitState = _data["unitState"] ? UnitState.fromJS(_data["unitState"]) : <any>undefined;
            this.unitStateId = _data["unitStateId"];
        }
    }

    static override fromJS(data: any): UnitCustomInputFunc {
        data = typeof data === 'object' ? data : {};
        let result = new UnitCustomInputFunc();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customInputFuncCounter1"] = this.customInputFuncCounter1;
        data["customInputFuncCounter2"] = this.customInputFuncCounter2;
        data["customInputFuncCounter3"] = this.customInputFuncCounter3;
        data["customInputFuncCounter4"] = this.customInputFuncCounter4;
        data["customInputFuncCounter5"] = this.customInputFuncCounter5;
        data["customInputFuncCounter6"] = this.customInputFuncCounter6;
        data["customInputFuncCounter7"] = this.customInputFuncCounter7;
        data["customInputFuncCounter8"] = this.customInputFuncCounter8;
        data["customInputFuncCounter9"] = this.customInputFuncCounter9;
        data["customInputFuncCounter10"] = this.customInputFuncCounter10;
        data["customInputFuncCounter11"] = this.customInputFuncCounter11;
        data["customInputFuncCounter12"] = this.customInputFuncCounter12;
        data["customInputFuncCounter13"] = this.customInputFuncCounter13;
        data["customInputFuncCounter14"] = this.customInputFuncCounter14;
        data["customInputFuncCounter15"] = this.customInputFuncCounter15;
        data["customInputFuncCounter16"] = this.customInputFuncCounter16;
        data["customInputFuncIndex1"] = this.customInputFuncIndex1;
        data["customInputFuncIndex2"] = this.customInputFuncIndex2;
        data["customInputFuncIndex3"] = this.customInputFuncIndex3;
        data["customInputFuncIndex4"] = this.customInputFuncIndex4;
        data["customInputFuncIndex5"] = this.customInputFuncIndex5;
        data["customInputFuncIndex6"] = this.customInputFuncIndex6;
        data["customInputFuncIndex7"] = this.customInputFuncIndex7;
        data["customInputFuncIndex8"] = this.customInputFuncIndex8;
        data["customInputFuncIndex9"] = this.customInputFuncIndex9;
        data["customInputFuncIndex10"] = this.customInputFuncIndex10;
        data["customInputFuncIndex11"] = this.customInputFuncIndex11;
        data["customInputFuncIndex12"] = this.customInputFuncIndex12;
        data["customInputFuncIndex13"] = this.customInputFuncIndex13;
        data["customInputFuncIndex14"] = this.customInputFuncIndex14;
        data["customInputFuncIndex15"] = this.customInputFuncIndex15;
        data["customInputFuncIndex16"] = this.customInputFuncIndex16;
        data["unitState"] = this.unitState ? this.unitState.toJSON() : <any>undefined;
        data["unitStateId"] = this.unitStateId;
        super.toJSON(data);
        return data;
    }
}

export interface IUnitCustomInputFunc extends IModelBaseId {
    customInputFuncCounter1?: number | undefined;
    customInputFuncCounter2?: number | undefined;
    customInputFuncCounter3?: number | undefined;
    customInputFuncCounter4?: number | undefined;
    customInputFuncCounter5?: number | undefined;
    customInputFuncCounter6?: number | undefined;
    customInputFuncCounter7?: number | undefined;
    customInputFuncCounter8?: number | undefined;
    customInputFuncCounter9?: number | undefined;
    customInputFuncCounter10?: number | undefined;
    customInputFuncCounter11?: number | undefined;
    customInputFuncCounter12?: number | undefined;
    customInputFuncCounter13?: number | undefined;
    customInputFuncCounter14?: number | undefined;
    customInputFuncCounter15?: number | undefined;
    customInputFuncCounter16?: number | undefined;
    customInputFuncIndex1?: number | undefined;
    customInputFuncIndex2?: number | undefined;
    customInputFuncIndex3?: number | undefined;
    customInputFuncIndex4?: number | undefined;
    customInputFuncIndex5?: number | undefined;
    customInputFuncIndex6?: number | undefined;
    customInputFuncIndex7?: number | undefined;
    customInputFuncIndex8?: number | undefined;
    customInputFuncIndex9?: number | undefined;
    customInputFuncIndex10?: number | undefined;
    customInputFuncIndex11?: number | undefined;
    customInputFuncIndex12?: number | undefined;
    customInputFuncIndex13?: number | undefined;
    customInputFuncIndex14?: number | undefined;
    customInputFuncIndex15?: number | undefined;
    customInputFuncIndex16?: number | undefined;
    unitState?: UnitState | undefined;
    unitStateId: number;
}

export class UnitBaleCounter extends ModelBaseId implements IUnitBaleCounter {
    baleFinishedCounter?: number | undefined;
    baleAlmostFinishedCounter?: number | undefined;
    unitState?: UnitState | undefined;
    unitStateId!: number;

    constructor(data?: IUnitBaleCounter) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.baleFinishedCounter = _data["baleFinishedCounter"];
            this.baleAlmostFinishedCounter = _data["baleAlmostFinishedCounter"];
            this.unitState = _data["unitState"] ? UnitState.fromJS(_data["unitState"]) : <any>undefined;
            this.unitStateId = _data["unitStateId"];
        }
    }

    static override fromJS(data: any): UnitBaleCounter {
        data = typeof data === 'object' ? data : {};
        let result = new UnitBaleCounter();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baleFinishedCounter"] = this.baleFinishedCounter;
        data["baleAlmostFinishedCounter"] = this.baleAlmostFinishedCounter;
        data["unitState"] = this.unitState ? this.unitState.toJSON() : <any>undefined;
        data["unitStateId"] = this.unitStateId;
        super.toJSON(data);
        return data;
    }
}

export interface IUnitBaleCounter extends IModelBaseId {
    baleFinishedCounter?: number | undefined;
    baleAlmostFinishedCounter?: number | undefined;
    unitState?: UnitState | undefined;
    unitStateId: number;
}

export class UnitMetadata extends ModelBaseId implements IUnitMetadata {
    homeLatitude?: string | undefined;
    homeLongitude?: string | undefined;
    siteUser?: string | undefined;
    siteAddress?: string | undefined;
    sitePostalCode?: string | undefined;
    siteCity?: string | undefined;
    siteDescription?: string | undefined;
    installationDate?: Date | undefined;
    lastService?: Date | undefined;
    nextService?: Date | undefined;
    warrantyExpires?: Date | undefined;
    comment?: string | undefined;
    internalComment?: string | undefined;
    pricePerEmptying?: number | undefined;
    pricePerEmptyingCurrency?: string | undefined;
    devicePhoneNo?: string | undefined;
    collector?: string | undefined;
    customerUnitId?: string | undefined;
    unitId!: number;
    unit?: Unit | undefined;

    constructor(data?: IUnitMetadata) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.homeLatitude = _data["homeLatitude"];
            this.homeLongitude = _data["homeLongitude"];
            this.siteUser = _data["siteUser"];
            this.siteAddress = _data["siteAddress"];
            this.sitePostalCode = _data["sitePostalCode"];
            this.siteCity = _data["siteCity"];
            this.siteDescription = _data["siteDescription"];
            this.installationDate = _data["installationDate"] ? new Date(_data["installationDate"].toString()) : <any>undefined;
            this.lastService = _data["lastService"] ? new Date(_data["lastService"].toString()) : <any>undefined;
            this.nextService = _data["nextService"] ? new Date(_data["nextService"].toString()) : <any>undefined;
            this.warrantyExpires = _data["warrantyExpires"] ? new Date(_data["warrantyExpires"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.internalComment = _data["internalComment"];
            this.pricePerEmptying = _data["pricePerEmptying"];
            this.pricePerEmptyingCurrency = _data["pricePerEmptyingCurrency"];
            this.devicePhoneNo = _data["devicePhoneNo"];
            this.collector = _data["collector"];
            this.customerUnitId = _data["customerUnitId"];
            this.unitId = _data["unitId"];
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): UnitMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new UnitMetadata();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["homeLatitude"] = this.homeLatitude;
        data["homeLongitude"] = this.homeLongitude;
        data["siteUser"] = this.siteUser;
        data["siteAddress"] = this.siteAddress;
        data["sitePostalCode"] = this.sitePostalCode;
        data["siteCity"] = this.siteCity;
        data["siteDescription"] = this.siteDescription;
        data["installationDate"] = this.installationDate ? this.installationDate.toISOString() : <any>undefined;
        data["lastService"] = this.lastService ? this.lastService.toISOString() : <any>undefined;
        data["nextService"] = this.nextService ? this.nextService.toISOString() : <any>undefined;
        data["warrantyExpires"] = this.warrantyExpires ? this.warrantyExpires.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["internalComment"] = this.internalComment;
        data["pricePerEmptying"] = this.pricePerEmptying;
        data["pricePerEmptyingCurrency"] = this.pricePerEmptyingCurrency;
        data["devicePhoneNo"] = this.devicePhoneNo;
        data["collector"] = this.collector;
        data["customerUnitId"] = this.customerUnitId;
        data["unitId"] = this.unitId;
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUnitMetadata extends IModelBaseId {
    homeLatitude?: string | undefined;
    homeLongitude?: string | undefined;
    siteUser?: string | undefined;
    siteAddress?: string | undefined;
    sitePostalCode?: string | undefined;
    siteCity?: string | undefined;
    siteDescription?: string | undefined;
    installationDate?: Date | undefined;
    lastService?: Date | undefined;
    nextService?: Date | undefined;
    warrantyExpires?: Date | undefined;
    comment?: string | undefined;
    internalComment?: string | undefined;
    pricePerEmptying?: number | undefined;
    pricePerEmptyingCurrency?: string | undefined;
    devicePhoneNo?: string | undefined;
    collector?: string | undefined;
    customerUnitId?: string | undefined;
    unitId: number;
    unit?: Unit | undefined;
}

export class UnitServiceContractType extends ModelBaseId implements IUnitServiceContractType {
    sortingNum!: number;
    nameTranslationKey?: string | undefined;
    units?: Unit[] | undefined;

    constructor(data?: IUnitServiceContractType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sortingNum = _data["sortingNum"];
            this.nameTranslationKey = _data["nameTranslationKey"];
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(Unit.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): UnitServiceContractType {
        data = typeof data === 'object' ? data : {};
        let result = new UnitServiceContractType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortingNum"] = this.sortingNum;
        data["nameTranslationKey"] = this.nameTranslationKey;
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUnitServiceContractType extends IModelBaseId {
    sortingNum: number;
    nameTranslationKey?: string | undefined;
    units?: Unit[] | undefined;
}

export class UnitOwnership extends ModelBaseId implements IUnitOwnership {
    nameTranslationKey?: string | undefined;

    constructor(data?: IUnitOwnership) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nameTranslationKey = _data["nameTranslationKey"];
        }
    }

    static override fromJS(data: any): UnitOwnership {
        data = typeof data === 'object' ? data : {};
        let result = new UnitOwnership();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameTranslationKey"] = this.nameTranslationKey;
        super.toJSON(data);
        return data;
    }
}

export interface IUnitOwnership extends IModelBaseId {
    nameTranslationKey?: string | undefined;
}

export class UnitWasteType extends ModelBaseId implements IUnitWasteType {
    nameTranslationKey?: string | undefined;

    constructor(data?: IUnitWasteType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.nameTranslationKey = _data["nameTranslationKey"];
        }
    }

    static override fromJS(data: any): UnitWasteType {
        data = typeof data === 'object' ? data : {};
        let result = new UnitWasteType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameTranslationKey"] = this.nameTranslationKey;
        super.toJSON(data);
        return data;
    }
}

export interface IUnitWasteType extends IModelBaseId {
    nameTranslationKey?: string | undefined;
}

export class WasteHandler extends ModelBaseId implements IWasteHandler {
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    unitId!: number;
    unit?: Unit | undefined;

    constructor(data?: IWasteHandler) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.unitId = _data["unitId"];
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): WasteHandler {
        data = typeof data === 'object' ? data : {};
        let result = new WasteHandler();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["unitId"] = this.unitId;
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IWasteHandler extends IModelBaseId {
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    unitId: number;
    unit?: Unit | undefined;
}

export class WasteHandlersUnit extends ModelBase implements IWasteHandlersUnit {
    requiredRole!: RolesType;
    unitId!: number;
    unit?: Unit | undefined;

    constructor(data?: IWasteHandlersUnit) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.requiredRole = _data["requiredRole"];
            this.unitId = _data["unitId"];
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): WasteHandlersUnit {
        data = typeof data === 'object' ? data : {};
        let result = new WasteHandlersUnit();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requiredRole"] = this.requiredRole;
        data["unitId"] = this.unitId;
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IWasteHandlersUnit extends IModelBase {
    requiredRole: RolesType;
    unitId: number;
    unit?: Unit | undefined;
}

export class NotificationCustomXtelMessage extends ModelBaseId implements INotificationCustomXtelMessage {
    unitId!: number;
    message?: string | undefined;
    unit?: Unit | undefined;

    constructor(data?: INotificationCustomXtelMessage) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.unitId = _data["unitId"];
            this.message = _data["message"];
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): NotificationCustomXtelMessage {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationCustomXtelMessage();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitId"] = this.unitId;
        data["message"] = this.message;
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface INotificationCustomXtelMessage extends IModelBaseId {
    unitId: number;
    message?: string | undefined;
    unit?: Unit | undefined;
}

export class TelemetryLast30Days implements ITelemetryLast30Days {
    unitId!: number;
    unitsEmptied?: number | undefined;
    pressCycles?: number | undefined;
    cyclesPerUnitsEmptied?: number | undefined;
    unit?: Unit | undefined;

    constructor(data?: ITelemetryLast30Days) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitId = _data["unitId"];
            this.unitsEmptied = _data["unitsEmptied"];
            this.pressCycles = _data["pressCycles"];
            this.cyclesPerUnitsEmptied = _data["cyclesPerUnitsEmptied"];
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TelemetryLast30Days {
        data = typeof data === 'object' ? data : {};
        let result = new TelemetryLast30Days();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitId"] = this.unitId;
        data["unitsEmptied"] = this.unitsEmptied;
        data["pressCycles"] = this.pressCycles;
        data["cyclesPerUnitsEmptied"] = this.cyclesPerUnitsEmptied;
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITelemetryLast30Days {
    unitId: number;
    unitsEmptied?: number | undefined;
    pressCycles?: number | undefined;
    cyclesPerUnitsEmptied?: number | undefined;
    unit?: Unit | undefined;
}

export class XtelUnitTracker extends ModelBaseId implements IXtelUnitTracker {
    unitId!: number;
    trackerId?: string | undefined;
    isActive!: boolean;
    unit?: Unit | undefined;

    constructor(data?: IXtelUnitTracker) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.unitId = _data["unitId"];
            this.trackerId = _data["trackerId"];
            this.isActive = _data["isActive"];
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): XtelUnitTracker {
        data = typeof data === 'object' ? data : {};
        let result = new XtelUnitTracker();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitId"] = this.unitId;
        data["trackerId"] = this.trackerId;
        data["isActive"] = this.isActive;
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IXtelUnitTracker extends IModelBaseId {
    unitId: number;
    trackerId?: string | undefined;
    isActive: boolean;
    unit?: Unit | undefined;
}

export class UnitTracker extends ModelBaseId implements IUnitTracker {
    trackerId?: string | undefined;
    unitId!: number;
    isActive!: boolean;
    unit?: Unit | undefined;
    batteryStatus?: number | undefined;
    batteryStatusUpdatedDate?: Date | undefined;

    constructor(data?: IUnitTracker) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trackerId = _data["trackerId"];
            this.unitId = _data["unitId"];
            this.isActive = _data["isActive"];
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : <any>undefined;
            this.batteryStatus = _data["batteryStatus"];
            this.batteryStatusUpdatedDate = _data["batteryStatusUpdatedDate"] ? new Date(_data["batteryStatusUpdatedDate"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): UnitTracker {
        data = typeof data === 'object' ? data : {};
        let result = new UnitTracker();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trackerId"] = this.trackerId;
        data["unitId"] = this.unitId;
        data["isActive"] = this.isActive;
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        data["batteryStatus"] = this.batteryStatus;
        data["batteryStatusUpdatedDate"] = this.batteryStatusUpdatedDate ? this.batteryStatusUpdatedDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUnitTracker extends IModelBaseId {
    trackerId?: string | undefined;
    unitId: number;
    isActive: boolean;
    unit?: Unit | undefined;
    batteryStatus?: number | undefined;
    batteryStatusUpdatedDate?: Date | undefined;
}

export class UnitWeight extends ModelBaseId implements IUnitWeight {
    weighingSerialNumber?: string | undefined;
    unitId!: number;
    isActive!: boolean;
    unit?: Unit | undefined;

    constructor(data?: IUnitWeight) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.weighingSerialNumber = _data["weighingSerialNumber"];
            this.unitId = _data["unitId"];
            this.isActive = _data["isActive"];
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): UnitWeight {
        data = typeof data === 'object' ? data : {};
        let result = new UnitWeight();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weighingSerialNumber"] = this.weighingSerialNumber;
        data["unitId"] = this.unitId;
        data["isActive"] = this.isActive;
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUnitWeight extends IModelBaseId {
    weighingSerialNumber?: string | undefined;
    unitId: number;
    isActive: boolean;
    unit?: Unit | undefined;
}

export class UnitDocument extends ModelBaseId implements IUnitDocument {
    countryCode?: string | undefined;
    languageCode?: string | undefined;
    electricalDiagram?: string | undefined;
    hydraulicsDiagram?: string | undefined;
    diagram?: string | undefined;
    userManual?: string | undefined;
    userManual2?: string | undefined;
    userManual3?: string | undefined;
    quickGuides?: string | undefined;
    userVideo?: string | undefined;
    userVideo2?: string | undefined;
    userVideo3?: string | undefined;
    sparePartsManual?: string | undefined;
    serviceVideo1?: string | undefined;
    serviceVideo2?: string | undefined;
    serviceVideo3?: string | undefined;
    serviceVideo4?: string | undefined;
    serviceVideo5?: string | undefined;
    serviceVideo6?: string | undefined;
    unitId!: number;
    unit?: Unit | undefined;

    constructor(data?: IUnitDocument) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.countryCode = _data["countryCode"];
            this.languageCode = _data["languageCode"];
            this.electricalDiagram = _data["electricalDiagram"];
            this.hydraulicsDiagram = _data["hydraulicsDiagram"];
            this.diagram = _data["diagram"];
            this.userManual = _data["userManual"];
            this.userManual2 = _data["userManual2"];
            this.userManual3 = _data["userManual3"];
            this.quickGuides = _data["quickGuides"];
            this.userVideo = _data["userVideo"];
            this.userVideo2 = _data["userVideo2"];
            this.userVideo3 = _data["userVideo3"];
            this.sparePartsManual = _data["sparePartsManual"];
            this.serviceVideo1 = _data["serviceVideo1"];
            this.serviceVideo2 = _data["serviceVideo2"];
            this.serviceVideo3 = _data["serviceVideo3"];
            this.serviceVideo4 = _data["serviceVideo4"];
            this.serviceVideo5 = _data["serviceVideo5"];
            this.serviceVideo6 = _data["serviceVideo6"];
            this.unitId = _data["unitId"];
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): UnitDocument {
        data = typeof data === 'object' ? data : {};
        let result = new UnitDocument();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["languageCode"] = this.languageCode;
        data["electricalDiagram"] = this.electricalDiagram;
        data["hydraulicsDiagram"] = this.hydraulicsDiagram;
        data["diagram"] = this.diagram;
        data["userManual"] = this.userManual;
        data["userManual2"] = this.userManual2;
        data["userManual3"] = this.userManual3;
        data["quickGuides"] = this.quickGuides;
        data["userVideo"] = this.userVideo;
        data["userVideo2"] = this.userVideo2;
        data["userVideo3"] = this.userVideo3;
        data["sparePartsManual"] = this.sparePartsManual;
        data["serviceVideo1"] = this.serviceVideo1;
        data["serviceVideo2"] = this.serviceVideo2;
        data["serviceVideo3"] = this.serviceVideo3;
        data["serviceVideo4"] = this.serviceVideo4;
        data["serviceVideo5"] = this.serviceVideo5;
        data["serviceVideo6"] = this.serviceVideo6;
        data["unitId"] = this.unitId;
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUnitDocument extends IModelBaseId {
    countryCode?: string | undefined;
    languageCode?: string | undefined;
    electricalDiagram?: string | undefined;
    hydraulicsDiagram?: string | undefined;
    diagram?: string | undefined;
    userManual?: string | undefined;
    userManual2?: string | undefined;
    userManual3?: string | undefined;
    quickGuides?: string | undefined;
    userVideo?: string | undefined;
    userVideo2?: string | undefined;
    userVideo3?: string | undefined;
    sparePartsManual?: string | undefined;
    serviceVideo1?: string | undefined;
    serviceVideo2?: string | undefined;
    serviceVideo3?: string | undefined;
    serviceVideo4?: string | undefined;
    serviceVideo5?: string | undefined;
    serviceVideo6?: string | undefined;
    unitId: number;
    unit?: Unit | undefined;
}

export class NotificationDefinitionUnit extends ModelBaseId implements INotificationDefinitionUnit {
    notificationDefinitionId!: number;
    notificationDefinition?: NotificationDefinition | undefined;
    unitId!: number;
    unit?: Unit | undefined;

    constructor(data?: INotificationDefinitionUnit) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.notificationDefinitionId = _data["notificationDefinitionId"];
            this.notificationDefinition = _data["notificationDefinition"] ? NotificationDefinition.fromJS(_data["notificationDefinition"]) : <any>undefined;
            this.unitId = _data["unitId"];
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): NotificationDefinitionUnit {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDefinitionUnit();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationDefinitionId"] = this.notificationDefinitionId;
        data["notificationDefinition"] = this.notificationDefinition ? this.notificationDefinition.toJSON() : <any>undefined;
        data["unitId"] = this.unitId;
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface INotificationDefinitionUnit extends IModelBaseId {
    notificationDefinitionId: number;
    notificationDefinition?: NotificationDefinition | undefined;
    unitId: number;
    unit?: Unit | undefined;
}

export class NotificationDefinition extends ModelBaseId implements INotificationDefinition {
    name?: string | undefined;
    selectedLanguage!: SelectedLanguage;
    shouldNotifyByEmail!: boolean;
    shouldNotifyByPush!: boolean;
    notificationDefinitionTypes?: NotificationDefinitionType[] | undefined;
    notificationDefinitionUnits?: NotificationDefinitionUnit[] | undefined;
    notificationUsers?: NotificationUser[] | undefined;
    notificationColumnsSelected?: NotificationColumnSelected[] | undefined;

    constructor(data?: INotificationDefinition) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.selectedLanguage = _data["selectedLanguage"];
            this.shouldNotifyByEmail = _data["shouldNotifyByEmail"];
            this.shouldNotifyByPush = _data["shouldNotifyByPush"];
            if (Array.isArray(_data["notificationDefinitionTypes"])) {
                this.notificationDefinitionTypes = [] as any;
                for (let item of _data["notificationDefinitionTypes"])
                    this.notificationDefinitionTypes!.push(NotificationDefinitionType.fromJS(item));
            }
            if (Array.isArray(_data["notificationDefinitionUnits"])) {
                this.notificationDefinitionUnits = [] as any;
                for (let item of _data["notificationDefinitionUnits"])
                    this.notificationDefinitionUnits!.push(NotificationDefinitionUnit.fromJS(item));
            }
            if (Array.isArray(_data["notificationUsers"])) {
                this.notificationUsers = [] as any;
                for (let item of _data["notificationUsers"])
                    this.notificationUsers!.push(NotificationUser.fromJS(item));
            }
            if (Array.isArray(_data["notificationColumnsSelected"])) {
                this.notificationColumnsSelected = [] as any;
                for (let item of _data["notificationColumnsSelected"])
                    this.notificationColumnsSelected!.push(NotificationColumnSelected.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): NotificationDefinition {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDefinition();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["selectedLanguage"] = this.selectedLanguage;
        data["shouldNotifyByEmail"] = this.shouldNotifyByEmail;
        data["shouldNotifyByPush"] = this.shouldNotifyByPush;
        if (Array.isArray(this.notificationDefinitionTypes)) {
            data["notificationDefinitionTypes"] = [];
            for (let item of this.notificationDefinitionTypes)
                data["notificationDefinitionTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.notificationDefinitionUnits)) {
            data["notificationDefinitionUnits"] = [];
            for (let item of this.notificationDefinitionUnits)
                data["notificationDefinitionUnits"].push(item.toJSON());
        }
        if (Array.isArray(this.notificationUsers)) {
            data["notificationUsers"] = [];
            for (let item of this.notificationUsers)
                data["notificationUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.notificationColumnsSelected)) {
            data["notificationColumnsSelected"] = [];
            for (let item of this.notificationColumnsSelected)
                data["notificationColumnsSelected"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface INotificationDefinition extends IModelBaseId {
    name?: string | undefined;
    selectedLanguage: SelectedLanguage;
    shouldNotifyByEmail: boolean;
    shouldNotifyByPush: boolean;
    notificationDefinitionTypes?: NotificationDefinitionType[] | undefined;
    notificationDefinitionUnits?: NotificationDefinitionUnit[] | undefined;
    notificationUsers?: NotificationUser[] | undefined;
    notificationColumnsSelected?: NotificationColumnSelected[] | undefined;
}

export enum SelectedLanguage {
    En = 0,
    Da = 1,
    De = 2,
    Fr = 3,
    It = 4,
    Pl = 5,
    Es = 6,
    Nl = 7,
    Pt = 8,
    Nb = 9,
    Sv = 10,
}

export class NotificationDefinitionType extends ModelBaseId implements INotificationDefinitionType {
    notificationDefinitionId!: number;
    notificationDefinition?: NotificationDefinition | undefined;
    notificationTypeId!: number;
    notificationType?: NotificationType | undefined;
    notificationFillSettings?: NotificationFillSettings[] | undefined;
    notificationAdvancedSettings?: NotificationAdvancedSetting[] | undefined;

    constructor(data?: INotificationDefinitionType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.notificationDefinitionId = _data["notificationDefinitionId"];
            this.notificationDefinition = _data["notificationDefinition"] ? NotificationDefinition.fromJS(_data["notificationDefinition"]) : <any>undefined;
            this.notificationTypeId = _data["notificationTypeId"];
            this.notificationType = _data["notificationType"] ? NotificationType.fromJS(_data["notificationType"]) : <any>undefined;
            if (Array.isArray(_data["notificationFillSettings"])) {
                this.notificationFillSettings = [] as any;
                for (let item of _data["notificationFillSettings"])
                    this.notificationFillSettings!.push(NotificationFillSettings.fromJS(item));
            }
            if (Array.isArray(_data["notificationAdvancedSettings"])) {
                this.notificationAdvancedSettings = [] as any;
                for (let item of _data["notificationAdvancedSettings"])
                    this.notificationAdvancedSettings!.push(NotificationAdvancedSetting.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): NotificationDefinitionType {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDefinitionType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationDefinitionId"] = this.notificationDefinitionId;
        data["notificationDefinition"] = this.notificationDefinition ? this.notificationDefinition.toJSON() : <any>undefined;
        data["notificationTypeId"] = this.notificationTypeId;
        data["notificationType"] = this.notificationType ? this.notificationType.toJSON() : <any>undefined;
        if (Array.isArray(this.notificationFillSettings)) {
            data["notificationFillSettings"] = [];
            for (let item of this.notificationFillSettings)
                data["notificationFillSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.notificationAdvancedSettings)) {
            data["notificationAdvancedSettings"] = [];
            for (let item of this.notificationAdvancedSettings)
                data["notificationAdvancedSettings"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface INotificationDefinitionType extends IModelBaseId {
    notificationDefinitionId: number;
    notificationDefinition?: NotificationDefinition | undefined;
    notificationTypeId: number;
    notificationType?: NotificationType | undefined;
    notificationFillSettings?: NotificationFillSettings[] | undefined;
    notificationAdvancedSettings?: NotificationAdvancedSetting[] | undefined;
}

export class NotificationType extends ModelBaseId implements INotificationType {
    name?: string | undefined;
    severity!: StatusSeverity;
    notificationErrorTypeId!: number;
    notificationErrorType?: NotificationErrorType | undefined;
    notificationDefinitionTypes?: NotificationDefinitionType[] | undefined;
    notificationHistoryTypes?: NotificationHistoryType[] | undefined;

    constructor(data?: INotificationType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.severity = _data["severity"];
            this.notificationErrorTypeId = _data["notificationErrorTypeId"];
            this.notificationErrorType = _data["notificationErrorType"] ? NotificationErrorType.fromJS(_data["notificationErrorType"]) : <any>undefined;
            if (Array.isArray(_data["notificationDefinitionTypes"])) {
                this.notificationDefinitionTypes = [] as any;
                for (let item of _data["notificationDefinitionTypes"])
                    this.notificationDefinitionTypes!.push(NotificationDefinitionType.fromJS(item));
            }
            if (Array.isArray(_data["notificationHistoryTypes"])) {
                this.notificationHistoryTypes = [] as any;
                for (let item of _data["notificationHistoryTypes"])
                    this.notificationHistoryTypes!.push(NotificationHistoryType.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): NotificationType {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["severity"] = this.severity;
        data["notificationErrorTypeId"] = this.notificationErrorTypeId;
        data["notificationErrorType"] = this.notificationErrorType ? this.notificationErrorType.toJSON() : <any>undefined;
        if (Array.isArray(this.notificationDefinitionTypes)) {
            data["notificationDefinitionTypes"] = [];
            for (let item of this.notificationDefinitionTypes)
                data["notificationDefinitionTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.notificationHistoryTypes)) {
            data["notificationHistoryTypes"] = [];
            for (let item of this.notificationHistoryTypes)
                data["notificationHistoryTypes"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface INotificationType extends IModelBaseId {
    name?: string | undefined;
    severity: StatusSeverity;
    notificationErrorTypeId: number;
    notificationErrorType?: NotificationErrorType | undefined;
    notificationDefinitionTypes?: NotificationDefinitionType[] | undefined;
    notificationHistoryTypes?: NotificationHistoryType[] | undefined;
}

export class NotificationErrorType extends ModelBaseId implements INotificationErrorType {
    errorId?: number | undefined;
    machineType!: NotificationMachineType;
    notificationTypes?: NotificationType[] | undefined;

    constructor(data?: INotificationErrorType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.errorId = _data["errorId"];
            this.machineType = _data["machineType"];
            if (Array.isArray(_data["notificationTypes"])) {
                this.notificationTypes = [] as any;
                for (let item of _data["notificationTypes"])
                    this.notificationTypes!.push(NotificationType.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): NotificationErrorType {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationErrorType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorId"] = this.errorId;
        data["machineType"] = this.machineType;
        if (Array.isArray(this.notificationTypes)) {
            data["notificationTypes"] = [];
            for (let item of this.notificationTypes)
                data["notificationTypes"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface INotificationErrorType extends IModelBaseId {
    errorId?: number | undefined;
    machineType: NotificationMachineType;
    notificationTypes?: NotificationType[] | undefined;
}

export enum NotificationMachineType {
    Baler = 0,
    Compactor = 1,
    Link = 2,
    SharkMK3 = 3,
    Container = 4,
}

export class NotificationHistoryType extends ModelBase implements INotificationHistoryType {
    fillSettingsDayOfWeek?: DayOfWeek | undefined;
    fillSettingsThreshold?: number | undefined;
    pickUpOrderedAmount?: number | undefined;
    triggeredByUser?: string | undefined;
    pickUpComment?: string | undefined;
    pickUpOnDate?: Date | undefined;
    fillLevelWhenEmptied?: number | undefined;
    xtelCustomMessage?: string | undefined;
    notificationAdvancedSettingHistoryTypes?: NotificationAdvancedSettingHistoryType[] | undefined;
    notificationCustomMsgNotificationHistoryTypes?: NotificationCustomMsgNotificationHistoryTypes[] | undefined;
    notificationTypeId!: number;
    notificationType?: NotificationType | undefined;
    notificationHistoryId!: number;
    notificationHistory?: NotificationHistory | undefined;

    constructor(data?: INotificationHistoryType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fillSettingsDayOfWeek = _data["fillSettingsDayOfWeek"];
            this.fillSettingsThreshold = _data["fillSettingsThreshold"];
            this.pickUpOrderedAmount = _data["pickUpOrderedAmount"];
            this.triggeredByUser = _data["triggeredByUser"];
            this.pickUpComment = _data["pickUpComment"];
            this.pickUpOnDate = _data["pickUpOnDate"] ? new Date(_data["pickUpOnDate"].toString()) : <any>undefined;
            this.fillLevelWhenEmptied = _data["fillLevelWhenEmptied"];
            this.xtelCustomMessage = _data["xtelCustomMessage"];
            if (Array.isArray(_data["notificationAdvancedSettingHistoryTypes"])) {
                this.notificationAdvancedSettingHistoryTypes = [] as any;
                for (let item of _data["notificationAdvancedSettingHistoryTypes"])
                    this.notificationAdvancedSettingHistoryTypes!.push(NotificationAdvancedSettingHistoryType.fromJS(item));
            }
            if (Array.isArray(_data["notificationCustomMsgNotificationHistoryTypes"])) {
                this.notificationCustomMsgNotificationHistoryTypes = [] as any;
                for (let item of _data["notificationCustomMsgNotificationHistoryTypes"])
                    this.notificationCustomMsgNotificationHistoryTypes!.push(NotificationCustomMsgNotificationHistoryTypes.fromJS(item));
            }
            this.notificationTypeId = _data["notificationTypeId"];
            this.notificationType = _data["notificationType"] ? NotificationType.fromJS(_data["notificationType"]) : <any>undefined;
            this.notificationHistoryId = _data["notificationHistoryId"];
            this.notificationHistory = _data["notificationHistory"] ? NotificationHistory.fromJS(_data["notificationHistory"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): NotificationHistoryType {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationHistoryType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fillSettingsDayOfWeek"] = this.fillSettingsDayOfWeek;
        data["fillSettingsThreshold"] = this.fillSettingsThreshold;
        data["pickUpOrderedAmount"] = this.pickUpOrderedAmount;
        data["triggeredByUser"] = this.triggeredByUser;
        data["pickUpComment"] = this.pickUpComment;
        data["pickUpOnDate"] = this.pickUpOnDate ? this.pickUpOnDate.toISOString() : <any>undefined;
        data["fillLevelWhenEmptied"] = this.fillLevelWhenEmptied;
        data["xtelCustomMessage"] = this.xtelCustomMessage;
        if (Array.isArray(this.notificationAdvancedSettingHistoryTypes)) {
            data["notificationAdvancedSettingHistoryTypes"] = [];
            for (let item of this.notificationAdvancedSettingHistoryTypes)
                data["notificationAdvancedSettingHistoryTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.notificationCustomMsgNotificationHistoryTypes)) {
            data["notificationCustomMsgNotificationHistoryTypes"] = [];
            for (let item of this.notificationCustomMsgNotificationHistoryTypes)
                data["notificationCustomMsgNotificationHistoryTypes"].push(item.toJSON());
        }
        data["notificationTypeId"] = this.notificationTypeId;
        data["notificationType"] = this.notificationType ? this.notificationType.toJSON() : <any>undefined;
        data["notificationHistoryId"] = this.notificationHistoryId;
        data["notificationHistory"] = this.notificationHistory ? this.notificationHistory.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface INotificationHistoryType extends IModelBase {
    fillSettingsDayOfWeek?: DayOfWeek | undefined;
    fillSettingsThreshold?: number | undefined;
    pickUpOrderedAmount?: number | undefined;
    triggeredByUser?: string | undefined;
    pickUpComment?: string | undefined;
    pickUpOnDate?: Date | undefined;
    fillLevelWhenEmptied?: number | undefined;
    xtelCustomMessage?: string | undefined;
    notificationAdvancedSettingHistoryTypes?: NotificationAdvancedSettingHistoryType[] | undefined;
    notificationCustomMsgNotificationHistoryTypes?: NotificationCustomMsgNotificationHistoryTypes[] | undefined;
    notificationTypeId: number;
    notificationType?: NotificationType | undefined;
    notificationHistoryId: number;
    notificationHistory?: NotificationHistory | undefined;
}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export class NotificationAdvancedSettingHistoryType extends ModelBaseId implements INotificationAdvancedSettingHistoryType {
    notificationTypeId!: number;
    notificationHistoryId!: number;
    notificationMessage?: string | undefined;
    notificationHistoryType?: NotificationHistoryType | undefined;

    constructor(data?: INotificationAdvancedSettingHistoryType) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.notificationTypeId = _data["notificationTypeId"];
            this.notificationHistoryId = _data["notificationHistoryId"];
            this.notificationMessage = _data["notificationMessage"];
            this.notificationHistoryType = _data["notificationHistoryType"] ? NotificationHistoryType.fromJS(_data["notificationHistoryType"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): NotificationAdvancedSettingHistoryType {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationAdvancedSettingHistoryType();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationTypeId"] = this.notificationTypeId;
        data["notificationHistoryId"] = this.notificationHistoryId;
        data["notificationMessage"] = this.notificationMessage;
        data["notificationHistoryType"] = this.notificationHistoryType ? this.notificationHistoryType.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface INotificationAdvancedSettingHistoryType extends IModelBaseId {
    notificationTypeId: number;
    notificationHistoryId: number;
    notificationMessage?: string | undefined;
    notificationHistoryType?: NotificationHistoryType | undefined;
}

export class NotificationCustomMsgNotificationHistoryTypes extends ModelBaseId implements INotificationCustomMsgNotificationHistoryTypes {
    customMessage?: string | undefined;
    notificationTypeId!: number;
    notificationHistoryId!: number;
    notificationHistoryType?: NotificationHistoryType | undefined;

    constructor(data?: INotificationCustomMsgNotificationHistoryTypes) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customMessage = _data["customMessage"];
            this.notificationTypeId = _data["notificationTypeId"];
            this.notificationHistoryId = _data["notificationHistoryId"];
            this.notificationHistoryType = _data["notificationHistoryType"] ? NotificationHistoryType.fromJS(_data["notificationHistoryType"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): NotificationCustomMsgNotificationHistoryTypes {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationCustomMsgNotificationHistoryTypes();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customMessage"] = this.customMessage;
        data["notificationTypeId"] = this.notificationTypeId;
        data["notificationHistoryId"] = this.notificationHistoryId;
        data["notificationHistoryType"] = this.notificationHistoryType ? this.notificationHistoryType.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface INotificationCustomMsgNotificationHistoryTypes extends IModelBaseId {
    customMessage?: string | undefined;
    notificationTypeId: number;
    notificationHistoryId: number;
    notificationHistoryType?: NotificationHistoryType | undefined;
}

export class NotificationHistory extends ModelBaseId implements INotificationHistory {
    stateChangeDateTime!: Date;
    isResend!: boolean;
    isEmail!: boolean;
    isPushNotification!: boolean;
    unitId!: number;
    unit?: Unit | undefined;
    notificationDefinitionId?: number | undefined;
    notificationDefinition?: NotificationDefinition | undefined;
    notificationHistoryUsers?: NotificationHistoryUser[] | undefined;
    notificationHistoryTypes?: NotificationHistoryType[] | undefined;
    notificationHistoryUserDefinedValues?: NotificationHistoryUserDefinedValues | undefined;

    constructor(data?: INotificationHistory) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.stateChangeDateTime = _data["stateChangeDateTime"] ? new Date(_data["stateChangeDateTime"].toString()) : <any>undefined;
            this.isResend = _data["isResend"];
            this.isEmail = _data["isEmail"];
            this.isPushNotification = _data["isPushNotification"];
            this.unitId = _data["unitId"];
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : <any>undefined;
            this.notificationDefinitionId = _data["notificationDefinitionId"];
            this.notificationDefinition = _data["notificationDefinition"] ? NotificationDefinition.fromJS(_data["notificationDefinition"]) : <any>undefined;
            if (Array.isArray(_data["notificationHistoryUsers"])) {
                this.notificationHistoryUsers = [] as any;
                for (let item of _data["notificationHistoryUsers"])
                    this.notificationHistoryUsers!.push(NotificationHistoryUser.fromJS(item));
            }
            if (Array.isArray(_data["notificationHistoryTypes"])) {
                this.notificationHistoryTypes = [] as any;
                for (let item of _data["notificationHistoryTypes"])
                    this.notificationHistoryTypes!.push(NotificationHistoryType.fromJS(item));
            }
            this.notificationHistoryUserDefinedValues = _data["notificationHistoryUserDefinedValues"] ? NotificationHistoryUserDefinedValues.fromJS(_data["notificationHistoryUserDefinedValues"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): NotificationHistory {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationHistory();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stateChangeDateTime"] = this.stateChangeDateTime ? this.stateChangeDateTime.toISOString() : <any>undefined;
        data["isResend"] = this.isResend;
        data["isEmail"] = this.isEmail;
        data["isPushNotification"] = this.isPushNotification;
        data["unitId"] = this.unitId;
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        data["notificationDefinitionId"] = this.notificationDefinitionId;
        data["notificationDefinition"] = this.notificationDefinition ? this.notificationDefinition.toJSON() : <any>undefined;
        if (Array.isArray(this.notificationHistoryUsers)) {
            data["notificationHistoryUsers"] = [];
            for (let item of this.notificationHistoryUsers)
                data["notificationHistoryUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.notificationHistoryTypes)) {
            data["notificationHistoryTypes"] = [];
            for (let item of this.notificationHistoryTypes)
                data["notificationHistoryTypes"].push(item.toJSON());
        }
        data["notificationHistoryUserDefinedValues"] = this.notificationHistoryUserDefinedValues ? this.notificationHistoryUserDefinedValues.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface INotificationHistory extends IModelBaseId {
    stateChangeDateTime: Date;
    isResend: boolean;
    isEmail: boolean;
    isPushNotification: boolean;
    unitId: number;
    unit?: Unit | undefined;
    notificationDefinitionId?: number | undefined;
    notificationDefinition?: NotificationDefinition | undefined;
    notificationHistoryUsers?: NotificationHistoryUser[] | undefined;
    notificationHistoryTypes?: NotificationHistoryType[] | undefined;
    notificationHistoryUserDefinedValues?: NotificationHistoryUserDefinedValues | undefined;
}

export class NotificationHistoryUser extends ModelBase implements INotificationHistoryUser {
    notificationUserId!: number;
    notificationUser?: NotificationUser | undefined;
    notificationHistoryId!: number;
    notificationHistory?: NotificationHistory | undefined;

    constructor(data?: INotificationHistoryUser) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.notificationUserId = _data["notificationUserId"];
            this.notificationUser = _data["notificationUser"] ? NotificationUser.fromJS(_data["notificationUser"]) : <any>undefined;
            this.notificationHistoryId = _data["notificationHistoryId"];
            this.notificationHistory = _data["notificationHistory"] ? NotificationHistory.fromJS(_data["notificationHistory"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): NotificationHistoryUser {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationHistoryUser();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationUserId"] = this.notificationUserId;
        data["notificationUser"] = this.notificationUser ? this.notificationUser.toJSON() : <any>undefined;
        data["notificationHistoryId"] = this.notificationHistoryId;
        data["notificationHistory"] = this.notificationHistory ? this.notificationHistory.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface INotificationHistoryUser extends IModelBase {
    notificationUserId: number;
    notificationUser?: NotificationUser | undefined;
    notificationHistoryId: number;
    notificationHistory?: NotificationHistory | undefined;
}

export class NotificationUser extends ModelBaseId implements INotificationUser {
    email?: string | undefined;
    notificationDefinitionId!: number;
    notificationDefinition?: NotificationDefinition | undefined;
    userSettingsId?: string | undefined;
    userSettings?: UserSettings | undefined;
    notificationHistoryUsers?: NotificationHistoryUser[] | undefined;

    constructor(data?: INotificationUser) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.email = _data["email"];
            this.notificationDefinitionId = _data["notificationDefinitionId"];
            this.notificationDefinition = _data["notificationDefinition"] ? NotificationDefinition.fromJS(_data["notificationDefinition"]) : <any>undefined;
            this.userSettingsId = _data["userSettingsId"];
            this.userSettings = _data["userSettings"] ? UserSettings.fromJS(_data["userSettings"]) : <any>undefined;
            if (Array.isArray(_data["notificationHistoryUsers"])) {
                this.notificationHistoryUsers = [] as any;
                for (let item of _data["notificationHistoryUsers"])
                    this.notificationHistoryUsers!.push(NotificationHistoryUser.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): NotificationUser {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationUser();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["notificationDefinitionId"] = this.notificationDefinitionId;
        data["notificationDefinition"] = this.notificationDefinition ? this.notificationDefinition.toJSON() : <any>undefined;
        data["userSettingsId"] = this.userSettingsId;
        data["userSettings"] = this.userSettings ? this.userSettings.toJSON() : <any>undefined;
        if (Array.isArray(this.notificationHistoryUsers)) {
            data["notificationHistoryUsers"] = [];
            for (let item of this.notificationHistoryUsers)
                data["notificationHistoryUsers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface INotificationUser extends IModelBaseId {
    email?: string | undefined;
    notificationDefinitionId: number;
    notificationDefinition?: NotificationDefinition | undefined;
    userSettingsId?: string | undefined;
    userSettings?: UserSettings | undefined;
    notificationHistoryUsers?: NotificationHistoryUser[] | undefined;
}

export class UserSettings extends ModelBase implements IUserSettings {
    userId?: string | undefined;
    profileUnits!: ProfileUnit;
    selectedLanguage!: SelectedLanguage;
    agreedToTermsAndConditions!: boolean;
    agreedToTermsAndConditionsDate!: Date;
    notificationUsers?: NotificationUser[] | undefined;

    constructor(data?: IUserSettings) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"];
            this.profileUnits = _data["profileUnits"];
            this.selectedLanguage = _data["selectedLanguage"];
            this.agreedToTermsAndConditions = _data["agreedToTermsAndConditions"];
            this.agreedToTermsAndConditionsDate = _data["agreedToTermsAndConditionsDate"] ? new Date(_data["agreedToTermsAndConditionsDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["notificationUsers"])) {
                this.notificationUsers = [] as any;
                for (let item of _data["notificationUsers"])
                    this.notificationUsers!.push(NotificationUser.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): UserSettings {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettings();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["profileUnits"] = this.profileUnits;
        data["selectedLanguage"] = this.selectedLanguage;
        data["agreedToTermsAndConditions"] = this.agreedToTermsAndConditions;
        data["agreedToTermsAndConditionsDate"] = this.agreedToTermsAndConditionsDate ? this.agreedToTermsAndConditionsDate.toISOString() : <any>undefined;
        if (Array.isArray(this.notificationUsers)) {
            data["notificationUsers"] = [];
            for (let item of this.notificationUsers)
                data["notificationUsers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUserSettings extends IModelBase {
    userId?: string | undefined;
    profileUnits: ProfileUnit;
    selectedLanguage: SelectedLanguage;
    agreedToTermsAndConditions: boolean;
    agreedToTermsAndConditionsDate: Date;
    notificationUsers?: NotificationUser[] | undefined;
}

export enum ProfileUnit {
    Metric = 0,
    Imperial = 1,
}

export class NotificationHistoryUserDefinedValues extends ModelBaseId implements INotificationHistoryUserDefinedValues {
    pickUpOrderedAmount?: number | undefined;
    notificationHistory?: NotificationHistory | undefined;

    constructor(data?: INotificationHistoryUserDefinedValues) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pickUpOrderedAmount = _data["pickUpOrderedAmount"];
            this.notificationHistory = _data["notificationHistory"] ? NotificationHistory.fromJS(_data["notificationHistory"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): NotificationHistoryUserDefinedValues {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationHistoryUserDefinedValues();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pickUpOrderedAmount"] = this.pickUpOrderedAmount;
        data["notificationHistory"] = this.notificationHistory ? this.notificationHistory.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface INotificationHistoryUserDefinedValues extends IModelBaseId {
    pickUpOrderedAmount?: number | undefined;
    notificationHistory?: NotificationHistory | undefined;
}

export class NotificationFillSettings extends ModelBaseId implements INotificationFillSettings {
    thresholdPercentage!: number;
    dayOfWeek!: DayOfWeek;
    notificationDefinitionTypeId!: number;
    notificationDefinitionType?: NotificationDefinitionType | undefined;

    constructor(data?: INotificationFillSettings) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.thresholdPercentage = _data["thresholdPercentage"];
            this.dayOfWeek = _data["dayOfWeek"];
            this.notificationDefinitionTypeId = _data["notificationDefinitionTypeId"];
            this.notificationDefinitionType = _data["notificationDefinitionType"] ? NotificationDefinitionType.fromJS(_data["notificationDefinitionType"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): NotificationFillSettings {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationFillSettings();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["thresholdPercentage"] = this.thresholdPercentage;
        data["dayOfWeek"] = this.dayOfWeek;
        data["notificationDefinitionTypeId"] = this.notificationDefinitionTypeId;
        data["notificationDefinitionType"] = this.notificationDefinitionType ? this.notificationDefinitionType.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface INotificationFillSettings extends IModelBaseId {
    thresholdPercentage: number;
    dayOfWeek: DayOfWeek;
    notificationDefinitionTypeId: number;
    notificationDefinitionType?: NotificationDefinitionType | undefined;
}

export class NotificationAdvancedSetting extends ModelBaseId implements INotificationAdvancedSetting {
    comparerInput!: ComparerInput;
    comparisonOperator!: ComparisonOperator;
    comparisonValue?: string | undefined;
    notificationMessage?: string | undefined;
    notificationDefinitionTypeId!: number;
    notificationDefinitionType?: NotificationDefinitionType | undefined;

    constructor(data?: INotificationAdvancedSetting) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.comparerInput = _data["comparerInput"];
            this.comparisonOperator = _data["comparisonOperator"];
            this.comparisonValue = _data["comparisonValue"];
            this.notificationMessage = _data["notificationMessage"];
            this.notificationDefinitionTypeId = _data["notificationDefinitionTypeId"];
            this.notificationDefinitionType = _data["notificationDefinitionType"] ? NotificationDefinitionType.fromJS(_data["notificationDefinitionType"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): NotificationAdvancedSetting {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationAdvancedSetting();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comparerInput"] = this.comparerInput;
        data["comparisonOperator"] = this.comparisonOperator;
        data["comparisonValue"] = this.comparisonValue;
        data["notificationMessage"] = this.notificationMessage;
        data["notificationDefinitionTypeId"] = this.notificationDefinitionTypeId;
        data["notificationDefinitionType"] = this.notificationDefinitionType ? this.notificationDefinitionType.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface INotificationAdvancedSetting extends IModelBaseId {
    comparerInput: ComparerInput;
    comparisonOperator: ComparisonOperator;
    comparisonValue?: string | undefined;
    notificationMessage?: string | undefined;
    notificationDefinitionTypeId: number;
    notificationDefinitionType?: NotificationDefinitionType | undefined;
}

export enum ComparerInput {
    BalesOnSite = 0,
    FillLevel = 1,
    WarrantyExpiresXDays = 2,
    NextServiceXDays = 3,
    UnitsEmptied = 4,
    TotalRunningHours = 5,
    TotalNumberOfCycles = 6,
    CyclesSinceLastOutput = 7,
    DaysSinceInstalled = 8,
    FullCounterAverage = 9,
    FillLevelEmptyBelowThreshold = 10,
    FillLevelEmptyBelowThreshold2Times = 11,
    FillLevelEmptyBelowThreshold3Times = 12,
}

export enum ComparisonOperator {
    BiggerThan = 0,
    SmallerThan = 1,
    Equal = 2,
    Interval = 3,
}

export class NotificationColumnSelected extends ModelBaseId implements INotificationColumnSelected {
    columnName?: string | undefined;
    sortingIndex!: number;
    notificationDefinitionId!: number;
    notificationDefinition?: NotificationDefinition | undefined;

    constructor(data?: INotificationColumnSelected) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.columnName = _data["columnName"];
            this.sortingIndex = _data["sortingIndex"];
            this.notificationDefinitionId = _data["notificationDefinitionId"];
            this.notificationDefinition = _data["notificationDefinition"] ? NotificationDefinition.fromJS(_data["notificationDefinition"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): NotificationColumnSelected {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationColumnSelected();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columnName"] = this.columnName;
        data["sortingIndex"] = this.sortingIndex;
        data["notificationDefinitionId"] = this.notificationDefinitionId;
        data["notificationDefinition"] = this.notificationDefinition ? this.notificationDefinition.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface INotificationColumnSelected extends IModelBaseId {
    columnName?: string | undefined;
    sortingIndex: number;
    notificationDefinitionId: number;
    notificationDefinition?: NotificationDefinition | undefined;
}

export class WasteHandlersEmptying extends ModelBaseId implements IWasteHandlersEmptying {
    weight!: number;
    weightUnit!: WeightUnit;
    dateOfEmptying!: Date;
    unitId!: number;
    unit?: Unit | undefined;

    constructor(data?: IWasteHandlersEmptying) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.weight = _data["weight"];
            this.weightUnit = _data["weightUnit"];
            this.dateOfEmptying = _data["dateOfEmptying"] ? new Date(_data["dateOfEmptying"].toString()) : <any>undefined;
            this.unitId = _data["unitId"];
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): WasteHandlersEmptying {
        data = typeof data === 'object' ? data : {};
        let result = new WasteHandlersEmptying();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weight"] = this.weight;
        data["weightUnit"] = this.weightUnit;
        data["dateOfEmptying"] = this.dateOfEmptying ? this.dateOfEmptying.toISOString() : <any>undefined;
        data["unitId"] = this.unitId;
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IWasteHandlersEmptying extends IModelBaseId {
    weight: number;
    weightUnit: WeightUnit;
    dateOfEmptying: Date;
    unitId: number;
    unit?: Unit | undefined;
}

export enum WeightUnit {
    Kg = 0,
    Pound = 1,
}

export class FavoriteUnit extends ModelBaseId implements IFavoriteUnit {
    userId?: string | undefined;
    unitId!: number;
    unit?: Unit | undefined;

    constructor(data?: IFavoriteUnit) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.userId = _data["userId"];
            this.unitId = _data["unitId"];
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): FavoriteUnit {
        data = typeof data === 'object' ? data : {};
        let result = new FavoriteUnit();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["unitId"] = this.unitId;
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFavoriteUnit extends IModelBaseId {
    userId?: string | undefined;
    unitId: number;
    unit?: Unit | undefined;
}

export class NotificationCustomMessage extends ModelBaseId implements INotificationCustomMessage {
    linkError!: LinkErrorEnum;
    message?: string | undefined;
    customFuncCounter!: number;
    unitId!: number;
    unit?: Unit | undefined;

    constructor(data?: INotificationCustomMessage) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.linkError = _data["linkError"];
            this.message = _data["message"];
            this.customFuncCounter = _data["customFuncCounter"];
            this.unitId = _data["unitId"];
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): NotificationCustomMessage {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationCustomMessage();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkError"] = this.linkError;
        data["message"] = this.message;
        data["customFuncCounter"] = this.customFuncCounter;
        data["unitId"] = this.unitId;
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface INotificationCustomMessage extends IModelBaseId {
    linkError: LinkErrorEnum;
    message?: string | undefined;
    customFuncCounter: number;
    unitId: number;
    unit?: Unit | undefined;
}

export enum LinkErrorEnum {
    InFunc_None = 0,
    InFunc_EStop_Pressed = 1,
    InFunc_isMotorRunning = 2,
    InFunc_FillLevelPressure = 3,
    InFunc_isFull_Input = 4,
    InFunc_isMachineReady = 5,
    InFunc_StartButton = 6,
    InFunc_MotorProtectError = 7,
    InFunc_OilLevelAndTempError = 8,
    InFunc_Stop = 9,
    InFunc_Mode = 10,
    InFunc_isAlmostFull_Input = 11,
    InFunc_Container_Not_Present = 12,
    InFunc_BarrierOpen = 13,
    InFunc_MotorThermoError = 14,
    InFunc_FullyOpen = 15,
    InFunc_Back = 16,
    InFunc_OilLevelLow = 17,
    InFunc_EnableControls = 18,
    InFunc_NonCriticalDoorOpen = 19,
    InFunc_Befreiung_Pressed = 20,
    InFunc_WireRunOutError = 21,
    InFunc_IncrementBaleCounter = 22,
    InFunc_IncrementSeriesCounter = 23,
    InFunc_MachineFaultInput = 24,
    InFunc_ContainerEmptying_Input = 25,
    InFunc_Custom_1 = 26,
    InFunc_Custom_2 = 27,
    InFunc_Custom_3 = 28,
    InFunc_Custom_4 = 29,
    InFunc_Custom_5 = 30,
    InFunc_Custom_6 = 31,
    InFunc_Custom_7 = 32,
    InFunc_Custom_8 = 33,
    InFunc_ExtraFunctionActive = 34,
    InFunc_PressureSwitchAlmostFull = 35,
    InFunc_PressureSwitchFull = 36,
    InFunc_isPressing = 37,
    InFunc_isReturning = 38,
}

export class DashboardStaticMapTileSettings extends ModelBaseId implements IDashboardStaticMapTileSettings {
    locationName?: string | undefined;
    longitude!: number;
    latitude!: number;
    zoomLevel!: number;
    south!: number;
    west!: number;
    north!: number;
    east!: number;
    filter?: FilterDto | undefined;
    dashboardBase?: DashboardBase | undefined;
    units?: Unit[] | undefined;

    constructor(data?: IDashboardStaticMapTileSettings) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.locationName = _data["locationName"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
            this.zoomLevel = _data["zoomLevel"];
            this.south = _data["south"];
            this.west = _data["west"];
            this.north = _data["north"];
            this.east = _data["east"];
            this.filter = _data["filter"] ? FilterDto.fromJS(_data["filter"]) : <any>undefined;
            this.dashboardBase = _data["dashboardBase"] ? DashboardBase.fromJS(_data["dashboardBase"]) : <any>undefined;
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(Unit.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): DashboardStaticMapTileSettings {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardStaticMapTileSettings();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationName"] = this.locationName;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        data["zoomLevel"] = this.zoomLevel;
        data["south"] = this.south;
        data["west"] = this.west;
        data["north"] = this.north;
        data["east"] = this.east;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["dashboardBase"] = this.dashboardBase ? this.dashboardBase.toJSON() : <any>undefined;
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDashboardStaticMapTileSettings extends IModelBaseId {
    locationName?: string | undefined;
    longitude: number;
    latitude: number;
    zoomLevel: number;
    south: number;
    west: number;
    north: number;
    east: number;
    filter?: FilterDto | undefined;
    dashboardBase?: DashboardBase | undefined;
    units?: Unit[] | undefined;
}

export class TelemetryAggregates implements ITelemetryAggregates {
    unitId!: number;
    telemetryMetricTypeId!: number;
    dateHour!: Date;
    metricValue!: number;
    unit?: Unit | undefined;
    telemetryMetricType?: TelemetryMetricType | undefined;

    constructor(data?: ITelemetryAggregates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitId = _data["unitId"];
            this.telemetryMetricTypeId = _data["telemetryMetricTypeId"];
            this.dateHour = _data["dateHour"] ? new Date(_data["dateHour"].toString()) : <any>undefined;
            this.metricValue = _data["metricValue"];
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : <any>undefined;
            this.telemetryMetricType = _data["telemetryMetricType"] ? TelemetryMetricType.fromJS(_data["telemetryMetricType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TelemetryAggregates {
        data = typeof data === 'object' ? data : {};
        let result = new TelemetryAggregates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitId"] = this.unitId;
        data["telemetryMetricTypeId"] = this.telemetryMetricTypeId;
        data["dateHour"] = this.dateHour ? this.dateHour.toISOString() : <any>undefined;
        data["metricValue"] = this.metricValue;
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        data["telemetryMetricType"] = this.telemetryMetricType ? this.telemetryMetricType.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITelemetryAggregates {
    unitId: number;
    telemetryMetricTypeId: number;
    dateHour: Date;
    metricValue: number;
    unit?: Unit | undefined;
    telemetryMetricType?: TelemetryMetricType | undefined;
}

export class TelemetryMetricType implements ITelemetryMetricType {
    id!: number;
    metricName?: string | undefined;
    telemetryAggregates?: TelemetryAggregates[] | undefined;
    telemetryAggregatesDailies?: TelemetryAggregatesDaily[] | undefined;

    constructor(data?: ITelemetryMetricType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.metricName = _data["metricName"];
            if (Array.isArray(_data["telemetryAggregates"])) {
                this.telemetryAggregates = [] as any;
                for (let item of _data["telemetryAggregates"])
                    this.telemetryAggregates!.push(TelemetryAggregates.fromJS(item));
            }
            if (Array.isArray(_data["telemetryAggregatesDailies"])) {
                this.telemetryAggregatesDailies = [] as any;
                for (let item of _data["telemetryAggregatesDailies"])
                    this.telemetryAggregatesDailies!.push(TelemetryAggregatesDaily.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TelemetryMetricType {
        data = typeof data === 'object' ? data : {};
        let result = new TelemetryMetricType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["metricName"] = this.metricName;
        if (Array.isArray(this.telemetryAggregates)) {
            data["telemetryAggregates"] = [];
            for (let item of this.telemetryAggregates)
                data["telemetryAggregates"].push(item.toJSON());
        }
        if (Array.isArray(this.telemetryAggregatesDailies)) {
            data["telemetryAggregatesDailies"] = [];
            for (let item of this.telemetryAggregatesDailies)
                data["telemetryAggregatesDailies"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITelemetryMetricType {
    id: number;
    metricName?: string | undefined;
    telemetryAggregates?: TelemetryAggregates[] | undefined;
    telemetryAggregatesDailies?: TelemetryAggregatesDaily[] | undefined;
}

export class TelemetryAggregatesDaily implements ITelemetryAggregatesDaily {
    unitId!: number;
    telemetryMetricTypeId!: number;
    date!: Date;
    metricValue!: number;
    unit?: Unit | undefined;
    telemetryMetricType?: TelemetryMetricType | undefined;

    constructor(data?: ITelemetryAggregatesDaily) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitId = _data["unitId"];
            this.telemetryMetricTypeId = _data["telemetryMetricTypeId"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.metricValue = _data["metricValue"];
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : <any>undefined;
            this.telemetryMetricType = _data["telemetryMetricType"] ? TelemetryMetricType.fromJS(_data["telemetryMetricType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TelemetryAggregatesDaily {
        data = typeof data === 'object' ? data : {};
        let result = new TelemetryAggregatesDaily();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitId"] = this.unitId;
        data["telemetryMetricTypeId"] = this.telemetryMetricTypeId;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["metricValue"] = this.metricValue;
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        data["telemetryMetricType"] = this.telemetryMetricType ? this.telemetryMetricType.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITelemetryAggregatesDaily {
    unitId: number;
    telemetryMetricTypeId: number;
    date: Date;
    metricValue: number;
    unit?: Unit | undefined;
    telemetryMetricType?: TelemetryMetricType | undefined;
}

export class PredictionGrouping extends ModelBaseId implements IPredictionGrouping {
    serialNumber?: string | undefined;
    emptyCounter!: number;
    actualEmptiedDate?: Date | undefined;
    previousEmptyingDate?: Date | undefined;
    fillLevelWhenEmptied?: number | undefined;
    unit?: Unit | undefined;
    predictions?: Prediction[] | undefined;

    constructor(data?: IPredictionGrouping) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.serialNumber = _data["serialNumber"];
            this.emptyCounter = _data["emptyCounter"];
            this.actualEmptiedDate = _data["actualEmptiedDate"] ? new Date(_data["actualEmptiedDate"].toString()) : <any>undefined;
            this.previousEmptyingDate = _data["previousEmptyingDate"] ? new Date(_data["previousEmptyingDate"].toString()) : <any>undefined;
            this.fillLevelWhenEmptied = _data["fillLevelWhenEmptied"];
            this.unit = _data["unit"] ? Unit.fromJS(_data["unit"]) : <any>undefined;
            if (Array.isArray(_data["predictions"])) {
                this.predictions = [] as any;
                for (let item of _data["predictions"])
                    this.predictions!.push(Prediction.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): PredictionGrouping {
        data = typeof data === 'object' ? data : {};
        let result = new PredictionGrouping();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        data["emptyCounter"] = this.emptyCounter;
        data["actualEmptiedDate"] = this.actualEmptiedDate ? this.actualEmptiedDate.toISOString() : <any>undefined;
        data["previousEmptyingDate"] = this.previousEmptyingDate ? this.previousEmptyingDate.toISOString() : <any>undefined;
        data["fillLevelWhenEmptied"] = this.fillLevelWhenEmptied;
        data["unit"] = this.unit ? this.unit.toJSON() : <any>undefined;
        if (Array.isArray(this.predictions)) {
            data["predictions"] = [];
            for (let item of this.predictions)
                data["predictions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPredictionGrouping extends IModelBaseId {
    serialNumber?: string | undefined;
    emptyCounter: number;
    actualEmptiedDate?: Date | undefined;
    previousEmptyingDate?: Date | undefined;
    fillLevelWhenEmptied?: number | undefined;
    unit?: Unit | undefined;
    predictions?: Prediction[] | undefined;
}

export class Prediction extends ModelBaseId implements IPrediction {
    serialNumber?: string | undefined;
    emptyCounter!: number;
    predictedMinutesUntilFull!: number;
    predictionDate!: Date;

    constructor(data?: IPrediction) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.serialNumber = _data["serialNumber"];
            this.emptyCounter = _data["emptyCounter"];
            this.predictedMinutesUntilFull = _data["predictedMinutesUntilFull"];
            this.predictionDate = _data["predictionDate"] ? new Date(_data["predictionDate"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): Prediction {
        data = typeof data === 'object' ? data : {};
        let result = new Prediction();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        data["emptyCounter"] = this.emptyCounter;
        data["predictedMinutesUntilFull"] = this.predictedMinutesUntilFull;
        data["predictionDate"] = this.predictionDate ? this.predictionDate.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPrediction extends IModelBaseId {
    serialNumber?: string | undefined;
    emptyCounter: number;
    predictedMinutesUntilFull: number;
    predictionDate: Date;
}

export class PortfolioTileDto extends DashboardBaseDto implements IPortfolioTileDto {
    portfolioDto?: PortfolioDto | undefined;

    constructor(data?: IPortfolioTileDto) {
        super(data);
        this._discriminator = "PortfolioTileDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.portfolioDto = _data["portfolioDto"] ? PortfolioDto.fromJS(_data["portfolioDto"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): PortfolioTileDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortfolioTileDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["portfolioDto"] = this.portfolioDto ? this.portfolioDto.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IPortfolioTileDto extends IDashboardBaseDto {
    portfolioDto?: PortfolioDto | undefined;
}

export class PortfolioDto implements IPortfolioDto {
    units!: number;
    connected!: number;

    constructor(data?: IPortfolioDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.units = _data["units"];
            this.connected = _data["connected"];
        }
    }

    static fromJS(data: any): PortfolioDto {
        data = typeof data === 'object' ? data : {};
        let result = new PortfolioDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["units"] = this.units;
        data["connected"] = this.connected;
        return data;
    }
}

export interface IPortfolioDto {
    units: number;
    connected: number;
}

export class KPIFillLevelTileDto extends DashboardBaseDto implements IKPIFillLevelTileDto {
    avgFillLevel!: number;
    currentMonth?: string | undefined;

    constructor(data?: IKPIFillLevelTileDto) {
        super(data);
        this._discriminator = "KPIFillLevelTileDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.avgFillLevel = _data["avgFillLevel"];
            this.currentMonth = _data["currentMonth"];
        }
    }

    static override fromJS(data: any): KPIFillLevelTileDto {
        data = typeof data === 'object' ? data : {};
        let result = new KPIFillLevelTileDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avgFillLevel"] = this.avgFillLevel;
        data["currentMonth"] = this.currentMonth;
        super.toJSON(data);
        return data;
    }
}

export interface IKPIFillLevelTileDto extends IDashboardBaseDto {
    avgFillLevel: number;
    currentMonth?: string | undefined;
}

export class KPIServiceTileDto extends DashboardBaseDto implements IKPIServiceTileDto {
    unitWithValidService!: number;

    constructor(data?: IKPIServiceTileDto) {
        super(data);
        this._discriminator = "KPIServiceTileDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.unitWithValidService = _data["unitWithValidService"];
        }
    }

    static override fromJS(data: any): KPIServiceTileDto {
        data = typeof data === 'object' ? data : {};
        let result = new KPIServiceTileDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitWithValidService"] = this.unitWithValidService;
        super.toJSON(data);
        return data;
    }
}

export interface IKPIServiceTileDto extends IDashboardBaseDto {
    unitWithValidService: number;
}

export class UnitsPerUnitModelsTileDto extends DashboardBaseDto implements IUnitsPerUnitModelsTileDto {
    unitsPerUnitModel?: DashboardChartItem[] | undefined;

    constructor(data?: IUnitsPerUnitModelsTileDto) {
        super(data);
        this._discriminator = "UnitsPerUnitModelsTileDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["unitsPerUnitModel"])) {
                this.unitsPerUnitModel = [] as any;
                for (let item of _data["unitsPerUnitModel"])
                    this.unitsPerUnitModel!.push(DashboardChartItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): UnitsPerUnitModelsTileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitsPerUnitModelsTileDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.unitsPerUnitModel)) {
            data["unitsPerUnitModel"] = [];
            for (let item of this.unitsPerUnitModel)
                data["unitsPerUnitModel"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUnitsPerUnitModelsTileDto extends IDashboardBaseDto {
    unitsPerUnitModel?: DashboardChartItem[] | undefined;
}

export class DashboardChartItem implements IDashboardChartItem {
    chartName?: string | undefined;
    chartValue!: number;

    constructor(data?: IDashboardChartItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chartName = _data["chartName"];
            this.chartValue = _data["chartValue"];
        }
    }

    static fromJS(data: any): DashboardChartItem {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardChartItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chartName"] = this.chartName;
        data["chartValue"] = this.chartValue;
        return data;
    }
}

export interface IDashboardChartItem {
    chartName?: string | undefined;
    chartValue: number;
}

export class FillLevelPerUnitModelsTileDto extends DashboardBaseDto implements IFillLevelPerUnitModelsTileDto {
    fillLevelPerUnitModel?: DashboardChartItem[] | undefined;

    constructor(data?: IFillLevelPerUnitModelsTileDto) {
        super(data);
        this._discriminator = "FillLevelPerUnitModelsTileDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["fillLevelPerUnitModel"])) {
                this.fillLevelPerUnitModel = [] as any;
                for (let item of _data["fillLevelPerUnitModel"])
                    this.fillLevelPerUnitModel!.push(DashboardChartItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): FillLevelPerUnitModelsTileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FillLevelPerUnitModelsTileDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fillLevelPerUnitModel)) {
            data["fillLevelPerUnitModel"] = [];
            for (let item of this.fillLevelPerUnitModel)
                data["fillLevelPerUnitModel"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFillLevelPerUnitModelsTileDto extends IDashboardBaseDto {
    fillLevelPerUnitModel?: DashboardChartItem[] | undefined;
}

export class ServiceContractTileDto extends DashboardBaseDto implements IServiceContractTileDto {
    withinOneMonth?: DashboardChartItem | undefined;
    betweenOneAndThreeMonths?: DashboardChartItem | undefined;
    overThreeMonths?: DashboardChartItem | undefined;
    notFilledOut?: DashboardChartItem | undefined;

    constructor(data?: IServiceContractTileDto) {
        super(data);
        this._discriminator = "ServiceContractTileDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.withinOneMonth = _data["withinOneMonth"] ? DashboardChartItem.fromJS(_data["withinOneMonth"]) : <any>undefined;
            this.betweenOneAndThreeMonths = _data["betweenOneAndThreeMonths"] ? DashboardChartItem.fromJS(_data["betweenOneAndThreeMonths"]) : <any>undefined;
            this.overThreeMonths = _data["overThreeMonths"] ? DashboardChartItem.fromJS(_data["overThreeMonths"]) : <any>undefined;
            this.notFilledOut = _data["notFilledOut"] ? DashboardChartItem.fromJS(_data["notFilledOut"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ServiceContractTileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceContractTileDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["withinOneMonth"] = this.withinOneMonth ? this.withinOneMonth.toJSON() : <any>undefined;
        data["betweenOneAndThreeMonths"] = this.betweenOneAndThreeMonths ? this.betweenOneAndThreeMonths.toJSON() : <any>undefined;
        data["overThreeMonths"] = this.overThreeMonths ? this.overThreeMonths.toJSON() : <any>undefined;
        data["notFilledOut"] = this.notFilledOut ? this.notFilledOut.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IServiceContractTileDto extends IDashboardBaseDto {
    withinOneMonth?: DashboardChartItem | undefined;
    betweenOneAndThreeMonths?: DashboardChartItem | undefined;
    overThreeMonths?: DashboardChartItem | undefined;
    notFilledOut?: DashboardChartItem | undefined;
}

export class CriticalErrorsTileDto extends DashboardBaseDto implements ICriticalErrorsTileDto {
    criticalErrorList?: CriticalErrorsDto[] | undefined;

    constructor(data?: ICriticalErrorsTileDto) {
        super(data);
        this._discriminator = "CriticalErrorsTileDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["criticalErrorList"])) {
                this.criticalErrorList = [] as any;
                for (let item of _data["criticalErrorList"])
                    this.criticalErrorList!.push(CriticalErrorsDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CriticalErrorsTileDto {
        data = typeof data === 'object' ? data : {};
        let result = new CriticalErrorsTileDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.criticalErrorList)) {
            data["criticalErrorList"] = [];
            for (let item of this.criticalErrorList)
                data["criticalErrorList"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICriticalErrorsTileDto extends IDashboardBaseDto {
    criticalErrorList?: CriticalErrorsDto[] | undefined;
}

export class CriticalErrorsDto implements ICriticalErrorsDto {
    controller?: string | undefined;
    hasErrors!: boolean;
    hasWarnings!: boolean;

    constructor(data?: ICriticalErrorsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.controller = _data["controller"];
            this.hasErrors = _data["hasErrors"];
            this.hasWarnings = _data["hasWarnings"];
        }
    }

    static fromJS(data: any): CriticalErrorsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CriticalErrorsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["controller"] = this.controller;
        data["hasErrors"] = this.hasErrors;
        data["hasWarnings"] = this.hasWarnings;
        return data;
    }
}

export interface ICriticalErrorsDto {
    controller?: string | undefined;
    hasErrors: boolean;
    hasWarnings: boolean;
}

export class RecordedPickUpsTileDto extends DashboardBaseDto implements IRecordedPickUpsTileDto {
    recordedPickUps?: AmountByDateType | undefined;

    constructor(data?: IRecordedPickUpsTileDto) {
        super(data);
        this._discriminator = "RecordedPickUpsTileDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.recordedPickUps = _data["recordedPickUps"] ? AmountByDateType.fromJS(_data["recordedPickUps"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): RecordedPickUpsTileDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecordedPickUpsTileDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordedPickUps"] = this.recordedPickUps ? this.recordedPickUps.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IRecordedPickUpsTileDto extends IDashboardBaseDto {
    recordedPickUps?: AmountByDateType | undefined;
}

export class AmountByDateType implements IAmountByDateType {
    dateType!: DateTypes;
    amount!: number;

    constructor(data?: IAmountByDateType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateType = _data["dateType"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): AmountByDateType {
        data = typeof data === 'object' ? data : {};
        let result = new AmountByDateType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateType"] = this.dateType;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IAmountByDateType {
    dateType: DateTypes;
    amount: number;
}

export class Last10BalesTileDto extends DashboardBaseDto implements ILast10BalesTileDto {
    balesData?: DashboardLast10BalesDto[] | undefined;

    constructor(data?: ILast10BalesTileDto) {
        super(data);
        this._discriminator = "Last10BalesTileDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["balesData"])) {
                this.balesData = [] as any;
                for (let item of _data["balesData"])
                    this.balesData!.push(DashboardLast10BalesDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): Last10BalesTileDto {
        data = typeof data === 'object' ? data : {};
        let result = new Last10BalesTileDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.balesData)) {
            data["balesData"] = [];
            for (let item of this.balesData)
                data["balesData"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ILast10BalesTileDto extends IDashboardBaseDto {
    balesData?: DashboardLast10BalesDto[] | undefined;
}

export class DashboardLast10BalesDto implements IDashboardLast10BalesDto {
    unitId?: string | undefined;
    unitModel?: string | undefined;
    date!: Date;
    weight!: number;

    constructor(data?: IDashboardLast10BalesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitId = _data["unitId"];
            this.unitModel = _data["unitModel"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            this.weight = _data["weight"];
        }
    }

    static fromJS(data: any): DashboardLast10BalesDto {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardLast10BalesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitId"] = this.unitId;
        data["unitModel"] = this.unitModel;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        data["weight"] = this.weight;
        return data;
    }
}

export interface IDashboardLast10BalesDto {
    unitId?: string | undefined;
    unitModel?: string | undefined;
    date: Date;
    weight: number;
}

export class LocationTileDto extends DashboardBaseDto implements ILocationTileDto {
    locationTileSettings!: LocationTileSettingsDto;
    staticMapMachines?: StaticMapMachineDto[] | undefined;

    constructor(data?: ILocationTileDto) {
        super(data);
        if (!data) {
            this.locationTileSettings = new LocationTileSettingsDto();
        }
        this._discriminator = "LocationTileDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.locationTileSettings = _data["locationTileSettings"] ? LocationTileSettingsDto.fromJS(_data["locationTileSettings"]) : new LocationTileSettingsDto();
            if (Array.isArray(_data["staticMapMachines"])) {
                this.staticMapMachines = [] as any;
                for (let item of _data["staticMapMachines"])
                    this.staticMapMachines!.push(StaticMapMachineDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): LocationTileDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationTileDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationTileSettings"] = this.locationTileSettings ? this.locationTileSettings.toJSON() : <any>undefined;
        if (Array.isArray(this.staticMapMachines)) {
            data["staticMapMachines"] = [];
            for (let item of this.staticMapMachines)
                data["staticMapMachines"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ILocationTileDto extends IDashboardBaseDto {
    locationTileSettings: LocationTileSettingsDto;
    staticMapMachines?: StaticMapMachineDto[] | undefined;
}

export class LocationTileSettingsDto implements ILocationTileSettingsDto {
    id!: number;
    locationName?: string | undefined;
    mapCenter?: CoordinateDto | undefined;
    zoomLevel!: number;
    mapBounds?: MapBounds | undefined;
    filter?: FilterDto | undefined;
    selectedMachines?: number[] | undefined;

    constructor(data?: ILocationTileSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationName = _data["locationName"];
            this.mapCenter = _data["mapCenter"] ? CoordinateDto.fromJS(_data["mapCenter"]) : <any>undefined;
            this.zoomLevel = _data["zoomLevel"];
            this.mapBounds = _data["mapBounds"] ? MapBounds.fromJS(_data["mapBounds"]) : <any>undefined;
            this.filter = _data["filter"] ? FilterDto.fromJS(_data["filter"]) : <any>undefined;
            if (Array.isArray(_data["selectedMachines"])) {
                this.selectedMachines = [] as any;
                for (let item of _data["selectedMachines"])
                    this.selectedMachines!.push(item);
            }
        }
    }

    static fromJS(data: any): LocationTileSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationTileSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationName"] = this.locationName;
        data["mapCenter"] = this.mapCenter ? this.mapCenter.toJSON() : <any>undefined;
        data["zoomLevel"] = this.zoomLevel;
        data["mapBounds"] = this.mapBounds ? this.mapBounds.toJSON() : <any>undefined;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        if (Array.isArray(this.selectedMachines)) {
            data["selectedMachines"] = [];
            for (let item of this.selectedMachines)
                data["selectedMachines"].push(item);
        }
        return data;
    }
}

export interface ILocationTileSettingsDto {
    id: number;
    locationName?: string | undefined;
    mapCenter?: CoordinateDto | undefined;
    zoomLevel: number;
    mapBounds?: MapBounds | undefined;
    filter?: FilterDto | undefined;
    selectedMachines?: number[] | undefined;
}

export class CoordinateDto implements ICoordinateDto {
    latitude!: number;
    longitude!: number;

    constructor(data?: ICoordinateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
        }
    }

    static fromJS(data: any): CoordinateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CoordinateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        return data;
    }
}

export interface ICoordinateDto {
    latitude: number;
    longitude: number;
}

export class MapBounds implements IMapBounds {
    south!: number;
    west!: number;
    north!: number;
    east!: number;

    constructor(data?: IMapBounds) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.south = _data["south"];
            this.west = _data["west"];
            this.north = _data["north"];
            this.east = _data["east"];
        }
    }

    static fromJS(data: any): MapBounds {
        data = typeof data === 'object' ? data : {};
        let result = new MapBounds();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["south"] = this.south;
        data["west"] = this.west;
        data["north"] = this.north;
        data["east"] = this.east;
        return data;
    }
}

export interface IMapBounds {
    south: number;
    west: number;
    north: number;
    east: number;
}

export class StaticMapMachineDto implements IStaticMapMachineDto {
    fillLevel?: number | undefined;
    hasModem!: boolean;
    latitude!: number;
    longitude!: number;
    isOnline!: boolean;

    constructor(data?: IStaticMapMachineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fillLevel = _data["fillLevel"];
            this.hasModem = _data["hasModem"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.isOnline = _data["isOnline"];
        }
    }

    static fromJS(data: any): StaticMapMachineDto {
        data = typeof data === 'object' ? data : {};
        let result = new StaticMapMachineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fillLevel"] = this.fillLevel;
        data["hasModem"] = this.hasModem;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["isOnline"] = this.isOnline;
        return data;
    }
}

export interface IStaticMapMachineDto {
    fillLevel?: number | undefined;
    hasModem: boolean;
    latitude: number;
    longitude: number;
    isOnline: boolean;
}

export class ReportTileDto extends DashboardBaseDto implements IReportTileDto {
    reportTileSettingsDto!: ReportTileSettingsDto;
    reportData?: ReportSingleUnitDto[] | undefined;
    isPreview!: boolean;

    constructor(data?: IReportTileDto) {
        super(data);
        if (!data) {
            this.reportTileSettingsDto = new ReportTileSettingsDto();
        }
        this._discriminator = "ReportTileDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.reportTileSettingsDto = _data["reportTileSettingsDto"] ? ReportTileSettingsDto.fromJS(_data["reportTileSettingsDto"]) : new ReportTileSettingsDto();
            if (Array.isArray(_data["reportData"])) {
                this.reportData = [] as any;
                for (let item of _data["reportData"])
                    this.reportData!.push(ReportSingleUnitDto.fromJS(item));
            }
            this.isPreview = _data["isPreview"];
        }
    }

    static override fromJS(data: any): ReportTileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportTileDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportTileSettingsDto"] = this.reportTileSettingsDto ? this.reportTileSettingsDto.toJSON() : <any>undefined;
        if (Array.isArray(this.reportData)) {
            data["reportData"] = [];
            for (let item of this.reportData)
                data["reportData"].push(item.toJSON());
        }
        data["isPreview"] = this.isPreview;
        super.toJSON(data);
        return data;
    }
}

export interface IReportTileDto extends IDashboardBaseDto {
    reportTileSettingsDto: ReportTileSettingsDto;
    reportData?: ReportSingleUnitDto[] | undefined;
    isPreview: boolean;
}

export class BaseReportSettingsDto implements IBaseReportSettingsDto {
    tileName?: string | undefined;
    dataType!: DataTypes;
    dateType!: DateTypes;

    constructor(data?: IBaseReportSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tileName = _data["tileName"];
            this.dataType = _data["dataType"];
            this.dateType = _data["dateType"];
        }
    }

    static fromJS(data: any): BaseReportSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseReportSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tileName"] = this.tileName;
        data["dataType"] = this.dataType;
        data["dateType"] = this.dateType;
        return data;
    }
}

export interface IBaseReportSettingsDto {
    tileName?: string | undefined;
    dataType: DataTypes;
    dateType: DateTypes;
}

export class ReportTileSettingsDto extends BaseReportSettingsDto implements IReportTileSettingsDto {
    endDate!: Date;
    startDate!: Date;
    groupingDateType!: DateTypes;

    constructor(data?: IReportTileSettingsDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.groupingDateType = _data["groupingDateType"];
        }
    }

    static override fromJS(data: any): ReportTileSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportTileSettingsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["groupingDateType"] = this.groupingDateType;
        super.toJSON(data);
        return data;
    }
}

export interface IReportTileSettingsDto extends IBaseReportSettingsDto {
    endDate: Date;
    startDate: Date;
    groupingDateType: DateTypes;
}

export class ReportSingleUnitDto implements IReportSingleUnitDto {
    unitSerialNumber?: string | undefined;
    values?: ReportValue[] | undefined;
    unitType?: string | undefined;
    machineGroupsName?: string | undefined;
    siteUser?: string | undefined;
    siteAddress?: string | undefined;
    sitePostalCode?: string | undefined;
    siteCity?: string | undefined;
    totalNumberOfPressSeries?: number | undefined;
    totalNumberOfCycles?: number | undefined;

    constructor(data?: IReportSingleUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitSerialNumber = _data["unitSerialNumber"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(ReportValue.fromJS(item));
            }
            this.unitType = _data["unitType"];
            this.machineGroupsName = _data["machineGroupsName"];
            this.siteUser = _data["siteUser"];
            this.siteAddress = _data["siteAddress"];
            this.sitePostalCode = _data["sitePostalCode"];
            this.siteCity = _data["siteCity"];
            this.totalNumberOfPressSeries = _data["totalNumberOfPressSeries"];
            this.totalNumberOfCycles = _data["totalNumberOfCycles"];
        }
    }

    static fromJS(data: any): ReportSingleUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportSingleUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitSerialNumber"] = this.unitSerialNumber;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        data["unitType"] = this.unitType;
        data["machineGroupsName"] = this.machineGroupsName;
        data["siteUser"] = this.siteUser;
        data["siteAddress"] = this.siteAddress;
        data["sitePostalCode"] = this.sitePostalCode;
        data["siteCity"] = this.siteCity;
        data["totalNumberOfPressSeries"] = this.totalNumberOfPressSeries;
        data["totalNumberOfCycles"] = this.totalNumberOfCycles;
        return data;
    }
}

export interface IReportSingleUnitDto {
    unitSerialNumber?: string | undefined;
    values?: ReportValue[] | undefined;
    unitType?: string | undefined;
    machineGroupsName?: string | undefined;
    siteUser?: string | undefined;
    siteAddress?: string | undefined;
    sitePostalCode?: string | undefined;
    siteCity?: string | undefined;
    totalNumberOfPressSeries?: number | undefined;
    totalNumberOfCycles?: number | undefined;
}

export class ReportValue implements IReportValue {
    yearPart!: number;
    datePart!: number;
    value!: number;
    numberOfEmptyings!: number;
    fillLevelWhenEmptied!: number;
    reportType!: DataTypes;

    constructor(data?: IReportValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.yearPart = _data["yearPart"];
            this.datePart = _data["datePart"];
            this.value = _data["value"];
            this.numberOfEmptyings = _data["numberOfEmptyings"];
            this.fillLevelWhenEmptied = _data["fillLevelWhenEmptied"];
            this.reportType = _data["reportType"];
        }
    }

    static fromJS(data: any): ReportValue {
        data = typeof data === 'object' ? data : {};
        let result = new ReportValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["yearPart"] = this.yearPart;
        data["datePart"] = this.datePart;
        data["value"] = this.value;
        data["numberOfEmptyings"] = this.numberOfEmptyings;
        data["fillLevelWhenEmptied"] = this.fillLevelWhenEmptied;
        data["reportType"] = this.reportType;
        return data;
    }
}

export interface IReportValue {
    yearPart: number;
    datePart: number;
    value: number;
    numberOfEmptyings: number;
    fillLevelWhenEmptied: number;
    reportType: DataTypes;
}

export class BalesProducedTileDto extends DashboardBaseDto implements IBalesProducedTileDto {
    balesProduced?: AmountByDateType | undefined;

    constructor(data?: IBalesProducedTileDto) {
        super(data);
        this._discriminator = "BalesProducedTileDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.balesProduced = _data["balesProduced"] ? AmountByDateType.fromJS(_data["balesProduced"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): BalesProducedTileDto {
        data = typeof data === 'object' ? data : {};
        let result = new BalesProducedTileDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["balesProduced"] = this.balesProduced ? this.balesProduced.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IBalesProducedTileDto extends IDashboardBaseDto {
    balesProduced?: AmountByDateType | undefined;
}

export class CreateReportTileSettingsDto extends BaseReportSettingsDto implements ICreateReportTileSettingsDto {
    filter?: FilterDto | undefined;
    deviceIds?: number[] | undefined;

    constructor(data?: ICreateReportTileSettingsDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.filter = _data["filter"] ? FilterDto.fromJS(_data["filter"]) : <any>undefined;
            if (Array.isArray(_data["deviceIds"])) {
                this.deviceIds = [] as any;
                for (let item of _data["deviceIds"])
                    this.deviceIds!.push(item);
            }
        }
    }

    static override fromJS(data: any): CreateReportTileSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReportTileSettingsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        if (Array.isArray(this.deviceIds)) {
            data["deviceIds"] = [];
            for (let item of this.deviceIds)
                data["deviceIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICreateReportTileSettingsDto extends IBaseReportSettingsDto {
    filter?: FilterDto | undefined;
    deviceIds?: number[] | undefined;
}

export class GetDebtorDto implements IGetDebtorDto {
    id!: number;
    imageFileName?: string | undefined;
    website?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    phoneNumberSales?: string | undefined;
    orderServiceLink?: string | undefined;
    orderStrappingLink?: string | undefined;

    constructor(data?: IGetDebtorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imageFileName = _data["imageFileName"];
            this.website = _data["website"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.phoneNumberSales = _data["phoneNumberSales"];
            this.orderServiceLink = _data["orderServiceLink"];
            this.orderStrappingLink = _data["orderStrappingLink"];
        }
    }

    static fromJS(data: any): GetDebtorDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetDebtorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imageFileName"] = this.imageFileName;
        data["website"] = this.website;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["phoneNumberSales"] = this.phoneNumberSales;
        data["orderServiceLink"] = this.orderServiceLink;
        data["orderStrappingLink"] = this.orderStrappingLink;
        return data;
    }
}

export interface IGetDebtorDto {
    id: number;
    imageFileName?: string | undefined;
    website?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    phoneNumberSales?: string | undefined;
    orderServiceLink?: string | undefined;
    orderStrappingLink?: string | undefined;
}

export class GPSHistoryDto implements IGPSHistoryDto {
    deviceId!: number;
    createdOn!: Date;
    updatedDate!: Date;
    homeLat?: string | undefined;
    homeLng?: string | undefined;
    currentLat?: string | undefined;
    currentLng?: string | undefined;
    distance!: number;
    source?: string | undefined;
    triggeredBy?: string | undefined;

    constructor(data?: IGPSHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.homeLat = _data["homeLat"];
            this.homeLng = _data["homeLng"];
            this.currentLat = _data["currentLat"];
            this.currentLng = _data["currentLng"];
            this.distance = _data["distance"];
            this.source = _data["source"];
            this.triggeredBy = _data["triggeredBy"];
        }
    }

    static fromJS(data: any): GPSHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new GPSHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["homeLat"] = this.homeLat;
        data["homeLng"] = this.homeLng;
        data["currentLat"] = this.currentLat;
        data["currentLng"] = this.currentLng;
        data["distance"] = this.distance;
        data["source"] = this.source;
        data["triggeredBy"] = this.triggeredBy;
        return data;
    }
}

export interface IGPSHistoryDto {
    deviceId: number;
    createdOn: Date;
    updatedDate: Date;
    homeLat?: string | undefined;
    homeLng?: string | undefined;
    currentLat?: string | undefined;
    currentLng?: string | undefined;
    distance: number;
    source?: string | undefined;
    triggeredBy?: string | undefined;
}

export class GroupsDto implements IGroupsDto {
    id!: number;
    groupName?: string | undefined;
    parentGroupId?: number | undefined;
    roleType!: RolesType;
    debtorNumber?: string | undefined;
    countryCode?: string | undefined;
    isDistributor!: boolean;

    constructor(data?: IGroupsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.groupName = _data["groupName"];
            this.parentGroupId = _data["parentGroupId"];
            this.roleType = _data["roleType"];
            this.debtorNumber = _data["debtorNumber"];
            this.countryCode = _data["countryCode"];
            this.isDistributor = _data["isDistributor"];
        }
    }

    static fromJS(data: any): GroupsDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["groupName"] = this.groupName;
        data["parentGroupId"] = this.parentGroupId;
        data["roleType"] = this.roleType;
        data["debtorNumber"] = this.debtorNumber;
        data["countryCode"] = this.countryCode;
        data["isDistributor"] = this.isDistributor;
        return data;
    }
}

export interface IGroupsDto {
    id: number;
    groupName?: string | undefined;
    parentGroupId?: number | undefined;
    roleType: RolesType;
    debtorNumber?: string | undefined;
    countryCode?: string | undefined;
    isDistributor: boolean;
}

export class CreateGroupsDto implements ICreateGroupsDto {
    groupName?: string | undefined;
    parentGroupId!: number;

    constructor(data?: ICreateGroupsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupName = _data["groupName"];
            this.parentGroupId = _data["parentGroupId"];
        }
    }

    static fromJS(data: any): CreateGroupsDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGroupsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        data["parentGroupId"] = this.parentGroupId;
        return data;
    }
}

export interface ICreateGroupsDto {
    groupName?: string | undefined;
    parentGroupId: number;
}

export class EditGroupsDto implements IEditGroupsDto {
    groupName?: string | undefined;
    groupId!: number;

    constructor(data?: IEditGroupsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupName = _data["groupName"];
            this.groupId = _data["groupId"];
        }
    }

    static fromJS(data: any): EditGroupsDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditGroupsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        data["groupId"] = this.groupId;
        return data;
    }
}

export interface IEditGroupsDto {
    groupName?: string | undefined;
    groupId: number;
}

export class EditGroupsDebtorDto implements IEditGroupsDebtorDto {
    groupId!: number;
    debtorNumber?: string | undefined;
    countryCode?: string | undefined;
    isDistributor!: boolean;
    debtor?: EditDebtorDto | undefined;

    constructor(data?: IEditGroupsDebtorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.debtorNumber = _data["debtorNumber"];
            this.countryCode = _data["countryCode"];
            this.isDistributor = _data["isDistributor"];
            this.debtor = _data["debtor"] ? EditDebtorDto.fromJS(_data["debtor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditGroupsDebtorDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditGroupsDebtorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["debtorNumber"] = this.debtorNumber;
        data["countryCode"] = this.countryCode;
        data["isDistributor"] = this.isDistributor;
        data["debtor"] = this.debtor ? this.debtor.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEditGroupsDebtorDto {
    groupId: number;
    debtorNumber?: string | undefined;
    countryCode?: string | undefined;
    isDistributor: boolean;
    debtor?: EditDebtorDto | undefined;
}

export class EditDebtorDto implements IEditDebtorDto {
    imageFileName?: string | undefined;
    website?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    phoneNumberSales?: string | undefined;
    orderServiceLink?: string | undefined;
    orderStrappingLink?: string | undefined;

    constructor(data?: IEditDebtorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.imageFileName = _data["imageFileName"];
            this.website = _data["website"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.phoneNumberSales = _data["phoneNumberSales"];
            this.orderServiceLink = _data["orderServiceLink"];
            this.orderStrappingLink = _data["orderStrappingLink"];
        }
    }

    static fromJS(data: any): EditDebtorDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditDebtorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["imageFileName"] = this.imageFileName;
        data["website"] = this.website;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["phoneNumberSales"] = this.phoneNumberSales;
        data["orderServiceLink"] = this.orderServiceLink;
        data["orderStrappingLink"] = this.orderStrappingLink;
        return data;
    }
}

export interface IEditDebtorDto {
    imageFileName?: string | undefined;
    website?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    postalCode?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    country?: string | undefined;
    phoneNumber?: string | undefined;
    email?: string | undefined;
    phoneNumberSales?: string | undefined;
    orderServiceLink?: string | undefined;
    orderStrappingLink?: string | undefined;
}

export class GroupsNameIdDto implements IGroupsNameIdDto {
    id!: number;
    name?: string | undefined;
    parentGroudId?: number | undefined;

    constructor(data?: IGroupsNameIdDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentGroudId = _data["parentGroudId"];
        }
    }

    static fromJS(data: any): GroupsNameIdDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupsNameIdDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentGroudId"] = this.parentGroudId;
        return data;
    }
}

export interface IGroupsNameIdDto {
    id: number;
    name?: string | undefined;
    parentGroudId?: number | undefined;
}

export class MachineLearningInferenceDataDto implements IMachineLearningInferenceDataDto {
    emptyCounter!: number;
    serialNumber?: string | undefined;
    currentFillLevel!: number;
    day!: number;
    cyclesSinceLastOutput!: number;
    cyclesSinceFillLevelChange!: number;
    minutesSinceLastEmptying!: number;
    dateOfLastEmptying!: Date;
    currentTime!: Date;
    minutesToCurrentFillLevel!: number;
    unitModelName?: string | undefined;
    alarmSeverity!: number;
    runningHoursSinceOutput!: number;

    constructor(data?: IMachineLearningInferenceDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emptyCounter = _data["emptyCounter"];
            this.serialNumber = _data["serialNumber"];
            this.currentFillLevel = _data["currentFillLevel"];
            this.day = _data["day"];
            this.cyclesSinceLastOutput = _data["cyclesSinceLastOutput"];
            this.cyclesSinceFillLevelChange = _data["cyclesSinceFillLevelChange"];
            this.minutesSinceLastEmptying = _data["minutesSinceLastEmptying"];
            this.dateOfLastEmptying = _data["dateOfLastEmptying"] ? new Date(_data["dateOfLastEmptying"].toString()) : <any>undefined;
            this.currentTime = _data["currentTime"] ? new Date(_data["currentTime"].toString()) : <any>undefined;
            this.minutesToCurrentFillLevel = _data["minutesToCurrentFillLevel"];
            this.unitModelName = _data["unitModelName"];
            this.alarmSeverity = _data["alarmSeverity"];
            this.runningHoursSinceOutput = _data["runningHoursSinceOutput"];
        }
    }

    static fromJS(data: any): MachineLearningInferenceDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new MachineLearningInferenceDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emptyCounter"] = this.emptyCounter;
        data["serialNumber"] = this.serialNumber;
        data["currentFillLevel"] = this.currentFillLevel;
        data["day"] = this.day;
        data["cyclesSinceLastOutput"] = this.cyclesSinceLastOutput;
        data["cyclesSinceFillLevelChange"] = this.cyclesSinceFillLevelChange;
        data["minutesSinceLastEmptying"] = this.minutesSinceLastEmptying;
        data["dateOfLastEmptying"] = this.dateOfLastEmptying ? this.dateOfLastEmptying.toISOString() : <any>undefined;
        data["currentTime"] = this.currentTime ? this.currentTime.toISOString() : <any>undefined;
        data["minutesToCurrentFillLevel"] = this.minutesToCurrentFillLevel;
        data["unitModelName"] = this.unitModelName;
        data["alarmSeverity"] = this.alarmSeverity;
        data["runningHoursSinceOutput"] = this.runningHoursSinceOutput;
        return data;
    }
}

export interface IMachineLearningInferenceDataDto {
    emptyCounter: number;
    serialNumber?: string | undefined;
    currentFillLevel: number;
    day: number;
    cyclesSinceLastOutput: number;
    cyclesSinceFillLevelChange: number;
    minutesSinceLastEmptying: number;
    dateOfLastEmptying: Date;
    currentTime: Date;
    minutesToCurrentFillLevel: number;
    unitModelName?: string | undefined;
    alarmSeverity: number;
    runningHoursSinceOutput: number;
}

export class MachineLearningTrainingDataDto extends MachineLearningInferenceDataDto implements IMachineLearningTrainingDataDto {
    minutesUntilFullNotif!: number;

    constructor(data?: IMachineLearningTrainingDataDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minutesUntilFullNotif = _data["minutesUntilFullNotif"];
        }
    }

    static override fromJS(data: any): MachineLearningTrainingDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new MachineLearningTrainingDataDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minutesUntilFullNotif"] = this.minutesUntilFullNotif;
        super.toJSON(data);
        return data;
    }
}

export interface IMachineLearningTrainingDataDto extends IMachineLearningInferenceDataDto {
    minutesUntilFullNotif: number;
}

export class PredictionDto implements IPredictionDto {
    serialNumber?: string | undefined;
    emptyCounter!: number;
    predictedMinutesUntilFull!: number;
    predictionDate!: Date;

    constructor(data?: IPredictionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"];
            this.emptyCounter = _data["emptyCounter"];
            this.predictedMinutesUntilFull = _data["predictedMinutesUntilFull"];
            this.predictionDate = _data["predictionDate"] ? new Date(_data["predictionDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PredictionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PredictionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        data["emptyCounter"] = this.emptyCounter;
        data["predictedMinutesUntilFull"] = this.predictedMinutesUntilFull;
        data["predictionDate"] = this.predictionDate ? this.predictionDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPredictionDto {
    serialNumber?: string | undefined;
    emptyCounter: number;
    predictedMinutesUntilFull: number;
    predictionDate: Date;
}

export class PredictionGroupingDto implements IPredictionGroupingDto {
    serialNumber?: string | undefined;
    emptyCounter!: number;
    actualEmptiedDate?: Date | undefined;
    previousEmptyingDate?: Date | undefined;
    fillLevelWhenEmptied?: number | undefined;
    predictions?: PredictionDto[] | undefined;

    constructor(data?: IPredictionGroupingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"];
            this.emptyCounter = _data["emptyCounter"];
            this.actualEmptiedDate = _data["actualEmptiedDate"] ? new Date(_data["actualEmptiedDate"].toString()) : <any>undefined;
            this.previousEmptyingDate = _data["previousEmptyingDate"] ? new Date(_data["previousEmptyingDate"].toString()) : <any>undefined;
            this.fillLevelWhenEmptied = _data["fillLevelWhenEmptied"];
            if (Array.isArray(_data["predictions"])) {
                this.predictions = [] as any;
                for (let item of _data["predictions"])
                    this.predictions!.push(PredictionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PredictionGroupingDto {
        data = typeof data === 'object' ? data : {};
        let result = new PredictionGroupingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        data["emptyCounter"] = this.emptyCounter;
        data["actualEmptiedDate"] = this.actualEmptiedDate ? this.actualEmptiedDate.toISOString() : <any>undefined;
        data["previousEmptyingDate"] = this.previousEmptyingDate ? this.previousEmptyingDate.toISOString() : <any>undefined;
        data["fillLevelWhenEmptied"] = this.fillLevelWhenEmptied;
        if (Array.isArray(this.predictions)) {
            data["predictions"] = [];
            for (let item of this.predictions)
                data["predictions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPredictionGroupingDto {
    serialNumber?: string | undefined;
    emptyCounter: number;
    actualEmptiedDate?: Date | undefined;
    previousEmptyingDate?: Date | undefined;
    fillLevelWhenEmptied?: number | undefined;
    predictions?: PredictionDto[] | undefined;
}

export class NavFileResult implements INavFileResult {
    fileName?: string | undefined;
    invalidUnitInfos?: NavInvalidUnitInfo[] | undefined;

    constructor(data?: INavFileResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            if (Array.isArray(_data["invalidUnitInfos"])) {
                this.invalidUnitInfos = [] as any;
                for (let item of _data["invalidUnitInfos"])
                    this.invalidUnitInfos!.push(NavInvalidUnitInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NavFileResult {
        data = typeof data === 'object' ? data : {};
        let result = new NavFileResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        if (Array.isArray(this.invalidUnitInfos)) {
            data["invalidUnitInfos"] = [];
            for (let item of this.invalidUnitInfos)
                data["invalidUnitInfos"].push(item.toJSON());
        }
        return data;
    }
}

export interface INavFileResult {
    fileName?: string | undefined;
    invalidUnitInfos?: NavInvalidUnitInfo[] | undefined;
}

export class NavInvalidUnitInfo implements INavInvalidUnitInfo {
    columnNames?: string[] | undefined;
    unitId?: string | undefined;

    constructor(data?: INavInvalidUnitInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columnNames"])) {
                this.columnNames = [] as any;
                for (let item of _data["columnNames"])
                    this.columnNames!.push(item);
            }
            this.unitId = _data["unitId"];
        }
    }

    static fromJS(data: any): NavInvalidUnitInfo {
        data = typeof data === 'object' ? data : {};
        let result = new NavInvalidUnitInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columnNames)) {
            data["columnNames"] = [];
            for (let item of this.columnNames)
                data["columnNames"].push(item);
        }
        data["unitId"] = this.unitId;
        return data;
    }
}

export interface INavInvalidUnitInfo {
    columnNames?: string[] | undefined;
    unitId?: string | undefined;
}

export class NavUnitFromCsvDto implements INavUnitFromCsvDto {
    fileName!: string;
    unitId?: string | undefined;
    modelCode?: string | undefined;
    en_GB_ElectricalDiagrams?: string | undefined;
    en_GB_HydraulicsDiagrams?: string | undefined;
    en_Diagrams?: string | undefined;
    de_Diagrams?: string | undefined;
    xX_Diagrams?: string | undefined;
    en_Usermanual?: string | undefined;
    de_Usermanual?: string | undefined;
    xX_Usermanual?: string | undefined;
    da_DK_Manual?: string | undefined;
    da_DK_Manual2?: string | undefined;
    da_DK_Manual3?: string | undefined;
    en_GB_Manual?: string | undefined;
    en_GB_Manual2?: string | undefined;
    en_GB_Manual3?: string | undefined;
    en_UK_Manual?: string | undefined;
    en_UK_Manual2?: string | undefined;
    en_UK_Manual3?: string | undefined;
    de_DE_Manual?: string | undefined;
    de_DE_Manual2?: string | undefined;
    de_DE_Manual3?: string | undefined;
    nl_NL_Manual?: string | undefined;
    nl_NL_Manual2?: string | undefined;
    nl_NL_Manual3?: string | undefined;
    fr_FR_Manual?: string | undefined;
    fr_FR_Manual2?: string | undefined;
    fr_FR_Manual3?: string | undefined;
    sv_SE_Manual?: string | undefined;
    sv_SE_Manual2?: string | undefined;
    sv_SE_Manual3?: string | undefined;
    nb_NO_Manual?: string | undefined;
    nb_NO_Manual2?: string | undefined;
    nb_NO_Manual3?: string | undefined;
    fi_FI_Manual?: string | undefined;
    fi_FI_Manual2?: string | undefined;
    fi_FI_Manual3?: string | undefined;
    ru_RU_Manual?: string | undefined;
    ru_RU_Manual2?: string | undefined;
    ru_RU_Manual3?: string | undefined;
    ja_JP_Manual?: string | undefined;
    ja_JP_Manual2?: string | undefined;
    ja_JP_Manual3?: string | undefined;
    pl_PL_Manual?: string | undefined;
    pl_PL_Manual2?: string | undefined;
    pl_PL_Manual3?: string | undefined;
    es_ES_Manual?: string | undefined;
    es_ES_Manual2?: string | undefined;
    es_ES_Manual3?: string | undefined;
    pt_PT_Manual?: string | undefined;
    pt_PT_Manual2?: string | undefined;
    pt_PT_Manual3?: string | undefined;
    ko_KR_Manual?: string | undefined;
    ko_KR_Manual2?: string | undefined;
    ko_KR_Manual3?: string | undefined;
    it_IT_Manual?: string | undefined;
    it_IT_Manual2?: string | undefined;
    it_IT_Manual3?: string | undefined;
    hu_HU_Manual?: string | undefined;
    hu_HU_Manual2?: string | undefined;
    hu_HU_Manual3?: string | undefined;
    cs_CZ_Manual?: string | undefined;
    cs_CZ_Manual2?: string | undefined;
    cs_CZ_Manual3?: string | undefined;
    ro_RO_Manual?: string | undefined;
    ro_RO_Manual2?: string | undefined;
    ro_RO_Manual3?: string | undefined;
    el_GR_Manual?: string | undefined;
    el_GR_Manual2?: string | undefined;
    el_GR_Manual3?: string | undefined;
    tr_TR_Manual?: string | undefined;
    tr_TR_Manual2?: string | undefined;
    tr_TR_Manual3?: string | undefined;
    lt_LT_Manual?: string | undefined;
    lt_LT_Manual2?: string | undefined;
    lt_LT_Manual3?: string | undefined;
    sl_SL_Manual?: string | undefined;
    sl_SL_Manual2?: string | undefined;
    sl_SL_Manual3?: string | undefined;
    bg_BG_Manual?: string | undefined;
    bg_BG_Manual2?: string | undefined;
    bg_BG_Manual3?: string | undefined;
    hr_HR_Manual?: string | undefined;
    hr_HR_Manual2?: string | undefined;
    hr_HR_Manual3?: string | undefined;
    et_EE_Manual?: string | undefined;
    et_EE_Manual2?: string | undefined;
    et_EE_Manual3?: string | undefined;
    is_IS_Manual?: string | undefined;
    is_IS_Manual2?: string | undefined;
    is_IS_Manual3?: string | undefined;
    lv_LV_Manual?: string | undefined;
    lv_LV_Manual2?: string | undefined;
    lv_LV_Manual3?: string | undefined;
    zh_CN_Manual?: string | undefined;
    zh_CN_Manual2?: string | undefined;
    zh_CN_Manual3?: string | undefined;
    th_TH_Manual?: string | undefined;
    th_TH_Manual2?: string | undefined;
    th_TH_Manual3?: string | undefined;
    he_IL_Manual?: string | undefined;
    he_IL_Manual2?: string | undefined;
    he_IL_Manual3?: string | undefined;
    fr_CA_Manual?: string | undefined;
    fr_CA_Manual2?: string | undefined;
    fr_CA_Manual3?: string | undefined;
    en_US_Manual?: string | undefined;
    en_US_Manual2?: string | undefined;
    en_US_Manual3?: string | undefined;
    es_US_Manual?: string | undefined;
    es_US_Manual2?: string | undefined;
    es_US_Manual3?: string | undefined;
    sk_SK_Manual?: string | undefined;
    sk_SK_Manual2?: string | undefined;
    sk_SK_Manual3?: string | undefined;
    en_GB_Quickguides?: string | undefined;
    da_DK_UserVideo?: string | undefined;
    da_DK_UserVideo2?: string | undefined;
    da_DK_UserVideo3?: string | undefined;
    en_GB_UserVideo?: string | undefined;
    en_GB_UserVideo2?: string | undefined;
    en_GB_UserVideo3?: string | undefined;
    en_UK_UserVideo?: string | undefined;
    en_UK_UserVideo2?: string | undefined;
    en_UK_UserVideo3?: string | undefined;
    de_DE_UserVideo?: string | undefined;
    de_DE_UserVideo2?: string | undefined;
    de_DE_UserVideo3?: string | undefined;
    nl_NL_UserVideo?: string | undefined;
    nl_NL_UserVideo2?: string | undefined;
    nl_NL_UserVideo3?: string | undefined;
    fr_FR_UserVideo?: string | undefined;
    fr_FR_UserVideo2?: string | undefined;
    fr_FR_UserVideo3?: string | undefined;
    sv_SE_UserVideo?: string | undefined;
    sv_SE_UserVideo2?: string | undefined;
    sv_SE_UserVideo3?: string | undefined;
    nb_NO_UserVideo?: string | undefined;
    nb_NO_UserVideo2?: string | undefined;
    nb_NO_UserVideo3?: string | undefined;
    fi_FI_UserVideo?: string | undefined;
    fi_FI_UserVideo2?: string | undefined;
    fi_FI_UserVideo3?: string | undefined;
    ru_RU_UserVideo?: string | undefined;
    ru_RU_UserVideo2?: string | undefined;
    ru_RU_UserVideo3?: string | undefined;
    ja_JP_UserVideo?: string | undefined;
    ja_JP_UserVideo2?: string | undefined;
    ja_JP_UserVideo3?: string | undefined;
    pl_PL_UserVideo?: string | undefined;
    pl_PL_UserVideo2?: string | undefined;
    pl_PL_UserVideo3?: string | undefined;
    es_ES_UserVideo?: string | undefined;
    es_ES_UserVideo2?: string | undefined;
    es_ES_UserVideo3?: string | undefined;
    pt_PT_UserVideo?: string | undefined;
    pt_PT_UserVideo2?: string | undefined;
    pt_PT_UserVideo3?: string | undefined;
    ko_KR_UserVideo?: string | undefined;
    ko_KR_UserVideo2?: string | undefined;
    ko_KR_UserVideo3?: string | undefined;
    it_IT_UserVideo?: string | undefined;
    it_IT_UserVideo2?: string | undefined;
    it_IT_UserVideo3?: string | undefined;
    hu_HU_UserVideo?: string | undefined;
    hu_HU_UserVideo2?: string | undefined;
    hu_HU_UserVideo3?: string | undefined;
    cs_CZ_UserVideo?: string | undefined;
    cs_CZ_UserVideo2?: string | undefined;
    cs_CZ_UserVideo3?: string | undefined;
    ro_RO_UserVideo?: string | undefined;
    ro_RO_UserVideo2?: string | undefined;
    ro_RO_UserVideo3?: string | undefined;
    el_GR_UserVideo?: string | undefined;
    el_GR_UserVideo2?: string | undefined;
    el_GR_UserVideo3?: string | undefined;
    tr_TR_UserVideo?: string | undefined;
    tr_TR_UserVideo2?: string | undefined;
    tr_TR_UserVideo3?: string | undefined;
    lt_LT_UserVideo?: string | undefined;
    lt_LT_UserVideo2?: string | undefined;
    lt_LT_UserVideo3?: string | undefined;
    sl_SL_UserVideo?: string | undefined;
    sl_SL_UserVideo2?: string | undefined;
    sl_SL_UserVideo3?: string | undefined;
    bg_BG_UserVideo?: string | undefined;
    bg_BG_UserVideo2?: string | undefined;
    bg_BG_UserVideo3?: string | undefined;
    hr_HR_UserVideo?: string | undefined;
    hr_HR_UserVideo2?: string | undefined;
    hr_HR_UserVideo3?: string | undefined;
    et_EE_UserVideo?: string | undefined;
    et_EE_UserVideo2?: string | undefined;
    et_EE_UserVideo3?: string | undefined;
    is_IS_UserVideo?: string | undefined;
    is_IS_UserVideo2?: string | undefined;
    is_IS_UserVideo3?: string | undefined;
    lv_LV_UserVideo?: string | undefined;
    lv_LV_UserVideo2?: string | undefined;
    lv_LV_UserVideo3?: string | undefined;
    zh_CN_UserVideo?: string | undefined;
    zh_CN_UserVideo2?: string | undefined;
    zh_CN_UserVideo3?: string | undefined;
    th_TH_UserVideo?: string | undefined;
    th_TH_UserVideo2?: string | undefined;
    th_TH_UserVideo3?: string | undefined;
    he_IL_UserVideo?: string | undefined;
    he_IL_UserVideo2?: string | undefined;
    he_IL_UserVideo3?: string | undefined;
    fr_CA_UserVideo?: string | undefined;
    fr_CA_UserVideo2?: string | undefined;
    fr_CA_UserVideo3?: string | undefined;
    en_US_UserVideo?: string | undefined;
    en_US_UserVideo2?: string | undefined;
    en_US_UserVideo3?: string | undefined;
    es_US_UserVideo?: string | undefined;
    es_US_UserVideo2?: string | undefined;
    es_US_UserVideo3?: string | undefined;
    sk_SK_UserVideo?: string | undefined;
    sk_SK_UserVideo2?: string | undefined;
    sk_SK_UserVideo3?: string | undefined;
    en_GB_Servicevideo1?: string | undefined;
    en_GB_Servicevideo2?: string | undefined;
    en_GB_Servicevideo3?: string | undefined;
    en_GB_Servicevideo4?: string | undefined;
    en_GB_Servicevideo5?: string | undefined;
    en_GB_Servicevideo6?: string | undefined;
    en_GB_SparePartsManualWW?: string | undefined;
    debtorNumberForBilling?: string | undefined;
    customer?: string | undefined;
    distributorCountry?: string | undefined;
    siteUser?: string | undefined;
    siteAddress?: string | undefined;
    siteCity?: string | undefined;
    sitePostalCode?: string | undefined;
    installationDate?: string | undefined;
    warrantyEndDate?: string | undefined;
    machineType?: string | undefined;
    containerSize?: string | undefined;

    constructor(data?: INavUnitFromCsvDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.unitId = _data["unitId"];
            this.modelCode = _data["modelCode"];
            this.en_GB_ElectricalDiagrams = _data["en_GB_ElectricalDiagrams"];
            this.en_GB_HydraulicsDiagrams = _data["en_GB_HydraulicsDiagrams"];
            this.en_Diagrams = _data["en_Diagrams"];
            this.de_Diagrams = _data["de_Diagrams"];
            this.xX_Diagrams = _data["xX_Diagrams"];
            this.en_Usermanual = _data["en_Usermanual"];
            this.de_Usermanual = _data["de_Usermanual"];
            this.xX_Usermanual = _data["xX_Usermanual"];
            this.da_DK_Manual = _data["da_DK_Manual"];
            this.da_DK_Manual2 = _data["da_DK_Manual2"];
            this.da_DK_Manual3 = _data["da_DK_Manual3"];
            this.en_GB_Manual = _data["en_GB_Manual"];
            this.en_GB_Manual2 = _data["en_GB_Manual2"];
            this.en_GB_Manual3 = _data["en_GB_Manual3"];
            this.en_UK_Manual = _data["en_UK_Manual"];
            this.en_UK_Manual2 = _data["en_UK_Manual2"];
            this.en_UK_Manual3 = _data["en_UK_Manual3"];
            this.de_DE_Manual = _data["de_DE_Manual"];
            this.de_DE_Manual2 = _data["de_DE_Manual2"];
            this.de_DE_Manual3 = _data["de_DE_Manual3"];
            this.nl_NL_Manual = _data["nl_NL_Manual"];
            this.nl_NL_Manual2 = _data["nl_NL_Manual2"];
            this.nl_NL_Manual3 = _data["nl_NL_Manual3"];
            this.fr_FR_Manual = _data["fr_FR_Manual"];
            this.fr_FR_Manual2 = _data["fr_FR_Manual2"];
            this.fr_FR_Manual3 = _data["fr_FR_Manual3"];
            this.sv_SE_Manual = _data["sv_SE_Manual"];
            this.sv_SE_Manual2 = _data["sv_SE_Manual2"];
            this.sv_SE_Manual3 = _data["sv_SE_Manual3"];
            this.nb_NO_Manual = _data["nb_NO_Manual"];
            this.nb_NO_Manual2 = _data["nb_NO_Manual2"];
            this.nb_NO_Manual3 = _data["nb_NO_Manual3"];
            this.fi_FI_Manual = _data["fi_FI_Manual"];
            this.fi_FI_Manual2 = _data["fi_FI_Manual2"];
            this.fi_FI_Manual3 = _data["fi_FI_Manual3"];
            this.ru_RU_Manual = _data["ru_RU_Manual"];
            this.ru_RU_Manual2 = _data["ru_RU_Manual2"];
            this.ru_RU_Manual3 = _data["ru_RU_Manual3"];
            this.ja_JP_Manual = _data["ja_JP_Manual"];
            this.ja_JP_Manual2 = _data["ja_JP_Manual2"];
            this.ja_JP_Manual3 = _data["ja_JP_Manual3"];
            this.pl_PL_Manual = _data["pl_PL_Manual"];
            this.pl_PL_Manual2 = _data["pl_PL_Manual2"];
            this.pl_PL_Manual3 = _data["pl_PL_Manual3"];
            this.es_ES_Manual = _data["es_ES_Manual"];
            this.es_ES_Manual2 = _data["es_ES_Manual2"];
            this.es_ES_Manual3 = _data["es_ES_Manual3"];
            this.pt_PT_Manual = _data["pt_PT_Manual"];
            this.pt_PT_Manual2 = _data["pt_PT_Manual2"];
            this.pt_PT_Manual3 = _data["pt_PT_Manual3"];
            this.ko_KR_Manual = _data["ko_KR_Manual"];
            this.ko_KR_Manual2 = _data["ko_KR_Manual2"];
            this.ko_KR_Manual3 = _data["ko_KR_Manual3"];
            this.it_IT_Manual = _data["it_IT_Manual"];
            this.it_IT_Manual2 = _data["it_IT_Manual2"];
            this.it_IT_Manual3 = _data["it_IT_Manual3"];
            this.hu_HU_Manual = _data["hu_HU_Manual"];
            this.hu_HU_Manual2 = _data["hu_HU_Manual2"];
            this.hu_HU_Manual3 = _data["hu_HU_Manual3"];
            this.cs_CZ_Manual = _data["cs_CZ_Manual"];
            this.cs_CZ_Manual2 = _data["cs_CZ_Manual2"];
            this.cs_CZ_Manual3 = _data["cs_CZ_Manual3"];
            this.ro_RO_Manual = _data["ro_RO_Manual"];
            this.ro_RO_Manual2 = _data["ro_RO_Manual2"];
            this.ro_RO_Manual3 = _data["ro_RO_Manual3"];
            this.el_GR_Manual = _data["el_GR_Manual"];
            this.el_GR_Manual2 = _data["el_GR_Manual2"];
            this.el_GR_Manual3 = _data["el_GR_Manual3"];
            this.tr_TR_Manual = _data["tr_TR_Manual"];
            this.tr_TR_Manual2 = _data["tr_TR_Manual2"];
            this.tr_TR_Manual3 = _data["tr_TR_Manual3"];
            this.lt_LT_Manual = _data["lt_LT_Manual"];
            this.lt_LT_Manual2 = _data["lt_LT_Manual2"];
            this.lt_LT_Manual3 = _data["lt_LT_Manual3"];
            this.sl_SL_Manual = _data["sl_SL_Manual"];
            this.sl_SL_Manual2 = _data["sl_SL_Manual2"];
            this.sl_SL_Manual3 = _data["sl_SL_Manual3"];
            this.bg_BG_Manual = _data["bg_BG_Manual"];
            this.bg_BG_Manual2 = _data["bg_BG_Manual2"];
            this.bg_BG_Manual3 = _data["bg_BG_Manual3"];
            this.hr_HR_Manual = _data["hr_HR_Manual"];
            this.hr_HR_Manual2 = _data["hr_HR_Manual2"];
            this.hr_HR_Manual3 = _data["hr_HR_Manual3"];
            this.et_EE_Manual = _data["et_EE_Manual"];
            this.et_EE_Manual2 = _data["et_EE_Manual2"];
            this.et_EE_Manual3 = _data["et_EE_Manual3"];
            this.is_IS_Manual = _data["is_IS_Manual"];
            this.is_IS_Manual2 = _data["is_IS_Manual2"];
            this.is_IS_Manual3 = _data["is_IS_Manual3"];
            this.lv_LV_Manual = _data["lv_LV_Manual"];
            this.lv_LV_Manual2 = _data["lv_LV_Manual2"];
            this.lv_LV_Manual3 = _data["lv_LV_Manual3"];
            this.zh_CN_Manual = _data["zh_CN_Manual"];
            this.zh_CN_Manual2 = _data["zh_CN_Manual2"];
            this.zh_CN_Manual3 = _data["zh_CN_Manual3"];
            this.th_TH_Manual = _data["th_TH_Manual"];
            this.th_TH_Manual2 = _data["th_TH_Manual2"];
            this.th_TH_Manual3 = _data["th_TH_Manual3"];
            this.he_IL_Manual = _data["he_IL_Manual"];
            this.he_IL_Manual2 = _data["he_IL_Manual2"];
            this.he_IL_Manual3 = _data["he_IL_Manual3"];
            this.fr_CA_Manual = _data["fr_CA_Manual"];
            this.fr_CA_Manual2 = _data["fr_CA_Manual2"];
            this.fr_CA_Manual3 = _data["fr_CA_Manual3"];
            this.en_US_Manual = _data["en_US_Manual"];
            this.en_US_Manual2 = _data["en_US_Manual2"];
            this.en_US_Manual3 = _data["en_US_Manual3"];
            this.es_US_Manual = _data["es_US_Manual"];
            this.es_US_Manual2 = _data["es_US_Manual2"];
            this.es_US_Manual3 = _data["es_US_Manual3"];
            this.sk_SK_Manual = _data["sk_SK_Manual"];
            this.sk_SK_Manual2 = _data["sk_SK_Manual2"];
            this.sk_SK_Manual3 = _data["sk_SK_Manual3"];
            this.en_GB_Quickguides = _data["en_GB_Quickguides"];
            this.da_DK_UserVideo = _data["da_DK_UserVideo"];
            this.da_DK_UserVideo2 = _data["da_DK_UserVideo2"];
            this.da_DK_UserVideo3 = _data["da_DK_UserVideo3"];
            this.en_GB_UserVideo = _data["en_GB_UserVideo"];
            this.en_GB_UserVideo2 = _data["en_GB_UserVideo2"];
            this.en_GB_UserVideo3 = _data["en_GB_UserVideo3"];
            this.en_UK_UserVideo = _data["en_UK_UserVideo"];
            this.en_UK_UserVideo2 = _data["en_UK_UserVideo2"];
            this.en_UK_UserVideo3 = _data["en_UK_UserVideo3"];
            this.de_DE_UserVideo = _data["de_DE_UserVideo"];
            this.de_DE_UserVideo2 = _data["de_DE_UserVideo2"];
            this.de_DE_UserVideo3 = _data["de_DE_UserVideo3"];
            this.nl_NL_UserVideo = _data["nl_NL_UserVideo"];
            this.nl_NL_UserVideo2 = _data["nl_NL_UserVideo2"];
            this.nl_NL_UserVideo3 = _data["nl_NL_UserVideo3"];
            this.fr_FR_UserVideo = _data["fr_FR_UserVideo"];
            this.fr_FR_UserVideo2 = _data["fr_FR_UserVideo2"];
            this.fr_FR_UserVideo3 = _data["fr_FR_UserVideo3"];
            this.sv_SE_UserVideo = _data["sv_SE_UserVideo"];
            this.sv_SE_UserVideo2 = _data["sv_SE_UserVideo2"];
            this.sv_SE_UserVideo3 = _data["sv_SE_UserVideo3"];
            this.nb_NO_UserVideo = _data["nb_NO_UserVideo"];
            this.nb_NO_UserVideo2 = _data["nb_NO_UserVideo2"];
            this.nb_NO_UserVideo3 = _data["nb_NO_UserVideo3"];
            this.fi_FI_UserVideo = _data["fi_FI_UserVideo"];
            this.fi_FI_UserVideo2 = _data["fi_FI_UserVideo2"];
            this.fi_FI_UserVideo3 = _data["fi_FI_UserVideo3"];
            this.ru_RU_UserVideo = _data["ru_RU_UserVideo"];
            this.ru_RU_UserVideo2 = _data["ru_RU_UserVideo2"];
            this.ru_RU_UserVideo3 = _data["ru_RU_UserVideo3"];
            this.ja_JP_UserVideo = _data["ja_JP_UserVideo"];
            this.ja_JP_UserVideo2 = _data["ja_JP_UserVideo2"];
            this.ja_JP_UserVideo3 = _data["ja_JP_UserVideo3"];
            this.pl_PL_UserVideo = _data["pl_PL_UserVideo"];
            this.pl_PL_UserVideo2 = _data["pl_PL_UserVideo2"];
            this.pl_PL_UserVideo3 = _data["pl_PL_UserVideo3"];
            this.es_ES_UserVideo = _data["es_ES_UserVideo"];
            this.es_ES_UserVideo2 = _data["es_ES_UserVideo2"];
            this.es_ES_UserVideo3 = _data["es_ES_UserVideo3"];
            this.pt_PT_UserVideo = _data["pt_PT_UserVideo"];
            this.pt_PT_UserVideo2 = _data["pt_PT_UserVideo2"];
            this.pt_PT_UserVideo3 = _data["pt_PT_UserVideo3"];
            this.ko_KR_UserVideo = _data["ko_KR_UserVideo"];
            this.ko_KR_UserVideo2 = _data["ko_KR_UserVideo2"];
            this.ko_KR_UserVideo3 = _data["ko_KR_UserVideo3"];
            this.it_IT_UserVideo = _data["it_IT_UserVideo"];
            this.it_IT_UserVideo2 = _data["it_IT_UserVideo2"];
            this.it_IT_UserVideo3 = _data["it_IT_UserVideo3"];
            this.hu_HU_UserVideo = _data["hu_HU_UserVideo"];
            this.hu_HU_UserVideo2 = _data["hu_HU_UserVideo2"];
            this.hu_HU_UserVideo3 = _data["hu_HU_UserVideo3"];
            this.cs_CZ_UserVideo = _data["cs_CZ_UserVideo"];
            this.cs_CZ_UserVideo2 = _data["cs_CZ_UserVideo2"];
            this.cs_CZ_UserVideo3 = _data["cs_CZ_UserVideo3"];
            this.ro_RO_UserVideo = _data["ro_RO_UserVideo"];
            this.ro_RO_UserVideo2 = _data["ro_RO_UserVideo2"];
            this.ro_RO_UserVideo3 = _data["ro_RO_UserVideo3"];
            this.el_GR_UserVideo = _data["el_GR_UserVideo"];
            this.el_GR_UserVideo2 = _data["el_GR_UserVideo2"];
            this.el_GR_UserVideo3 = _data["el_GR_UserVideo3"];
            this.tr_TR_UserVideo = _data["tr_TR_UserVideo"];
            this.tr_TR_UserVideo2 = _data["tr_TR_UserVideo2"];
            this.tr_TR_UserVideo3 = _data["tr_TR_UserVideo3"];
            this.lt_LT_UserVideo = _data["lt_LT_UserVideo"];
            this.lt_LT_UserVideo2 = _data["lt_LT_UserVideo2"];
            this.lt_LT_UserVideo3 = _data["lt_LT_UserVideo3"];
            this.sl_SL_UserVideo = _data["sl_SL_UserVideo"];
            this.sl_SL_UserVideo2 = _data["sl_SL_UserVideo2"];
            this.sl_SL_UserVideo3 = _data["sl_SL_UserVideo3"];
            this.bg_BG_UserVideo = _data["bg_BG_UserVideo"];
            this.bg_BG_UserVideo2 = _data["bg_BG_UserVideo2"];
            this.bg_BG_UserVideo3 = _data["bg_BG_UserVideo3"];
            this.hr_HR_UserVideo = _data["hr_HR_UserVideo"];
            this.hr_HR_UserVideo2 = _data["hr_HR_UserVideo2"];
            this.hr_HR_UserVideo3 = _data["hr_HR_UserVideo3"];
            this.et_EE_UserVideo = _data["et_EE_UserVideo"];
            this.et_EE_UserVideo2 = _data["et_EE_UserVideo2"];
            this.et_EE_UserVideo3 = _data["et_EE_UserVideo3"];
            this.is_IS_UserVideo = _data["is_IS_UserVideo"];
            this.is_IS_UserVideo2 = _data["is_IS_UserVideo2"];
            this.is_IS_UserVideo3 = _data["is_IS_UserVideo3"];
            this.lv_LV_UserVideo = _data["lv_LV_UserVideo"];
            this.lv_LV_UserVideo2 = _data["lv_LV_UserVideo2"];
            this.lv_LV_UserVideo3 = _data["lv_LV_UserVideo3"];
            this.zh_CN_UserVideo = _data["zh_CN_UserVideo"];
            this.zh_CN_UserVideo2 = _data["zh_CN_UserVideo2"];
            this.zh_CN_UserVideo3 = _data["zh_CN_UserVideo3"];
            this.th_TH_UserVideo = _data["th_TH_UserVideo"];
            this.th_TH_UserVideo2 = _data["th_TH_UserVideo2"];
            this.th_TH_UserVideo3 = _data["th_TH_UserVideo3"];
            this.he_IL_UserVideo = _data["he_IL_UserVideo"];
            this.he_IL_UserVideo2 = _data["he_IL_UserVideo2"];
            this.he_IL_UserVideo3 = _data["he_IL_UserVideo3"];
            this.fr_CA_UserVideo = _data["fr_CA_UserVideo"];
            this.fr_CA_UserVideo2 = _data["fr_CA_UserVideo2"];
            this.fr_CA_UserVideo3 = _data["fr_CA_UserVideo3"];
            this.en_US_UserVideo = _data["en_US_UserVideo"];
            this.en_US_UserVideo2 = _data["en_US_UserVideo2"];
            this.en_US_UserVideo3 = _data["en_US_UserVideo3"];
            this.es_US_UserVideo = _data["es_US_UserVideo"];
            this.es_US_UserVideo2 = _data["es_US_UserVideo2"];
            this.es_US_UserVideo3 = _data["es_US_UserVideo3"];
            this.sk_SK_UserVideo = _data["sk_SK_UserVideo"];
            this.sk_SK_UserVideo2 = _data["sk_SK_UserVideo2"];
            this.sk_SK_UserVideo3 = _data["sk_SK_UserVideo3"];
            this.en_GB_Servicevideo1 = _data["en_GB_Servicevideo1"];
            this.en_GB_Servicevideo2 = _data["en_GB_Servicevideo2"];
            this.en_GB_Servicevideo3 = _data["en_GB_Servicevideo3"];
            this.en_GB_Servicevideo4 = _data["en_GB_Servicevideo4"];
            this.en_GB_Servicevideo5 = _data["en_GB_Servicevideo5"];
            this.en_GB_Servicevideo6 = _data["en_GB_Servicevideo6"];
            this.en_GB_SparePartsManualWW = _data["en_GB_SparePartsManualWW"];
            this.debtorNumberForBilling = _data["debtorNumberForBilling"];
            this.customer = _data["customer"];
            this.distributorCountry = _data["distributorCountry"];
            this.siteUser = _data["siteUser"];
            this.siteAddress = _data["siteAddress"];
            this.siteCity = _data["siteCity"];
            this.sitePostalCode = _data["sitePostalCode"];
            this.installationDate = _data["installationDate"];
            this.warrantyEndDate = _data["warrantyEndDate"];
            this.machineType = _data["machineType"];
            this.containerSize = _data["containerSize"];
        }
    }

    static fromJS(data: any): NavUnitFromCsvDto {
        data = typeof data === 'object' ? data : {};
        let result = new NavUnitFromCsvDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["unitId"] = this.unitId;
        data["modelCode"] = this.modelCode;
        data["en_GB_ElectricalDiagrams"] = this.en_GB_ElectricalDiagrams;
        data["en_GB_HydraulicsDiagrams"] = this.en_GB_HydraulicsDiagrams;
        data["en_Diagrams"] = this.en_Diagrams;
        data["de_Diagrams"] = this.de_Diagrams;
        data["xX_Diagrams"] = this.xX_Diagrams;
        data["en_Usermanual"] = this.en_Usermanual;
        data["de_Usermanual"] = this.de_Usermanual;
        data["xX_Usermanual"] = this.xX_Usermanual;
        data["da_DK_Manual"] = this.da_DK_Manual;
        data["da_DK_Manual2"] = this.da_DK_Manual2;
        data["da_DK_Manual3"] = this.da_DK_Manual3;
        data["en_GB_Manual"] = this.en_GB_Manual;
        data["en_GB_Manual2"] = this.en_GB_Manual2;
        data["en_GB_Manual3"] = this.en_GB_Manual3;
        data["en_UK_Manual"] = this.en_UK_Manual;
        data["en_UK_Manual2"] = this.en_UK_Manual2;
        data["en_UK_Manual3"] = this.en_UK_Manual3;
        data["de_DE_Manual"] = this.de_DE_Manual;
        data["de_DE_Manual2"] = this.de_DE_Manual2;
        data["de_DE_Manual3"] = this.de_DE_Manual3;
        data["nl_NL_Manual"] = this.nl_NL_Manual;
        data["nl_NL_Manual2"] = this.nl_NL_Manual2;
        data["nl_NL_Manual3"] = this.nl_NL_Manual3;
        data["fr_FR_Manual"] = this.fr_FR_Manual;
        data["fr_FR_Manual2"] = this.fr_FR_Manual2;
        data["fr_FR_Manual3"] = this.fr_FR_Manual3;
        data["sv_SE_Manual"] = this.sv_SE_Manual;
        data["sv_SE_Manual2"] = this.sv_SE_Manual2;
        data["sv_SE_Manual3"] = this.sv_SE_Manual3;
        data["nb_NO_Manual"] = this.nb_NO_Manual;
        data["nb_NO_Manual2"] = this.nb_NO_Manual2;
        data["nb_NO_Manual3"] = this.nb_NO_Manual3;
        data["fi_FI_Manual"] = this.fi_FI_Manual;
        data["fi_FI_Manual2"] = this.fi_FI_Manual2;
        data["fi_FI_Manual3"] = this.fi_FI_Manual3;
        data["ru_RU_Manual"] = this.ru_RU_Manual;
        data["ru_RU_Manual2"] = this.ru_RU_Manual2;
        data["ru_RU_Manual3"] = this.ru_RU_Manual3;
        data["ja_JP_Manual"] = this.ja_JP_Manual;
        data["ja_JP_Manual2"] = this.ja_JP_Manual2;
        data["ja_JP_Manual3"] = this.ja_JP_Manual3;
        data["pl_PL_Manual"] = this.pl_PL_Manual;
        data["pl_PL_Manual2"] = this.pl_PL_Manual2;
        data["pl_PL_Manual3"] = this.pl_PL_Manual3;
        data["es_ES_Manual"] = this.es_ES_Manual;
        data["es_ES_Manual2"] = this.es_ES_Manual2;
        data["es_ES_Manual3"] = this.es_ES_Manual3;
        data["pt_PT_Manual"] = this.pt_PT_Manual;
        data["pt_PT_Manual2"] = this.pt_PT_Manual2;
        data["pt_PT_Manual3"] = this.pt_PT_Manual3;
        data["ko_KR_Manual"] = this.ko_KR_Manual;
        data["ko_KR_Manual2"] = this.ko_KR_Manual2;
        data["ko_KR_Manual3"] = this.ko_KR_Manual3;
        data["it_IT_Manual"] = this.it_IT_Manual;
        data["it_IT_Manual2"] = this.it_IT_Manual2;
        data["it_IT_Manual3"] = this.it_IT_Manual3;
        data["hu_HU_Manual"] = this.hu_HU_Manual;
        data["hu_HU_Manual2"] = this.hu_HU_Manual2;
        data["hu_HU_Manual3"] = this.hu_HU_Manual3;
        data["cs_CZ_Manual"] = this.cs_CZ_Manual;
        data["cs_CZ_Manual2"] = this.cs_CZ_Manual2;
        data["cs_CZ_Manual3"] = this.cs_CZ_Manual3;
        data["ro_RO_Manual"] = this.ro_RO_Manual;
        data["ro_RO_Manual2"] = this.ro_RO_Manual2;
        data["ro_RO_Manual3"] = this.ro_RO_Manual3;
        data["el_GR_Manual"] = this.el_GR_Manual;
        data["el_GR_Manual2"] = this.el_GR_Manual2;
        data["el_GR_Manual3"] = this.el_GR_Manual3;
        data["tr_TR_Manual"] = this.tr_TR_Manual;
        data["tr_TR_Manual2"] = this.tr_TR_Manual2;
        data["tr_TR_Manual3"] = this.tr_TR_Manual3;
        data["lt_LT_Manual"] = this.lt_LT_Manual;
        data["lt_LT_Manual2"] = this.lt_LT_Manual2;
        data["lt_LT_Manual3"] = this.lt_LT_Manual3;
        data["sl_SL_Manual"] = this.sl_SL_Manual;
        data["sl_SL_Manual2"] = this.sl_SL_Manual2;
        data["sl_SL_Manual3"] = this.sl_SL_Manual3;
        data["bg_BG_Manual"] = this.bg_BG_Manual;
        data["bg_BG_Manual2"] = this.bg_BG_Manual2;
        data["bg_BG_Manual3"] = this.bg_BG_Manual3;
        data["hr_HR_Manual"] = this.hr_HR_Manual;
        data["hr_HR_Manual2"] = this.hr_HR_Manual2;
        data["hr_HR_Manual3"] = this.hr_HR_Manual3;
        data["et_EE_Manual"] = this.et_EE_Manual;
        data["et_EE_Manual2"] = this.et_EE_Manual2;
        data["et_EE_Manual3"] = this.et_EE_Manual3;
        data["is_IS_Manual"] = this.is_IS_Manual;
        data["is_IS_Manual2"] = this.is_IS_Manual2;
        data["is_IS_Manual3"] = this.is_IS_Manual3;
        data["lv_LV_Manual"] = this.lv_LV_Manual;
        data["lv_LV_Manual2"] = this.lv_LV_Manual2;
        data["lv_LV_Manual3"] = this.lv_LV_Manual3;
        data["zh_CN_Manual"] = this.zh_CN_Manual;
        data["zh_CN_Manual2"] = this.zh_CN_Manual2;
        data["zh_CN_Manual3"] = this.zh_CN_Manual3;
        data["th_TH_Manual"] = this.th_TH_Manual;
        data["th_TH_Manual2"] = this.th_TH_Manual2;
        data["th_TH_Manual3"] = this.th_TH_Manual3;
        data["he_IL_Manual"] = this.he_IL_Manual;
        data["he_IL_Manual2"] = this.he_IL_Manual2;
        data["he_IL_Manual3"] = this.he_IL_Manual3;
        data["fr_CA_Manual"] = this.fr_CA_Manual;
        data["fr_CA_Manual2"] = this.fr_CA_Manual2;
        data["fr_CA_Manual3"] = this.fr_CA_Manual3;
        data["en_US_Manual"] = this.en_US_Manual;
        data["en_US_Manual2"] = this.en_US_Manual2;
        data["en_US_Manual3"] = this.en_US_Manual3;
        data["es_US_Manual"] = this.es_US_Manual;
        data["es_US_Manual2"] = this.es_US_Manual2;
        data["es_US_Manual3"] = this.es_US_Manual3;
        data["sk_SK_Manual"] = this.sk_SK_Manual;
        data["sk_SK_Manual2"] = this.sk_SK_Manual2;
        data["sk_SK_Manual3"] = this.sk_SK_Manual3;
        data["en_GB_Quickguides"] = this.en_GB_Quickguides;
        data["da_DK_UserVideo"] = this.da_DK_UserVideo;
        data["da_DK_UserVideo2"] = this.da_DK_UserVideo2;
        data["da_DK_UserVideo3"] = this.da_DK_UserVideo3;
        data["en_GB_UserVideo"] = this.en_GB_UserVideo;
        data["en_GB_UserVideo2"] = this.en_GB_UserVideo2;
        data["en_GB_UserVideo3"] = this.en_GB_UserVideo3;
        data["en_UK_UserVideo"] = this.en_UK_UserVideo;
        data["en_UK_UserVideo2"] = this.en_UK_UserVideo2;
        data["en_UK_UserVideo3"] = this.en_UK_UserVideo3;
        data["de_DE_UserVideo"] = this.de_DE_UserVideo;
        data["de_DE_UserVideo2"] = this.de_DE_UserVideo2;
        data["de_DE_UserVideo3"] = this.de_DE_UserVideo3;
        data["nl_NL_UserVideo"] = this.nl_NL_UserVideo;
        data["nl_NL_UserVideo2"] = this.nl_NL_UserVideo2;
        data["nl_NL_UserVideo3"] = this.nl_NL_UserVideo3;
        data["fr_FR_UserVideo"] = this.fr_FR_UserVideo;
        data["fr_FR_UserVideo2"] = this.fr_FR_UserVideo2;
        data["fr_FR_UserVideo3"] = this.fr_FR_UserVideo3;
        data["sv_SE_UserVideo"] = this.sv_SE_UserVideo;
        data["sv_SE_UserVideo2"] = this.sv_SE_UserVideo2;
        data["sv_SE_UserVideo3"] = this.sv_SE_UserVideo3;
        data["nb_NO_UserVideo"] = this.nb_NO_UserVideo;
        data["nb_NO_UserVideo2"] = this.nb_NO_UserVideo2;
        data["nb_NO_UserVideo3"] = this.nb_NO_UserVideo3;
        data["fi_FI_UserVideo"] = this.fi_FI_UserVideo;
        data["fi_FI_UserVideo2"] = this.fi_FI_UserVideo2;
        data["fi_FI_UserVideo3"] = this.fi_FI_UserVideo3;
        data["ru_RU_UserVideo"] = this.ru_RU_UserVideo;
        data["ru_RU_UserVideo2"] = this.ru_RU_UserVideo2;
        data["ru_RU_UserVideo3"] = this.ru_RU_UserVideo3;
        data["ja_JP_UserVideo"] = this.ja_JP_UserVideo;
        data["ja_JP_UserVideo2"] = this.ja_JP_UserVideo2;
        data["ja_JP_UserVideo3"] = this.ja_JP_UserVideo3;
        data["pl_PL_UserVideo"] = this.pl_PL_UserVideo;
        data["pl_PL_UserVideo2"] = this.pl_PL_UserVideo2;
        data["pl_PL_UserVideo3"] = this.pl_PL_UserVideo3;
        data["es_ES_UserVideo"] = this.es_ES_UserVideo;
        data["es_ES_UserVideo2"] = this.es_ES_UserVideo2;
        data["es_ES_UserVideo3"] = this.es_ES_UserVideo3;
        data["pt_PT_UserVideo"] = this.pt_PT_UserVideo;
        data["pt_PT_UserVideo2"] = this.pt_PT_UserVideo2;
        data["pt_PT_UserVideo3"] = this.pt_PT_UserVideo3;
        data["ko_KR_UserVideo"] = this.ko_KR_UserVideo;
        data["ko_KR_UserVideo2"] = this.ko_KR_UserVideo2;
        data["ko_KR_UserVideo3"] = this.ko_KR_UserVideo3;
        data["it_IT_UserVideo"] = this.it_IT_UserVideo;
        data["it_IT_UserVideo2"] = this.it_IT_UserVideo2;
        data["it_IT_UserVideo3"] = this.it_IT_UserVideo3;
        data["hu_HU_UserVideo"] = this.hu_HU_UserVideo;
        data["hu_HU_UserVideo2"] = this.hu_HU_UserVideo2;
        data["hu_HU_UserVideo3"] = this.hu_HU_UserVideo3;
        data["cs_CZ_UserVideo"] = this.cs_CZ_UserVideo;
        data["cs_CZ_UserVideo2"] = this.cs_CZ_UserVideo2;
        data["cs_CZ_UserVideo3"] = this.cs_CZ_UserVideo3;
        data["ro_RO_UserVideo"] = this.ro_RO_UserVideo;
        data["ro_RO_UserVideo2"] = this.ro_RO_UserVideo2;
        data["ro_RO_UserVideo3"] = this.ro_RO_UserVideo3;
        data["el_GR_UserVideo"] = this.el_GR_UserVideo;
        data["el_GR_UserVideo2"] = this.el_GR_UserVideo2;
        data["el_GR_UserVideo3"] = this.el_GR_UserVideo3;
        data["tr_TR_UserVideo"] = this.tr_TR_UserVideo;
        data["tr_TR_UserVideo2"] = this.tr_TR_UserVideo2;
        data["tr_TR_UserVideo3"] = this.tr_TR_UserVideo3;
        data["lt_LT_UserVideo"] = this.lt_LT_UserVideo;
        data["lt_LT_UserVideo2"] = this.lt_LT_UserVideo2;
        data["lt_LT_UserVideo3"] = this.lt_LT_UserVideo3;
        data["sl_SL_UserVideo"] = this.sl_SL_UserVideo;
        data["sl_SL_UserVideo2"] = this.sl_SL_UserVideo2;
        data["sl_SL_UserVideo3"] = this.sl_SL_UserVideo3;
        data["bg_BG_UserVideo"] = this.bg_BG_UserVideo;
        data["bg_BG_UserVideo2"] = this.bg_BG_UserVideo2;
        data["bg_BG_UserVideo3"] = this.bg_BG_UserVideo3;
        data["hr_HR_UserVideo"] = this.hr_HR_UserVideo;
        data["hr_HR_UserVideo2"] = this.hr_HR_UserVideo2;
        data["hr_HR_UserVideo3"] = this.hr_HR_UserVideo3;
        data["et_EE_UserVideo"] = this.et_EE_UserVideo;
        data["et_EE_UserVideo2"] = this.et_EE_UserVideo2;
        data["et_EE_UserVideo3"] = this.et_EE_UserVideo3;
        data["is_IS_UserVideo"] = this.is_IS_UserVideo;
        data["is_IS_UserVideo2"] = this.is_IS_UserVideo2;
        data["is_IS_UserVideo3"] = this.is_IS_UserVideo3;
        data["lv_LV_UserVideo"] = this.lv_LV_UserVideo;
        data["lv_LV_UserVideo2"] = this.lv_LV_UserVideo2;
        data["lv_LV_UserVideo3"] = this.lv_LV_UserVideo3;
        data["zh_CN_UserVideo"] = this.zh_CN_UserVideo;
        data["zh_CN_UserVideo2"] = this.zh_CN_UserVideo2;
        data["zh_CN_UserVideo3"] = this.zh_CN_UserVideo3;
        data["th_TH_UserVideo"] = this.th_TH_UserVideo;
        data["th_TH_UserVideo2"] = this.th_TH_UserVideo2;
        data["th_TH_UserVideo3"] = this.th_TH_UserVideo3;
        data["he_IL_UserVideo"] = this.he_IL_UserVideo;
        data["he_IL_UserVideo2"] = this.he_IL_UserVideo2;
        data["he_IL_UserVideo3"] = this.he_IL_UserVideo3;
        data["fr_CA_UserVideo"] = this.fr_CA_UserVideo;
        data["fr_CA_UserVideo2"] = this.fr_CA_UserVideo2;
        data["fr_CA_UserVideo3"] = this.fr_CA_UserVideo3;
        data["en_US_UserVideo"] = this.en_US_UserVideo;
        data["en_US_UserVideo2"] = this.en_US_UserVideo2;
        data["en_US_UserVideo3"] = this.en_US_UserVideo3;
        data["es_US_UserVideo"] = this.es_US_UserVideo;
        data["es_US_UserVideo2"] = this.es_US_UserVideo2;
        data["es_US_UserVideo3"] = this.es_US_UserVideo3;
        data["sk_SK_UserVideo"] = this.sk_SK_UserVideo;
        data["sk_SK_UserVideo2"] = this.sk_SK_UserVideo2;
        data["sk_SK_UserVideo3"] = this.sk_SK_UserVideo3;
        data["en_GB_Servicevideo1"] = this.en_GB_Servicevideo1;
        data["en_GB_Servicevideo2"] = this.en_GB_Servicevideo2;
        data["en_GB_Servicevideo3"] = this.en_GB_Servicevideo3;
        data["en_GB_Servicevideo4"] = this.en_GB_Servicevideo4;
        data["en_GB_Servicevideo5"] = this.en_GB_Servicevideo5;
        data["en_GB_Servicevideo6"] = this.en_GB_Servicevideo6;
        data["en_GB_SparePartsManualWW"] = this.en_GB_SparePartsManualWW;
        data["debtorNumberForBilling"] = this.debtorNumberForBilling;
        data["customer"] = this.customer;
        data["distributorCountry"] = this.distributorCountry;
        data["siteUser"] = this.siteUser;
        data["siteAddress"] = this.siteAddress;
        data["siteCity"] = this.siteCity;
        data["sitePostalCode"] = this.sitePostalCode;
        data["installationDate"] = this.installationDate;
        data["warrantyEndDate"] = this.warrantyEndDate;
        data["machineType"] = this.machineType;
        data["containerSize"] = this.containerSize;
        return data;
    }
}

export interface INavUnitFromCsvDto {
    fileName: string;
    unitId?: string | undefined;
    modelCode?: string | undefined;
    en_GB_ElectricalDiagrams?: string | undefined;
    en_GB_HydraulicsDiagrams?: string | undefined;
    en_Diagrams?: string | undefined;
    de_Diagrams?: string | undefined;
    xX_Diagrams?: string | undefined;
    en_Usermanual?: string | undefined;
    de_Usermanual?: string | undefined;
    xX_Usermanual?: string | undefined;
    da_DK_Manual?: string | undefined;
    da_DK_Manual2?: string | undefined;
    da_DK_Manual3?: string | undefined;
    en_GB_Manual?: string | undefined;
    en_GB_Manual2?: string | undefined;
    en_GB_Manual3?: string | undefined;
    en_UK_Manual?: string | undefined;
    en_UK_Manual2?: string | undefined;
    en_UK_Manual3?: string | undefined;
    de_DE_Manual?: string | undefined;
    de_DE_Manual2?: string | undefined;
    de_DE_Manual3?: string | undefined;
    nl_NL_Manual?: string | undefined;
    nl_NL_Manual2?: string | undefined;
    nl_NL_Manual3?: string | undefined;
    fr_FR_Manual?: string | undefined;
    fr_FR_Manual2?: string | undefined;
    fr_FR_Manual3?: string | undefined;
    sv_SE_Manual?: string | undefined;
    sv_SE_Manual2?: string | undefined;
    sv_SE_Manual3?: string | undefined;
    nb_NO_Manual?: string | undefined;
    nb_NO_Manual2?: string | undefined;
    nb_NO_Manual3?: string | undefined;
    fi_FI_Manual?: string | undefined;
    fi_FI_Manual2?: string | undefined;
    fi_FI_Manual3?: string | undefined;
    ru_RU_Manual?: string | undefined;
    ru_RU_Manual2?: string | undefined;
    ru_RU_Manual3?: string | undefined;
    ja_JP_Manual?: string | undefined;
    ja_JP_Manual2?: string | undefined;
    ja_JP_Manual3?: string | undefined;
    pl_PL_Manual?: string | undefined;
    pl_PL_Manual2?: string | undefined;
    pl_PL_Manual3?: string | undefined;
    es_ES_Manual?: string | undefined;
    es_ES_Manual2?: string | undefined;
    es_ES_Manual3?: string | undefined;
    pt_PT_Manual?: string | undefined;
    pt_PT_Manual2?: string | undefined;
    pt_PT_Manual3?: string | undefined;
    ko_KR_Manual?: string | undefined;
    ko_KR_Manual2?: string | undefined;
    ko_KR_Manual3?: string | undefined;
    it_IT_Manual?: string | undefined;
    it_IT_Manual2?: string | undefined;
    it_IT_Manual3?: string | undefined;
    hu_HU_Manual?: string | undefined;
    hu_HU_Manual2?: string | undefined;
    hu_HU_Manual3?: string | undefined;
    cs_CZ_Manual?: string | undefined;
    cs_CZ_Manual2?: string | undefined;
    cs_CZ_Manual3?: string | undefined;
    ro_RO_Manual?: string | undefined;
    ro_RO_Manual2?: string | undefined;
    ro_RO_Manual3?: string | undefined;
    el_GR_Manual?: string | undefined;
    el_GR_Manual2?: string | undefined;
    el_GR_Manual3?: string | undefined;
    tr_TR_Manual?: string | undefined;
    tr_TR_Manual2?: string | undefined;
    tr_TR_Manual3?: string | undefined;
    lt_LT_Manual?: string | undefined;
    lt_LT_Manual2?: string | undefined;
    lt_LT_Manual3?: string | undefined;
    sl_SL_Manual?: string | undefined;
    sl_SL_Manual2?: string | undefined;
    sl_SL_Manual3?: string | undefined;
    bg_BG_Manual?: string | undefined;
    bg_BG_Manual2?: string | undefined;
    bg_BG_Manual3?: string | undefined;
    hr_HR_Manual?: string | undefined;
    hr_HR_Manual2?: string | undefined;
    hr_HR_Manual3?: string | undefined;
    et_EE_Manual?: string | undefined;
    et_EE_Manual2?: string | undefined;
    et_EE_Manual3?: string | undefined;
    is_IS_Manual?: string | undefined;
    is_IS_Manual2?: string | undefined;
    is_IS_Manual3?: string | undefined;
    lv_LV_Manual?: string | undefined;
    lv_LV_Manual2?: string | undefined;
    lv_LV_Manual3?: string | undefined;
    zh_CN_Manual?: string | undefined;
    zh_CN_Manual2?: string | undefined;
    zh_CN_Manual3?: string | undefined;
    th_TH_Manual?: string | undefined;
    th_TH_Manual2?: string | undefined;
    th_TH_Manual3?: string | undefined;
    he_IL_Manual?: string | undefined;
    he_IL_Manual2?: string | undefined;
    he_IL_Manual3?: string | undefined;
    fr_CA_Manual?: string | undefined;
    fr_CA_Manual2?: string | undefined;
    fr_CA_Manual3?: string | undefined;
    en_US_Manual?: string | undefined;
    en_US_Manual2?: string | undefined;
    en_US_Manual3?: string | undefined;
    es_US_Manual?: string | undefined;
    es_US_Manual2?: string | undefined;
    es_US_Manual3?: string | undefined;
    sk_SK_Manual?: string | undefined;
    sk_SK_Manual2?: string | undefined;
    sk_SK_Manual3?: string | undefined;
    en_GB_Quickguides?: string | undefined;
    da_DK_UserVideo?: string | undefined;
    da_DK_UserVideo2?: string | undefined;
    da_DK_UserVideo3?: string | undefined;
    en_GB_UserVideo?: string | undefined;
    en_GB_UserVideo2?: string | undefined;
    en_GB_UserVideo3?: string | undefined;
    en_UK_UserVideo?: string | undefined;
    en_UK_UserVideo2?: string | undefined;
    en_UK_UserVideo3?: string | undefined;
    de_DE_UserVideo?: string | undefined;
    de_DE_UserVideo2?: string | undefined;
    de_DE_UserVideo3?: string | undefined;
    nl_NL_UserVideo?: string | undefined;
    nl_NL_UserVideo2?: string | undefined;
    nl_NL_UserVideo3?: string | undefined;
    fr_FR_UserVideo?: string | undefined;
    fr_FR_UserVideo2?: string | undefined;
    fr_FR_UserVideo3?: string | undefined;
    sv_SE_UserVideo?: string | undefined;
    sv_SE_UserVideo2?: string | undefined;
    sv_SE_UserVideo3?: string | undefined;
    nb_NO_UserVideo?: string | undefined;
    nb_NO_UserVideo2?: string | undefined;
    nb_NO_UserVideo3?: string | undefined;
    fi_FI_UserVideo?: string | undefined;
    fi_FI_UserVideo2?: string | undefined;
    fi_FI_UserVideo3?: string | undefined;
    ru_RU_UserVideo?: string | undefined;
    ru_RU_UserVideo2?: string | undefined;
    ru_RU_UserVideo3?: string | undefined;
    ja_JP_UserVideo?: string | undefined;
    ja_JP_UserVideo2?: string | undefined;
    ja_JP_UserVideo3?: string | undefined;
    pl_PL_UserVideo?: string | undefined;
    pl_PL_UserVideo2?: string | undefined;
    pl_PL_UserVideo3?: string | undefined;
    es_ES_UserVideo?: string | undefined;
    es_ES_UserVideo2?: string | undefined;
    es_ES_UserVideo3?: string | undefined;
    pt_PT_UserVideo?: string | undefined;
    pt_PT_UserVideo2?: string | undefined;
    pt_PT_UserVideo3?: string | undefined;
    ko_KR_UserVideo?: string | undefined;
    ko_KR_UserVideo2?: string | undefined;
    ko_KR_UserVideo3?: string | undefined;
    it_IT_UserVideo?: string | undefined;
    it_IT_UserVideo2?: string | undefined;
    it_IT_UserVideo3?: string | undefined;
    hu_HU_UserVideo?: string | undefined;
    hu_HU_UserVideo2?: string | undefined;
    hu_HU_UserVideo3?: string | undefined;
    cs_CZ_UserVideo?: string | undefined;
    cs_CZ_UserVideo2?: string | undefined;
    cs_CZ_UserVideo3?: string | undefined;
    ro_RO_UserVideo?: string | undefined;
    ro_RO_UserVideo2?: string | undefined;
    ro_RO_UserVideo3?: string | undefined;
    el_GR_UserVideo?: string | undefined;
    el_GR_UserVideo2?: string | undefined;
    el_GR_UserVideo3?: string | undefined;
    tr_TR_UserVideo?: string | undefined;
    tr_TR_UserVideo2?: string | undefined;
    tr_TR_UserVideo3?: string | undefined;
    lt_LT_UserVideo?: string | undefined;
    lt_LT_UserVideo2?: string | undefined;
    lt_LT_UserVideo3?: string | undefined;
    sl_SL_UserVideo?: string | undefined;
    sl_SL_UserVideo2?: string | undefined;
    sl_SL_UserVideo3?: string | undefined;
    bg_BG_UserVideo?: string | undefined;
    bg_BG_UserVideo2?: string | undefined;
    bg_BG_UserVideo3?: string | undefined;
    hr_HR_UserVideo?: string | undefined;
    hr_HR_UserVideo2?: string | undefined;
    hr_HR_UserVideo3?: string | undefined;
    et_EE_UserVideo?: string | undefined;
    et_EE_UserVideo2?: string | undefined;
    et_EE_UserVideo3?: string | undefined;
    is_IS_UserVideo?: string | undefined;
    is_IS_UserVideo2?: string | undefined;
    is_IS_UserVideo3?: string | undefined;
    lv_LV_UserVideo?: string | undefined;
    lv_LV_UserVideo2?: string | undefined;
    lv_LV_UserVideo3?: string | undefined;
    zh_CN_UserVideo?: string | undefined;
    zh_CN_UserVideo2?: string | undefined;
    zh_CN_UserVideo3?: string | undefined;
    th_TH_UserVideo?: string | undefined;
    th_TH_UserVideo2?: string | undefined;
    th_TH_UserVideo3?: string | undefined;
    he_IL_UserVideo?: string | undefined;
    he_IL_UserVideo2?: string | undefined;
    he_IL_UserVideo3?: string | undefined;
    fr_CA_UserVideo?: string | undefined;
    fr_CA_UserVideo2?: string | undefined;
    fr_CA_UserVideo3?: string | undefined;
    en_US_UserVideo?: string | undefined;
    en_US_UserVideo2?: string | undefined;
    en_US_UserVideo3?: string | undefined;
    es_US_UserVideo?: string | undefined;
    es_US_UserVideo2?: string | undefined;
    es_US_UserVideo3?: string | undefined;
    sk_SK_UserVideo?: string | undefined;
    sk_SK_UserVideo2?: string | undefined;
    sk_SK_UserVideo3?: string | undefined;
    en_GB_Servicevideo1?: string | undefined;
    en_GB_Servicevideo2?: string | undefined;
    en_GB_Servicevideo3?: string | undefined;
    en_GB_Servicevideo4?: string | undefined;
    en_GB_Servicevideo5?: string | undefined;
    en_GB_Servicevideo6?: string | undefined;
    en_GB_SparePartsManualWW?: string | undefined;
    debtorNumberForBilling?: string | undefined;
    customer?: string | undefined;
    distributorCountry?: string | undefined;
    siteUser?: string | undefined;
    siteAddress?: string | undefined;
    siteCity?: string | undefined;
    sitePostalCode?: string | undefined;
    installationDate?: string | undefined;
    warrantyEndDate?: string | undefined;
    machineType?: string | undefined;
    containerSize?: string | undefined;
}

export class NavUnitDocumentDto implements INavUnitDocumentDto {
    en_GB_ElectricalDiagrams?: NavArticlePermissions | undefined;
    en_GB_HydraulicsDiagrams?: NavArticlePermissions | undefined;
    en_Diagrams?: NavArticlePermissions | undefined;
    de_Diagrams?: NavArticlePermissions | undefined;
    xX_Diagrams?: NavArticlePermissions | undefined;
    de_Usermanual?: NavArticlePermissions | undefined;
    en_Usermanual?: NavArticlePermissions | undefined;
    xX_Usermanual?: NavArticlePermissions | undefined;
    da_DK_Manual?: NavArticlePermissions | undefined;
    da_DK_Manual2?: NavArticlePermissions | undefined;
    da_DK_Manual3?: NavArticlePermissions | undefined;
    en_GB_Manual?: NavArticlePermissions | undefined;
    en_GB_Manual2?: NavArticlePermissions | undefined;
    en_GB_Manual3?: NavArticlePermissions | undefined;
    en_UK_Manual?: NavArticlePermissions | undefined;
    en_UK_Manual2?: NavArticlePermissions | undefined;
    en_UK_Manual3?: NavArticlePermissions | undefined;
    de_DE_Manual?: NavArticlePermissions | undefined;
    de_DE_Manual2?: NavArticlePermissions | undefined;
    de_DE_Manual3?: NavArticlePermissions | undefined;
    nl_NL_Manual?: NavArticlePermissions | undefined;
    nl_NL_Manual2?: NavArticlePermissions | undefined;
    nl_NL_Manual3?: NavArticlePermissions | undefined;
    fr_FR_Manual?: NavArticlePermissions | undefined;
    fr_FR_Manual2?: NavArticlePermissions | undefined;
    fr_FR_Manual3?: NavArticlePermissions | undefined;
    sv_SE_Manual?: NavArticlePermissions | undefined;
    sv_SE_Manual2?: NavArticlePermissions | undefined;
    sv_SE_Manual3?: NavArticlePermissions | undefined;
    nb_NO_Manual?: NavArticlePermissions | undefined;
    nb_NO_Manual2?: NavArticlePermissions | undefined;
    nb_NO_Manual3?: NavArticlePermissions | undefined;
    fi_FI_Manual?: NavArticlePermissions | undefined;
    fi_FI_Manual2?: NavArticlePermissions | undefined;
    fi_FI_Manual3?: NavArticlePermissions | undefined;
    ru_RU_Manual?: NavArticlePermissions | undefined;
    ru_RU_Manual2?: NavArticlePermissions | undefined;
    ru_RU_Manual3?: NavArticlePermissions | undefined;
    ja_JP_Manual?: NavArticlePermissions | undefined;
    ja_JP_Manual2?: NavArticlePermissions | undefined;
    ja_JP_Manual3?: NavArticlePermissions | undefined;
    pl_PL_Manual?: NavArticlePermissions | undefined;
    pl_PL_Manual2?: NavArticlePermissions | undefined;
    pl_PL_Manual3?: NavArticlePermissions | undefined;
    es_ES_Manual?: NavArticlePermissions | undefined;
    es_ES_Manual2?: NavArticlePermissions | undefined;
    es_ES_Manual3?: NavArticlePermissions | undefined;
    pt_PT_Manual?: NavArticlePermissions | undefined;
    pt_PT_Manual2?: NavArticlePermissions | undefined;
    pt_PT_Manual3?: NavArticlePermissions | undefined;
    ko_KR_Manual?: NavArticlePermissions | undefined;
    ko_KR_Manual2?: NavArticlePermissions | undefined;
    ko_KR_Manual3?: NavArticlePermissions | undefined;
    it_IT_Manual?: NavArticlePermissions | undefined;
    it_IT_Manual2?: NavArticlePermissions | undefined;
    it_IT_Manual3?: NavArticlePermissions | undefined;
    hu_HU_Manual?: NavArticlePermissions | undefined;
    hu_HU_Manual2?: NavArticlePermissions | undefined;
    hu_HU_Manual3?: NavArticlePermissions | undefined;
    cs_CZ_Manual?: NavArticlePermissions | undefined;
    cs_CZ_Manual2?: NavArticlePermissions | undefined;
    cs_CZ_Manual3?: NavArticlePermissions | undefined;
    ro_RO_Manual?: NavArticlePermissions | undefined;
    ro_RO_Manual2?: NavArticlePermissions | undefined;
    ro_RO_Manual3?: NavArticlePermissions | undefined;
    el_GR_Manual?: NavArticlePermissions | undefined;
    el_GR_Manual2?: NavArticlePermissions | undefined;
    el_GR_Manual3?: NavArticlePermissions | undefined;
    tr_TR_Manual?: NavArticlePermissions | undefined;
    tr_TR_Manual2?: NavArticlePermissions | undefined;
    tr_TR_Manual3?: NavArticlePermissions | undefined;
    lt_LT_Manual?: NavArticlePermissions | undefined;
    lt_LT_Manual2?: NavArticlePermissions | undefined;
    lt_LT_Manual3?: NavArticlePermissions | undefined;
    sl_SL_Manual?: NavArticlePermissions | undefined;
    sl_SL_Manual2?: NavArticlePermissions | undefined;
    sl_SL_Manual3?: NavArticlePermissions | undefined;
    bg_BG_Manual?: NavArticlePermissions | undefined;
    bg_BG_Manual2?: NavArticlePermissions | undefined;
    bg_BG_Manual3?: NavArticlePermissions | undefined;
    hr_HR_Manual?: NavArticlePermissions | undefined;
    hr_HR_Manual2?: NavArticlePermissions | undefined;
    hr_HR_Manual3?: NavArticlePermissions | undefined;
    et_EE_Manual?: NavArticlePermissions | undefined;
    et_EE_Manual2?: NavArticlePermissions | undefined;
    et_EE_Manual3?: NavArticlePermissions | undefined;
    is_IS_Manual?: NavArticlePermissions | undefined;
    is_IS_Manual2?: NavArticlePermissions | undefined;
    is_IS_Manual3?: NavArticlePermissions | undefined;
    lv_LV_Manual?: NavArticlePermissions | undefined;
    lv_LV_Manual2?: NavArticlePermissions | undefined;
    lv_LV_Manual3?: NavArticlePermissions | undefined;
    zh_CN_Manual?: NavArticlePermissions | undefined;
    zh_CN_Manual2?: NavArticlePermissions | undefined;
    zh_CN_Manual3?: NavArticlePermissions | undefined;
    th_TH_Manual?: NavArticlePermissions | undefined;
    th_TH_Manual2?: NavArticlePermissions | undefined;
    th_TH_Manual3?: NavArticlePermissions | undefined;
    he_IL_Manual?: NavArticlePermissions | undefined;
    he_IL_Manual2?: NavArticlePermissions | undefined;
    he_IL_Manual3?: NavArticlePermissions | undefined;
    fr_CA_Manual?: NavArticlePermissions | undefined;
    fr_CA_Manual2?: NavArticlePermissions | undefined;
    fr_CA_Manual3?: NavArticlePermissions | undefined;
    en_US_Manual?: NavArticlePermissions | undefined;
    en_US_Manual2?: NavArticlePermissions | undefined;
    en_US_Manual3?: NavArticlePermissions | undefined;
    es_US_Manual?: NavArticlePermissions | undefined;
    es_US_Manual2?: NavArticlePermissions | undefined;
    es_US_Manual3?: NavArticlePermissions | undefined;
    sk_SK_Manual?: NavArticlePermissions | undefined;
    sk_SK_Manual2?: NavArticlePermissions | undefined;
    sk_SK_Manual3?: NavArticlePermissions | undefined;
    en_GB_Quickguides?: NavArticlePermissions | undefined;
    da_DK_UserVideo?: NavArticlePermissions | undefined;
    da_DK_UserVideo2?: NavArticlePermissions | undefined;
    da_DK_UserVideo3?: NavArticlePermissions | undefined;
    en_GB_UserVideo?: NavArticlePermissions | undefined;
    en_GB_UserVideo2?: NavArticlePermissions | undefined;
    en_GB_UserVideo3?: NavArticlePermissions | undefined;
    en_UK_UserVideo?: NavArticlePermissions | undefined;
    en_UK_UserVideo2?: NavArticlePermissions | undefined;
    en_UK_UserVideo3?: NavArticlePermissions | undefined;
    de_DE_UserVideo?: NavArticlePermissions | undefined;
    de_DE_UserVideo2?: NavArticlePermissions | undefined;
    de_DE_UserVideo3?: NavArticlePermissions | undefined;
    nl_NL_UserVideo?: NavArticlePermissions | undefined;
    nl_NL_UserVideo2?: NavArticlePermissions | undefined;
    nl_NL_UserVideo3?: NavArticlePermissions | undefined;
    fr_FR_UserVideo?: NavArticlePermissions | undefined;
    fr_FR_UserVideo2?: NavArticlePermissions | undefined;
    fr_FR_UserVideo3?: NavArticlePermissions | undefined;
    sv_SE_UserVideo?: NavArticlePermissions | undefined;
    sv_SE_UserVideo2?: NavArticlePermissions | undefined;
    sv_SE_UserVideo3?: NavArticlePermissions | undefined;
    nb_NO_UserVideo?: NavArticlePermissions | undefined;
    nb_NO_UserVideo2?: NavArticlePermissions | undefined;
    nb_NO_UserVideo3?: NavArticlePermissions | undefined;
    fi_FI_UserVideo?: NavArticlePermissions | undefined;
    fi_FI_UserVideo2?: NavArticlePermissions | undefined;
    fi_FI_UserVideo3?: NavArticlePermissions | undefined;
    ru_RU_UserVideo?: NavArticlePermissions | undefined;
    ru_RU_UserVideo2?: NavArticlePermissions | undefined;
    ru_RU_UserVideo3?: NavArticlePermissions | undefined;
    ja_JP_UserVideo?: NavArticlePermissions | undefined;
    ja_JP_UserVideo2?: NavArticlePermissions | undefined;
    ja_JP_UserVideo3?: NavArticlePermissions | undefined;
    pl_PL_UserVideo?: NavArticlePermissions | undefined;
    pl_PL_UserVideo2?: NavArticlePermissions | undefined;
    pl_PL_UserVideo3?: NavArticlePermissions | undefined;
    es_ES_UserVideo?: NavArticlePermissions | undefined;
    es_ES_UserVideo2?: NavArticlePermissions | undefined;
    es_ES_UserVideo3?: NavArticlePermissions | undefined;
    pt_PT_UserVideo?: NavArticlePermissions | undefined;
    pt_PT_UserVideo2?: NavArticlePermissions | undefined;
    pt_PT_UserVideo3?: NavArticlePermissions | undefined;
    ko_KR_UserVideo?: NavArticlePermissions | undefined;
    ko_KR_UserVideo2?: NavArticlePermissions | undefined;
    ko_KR_UserVideo3?: NavArticlePermissions | undefined;
    it_IT_UserVideo?: NavArticlePermissions | undefined;
    it_IT_UserVideo2?: NavArticlePermissions | undefined;
    it_IT_UserVideo3?: NavArticlePermissions | undefined;
    hu_HU_UserVideo?: NavArticlePermissions | undefined;
    hu_HU_UserVideo2?: NavArticlePermissions | undefined;
    hu_HU_UserVideo3?: NavArticlePermissions | undefined;
    cs_CZ_UserVideo?: NavArticlePermissions | undefined;
    cs_CZ_UserVideo2?: NavArticlePermissions | undefined;
    cs_CZ_UserVideo3?: NavArticlePermissions | undefined;
    ro_RO_UserVideo?: NavArticlePermissions | undefined;
    ro_RO_UserVideo2?: NavArticlePermissions | undefined;
    ro_RO_UserVideo3?: NavArticlePermissions | undefined;
    el_GR_UserVideo?: NavArticlePermissions | undefined;
    el_GR_UserVideo2?: NavArticlePermissions | undefined;
    el_GR_UserVideo3?: NavArticlePermissions | undefined;
    tr_TR_UserVideo?: NavArticlePermissions | undefined;
    tr_TR_UserVideo2?: NavArticlePermissions | undefined;
    tr_TR_UserVideo3?: NavArticlePermissions | undefined;
    lt_LT_UserVideo?: NavArticlePermissions | undefined;
    lt_LT_UserVideo2?: NavArticlePermissions | undefined;
    lt_LT_UserVideo3?: NavArticlePermissions | undefined;
    sl_SL_UserVideo?: NavArticlePermissions | undefined;
    sl_SL_UserVideo2?: NavArticlePermissions | undefined;
    sl_SL_UserVideo3?: NavArticlePermissions | undefined;
    bg_BG_UserVideo?: NavArticlePermissions | undefined;
    bg_BG_UserVideo2?: NavArticlePermissions | undefined;
    bg_BG_UserVideo3?: NavArticlePermissions | undefined;
    hr_HR_UserVideo?: NavArticlePermissions | undefined;
    hr_HR_UserVideo2?: NavArticlePermissions | undefined;
    hr_HR_UserVideo3?: NavArticlePermissions | undefined;
    et_EE_UserVideo?: NavArticlePermissions | undefined;
    et_EE_UserVideo2?: NavArticlePermissions | undefined;
    et_EE_UserVideo3?: NavArticlePermissions | undefined;
    is_IS_UserVideo?: NavArticlePermissions | undefined;
    is_IS_UserVideo2?: NavArticlePermissions | undefined;
    is_IS_UserVideo3?: NavArticlePermissions | undefined;
    lv_LV_UserVideo?: NavArticlePermissions | undefined;
    lv_LV_UserVideo2?: NavArticlePermissions | undefined;
    lv_LV_UserVideo3?: NavArticlePermissions | undefined;
    zh_CN_UserVideo?: NavArticlePermissions | undefined;
    zh_CN_UserVideo2?: NavArticlePermissions | undefined;
    zh_CN_UserVideo3?: NavArticlePermissions | undefined;
    th_TH_UserVideo?: NavArticlePermissions | undefined;
    th_TH_UserVideo2?: NavArticlePermissions | undefined;
    th_TH_UserVideo3?: NavArticlePermissions | undefined;
    he_IL_UserVideo?: NavArticlePermissions | undefined;
    he_IL_UserVideo2?: NavArticlePermissions | undefined;
    he_IL_UserVideo3?: NavArticlePermissions | undefined;
    fr_CA_UserVideo?: NavArticlePermissions | undefined;
    fr_CA_UserVideo2?: NavArticlePermissions | undefined;
    fr_CA_UserVideo3?: NavArticlePermissions | undefined;
    en_US_UserVideo?: NavArticlePermissions | undefined;
    en_US_UserVideo2?: NavArticlePermissions | undefined;
    en_US_UserVideo3?: NavArticlePermissions | undefined;
    es_US_UserVideo?: NavArticlePermissions | undefined;
    es_US_UserVideo2?: NavArticlePermissions | undefined;
    es_US_UserVideo3?: NavArticlePermissions | undefined;
    sk_SK_UserVideo?: NavArticlePermissions | undefined;
    sk_SK_UserVideo2?: NavArticlePermissions | undefined;
    sk_SK_UserVideo3?: NavArticlePermissions | undefined;
    en_GB_Servicevideo1?: NavArticlePermissions | undefined;
    en_GB_Servicevideo2?: NavArticlePermissions | undefined;
    en_GB_Servicevideo3?: NavArticlePermissions | undefined;
    en_GB_Servicevideo4?: NavArticlePermissions | undefined;
    en_GB_Servicevideo5?: NavArticlePermissions | undefined;
    en_GB_Servicevideo6?: NavArticlePermissions | undefined;
    en_GB_SparePartsManualWW?: NavArticlePermissions | undefined;

    constructor(data?: INavUnitDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.en_GB_ElectricalDiagrams = _data["en_GB_ElectricalDiagrams"] ? NavArticlePermissions.fromJS(_data["en_GB_ElectricalDiagrams"]) : <any>undefined;
            this.en_GB_HydraulicsDiagrams = _data["en_GB_HydraulicsDiagrams"] ? NavArticlePermissions.fromJS(_data["en_GB_HydraulicsDiagrams"]) : <any>undefined;
            this.en_Diagrams = _data["en_Diagrams"] ? NavArticlePermissions.fromJS(_data["en_Diagrams"]) : <any>undefined;
            this.de_Diagrams = _data["de_Diagrams"] ? NavArticlePermissions.fromJS(_data["de_Diagrams"]) : <any>undefined;
            this.xX_Diagrams = _data["xX_Diagrams"] ? NavArticlePermissions.fromJS(_data["xX_Diagrams"]) : <any>undefined;
            this.de_Usermanual = _data["de_Usermanual"] ? NavArticlePermissions.fromJS(_data["de_Usermanual"]) : <any>undefined;
            this.en_Usermanual = _data["en_Usermanual"] ? NavArticlePermissions.fromJS(_data["en_Usermanual"]) : <any>undefined;
            this.xX_Usermanual = _data["xX_Usermanual"] ? NavArticlePermissions.fromJS(_data["xX_Usermanual"]) : <any>undefined;
            this.da_DK_Manual = _data["da_DK_Manual"] ? NavArticlePermissions.fromJS(_data["da_DK_Manual"]) : <any>undefined;
            this.da_DK_Manual2 = _data["da_DK_Manual2"] ? NavArticlePermissions.fromJS(_data["da_DK_Manual2"]) : <any>undefined;
            this.da_DK_Manual3 = _data["da_DK_Manual3"] ? NavArticlePermissions.fromJS(_data["da_DK_Manual3"]) : <any>undefined;
            this.en_GB_Manual = _data["en_GB_Manual"] ? NavArticlePermissions.fromJS(_data["en_GB_Manual"]) : <any>undefined;
            this.en_GB_Manual2 = _data["en_GB_Manual2"] ? NavArticlePermissions.fromJS(_data["en_GB_Manual2"]) : <any>undefined;
            this.en_GB_Manual3 = _data["en_GB_Manual3"] ? NavArticlePermissions.fromJS(_data["en_GB_Manual3"]) : <any>undefined;
            this.en_UK_Manual = _data["en_UK_Manual"] ? NavArticlePermissions.fromJS(_data["en_UK_Manual"]) : <any>undefined;
            this.en_UK_Manual2 = _data["en_UK_Manual2"] ? NavArticlePermissions.fromJS(_data["en_UK_Manual2"]) : <any>undefined;
            this.en_UK_Manual3 = _data["en_UK_Manual3"] ? NavArticlePermissions.fromJS(_data["en_UK_Manual3"]) : <any>undefined;
            this.de_DE_Manual = _data["de_DE_Manual"] ? NavArticlePermissions.fromJS(_data["de_DE_Manual"]) : <any>undefined;
            this.de_DE_Manual2 = _data["de_DE_Manual2"] ? NavArticlePermissions.fromJS(_data["de_DE_Manual2"]) : <any>undefined;
            this.de_DE_Manual3 = _data["de_DE_Manual3"] ? NavArticlePermissions.fromJS(_data["de_DE_Manual3"]) : <any>undefined;
            this.nl_NL_Manual = _data["nl_NL_Manual"] ? NavArticlePermissions.fromJS(_data["nl_NL_Manual"]) : <any>undefined;
            this.nl_NL_Manual2 = _data["nl_NL_Manual2"] ? NavArticlePermissions.fromJS(_data["nl_NL_Manual2"]) : <any>undefined;
            this.nl_NL_Manual3 = _data["nl_NL_Manual3"] ? NavArticlePermissions.fromJS(_data["nl_NL_Manual3"]) : <any>undefined;
            this.fr_FR_Manual = _data["fr_FR_Manual"] ? NavArticlePermissions.fromJS(_data["fr_FR_Manual"]) : <any>undefined;
            this.fr_FR_Manual2 = _data["fr_FR_Manual2"] ? NavArticlePermissions.fromJS(_data["fr_FR_Manual2"]) : <any>undefined;
            this.fr_FR_Manual3 = _data["fr_FR_Manual3"] ? NavArticlePermissions.fromJS(_data["fr_FR_Manual3"]) : <any>undefined;
            this.sv_SE_Manual = _data["sv_SE_Manual"] ? NavArticlePermissions.fromJS(_data["sv_SE_Manual"]) : <any>undefined;
            this.sv_SE_Manual2 = _data["sv_SE_Manual2"] ? NavArticlePermissions.fromJS(_data["sv_SE_Manual2"]) : <any>undefined;
            this.sv_SE_Manual3 = _data["sv_SE_Manual3"] ? NavArticlePermissions.fromJS(_data["sv_SE_Manual3"]) : <any>undefined;
            this.nb_NO_Manual = _data["nb_NO_Manual"] ? NavArticlePermissions.fromJS(_data["nb_NO_Manual"]) : <any>undefined;
            this.nb_NO_Manual2 = _data["nb_NO_Manual2"] ? NavArticlePermissions.fromJS(_data["nb_NO_Manual2"]) : <any>undefined;
            this.nb_NO_Manual3 = _data["nb_NO_Manual3"] ? NavArticlePermissions.fromJS(_data["nb_NO_Manual3"]) : <any>undefined;
            this.fi_FI_Manual = _data["fi_FI_Manual"] ? NavArticlePermissions.fromJS(_data["fi_FI_Manual"]) : <any>undefined;
            this.fi_FI_Manual2 = _data["fi_FI_Manual2"] ? NavArticlePermissions.fromJS(_data["fi_FI_Manual2"]) : <any>undefined;
            this.fi_FI_Manual3 = _data["fi_FI_Manual3"] ? NavArticlePermissions.fromJS(_data["fi_FI_Manual3"]) : <any>undefined;
            this.ru_RU_Manual = _data["ru_RU_Manual"] ? NavArticlePermissions.fromJS(_data["ru_RU_Manual"]) : <any>undefined;
            this.ru_RU_Manual2 = _data["ru_RU_Manual2"] ? NavArticlePermissions.fromJS(_data["ru_RU_Manual2"]) : <any>undefined;
            this.ru_RU_Manual3 = _data["ru_RU_Manual3"] ? NavArticlePermissions.fromJS(_data["ru_RU_Manual3"]) : <any>undefined;
            this.ja_JP_Manual = _data["ja_JP_Manual"] ? NavArticlePermissions.fromJS(_data["ja_JP_Manual"]) : <any>undefined;
            this.ja_JP_Manual2 = _data["ja_JP_Manual2"] ? NavArticlePermissions.fromJS(_data["ja_JP_Manual2"]) : <any>undefined;
            this.ja_JP_Manual3 = _data["ja_JP_Manual3"] ? NavArticlePermissions.fromJS(_data["ja_JP_Manual3"]) : <any>undefined;
            this.pl_PL_Manual = _data["pl_PL_Manual"] ? NavArticlePermissions.fromJS(_data["pl_PL_Manual"]) : <any>undefined;
            this.pl_PL_Manual2 = _data["pl_PL_Manual2"] ? NavArticlePermissions.fromJS(_data["pl_PL_Manual2"]) : <any>undefined;
            this.pl_PL_Manual3 = _data["pl_PL_Manual3"] ? NavArticlePermissions.fromJS(_data["pl_PL_Manual3"]) : <any>undefined;
            this.es_ES_Manual = _data["es_ES_Manual"] ? NavArticlePermissions.fromJS(_data["es_ES_Manual"]) : <any>undefined;
            this.es_ES_Manual2 = _data["es_ES_Manual2"] ? NavArticlePermissions.fromJS(_data["es_ES_Manual2"]) : <any>undefined;
            this.es_ES_Manual3 = _data["es_ES_Manual3"] ? NavArticlePermissions.fromJS(_data["es_ES_Manual3"]) : <any>undefined;
            this.pt_PT_Manual = _data["pt_PT_Manual"] ? NavArticlePermissions.fromJS(_data["pt_PT_Manual"]) : <any>undefined;
            this.pt_PT_Manual2 = _data["pt_PT_Manual2"] ? NavArticlePermissions.fromJS(_data["pt_PT_Manual2"]) : <any>undefined;
            this.pt_PT_Manual3 = _data["pt_PT_Manual3"] ? NavArticlePermissions.fromJS(_data["pt_PT_Manual3"]) : <any>undefined;
            this.ko_KR_Manual = _data["ko_KR_Manual"] ? NavArticlePermissions.fromJS(_data["ko_KR_Manual"]) : <any>undefined;
            this.ko_KR_Manual2 = _data["ko_KR_Manual2"] ? NavArticlePermissions.fromJS(_data["ko_KR_Manual2"]) : <any>undefined;
            this.ko_KR_Manual3 = _data["ko_KR_Manual3"] ? NavArticlePermissions.fromJS(_data["ko_KR_Manual3"]) : <any>undefined;
            this.it_IT_Manual = _data["it_IT_Manual"] ? NavArticlePermissions.fromJS(_data["it_IT_Manual"]) : <any>undefined;
            this.it_IT_Manual2 = _data["it_IT_Manual2"] ? NavArticlePermissions.fromJS(_data["it_IT_Manual2"]) : <any>undefined;
            this.it_IT_Manual3 = _data["it_IT_Manual3"] ? NavArticlePermissions.fromJS(_data["it_IT_Manual3"]) : <any>undefined;
            this.hu_HU_Manual = _data["hu_HU_Manual"] ? NavArticlePermissions.fromJS(_data["hu_HU_Manual"]) : <any>undefined;
            this.hu_HU_Manual2 = _data["hu_HU_Manual2"] ? NavArticlePermissions.fromJS(_data["hu_HU_Manual2"]) : <any>undefined;
            this.hu_HU_Manual3 = _data["hu_HU_Manual3"] ? NavArticlePermissions.fromJS(_data["hu_HU_Manual3"]) : <any>undefined;
            this.cs_CZ_Manual = _data["cs_CZ_Manual"] ? NavArticlePermissions.fromJS(_data["cs_CZ_Manual"]) : <any>undefined;
            this.cs_CZ_Manual2 = _data["cs_CZ_Manual2"] ? NavArticlePermissions.fromJS(_data["cs_CZ_Manual2"]) : <any>undefined;
            this.cs_CZ_Manual3 = _data["cs_CZ_Manual3"] ? NavArticlePermissions.fromJS(_data["cs_CZ_Manual3"]) : <any>undefined;
            this.ro_RO_Manual = _data["ro_RO_Manual"] ? NavArticlePermissions.fromJS(_data["ro_RO_Manual"]) : <any>undefined;
            this.ro_RO_Manual2 = _data["ro_RO_Manual2"] ? NavArticlePermissions.fromJS(_data["ro_RO_Manual2"]) : <any>undefined;
            this.ro_RO_Manual3 = _data["ro_RO_Manual3"] ? NavArticlePermissions.fromJS(_data["ro_RO_Manual3"]) : <any>undefined;
            this.el_GR_Manual = _data["el_GR_Manual"] ? NavArticlePermissions.fromJS(_data["el_GR_Manual"]) : <any>undefined;
            this.el_GR_Manual2 = _data["el_GR_Manual2"] ? NavArticlePermissions.fromJS(_data["el_GR_Manual2"]) : <any>undefined;
            this.el_GR_Manual3 = _data["el_GR_Manual3"] ? NavArticlePermissions.fromJS(_data["el_GR_Manual3"]) : <any>undefined;
            this.tr_TR_Manual = _data["tr_TR_Manual"] ? NavArticlePermissions.fromJS(_data["tr_TR_Manual"]) : <any>undefined;
            this.tr_TR_Manual2 = _data["tr_TR_Manual2"] ? NavArticlePermissions.fromJS(_data["tr_TR_Manual2"]) : <any>undefined;
            this.tr_TR_Manual3 = _data["tr_TR_Manual3"] ? NavArticlePermissions.fromJS(_data["tr_TR_Manual3"]) : <any>undefined;
            this.lt_LT_Manual = _data["lt_LT_Manual"] ? NavArticlePermissions.fromJS(_data["lt_LT_Manual"]) : <any>undefined;
            this.lt_LT_Manual2 = _data["lt_LT_Manual2"] ? NavArticlePermissions.fromJS(_data["lt_LT_Manual2"]) : <any>undefined;
            this.lt_LT_Manual3 = _data["lt_LT_Manual3"] ? NavArticlePermissions.fromJS(_data["lt_LT_Manual3"]) : <any>undefined;
            this.sl_SL_Manual = _data["sl_SL_Manual"] ? NavArticlePermissions.fromJS(_data["sl_SL_Manual"]) : <any>undefined;
            this.sl_SL_Manual2 = _data["sl_SL_Manual2"] ? NavArticlePermissions.fromJS(_data["sl_SL_Manual2"]) : <any>undefined;
            this.sl_SL_Manual3 = _data["sl_SL_Manual3"] ? NavArticlePermissions.fromJS(_data["sl_SL_Manual3"]) : <any>undefined;
            this.bg_BG_Manual = _data["bg_BG_Manual"] ? NavArticlePermissions.fromJS(_data["bg_BG_Manual"]) : <any>undefined;
            this.bg_BG_Manual2 = _data["bg_BG_Manual2"] ? NavArticlePermissions.fromJS(_data["bg_BG_Manual2"]) : <any>undefined;
            this.bg_BG_Manual3 = _data["bg_BG_Manual3"] ? NavArticlePermissions.fromJS(_data["bg_BG_Manual3"]) : <any>undefined;
            this.hr_HR_Manual = _data["hr_HR_Manual"] ? NavArticlePermissions.fromJS(_data["hr_HR_Manual"]) : <any>undefined;
            this.hr_HR_Manual2 = _data["hr_HR_Manual2"] ? NavArticlePermissions.fromJS(_data["hr_HR_Manual2"]) : <any>undefined;
            this.hr_HR_Manual3 = _data["hr_HR_Manual3"] ? NavArticlePermissions.fromJS(_data["hr_HR_Manual3"]) : <any>undefined;
            this.et_EE_Manual = _data["et_EE_Manual"] ? NavArticlePermissions.fromJS(_data["et_EE_Manual"]) : <any>undefined;
            this.et_EE_Manual2 = _data["et_EE_Manual2"] ? NavArticlePermissions.fromJS(_data["et_EE_Manual2"]) : <any>undefined;
            this.et_EE_Manual3 = _data["et_EE_Manual3"] ? NavArticlePermissions.fromJS(_data["et_EE_Manual3"]) : <any>undefined;
            this.is_IS_Manual = _data["is_IS_Manual"] ? NavArticlePermissions.fromJS(_data["is_IS_Manual"]) : <any>undefined;
            this.is_IS_Manual2 = _data["is_IS_Manual2"] ? NavArticlePermissions.fromJS(_data["is_IS_Manual2"]) : <any>undefined;
            this.is_IS_Manual3 = _data["is_IS_Manual3"] ? NavArticlePermissions.fromJS(_data["is_IS_Manual3"]) : <any>undefined;
            this.lv_LV_Manual = _data["lv_LV_Manual"] ? NavArticlePermissions.fromJS(_data["lv_LV_Manual"]) : <any>undefined;
            this.lv_LV_Manual2 = _data["lv_LV_Manual2"] ? NavArticlePermissions.fromJS(_data["lv_LV_Manual2"]) : <any>undefined;
            this.lv_LV_Manual3 = _data["lv_LV_Manual3"] ? NavArticlePermissions.fromJS(_data["lv_LV_Manual3"]) : <any>undefined;
            this.zh_CN_Manual = _data["zh_CN_Manual"] ? NavArticlePermissions.fromJS(_data["zh_CN_Manual"]) : <any>undefined;
            this.zh_CN_Manual2 = _data["zh_CN_Manual2"] ? NavArticlePermissions.fromJS(_data["zh_CN_Manual2"]) : <any>undefined;
            this.zh_CN_Manual3 = _data["zh_CN_Manual3"] ? NavArticlePermissions.fromJS(_data["zh_CN_Manual3"]) : <any>undefined;
            this.th_TH_Manual = _data["th_TH_Manual"] ? NavArticlePermissions.fromJS(_data["th_TH_Manual"]) : <any>undefined;
            this.th_TH_Manual2 = _data["th_TH_Manual2"] ? NavArticlePermissions.fromJS(_data["th_TH_Manual2"]) : <any>undefined;
            this.th_TH_Manual3 = _data["th_TH_Manual3"] ? NavArticlePermissions.fromJS(_data["th_TH_Manual3"]) : <any>undefined;
            this.he_IL_Manual = _data["he_IL_Manual"] ? NavArticlePermissions.fromJS(_data["he_IL_Manual"]) : <any>undefined;
            this.he_IL_Manual2 = _data["he_IL_Manual2"] ? NavArticlePermissions.fromJS(_data["he_IL_Manual2"]) : <any>undefined;
            this.he_IL_Manual3 = _data["he_IL_Manual3"] ? NavArticlePermissions.fromJS(_data["he_IL_Manual3"]) : <any>undefined;
            this.fr_CA_Manual = _data["fr_CA_Manual"] ? NavArticlePermissions.fromJS(_data["fr_CA_Manual"]) : <any>undefined;
            this.fr_CA_Manual2 = _data["fr_CA_Manual2"] ? NavArticlePermissions.fromJS(_data["fr_CA_Manual2"]) : <any>undefined;
            this.fr_CA_Manual3 = _data["fr_CA_Manual3"] ? NavArticlePermissions.fromJS(_data["fr_CA_Manual3"]) : <any>undefined;
            this.en_US_Manual = _data["en_US_Manual"] ? NavArticlePermissions.fromJS(_data["en_US_Manual"]) : <any>undefined;
            this.en_US_Manual2 = _data["en_US_Manual2"] ? NavArticlePermissions.fromJS(_data["en_US_Manual2"]) : <any>undefined;
            this.en_US_Manual3 = _data["en_US_Manual3"] ? NavArticlePermissions.fromJS(_data["en_US_Manual3"]) : <any>undefined;
            this.es_US_Manual = _data["es_US_Manual"] ? NavArticlePermissions.fromJS(_data["es_US_Manual"]) : <any>undefined;
            this.es_US_Manual2 = _data["es_US_Manual2"] ? NavArticlePermissions.fromJS(_data["es_US_Manual2"]) : <any>undefined;
            this.es_US_Manual3 = _data["es_US_Manual3"] ? NavArticlePermissions.fromJS(_data["es_US_Manual3"]) : <any>undefined;
            this.sk_SK_Manual = _data["sk_SK_Manual"] ? NavArticlePermissions.fromJS(_data["sk_SK_Manual"]) : <any>undefined;
            this.sk_SK_Manual2 = _data["sk_SK_Manual2"] ? NavArticlePermissions.fromJS(_data["sk_SK_Manual2"]) : <any>undefined;
            this.sk_SK_Manual3 = _data["sk_SK_Manual3"] ? NavArticlePermissions.fromJS(_data["sk_SK_Manual3"]) : <any>undefined;
            this.en_GB_Quickguides = _data["en_GB_Quickguides"] ? NavArticlePermissions.fromJS(_data["en_GB_Quickguides"]) : <any>undefined;
            this.da_DK_UserVideo = _data["da_DK_UserVideo"] ? NavArticlePermissions.fromJS(_data["da_DK_UserVideo"]) : <any>undefined;
            this.da_DK_UserVideo2 = _data["da_DK_UserVideo2"] ? NavArticlePermissions.fromJS(_data["da_DK_UserVideo2"]) : <any>undefined;
            this.da_DK_UserVideo3 = _data["da_DK_UserVideo3"] ? NavArticlePermissions.fromJS(_data["da_DK_UserVideo3"]) : <any>undefined;
            this.en_GB_UserVideo = _data["en_GB_UserVideo"] ? NavArticlePermissions.fromJS(_data["en_GB_UserVideo"]) : <any>undefined;
            this.en_GB_UserVideo2 = _data["en_GB_UserVideo2"] ? NavArticlePermissions.fromJS(_data["en_GB_UserVideo2"]) : <any>undefined;
            this.en_GB_UserVideo3 = _data["en_GB_UserVideo3"] ? NavArticlePermissions.fromJS(_data["en_GB_UserVideo3"]) : <any>undefined;
            this.en_UK_UserVideo = _data["en_UK_UserVideo"] ? NavArticlePermissions.fromJS(_data["en_UK_UserVideo"]) : <any>undefined;
            this.en_UK_UserVideo2 = _data["en_UK_UserVideo2"] ? NavArticlePermissions.fromJS(_data["en_UK_UserVideo2"]) : <any>undefined;
            this.en_UK_UserVideo3 = _data["en_UK_UserVideo3"] ? NavArticlePermissions.fromJS(_data["en_UK_UserVideo3"]) : <any>undefined;
            this.de_DE_UserVideo = _data["de_DE_UserVideo"] ? NavArticlePermissions.fromJS(_data["de_DE_UserVideo"]) : <any>undefined;
            this.de_DE_UserVideo2 = _data["de_DE_UserVideo2"] ? NavArticlePermissions.fromJS(_data["de_DE_UserVideo2"]) : <any>undefined;
            this.de_DE_UserVideo3 = _data["de_DE_UserVideo3"] ? NavArticlePermissions.fromJS(_data["de_DE_UserVideo3"]) : <any>undefined;
            this.nl_NL_UserVideo = _data["nl_NL_UserVideo"] ? NavArticlePermissions.fromJS(_data["nl_NL_UserVideo"]) : <any>undefined;
            this.nl_NL_UserVideo2 = _data["nl_NL_UserVideo2"] ? NavArticlePermissions.fromJS(_data["nl_NL_UserVideo2"]) : <any>undefined;
            this.nl_NL_UserVideo3 = _data["nl_NL_UserVideo3"] ? NavArticlePermissions.fromJS(_data["nl_NL_UserVideo3"]) : <any>undefined;
            this.fr_FR_UserVideo = _data["fr_FR_UserVideo"] ? NavArticlePermissions.fromJS(_data["fr_FR_UserVideo"]) : <any>undefined;
            this.fr_FR_UserVideo2 = _data["fr_FR_UserVideo2"] ? NavArticlePermissions.fromJS(_data["fr_FR_UserVideo2"]) : <any>undefined;
            this.fr_FR_UserVideo3 = _data["fr_FR_UserVideo3"] ? NavArticlePermissions.fromJS(_data["fr_FR_UserVideo3"]) : <any>undefined;
            this.sv_SE_UserVideo = _data["sv_SE_UserVideo"] ? NavArticlePermissions.fromJS(_data["sv_SE_UserVideo"]) : <any>undefined;
            this.sv_SE_UserVideo2 = _data["sv_SE_UserVideo2"] ? NavArticlePermissions.fromJS(_data["sv_SE_UserVideo2"]) : <any>undefined;
            this.sv_SE_UserVideo3 = _data["sv_SE_UserVideo3"] ? NavArticlePermissions.fromJS(_data["sv_SE_UserVideo3"]) : <any>undefined;
            this.nb_NO_UserVideo = _data["nb_NO_UserVideo"] ? NavArticlePermissions.fromJS(_data["nb_NO_UserVideo"]) : <any>undefined;
            this.nb_NO_UserVideo2 = _data["nb_NO_UserVideo2"] ? NavArticlePermissions.fromJS(_data["nb_NO_UserVideo2"]) : <any>undefined;
            this.nb_NO_UserVideo3 = _data["nb_NO_UserVideo3"] ? NavArticlePermissions.fromJS(_data["nb_NO_UserVideo3"]) : <any>undefined;
            this.fi_FI_UserVideo = _data["fi_FI_UserVideo"] ? NavArticlePermissions.fromJS(_data["fi_FI_UserVideo"]) : <any>undefined;
            this.fi_FI_UserVideo2 = _data["fi_FI_UserVideo2"] ? NavArticlePermissions.fromJS(_data["fi_FI_UserVideo2"]) : <any>undefined;
            this.fi_FI_UserVideo3 = _data["fi_FI_UserVideo3"] ? NavArticlePermissions.fromJS(_data["fi_FI_UserVideo3"]) : <any>undefined;
            this.ru_RU_UserVideo = _data["ru_RU_UserVideo"] ? NavArticlePermissions.fromJS(_data["ru_RU_UserVideo"]) : <any>undefined;
            this.ru_RU_UserVideo2 = _data["ru_RU_UserVideo2"] ? NavArticlePermissions.fromJS(_data["ru_RU_UserVideo2"]) : <any>undefined;
            this.ru_RU_UserVideo3 = _data["ru_RU_UserVideo3"] ? NavArticlePermissions.fromJS(_data["ru_RU_UserVideo3"]) : <any>undefined;
            this.ja_JP_UserVideo = _data["ja_JP_UserVideo"] ? NavArticlePermissions.fromJS(_data["ja_JP_UserVideo"]) : <any>undefined;
            this.ja_JP_UserVideo2 = _data["ja_JP_UserVideo2"] ? NavArticlePermissions.fromJS(_data["ja_JP_UserVideo2"]) : <any>undefined;
            this.ja_JP_UserVideo3 = _data["ja_JP_UserVideo3"] ? NavArticlePermissions.fromJS(_data["ja_JP_UserVideo3"]) : <any>undefined;
            this.pl_PL_UserVideo = _data["pl_PL_UserVideo"] ? NavArticlePermissions.fromJS(_data["pl_PL_UserVideo"]) : <any>undefined;
            this.pl_PL_UserVideo2 = _data["pl_PL_UserVideo2"] ? NavArticlePermissions.fromJS(_data["pl_PL_UserVideo2"]) : <any>undefined;
            this.pl_PL_UserVideo3 = _data["pl_PL_UserVideo3"] ? NavArticlePermissions.fromJS(_data["pl_PL_UserVideo3"]) : <any>undefined;
            this.es_ES_UserVideo = _data["es_ES_UserVideo"] ? NavArticlePermissions.fromJS(_data["es_ES_UserVideo"]) : <any>undefined;
            this.es_ES_UserVideo2 = _data["es_ES_UserVideo2"] ? NavArticlePermissions.fromJS(_data["es_ES_UserVideo2"]) : <any>undefined;
            this.es_ES_UserVideo3 = _data["es_ES_UserVideo3"] ? NavArticlePermissions.fromJS(_data["es_ES_UserVideo3"]) : <any>undefined;
            this.pt_PT_UserVideo = _data["pt_PT_UserVideo"] ? NavArticlePermissions.fromJS(_data["pt_PT_UserVideo"]) : <any>undefined;
            this.pt_PT_UserVideo2 = _data["pt_PT_UserVideo2"] ? NavArticlePermissions.fromJS(_data["pt_PT_UserVideo2"]) : <any>undefined;
            this.pt_PT_UserVideo3 = _data["pt_PT_UserVideo3"] ? NavArticlePermissions.fromJS(_data["pt_PT_UserVideo3"]) : <any>undefined;
            this.ko_KR_UserVideo = _data["ko_KR_UserVideo"] ? NavArticlePermissions.fromJS(_data["ko_KR_UserVideo"]) : <any>undefined;
            this.ko_KR_UserVideo2 = _data["ko_KR_UserVideo2"] ? NavArticlePermissions.fromJS(_data["ko_KR_UserVideo2"]) : <any>undefined;
            this.ko_KR_UserVideo3 = _data["ko_KR_UserVideo3"] ? NavArticlePermissions.fromJS(_data["ko_KR_UserVideo3"]) : <any>undefined;
            this.it_IT_UserVideo = _data["it_IT_UserVideo"] ? NavArticlePermissions.fromJS(_data["it_IT_UserVideo"]) : <any>undefined;
            this.it_IT_UserVideo2 = _data["it_IT_UserVideo2"] ? NavArticlePermissions.fromJS(_data["it_IT_UserVideo2"]) : <any>undefined;
            this.it_IT_UserVideo3 = _data["it_IT_UserVideo3"] ? NavArticlePermissions.fromJS(_data["it_IT_UserVideo3"]) : <any>undefined;
            this.hu_HU_UserVideo = _data["hu_HU_UserVideo"] ? NavArticlePermissions.fromJS(_data["hu_HU_UserVideo"]) : <any>undefined;
            this.hu_HU_UserVideo2 = _data["hu_HU_UserVideo2"] ? NavArticlePermissions.fromJS(_data["hu_HU_UserVideo2"]) : <any>undefined;
            this.hu_HU_UserVideo3 = _data["hu_HU_UserVideo3"] ? NavArticlePermissions.fromJS(_data["hu_HU_UserVideo3"]) : <any>undefined;
            this.cs_CZ_UserVideo = _data["cs_CZ_UserVideo"] ? NavArticlePermissions.fromJS(_data["cs_CZ_UserVideo"]) : <any>undefined;
            this.cs_CZ_UserVideo2 = _data["cs_CZ_UserVideo2"] ? NavArticlePermissions.fromJS(_data["cs_CZ_UserVideo2"]) : <any>undefined;
            this.cs_CZ_UserVideo3 = _data["cs_CZ_UserVideo3"] ? NavArticlePermissions.fromJS(_data["cs_CZ_UserVideo3"]) : <any>undefined;
            this.ro_RO_UserVideo = _data["ro_RO_UserVideo"] ? NavArticlePermissions.fromJS(_data["ro_RO_UserVideo"]) : <any>undefined;
            this.ro_RO_UserVideo2 = _data["ro_RO_UserVideo2"] ? NavArticlePermissions.fromJS(_data["ro_RO_UserVideo2"]) : <any>undefined;
            this.ro_RO_UserVideo3 = _data["ro_RO_UserVideo3"] ? NavArticlePermissions.fromJS(_data["ro_RO_UserVideo3"]) : <any>undefined;
            this.el_GR_UserVideo = _data["el_GR_UserVideo"] ? NavArticlePermissions.fromJS(_data["el_GR_UserVideo"]) : <any>undefined;
            this.el_GR_UserVideo2 = _data["el_GR_UserVideo2"] ? NavArticlePermissions.fromJS(_data["el_GR_UserVideo2"]) : <any>undefined;
            this.el_GR_UserVideo3 = _data["el_GR_UserVideo3"] ? NavArticlePermissions.fromJS(_data["el_GR_UserVideo3"]) : <any>undefined;
            this.tr_TR_UserVideo = _data["tr_TR_UserVideo"] ? NavArticlePermissions.fromJS(_data["tr_TR_UserVideo"]) : <any>undefined;
            this.tr_TR_UserVideo2 = _data["tr_TR_UserVideo2"] ? NavArticlePermissions.fromJS(_data["tr_TR_UserVideo2"]) : <any>undefined;
            this.tr_TR_UserVideo3 = _data["tr_TR_UserVideo3"] ? NavArticlePermissions.fromJS(_data["tr_TR_UserVideo3"]) : <any>undefined;
            this.lt_LT_UserVideo = _data["lt_LT_UserVideo"] ? NavArticlePermissions.fromJS(_data["lt_LT_UserVideo"]) : <any>undefined;
            this.lt_LT_UserVideo2 = _data["lt_LT_UserVideo2"] ? NavArticlePermissions.fromJS(_data["lt_LT_UserVideo2"]) : <any>undefined;
            this.lt_LT_UserVideo3 = _data["lt_LT_UserVideo3"] ? NavArticlePermissions.fromJS(_data["lt_LT_UserVideo3"]) : <any>undefined;
            this.sl_SL_UserVideo = _data["sl_SL_UserVideo"] ? NavArticlePermissions.fromJS(_data["sl_SL_UserVideo"]) : <any>undefined;
            this.sl_SL_UserVideo2 = _data["sl_SL_UserVideo2"] ? NavArticlePermissions.fromJS(_data["sl_SL_UserVideo2"]) : <any>undefined;
            this.sl_SL_UserVideo3 = _data["sl_SL_UserVideo3"] ? NavArticlePermissions.fromJS(_data["sl_SL_UserVideo3"]) : <any>undefined;
            this.bg_BG_UserVideo = _data["bg_BG_UserVideo"] ? NavArticlePermissions.fromJS(_data["bg_BG_UserVideo"]) : <any>undefined;
            this.bg_BG_UserVideo2 = _data["bg_BG_UserVideo2"] ? NavArticlePermissions.fromJS(_data["bg_BG_UserVideo2"]) : <any>undefined;
            this.bg_BG_UserVideo3 = _data["bg_BG_UserVideo3"] ? NavArticlePermissions.fromJS(_data["bg_BG_UserVideo3"]) : <any>undefined;
            this.hr_HR_UserVideo = _data["hr_HR_UserVideo"] ? NavArticlePermissions.fromJS(_data["hr_HR_UserVideo"]) : <any>undefined;
            this.hr_HR_UserVideo2 = _data["hr_HR_UserVideo2"] ? NavArticlePermissions.fromJS(_data["hr_HR_UserVideo2"]) : <any>undefined;
            this.hr_HR_UserVideo3 = _data["hr_HR_UserVideo3"] ? NavArticlePermissions.fromJS(_data["hr_HR_UserVideo3"]) : <any>undefined;
            this.et_EE_UserVideo = _data["et_EE_UserVideo"] ? NavArticlePermissions.fromJS(_data["et_EE_UserVideo"]) : <any>undefined;
            this.et_EE_UserVideo2 = _data["et_EE_UserVideo2"] ? NavArticlePermissions.fromJS(_data["et_EE_UserVideo2"]) : <any>undefined;
            this.et_EE_UserVideo3 = _data["et_EE_UserVideo3"] ? NavArticlePermissions.fromJS(_data["et_EE_UserVideo3"]) : <any>undefined;
            this.is_IS_UserVideo = _data["is_IS_UserVideo"] ? NavArticlePermissions.fromJS(_data["is_IS_UserVideo"]) : <any>undefined;
            this.is_IS_UserVideo2 = _data["is_IS_UserVideo2"] ? NavArticlePermissions.fromJS(_data["is_IS_UserVideo2"]) : <any>undefined;
            this.is_IS_UserVideo3 = _data["is_IS_UserVideo3"] ? NavArticlePermissions.fromJS(_data["is_IS_UserVideo3"]) : <any>undefined;
            this.lv_LV_UserVideo = _data["lv_LV_UserVideo"] ? NavArticlePermissions.fromJS(_data["lv_LV_UserVideo"]) : <any>undefined;
            this.lv_LV_UserVideo2 = _data["lv_LV_UserVideo2"] ? NavArticlePermissions.fromJS(_data["lv_LV_UserVideo2"]) : <any>undefined;
            this.lv_LV_UserVideo3 = _data["lv_LV_UserVideo3"] ? NavArticlePermissions.fromJS(_data["lv_LV_UserVideo3"]) : <any>undefined;
            this.zh_CN_UserVideo = _data["zh_CN_UserVideo"] ? NavArticlePermissions.fromJS(_data["zh_CN_UserVideo"]) : <any>undefined;
            this.zh_CN_UserVideo2 = _data["zh_CN_UserVideo2"] ? NavArticlePermissions.fromJS(_data["zh_CN_UserVideo2"]) : <any>undefined;
            this.zh_CN_UserVideo3 = _data["zh_CN_UserVideo3"] ? NavArticlePermissions.fromJS(_data["zh_CN_UserVideo3"]) : <any>undefined;
            this.th_TH_UserVideo = _data["th_TH_UserVideo"] ? NavArticlePermissions.fromJS(_data["th_TH_UserVideo"]) : <any>undefined;
            this.th_TH_UserVideo2 = _data["th_TH_UserVideo2"] ? NavArticlePermissions.fromJS(_data["th_TH_UserVideo2"]) : <any>undefined;
            this.th_TH_UserVideo3 = _data["th_TH_UserVideo3"] ? NavArticlePermissions.fromJS(_data["th_TH_UserVideo3"]) : <any>undefined;
            this.he_IL_UserVideo = _data["he_IL_UserVideo"] ? NavArticlePermissions.fromJS(_data["he_IL_UserVideo"]) : <any>undefined;
            this.he_IL_UserVideo2 = _data["he_IL_UserVideo2"] ? NavArticlePermissions.fromJS(_data["he_IL_UserVideo2"]) : <any>undefined;
            this.he_IL_UserVideo3 = _data["he_IL_UserVideo3"] ? NavArticlePermissions.fromJS(_data["he_IL_UserVideo3"]) : <any>undefined;
            this.fr_CA_UserVideo = _data["fr_CA_UserVideo"] ? NavArticlePermissions.fromJS(_data["fr_CA_UserVideo"]) : <any>undefined;
            this.fr_CA_UserVideo2 = _data["fr_CA_UserVideo2"] ? NavArticlePermissions.fromJS(_data["fr_CA_UserVideo2"]) : <any>undefined;
            this.fr_CA_UserVideo3 = _data["fr_CA_UserVideo3"] ? NavArticlePermissions.fromJS(_data["fr_CA_UserVideo3"]) : <any>undefined;
            this.en_US_UserVideo = _data["en_US_UserVideo"] ? NavArticlePermissions.fromJS(_data["en_US_UserVideo"]) : <any>undefined;
            this.en_US_UserVideo2 = _data["en_US_UserVideo2"] ? NavArticlePermissions.fromJS(_data["en_US_UserVideo2"]) : <any>undefined;
            this.en_US_UserVideo3 = _data["en_US_UserVideo3"] ? NavArticlePermissions.fromJS(_data["en_US_UserVideo3"]) : <any>undefined;
            this.es_US_UserVideo = _data["es_US_UserVideo"] ? NavArticlePermissions.fromJS(_data["es_US_UserVideo"]) : <any>undefined;
            this.es_US_UserVideo2 = _data["es_US_UserVideo2"] ? NavArticlePermissions.fromJS(_data["es_US_UserVideo2"]) : <any>undefined;
            this.es_US_UserVideo3 = _data["es_US_UserVideo3"] ? NavArticlePermissions.fromJS(_data["es_US_UserVideo3"]) : <any>undefined;
            this.sk_SK_UserVideo = _data["sk_SK_UserVideo"] ? NavArticlePermissions.fromJS(_data["sk_SK_UserVideo"]) : <any>undefined;
            this.sk_SK_UserVideo2 = _data["sk_SK_UserVideo2"] ? NavArticlePermissions.fromJS(_data["sk_SK_UserVideo2"]) : <any>undefined;
            this.sk_SK_UserVideo3 = _data["sk_SK_UserVideo3"] ? NavArticlePermissions.fromJS(_data["sk_SK_UserVideo3"]) : <any>undefined;
            this.en_GB_Servicevideo1 = _data["en_GB_Servicevideo1"] ? NavArticlePermissions.fromJS(_data["en_GB_Servicevideo1"]) : <any>undefined;
            this.en_GB_Servicevideo2 = _data["en_GB_Servicevideo2"] ? NavArticlePermissions.fromJS(_data["en_GB_Servicevideo2"]) : <any>undefined;
            this.en_GB_Servicevideo3 = _data["en_GB_Servicevideo3"] ? NavArticlePermissions.fromJS(_data["en_GB_Servicevideo3"]) : <any>undefined;
            this.en_GB_Servicevideo4 = _data["en_GB_Servicevideo4"] ? NavArticlePermissions.fromJS(_data["en_GB_Servicevideo4"]) : <any>undefined;
            this.en_GB_Servicevideo5 = _data["en_GB_Servicevideo5"] ? NavArticlePermissions.fromJS(_data["en_GB_Servicevideo5"]) : <any>undefined;
            this.en_GB_Servicevideo6 = _data["en_GB_Servicevideo6"] ? NavArticlePermissions.fromJS(_data["en_GB_Servicevideo6"]) : <any>undefined;
            this.en_GB_SparePartsManualWW = _data["en_GB_SparePartsManualWW"] ? NavArticlePermissions.fromJS(_data["en_GB_SparePartsManualWW"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NavUnitDocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new NavUnitDocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["en_GB_ElectricalDiagrams"] = this.en_GB_ElectricalDiagrams ? this.en_GB_ElectricalDiagrams.toJSON() : <any>undefined;
        data["en_GB_HydraulicsDiagrams"] = this.en_GB_HydraulicsDiagrams ? this.en_GB_HydraulicsDiagrams.toJSON() : <any>undefined;
        data["en_Diagrams"] = this.en_Diagrams ? this.en_Diagrams.toJSON() : <any>undefined;
        data["de_Diagrams"] = this.de_Diagrams ? this.de_Diagrams.toJSON() : <any>undefined;
        data["xX_Diagrams"] = this.xX_Diagrams ? this.xX_Diagrams.toJSON() : <any>undefined;
        data["de_Usermanual"] = this.de_Usermanual ? this.de_Usermanual.toJSON() : <any>undefined;
        data["en_Usermanual"] = this.en_Usermanual ? this.en_Usermanual.toJSON() : <any>undefined;
        data["xX_Usermanual"] = this.xX_Usermanual ? this.xX_Usermanual.toJSON() : <any>undefined;
        data["da_DK_Manual"] = this.da_DK_Manual ? this.da_DK_Manual.toJSON() : <any>undefined;
        data["da_DK_Manual2"] = this.da_DK_Manual2 ? this.da_DK_Manual2.toJSON() : <any>undefined;
        data["da_DK_Manual3"] = this.da_DK_Manual3 ? this.da_DK_Manual3.toJSON() : <any>undefined;
        data["en_GB_Manual"] = this.en_GB_Manual ? this.en_GB_Manual.toJSON() : <any>undefined;
        data["en_GB_Manual2"] = this.en_GB_Manual2 ? this.en_GB_Manual2.toJSON() : <any>undefined;
        data["en_GB_Manual3"] = this.en_GB_Manual3 ? this.en_GB_Manual3.toJSON() : <any>undefined;
        data["en_UK_Manual"] = this.en_UK_Manual ? this.en_UK_Manual.toJSON() : <any>undefined;
        data["en_UK_Manual2"] = this.en_UK_Manual2 ? this.en_UK_Manual2.toJSON() : <any>undefined;
        data["en_UK_Manual3"] = this.en_UK_Manual3 ? this.en_UK_Manual3.toJSON() : <any>undefined;
        data["de_DE_Manual"] = this.de_DE_Manual ? this.de_DE_Manual.toJSON() : <any>undefined;
        data["de_DE_Manual2"] = this.de_DE_Manual2 ? this.de_DE_Manual2.toJSON() : <any>undefined;
        data["de_DE_Manual3"] = this.de_DE_Manual3 ? this.de_DE_Manual3.toJSON() : <any>undefined;
        data["nl_NL_Manual"] = this.nl_NL_Manual ? this.nl_NL_Manual.toJSON() : <any>undefined;
        data["nl_NL_Manual2"] = this.nl_NL_Manual2 ? this.nl_NL_Manual2.toJSON() : <any>undefined;
        data["nl_NL_Manual3"] = this.nl_NL_Manual3 ? this.nl_NL_Manual3.toJSON() : <any>undefined;
        data["fr_FR_Manual"] = this.fr_FR_Manual ? this.fr_FR_Manual.toJSON() : <any>undefined;
        data["fr_FR_Manual2"] = this.fr_FR_Manual2 ? this.fr_FR_Manual2.toJSON() : <any>undefined;
        data["fr_FR_Manual3"] = this.fr_FR_Manual3 ? this.fr_FR_Manual3.toJSON() : <any>undefined;
        data["sv_SE_Manual"] = this.sv_SE_Manual ? this.sv_SE_Manual.toJSON() : <any>undefined;
        data["sv_SE_Manual2"] = this.sv_SE_Manual2 ? this.sv_SE_Manual2.toJSON() : <any>undefined;
        data["sv_SE_Manual3"] = this.sv_SE_Manual3 ? this.sv_SE_Manual3.toJSON() : <any>undefined;
        data["nb_NO_Manual"] = this.nb_NO_Manual ? this.nb_NO_Manual.toJSON() : <any>undefined;
        data["nb_NO_Manual2"] = this.nb_NO_Manual2 ? this.nb_NO_Manual2.toJSON() : <any>undefined;
        data["nb_NO_Manual3"] = this.nb_NO_Manual3 ? this.nb_NO_Manual3.toJSON() : <any>undefined;
        data["fi_FI_Manual"] = this.fi_FI_Manual ? this.fi_FI_Manual.toJSON() : <any>undefined;
        data["fi_FI_Manual2"] = this.fi_FI_Manual2 ? this.fi_FI_Manual2.toJSON() : <any>undefined;
        data["fi_FI_Manual3"] = this.fi_FI_Manual3 ? this.fi_FI_Manual3.toJSON() : <any>undefined;
        data["ru_RU_Manual"] = this.ru_RU_Manual ? this.ru_RU_Manual.toJSON() : <any>undefined;
        data["ru_RU_Manual2"] = this.ru_RU_Manual2 ? this.ru_RU_Manual2.toJSON() : <any>undefined;
        data["ru_RU_Manual3"] = this.ru_RU_Manual3 ? this.ru_RU_Manual3.toJSON() : <any>undefined;
        data["ja_JP_Manual"] = this.ja_JP_Manual ? this.ja_JP_Manual.toJSON() : <any>undefined;
        data["ja_JP_Manual2"] = this.ja_JP_Manual2 ? this.ja_JP_Manual2.toJSON() : <any>undefined;
        data["ja_JP_Manual3"] = this.ja_JP_Manual3 ? this.ja_JP_Manual3.toJSON() : <any>undefined;
        data["pl_PL_Manual"] = this.pl_PL_Manual ? this.pl_PL_Manual.toJSON() : <any>undefined;
        data["pl_PL_Manual2"] = this.pl_PL_Manual2 ? this.pl_PL_Manual2.toJSON() : <any>undefined;
        data["pl_PL_Manual3"] = this.pl_PL_Manual3 ? this.pl_PL_Manual3.toJSON() : <any>undefined;
        data["es_ES_Manual"] = this.es_ES_Manual ? this.es_ES_Manual.toJSON() : <any>undefined;
        data["es_ES_Manual2"] = this.es_ES_Manual2 ? this.es_ES_Manual2.toJSON() : <any>undefined;
        data["es_ES_Manual3"] = this.es_ES_Manual3 ? this.es_ES_Manual3.toJSON() : <any>undefined;
        data["pt_PT_Manual"] = this.pt_PT_Manual ? this.pt_PT_Manual.toJSON() : <any>undefined;
        data["pt_PT_Manual2"] = this.pt_PT_Manual2 ? this.pt_PT_Manual2.toJSON() : <any>undefined;
        data["pt_PT_Manual3"] = this.pt_PT_Manual3 ? this.pt_PT_Manual3.toJSON() : <any>undefined;
        data["ko_KR_Manual"] = this.ko_KR_Manual ? this.ko_KR_Manual.toJSON() : <any>undefined;
        data["ko_KR_Manual2"] = this.ko_KR_Manual2 ? this.ko_KR_Manual2.toJSON() : <any>undefined;
        data["ko_KR_Manual3"] = this.ko_KR_Manual3 ? this.ko_KR_Manual3.toJSON() : <any>undefined;
        data["it_IT_Manual"] = this.it_IT_Manual ? this.it_IT_Manual.toJSON() : <any>undefined;
        data["it_IT_Manual2"] = this.it_IT_Manual2 ? this.it_IT_Manual2.toJSON() : <any>undefined;
        data["it_IT_Manual3"] = this.it_IT_Manual3 ? this.it_IT_Manual3.toJSON() : <any>undefined;
        data["hu_HU_Manual"] = this.hu_HU_Manual ? this.hu_HU_Manual.toJSON() : <any>undefined;
        data["hu_HU_Manual2"] = this.hu_HU_Manual2 ? this.hu_HU_Manual2.toJSON() : <any>undefined;
        data["hu_HU_Manual3"] = this.hu_HU_Manual3 ? this.hu_HU_Manual3.toJSON() : <any>undefined;
        data["cs_CZ_Manual"] = this.cs_CZ_Manual ? this.cs_CZ_Manual.toJSON() : <any>undefined;
        data["cs_CZ_Manual2"] = this.cs_CZ_Manual2 ? this.cs_CZ_Manual2.toJSON() : <any>undefined;
        data["cs_CZ_Manual3"] = this.cs_CZ_Manual3 ? this.cs_CZ_Manual3.toJSON() : <any>undefined;
        data["ro_RO_Manual"] = this.ro_RO_Manual ? this.ro_RO_Manual.toJSON() : <any>undefined;
        data["ro_RO_Manual2"] = this.ro_RO_Manual2 ? this.ro_RO_Manual2.toJSON() : <any>undefined;
        data["ro_RO_Manual3"] = this.ro_RO_Manual3 ? this.ro_RO_Manual3.toJSON() : <any>undefined;
        data["el_GR_Manual"] = this.el_GR_Manual ? this.el_GR_Manual.toJSON() : <any>undefined;
        data["el_GR_Manual2"] = this.el_GR_Manual2 ? this.el_GR_Manual2.toJSON() : <any>undefined;
        data["el_GR_Manual3"] = this.el_GR_Manual3 ? this.el_GR_Manual3.toJSON() : <any>undefined;
        data["tr_TR_Manual"] = this.tr_TR_Manual ? this.tr_TR_Manual.toJSON() : <any>undefined;
        data["tr_TR_Manual2"] = this.tr_TR_Manual2 ? this.tr_TR_Manual2.toJSON() : <any>undefined;
        data["tr_TR_Manual3"] = this.tr_TR_Manual3 ? this.tr_TR_Manual3.toJSON() : <any>undefined;
        data["lt_LT_Manual"] = this.lt_LT_Manual ? this.lt_LT_Manual.toJSON() : <any>undefined;
        data["lt_LT_Manual2"] = this.lt_LT_Manual2 ? this.lt_LT_Manual2.toJSON() : <any>undefined;
        data["lt_LT_Manual3"] = this.lt_LT_Manual3 ? this.lt_LT_Manual3.toJSON() : <any>undefined;
        data["sl_SL_Manual"] = this.sl_SL_Manual ? this.sl_SL_Manual.toJSON() : <any>undefined;
        data["sl_SL_Manual2"] = this.sl_SL_Manual2 ? this.sl_SL_Manual2.toJSON() : <any>undefined;
        data["sl_SL_Manual3"] = this.sl_SL_Manual3 ? this.sl_SL_Manual3.toJSON() : <any>undefined;
        data["bg_BG_Manual"] = this.bg_BG_Manual ? this.bg_BG_Manual.toJSON() : <any>undefined;
        data["bg_BG_Manual2"] = this.bg_BG_Manual2 ? this.bg_BG_Manual2.toJSON() : <any>undefined;
        data["bg_BG_Manual3"] = this.bg_BG_Manual3 ? this.bg_BG_Manual3.toJSON() : <any>undefined;
        data["hr_HR_Manual"] = this.hr_HR_Manual ? this.hr_HR_Manual.toJSON() : <any>undefined;
        data["hr_HR_Manual2"] = this.hr_HR_Manual2 ? this.hr_HR_Manual2.toJSON() : <any>undefined;
        data["hr_HR_Manual3"] = this.hr_HR_Manual3 ? this.hr_HR_Manual3.toJSON() : <any>undefined;
        data["et_EE_Manual"] = this.et_EE_Manual ? this.et_EE_Manual.toJSON() : <any>undefined;
        data["et_EE_Manual2"] = this.et_EE_Manual2 ? this.et_EE_Manual2.toJSON() : <any>undefined;
        data["et_EE_Manual3"] = this.et_EE_Manual3 ? this.et_EE_Manual3.toJSON() : <any>undefined;
        data["is_IS_Manual"] = this.is_IS_Manual ? this.is_IS_Manual.toJSON() : <any>undefined;
        data["is_IS_Manual2"] = this.is_IS_Manual2 ? this.is_IS_Manual2.toJSON() : <any>undefined;
        data["is_IS_Manual3"] = this.is_IS_Manual3 ? this.is_IS_Manual3.toJSON() : <any>undefined;
        data["lv_LV_Manual"] = this.lv_LV_Manual ? this.lv_LV_Manual.toJSON() : <any>undefined;
        data["lv_LV_Manual2"] = this.lv_LV_Manual2 ? this.lv_LV_Manual2.toJSON() : <any>undefined;
        data["lv_LV_Manual3"] = this.lv_LV_Manual3 ? this.lv_LV_Manual3.toJSON() : <any>undefined;
        data["zh_CN_Manual"] = this.zh_CN_Manual ? this.zh_CN_Manual.toJSON() : <any>undefined;
        data["zh_CN_Manual2"] = this.zh_CN_Manual2 ? this.zh_CN_Manual2.toJSON() : <any>undefined;
        data["zh_CN_Manual3"] = this.zh_CN_Manual3 ? this.zh_CN_Manual3.toJSON() : <any>undefined;
        data["th_TH_Manual"] = this.th_TH_Manual ? this.th_TH_Manual.toJSON() : <any>undefined;
        data["th_TH_Manual2"] = this.th_TH_Manual2 ? this.th_TH_Manual2.toJSON() : <any>undefined;
        data["th_TH_Manual3"] = this.th_TH_Manual3 ? this.th_TH_Manual3.toJSON() : <any>undefined;
        data["he_IL_Manual"] = this.he_IL_Manual ? this.he_IL_Manual.toJSON() : <any>undefined;
        data["he_IL_Manual2"] = this.he_IL_Manual2 ? this.he_IL_Manual2.toJSON() : <any>undefined;
        data["he_IL_Manual3"] = this.he_IL_Manual3 ? this.he_IL_Manual3.toJSON() : <any>undefined;
        data["fr_CA_Manual"] = this.fr_CA_Manual ? this.fr_CA_Manual.toJSON() : <any>undefined;
        data["fr_CA_Manual2"] = this.fr_CA_Manual2 ? this.fr_CA_Manual2.toJSON() : <any>undefined;
        data["fr_CA_Manual3"] = this.fr_CA_Manual3 ? this.fr_CA_Manual3.toJSON() : <any>undefined;
        data["en_US_Manual"] = this.en_US_Manual ? this.en_US_Manual.toJSON() : <any>undefined;
        data["en_US_Manual2"] = this.en_US_Manual2 ? this.en_US_Manual2.toJSON() : <any>undefined;
        data["en_US_Manual3"] = this.en_US_Manual3 ? this.en_US_Manual3.toJSON() : <any>undefined;
        data["es_US_Manual"] = this.es_US_Manual ? this.es_US_Manual.toJSON() : <any>undefined;
        data["es_US_Manual2"] = this.es_US_Manual2 ? this.es_US_Manual2.toJSON() : <any>undefined;
        data["es_US_Manual3"] = this.es_US_Manual3 ? this.es_US_Manual3.toJSON() : <any>undefined;
        data["sk_SK_Manual"] = this.sk_SK_Manual ? this.sk_SK_Manual.toJSON() : <any>undefined;
        data["sk_SK_Manual2"] = this.sk_SK_Manual2 ? this.sk_SK_Manual2.toJSON() : <any>undefined;
        data["sk_SK_Manual3"] = this.sk_SK_Manual3 ? this.sk_SK_Manual3.toJSON() : <any>undefined;
        data["en_GB_Quickguides"] = this.en_GB_Quickguides ? this.en_GB_Quickguides.toJSON() : <any>undefined;
        data["da_DK_UserVideo"] = this.da_DK_UserVideo ? this.da_DK_UserVideo.toJSON() : <any>undefined;
        data["da_DK_UserVideo2"] = this.da_DK_UserVideo2 ? this.da_DK_UserVideo2.toJSON() : <any>undefined;
        data["da_DK_UserVideo3"] = this.da_DK_UserVideo3 ? this.da_DK_UserVideo3.toJSON() : <any>undefined;
        data["en_GB_UserVideo"] = this.en_GB_UserVideo ? this.en_GB_UserVideo.toJSON() : <any>undefined;
        data["en_GB_UserVideo2"] = this.en_GB_UserVideo2 ? this.en_GB_UserVideo2.toJSON() : <any>undefined;
        data["en_GB_UserVideo3"] = this.en_GB_UserVideo3 ? this.en_GB_UserVideo3.toJSON() : <any>undefined;
        data["en_UK_UserVideo"] = this.en_UK_UserVideo ? this.en_UK_UserVideo.toJSON() : <any>undefined;
        data["en_UK_UserVideo2"] = this.en_UK_UserVideo2 ? this.en_UK_UserVideo2.toJSON() : <any>undefined;
        data["en_UK_UserVideo3"] = this.en_UK_UserVideo3 ? this.en_UK_UserVideo3.toJSON() : <any>undefined;
        data["de_DE_UserVideo"] = this.de_DE_UserVideo ? this.de_DE_UserVideo.toJSON() : <any>undefined;
        data["de_DE_UserVideo2"] = this.de_DE_UserVideo2 ? this.de_DE_UserVideo2.toJSON() : <any>undefined;
        data["de_DE_UserVideo3"] = this.de_DE_UserVideo3 ? this.de_DE_UserVideo3.toJSON() : <any>undefined;
        data["nl_NL_UserVideo"] = this.nl_NL_UserVideo ? this.nl_NL_UserVideo.toJSON() : <any>undefined;
        data["nl_NL_UserVideo2"] = this.nl_NL_UserVideo2 ? this.nl_NL_UserVideo2.toJSON() : <any>undefined;
        data["nl_NL_UserVideo3"] = this.nl_NL_UserVideo3 ? this.nl_NL_UserVideo3.toJSON() : <any>undefined;
        data["fr_FR_UserVideo"] = this.fr_FR_UserVideo ? this.fr_FR_UserVideo.toJSON() : <any>undefined;
        data["fr_FR_UserVideo2"] = this.fr_FR_UserVideo2 ? this.fr_FR_UserVideo2.toJSON() : <any>undefined;
        data["fr_FR_UserVideo3"] = this.fr_FR_UserVideo3 ? this.fr_FR_UserVideo3.toJSON() : <any>undefined;
        data["sv_SE_UserVideo"] = this.sv_SE_UserVideo ? this.sv_SE_UserVideo.toJSON() : <any>undefined;
        data["sv_SE_UserVideo2"] = this.sv_SE_UserVideo2 ? this.sv_SE_UserVideo2.toJSON() : <any>undefined;
        data["sv_SE_UserVideo3"] = this.sv_SE_UserVideo3 ? this.sv_SE_UserVideo3.toJSON() : <any>undefined;
        data["nb_NO_UserVideo"] = this.nb_NO_UserVideo ? this.nb_NO_UserVideo.toJSON() : <any>undefined;
        data["nb_NO_UserVideo2"] = this.nb_NO_UserVideo2 ? this.nb_NO_UserVideo2.toJSON() : <any>undefined;
        data["nb_NO_UserVideo3"] = this.nb_NO_UserVideo3 ? this.nb_NO_UserVideo3.toJSON() : <any>undefined;
        data["fi_FI_UserVideo"] = this.fi_FI_UserVideo ? this.fi_FI_UserVideo.toJSON() : <any>undefined;
        data["fi_FI_UserVideo2"] = this.fi_FI_UserVideo2 ? this.fi_FI_UserVideo2.toJSON() : <any>undefined;
        data["fi_FI_UserVideo3"] = this.fi_FI_UserVideo3 ? this.fi_FI_UserVideo3.toJSON() : <any>undefined;
        data["ru_RU_UserVideo"] = this.ru_RU_UserVideo ? this.ru_RU_UserVideo.toJSON() : <any>undefined;
        data["ru_RU_UserVideo2"] = this.ru_RU_UserVideo2 ? this.ru_RU_UserVideo2.toJSON() : <any>undefined;
        data["ru_RU_UserVideo3"] = this.ru_RU_UserVideo3 ? this.ru_RU_UserVideo3.toJSON() : <any>undefined;
        data["ja_JP_UserVideo"] = this.ja_JP_UserVideo ? this.ja_JP_UserVideo.toJSON() : <any>undefined;
        data["ja_JP_UserVideo2"] = this.ja_JP_UserVideo2 ? this.ja_JP_UserVideo2.toJSON() : <any>undefined;
        data["ja_JP_UserVideo3"] = this.ja_JP_UserVideo3 ? this.ja_JP_UserVideo3.toJSON() : <any>undefined;
        data["pl_PL_UserVideo"] = this.pl_PL_UserVideo ? this.pl_PL_UserVideo.toJSON() : <any>undefined;
        data["pl_PL_UserVideo2"] = this.pl_PL_UserVideo2 ? this.pl_PL_UserVideo2.toJSON() : <any>undefined;
        data["pl_PL_UserVideo3"] = this.pl_PL_UserVideo3 ? this.pl_PL_UserVideo3.toJSON() : <any>undefined;
        data["es_ES_UserVideo"] = this.es_ES_UserVideo ? this.es_ES_UserVideo.toJSON() : <any>undefined;
        data["es_ES_UserVideo2"] = this.es_ES_UserVideo2 ? this.es_ES_UserVideo2.toJSON() : <any>undefined;
        data["es_ES_UserVideo3"] = this.es_ES_UserVideo3 ? this.es_ES_UserVideo3.toJSON() : <any>undefined;
        data["pt_PT_UserVideo"] = this.pt_PT_UserVideo ? this.pt_PT_UserVideo.toJSON() : <any>undefined;
        data["pt_PT_UserVideo2"] = this.pt_PT_UserVideo2 ? this.pt_PT_UserVideo2.toJSON() : <any>undefined;
        data["pt_PT_UserVideo3"] = this.pt_PT_UserVideo3 ? this.pt_PT_UserVideo3.toJSON() : <any>undefined;
        data["ko_KR_UserVideo"] = this.ko_KR_UserVideo ? this.ko_KR_UserVideo.toJSON() : <any>undefined;
        data["ko_KR_UserVideo2"] = this.ko_KR_UserVideo2 ? this.ko_KR_UserVideo2.toJSON() : <any>undefined;
        data["ko_KR_UserVideo3"] = this.ko_KR_UserVideo3 ? this.ko_KR_UserVideo3.toJSON() : <any>undefined;
        data["it_IT_UserVideo"] = this.it_IT_UserVideo ? this.it_IT_UserVideo.toJSON() : <any>undefined;
        data["it_IT_UserVideo2"] = this.it_IT_UserVideo2 ? this.it_IT_UserVideo2.toJSON() : <any>undefined;
        data["it_IT_UserVideo3"] = this.it_IT_UserVideo3 ? this.it_IT_UserVideo3.toJSON() : <any>undefined;
        data["hu_HU_UserVideo"] = this.hu_HU_UserVideo ? this.hu_HU_UserVideo.toJSON() : <any>undefined;
        data["hu_HU_UserVideo2"] = this.hu_HU_UserVideo2 ? this.hu_HU_UserVideo2.toJSON() : <any>undefined;
        data["hu_HU_UserVideo3"] = this.hu_HU_UserVideo3 ? this.hu_HU_UserVideo3.toJSON() : <any>undefined;
        data["cs_CZ_UserVideo"] = this.cs_CZ_UserVideo ? this.cs_CZ_UserVideo.toJSON() : <any>undefined;
        data["cs_CZ_UserVideo2"] = this.cs_CZ_UserVideo2 ? this.cs_CZ_UserVideo2.toJSON() : <any>undefined;
        data["cs_CZ_UserVideo3"] = this.cs_CZ_UserVideo3 ? this.cs_CZ_UserVideo3.toJSON() : <any>undefined;
        data["ro_RO_UserVideo"] = this.ro_RO_UserVideo ? this.ro_RO_UserVideo.toJSON() : <any>undefined;
        data["ro_RO_UserVideo2"] = this.ro_RO_UserVideo2 ? this.ro_RO_UserVideo2.toJSON() : <any>undefined;
        data["ro_RO_UserVideo3"] = this.ro_RO_UserVideo3 ? this.ro_RO_UserVideo3.toJSON() : <any>undefined;
        data["el_GR_UserVideo"] = this.el_GR_UserVideo ? this.el_GR_UserVideo.toJSON() : <any>undefined;
        data["el_GR_UserVideo2"] = this.el_GR_UserVideo2 ? this.el_GR_UserVideo2.toJSON() : <any>undefined;
        data["el_GR_UserVideo3"] = this.el_GR_UserVideo3 ? this.el_GR_UserVideo3.toJSON() : <any>undefined;
        data["tr_TR_UserVideo"] = this.tr_TR_UserVideo ? this.tr_TR_UserVideo.toJSON() : <any>undefined;
        data["tr_TR_UserVideo2"] = this.tr_TR_UserVideo2 ? this.tr_TR_UserVideo2.toJSON() : <any>undefined;
        data["tr_TR_UserVideo3"] = this.tr_TR_UserVideo3 ? this.tr_TR_UserVideo3.toJSON() : <any>undefined;
        data["lt_LT_UserVideo"] = this.lt_LT_UserVideo ? this.lt_LT_UserVideo.toJSON() : <any>undefined;
        data["lt_LT_UserVideo2"] = this.lt_LT_UserVideo2 ? this.lt_LT_UserVideo2.toJSON() : <any>undefined;
        data["lt_LT_UserVideo3"] = this.lt_LT_UserVideo3 ? this.lt_LT_UserVideo3.toJSON() : <any>undefined;
        data["sl_SL_UserVideo"] = this.sl_SL_UserVideo ? this.sl_SL_UserVideo.toJSON() : <any>undefined;
        data["sl_SL_UserVideo2"] = this.sl_SL_UserVideo2 ? this.sl_SL_UserVideo2.toJSON() : <any>undefined;
        data["sl_SL_UserVideo3"] = this.sl_SL_UserVideo3 ? this.sl_SL_UserVideo3.toJSON() : <any>undefined;
        data["bg_BG_UserVideo"] = this.bg_BG_UserVideo ? this.bg_BG_UserVideo.toJSON() : <any>undefined;
        data["bg_BG_UserVideo2"] = this.bg_BG_UserVideo2 ? this.bg_BG_UserVideo2.toJSON() : <any>undefined;
        data["bg_BG_UserVideo3"] = this.bg_BG_UserVideo3 ? this.bg_BG_UserVideo3.toJSON() : <any>undefined;
        data["hr_HR_UserVideo"] = this.hr_HR_UserVideo ? this.hr_HR_UserVideo.toJSON() : <any>undefined;
        data["hr_HR_UserVideo2"] = this.hr_HR_UserVideo2 ? this.hr_HR_UserVideo2.toJSON() : <any>undefined;
        data["hr_HR_UserVideo3"] = this.hr_HR_UserVideo3 ? this.hr_HR_UserVideo3.toJSON() : <any>undefined;
        data["et_EE_UserVideo"] = this.et_EE_UserVideo ? this.et_EE_UserVideo.toJSON() : <any>undefined;
        data["et_EE_UserVideo2"] = this.et_EE_UserVideo2 ? this.et_EE_UserVideo2.toJSON() : <any>undefined;
        data["et_EE_UserVideo3"] = this.et_EE_UserVideo3 ? this.et_EE_UserVideo3.toJSON() : <any>undefined;
        data["is_IS_UserVideo"] = this.is_IS_UserVideo ? this.is_IS_UserVideo.toJSON() : <any>undefined;
        data["is_IS_UserVideo2"] = this.is_IS_UserVideo2 ? this.is_IS_UserVideo2.toJSON() : <any>undefined;
        data["is_IS_UserVideo3"] = this.is_IS_UserVideo3 ? this.is_IS_UserVideo3.toJSON() : <any>undefined;
        data["lv_LV_UserVideo"] = this.lv_LV_UserVideo ? this.lv_LV_UserVideo.toJSON() : <any>undefined;
        data["lv_LV_UserVideo2"] = this.lv_LV_UserVideo2 ? this.lv_LV_UserVideo2.toJSON() : <any>undefined;
        data["lv_LV_UserVideo3"] = this.lv_LV_UserVideo3 ? this.lv_LV_UserVideo3.toJSON() : <any>undefined;
        data["zh_CN_UserVideo"] = this.zh_CN_UserVideo ? this.zh_CN_UserVideo.toJSON() : <any>undefined;
        data["zh_CN_UserVideo2"] = this.zh_CN_UserVideo2 ? this.zh_CN_UserVideo2.toJSON() : <any>undefined;
        data["zh_CN_UserVideo3"] = this.zh_CN_UserVideo3 ? this.zh_CN_UserVideo3.toJSON() : <any>undefined;
        data["th_TH_UserVideo"] = this.th_TH_UserVideo ? this.th_TH_UserVideo.toJSON() : <any>undefined;
        data["th_TH_UserVideo2"] = this.th_TH_UserVideo2 ? this.th_TH_UserVideo2.toJSON() : <any>undefined;
        data["th_TH_UserVideo3"] = this.th_TH_UserVideo3 ? this.th_TH_UserVideo3.toJSON() : <any>undefined;
        data["he_IL_UserVideo"] = this.he_IL_UserVideo ? this.he_IL_UserVideo.toJSON() : <any>undefined;
        data["he_IL_UserVideo2"] = this.he_IL_UserVideo2 ? this.he_IL_UserVideo2.toJSON() : <any>undefined;
        data["he_IL_UserVideo3"] = this.he_IL_UserVideo3 ? this.he_IL_UserVideo3.toJSON() : <any>undefined;
        data["fr_CA_UserVideo"] = this.fr_CA_UserVideo ? this.fr_CA_UserVideo.toJSON() : <any>undefined;
        data["fr_CA_UserVideo2"] = this.fr_CA_UserVideo2 ? this.fr_CA_UserVideo2.toJSON() : <any>undefined;
        data["fr_CA_UserVideo3"] = this.fr_CA_UserVideo3 ? this.fr_CA_UserVideo3.toJSON() : <any>undefined;
        data["en_US_UserVideo"] = this.en_US_UserVideo ? this.en_US_UserVideo.toJSON() : <any>undefined;
        data["en_US_UserVideo2"] = this.en_US_UserVideo2 ? this.en_US_UserVideo2.toJSON() : <any>undefined;
        data["en_US_UserVideo3"] = this.en_US_UserVideo3 ? this.en_US_UserVideo3.toJSON() : <any>undefined;
        data["es_US_UserVideo"] = this.es_US_UserVideo ? this.es_US_UserVideo.toJSON() : <any>undefined;
        data["es_US_UserVideo2"] = this.es_US_UserVideo2 ? this.es_US_UserVideo2.toJSON() : <any>undefined;
        data["es_US_UserVideo3"] = this.es_US_UserVideo3 ? this.es_US_UserVideo3.toJSON() : <any>undefined;
        data["sk_SK_UserVideo"] = this.sk_SK_UserVideo ? this.sk_SK_UserVideo.toJSON() : <any>undefined;
        data["sk_SK_UserVideo2"] = this.sk_SK_UserVideo2 ? this.sk_SK_UserVideo2.toJSON() : <any>undefined;
        data["sk_SK_UserVideo3"] = this.sk_SK_UserVideo3 ? this.sk_SK_UserVideo3.toJSON() : <any>undefined;
        data["en_GB_Servicevideo1"] = this.en_GB_Servicevideo1 ? this.en_GB_Servicevideo1.toJSON() : <any>undefined;
        data["en_GB_Servicevideo2"] = this.en_GB_Servicevideo2 ? this.en_GB_Servicevideo2.toJSON() : <any>undefined;
        data["en_GB_Servicevideo3"] = this.en_GB_Servicevideo3 ? this.en_GB_Servicevideo3.toJSON() : <any>undefined;
        data["en_GB_Servicevideo4"] = this.en_GB_Servicevideo4 ? this.en_GB_Servicevideo4.toJSON() : <any>undefined;
        data["en_GB_Servicevideo5"] = this.en_GB_Servicevideo5 ? this.en_GB_Servicevideo5.toJSON() : <any>undefined;
        data["en_GB_Servicevideo6"] = this.en_GB_Servicevideo6 ? this.en_GB_Servicevideo6.toJSON() : <any>undefined;
        data["en_GB_SparePartsManualWW"] = this.en_GB_SparePartsManualWW ? this.en_GB_SparePartsManualWW.toJSON() : <any>undefined;
        return data;
    }
}

export interface INavUnitDocumentDto {
    en_GB_ElectricalDiagrams?: NavArticlePermissions | undefined;
    en_GB_HydraulicsDiagrams?: NavArticlePermissions | undefined;
    en_Diagrams?: NavArticlePermissions | undefined;
    de_Diagrams?: NavArticlePermissions | undefined;
    xX_Diagrams?: NavArticlePermissions | undefined;
    de_Usermanual?: NavArticlePermissions | undefined;
    en_Usermanual?: NavArticlePermissions | undefined;
    xX_Usermanual?: NavArticlePermissions | undefined;
    da_DK_Manual?: NavArticlePermissions | undefined;
    da_DK_Manual2?: NavArticlePermissions | undefined;
    da_DK_Manual3?: NavArticlePermissions | undefined;
    en_GB_Manual?: NavArticlePermissions | undefined;
    en_GB_Manual2?: NavArticlePermissions | undefined;
    en_GB_Manual3?: NavArticlePermissions | undefined;
    en_UK_Manual?: NavArticlePermissions | undefined;
    en_UK_Manual2?: NavArticlePermissions | undefined;
    en_UK_Manual3?: NavArticlePermissions | undefined;
    de_DE_Manual?: NavArticlePermissions | undefined;
    de_DE_Manual2?: NavArticlePermissions | undefined;
    de_DE_Manual3?: NavArticlePermissions | undefined;
    nl_NL_Manual?: NavArticlePermissions | undefined;
    nl_NL_Manual2?: NavArticlePermissions | undefined;
    nl_NL_Manual3?: NavArticlePermissions | undefined;
    fr_FR_Manual?: NavArticlePermissions | undefined;
    fr_FR_Manual2?: NavArticlePermissions | undefined;
    fr_FR_Manual3?: NavArticlePermissions | undefined;
    sv_SE_Manual?: NavArticlePermissions | undefined;
    sv_SE_Manual2?: NavArticlePermissions | undefined;
    sv_SE_Manual3?: NavArticlePermissions | undefined;
    nb_NO_Manual?: NavArticlePermissions | undefined;
    nb_NO_Manual2?: NavArticlePermissions | undefined;
    nb_NO_Manual3?: NavArticlePermissions | undefined;
    fi_FI_Manual?: NavArticlePermissions | undefined;
    fi_FI_Manual2?: NavArticlePermissions | undefined;
    fi_FI_Manual3?: NavArticlePermissions | undefined;
    ru_RU_Manual?: NavArticlePermissions | undefined;
    ru_RU_Manual2?: NavArticlePermissions | undefined;
    ru_RU_Manual3?: NavArticlePermissions | undefined;
    ja_JP_Manual?: NavArticlePermissions | undefined;
    ja_JP_Manual2?: NavArticlePermissions | undefined;
    ja_JP_Manual3?: NavArticlePermissions | undefined;
    pl_PL_Manual?: NavArticlePermissions | undefined;
    pl_PL_Manual2?: NavArticlePermissions | undefined;
    pl_PL_Manual3?: NavArticlePermissions | undefined;
    es_ES_Manual?: NavArticlePermissions | undefined;
    es_ES_Manual2?: NavArticlePermissions | undefined;
    es_ES_Manual3?: NavArticlePermissions | undefined;
    pt_PT_Manual?: NavArticlePermissions | undefined;
    pt_PT_Manual2?: NavArticlePermissions | undefined;
    pt_PT_Manual3?: NavArticlePermissions | undefined;
    ko_KR_Manual?: NavArticlePermissions | undefined;
    ko_KR_Manual2?: NavArticlePermissions | undefined;
    ko_KR_Manual3?: NavArticlePermissions | undefined;
    it_IT_Manual?: NavArticlePermissions | undefined;
    it_IT_Manual2?: NavArticlePermissions | undefined;
    it_IT_Manual3?: NavArticlePermissions | undefined;
    hu_HU_Manual?: NavArticlePermissions | undefined;
    hu_HU_Manual2?: NavArticlePermissions | undefined;
    hu_HU_Manual3?: NavArticlePermissions | undefined;
    cs_CZ_Manual?: NavArticlePermissions | undefined;
    cs_CZ_Manual2?: NavArticlePermissions | undefined;
    cs_CZ_Manual3?: NavArticlePermissions | undefined;
    ro_RO_Manual?: NavArticlePermissions | undefined;
    ro_RO_Manual2?: NavArticlePermissions | undefined;
    ro_RO_Manual3?: NavArticlePermissions | undefined;
    el_GR_Manual?: NavArticlePermissions | undefined;
    el_GR_Manual2?: NavArticlePermissions | undefined;
    el_GR_Manual3?: NavArticlePermissions | undefined;
    tr_TR_Manual?: NavArticlePermissions | undefined;
    tr_TR_Manual2?: NavArticlePermissions | undefined;
    tr_TR_Manual3?: NavArticlePermissions | undefined;
    lt_LT_Manual?: NavArticlePermissions | undefined;
    lt_LT_Manual2?: NavArticlePermissions | undefined;
    lt_LT_Manual3?: NavArticlePermissions | undefined;
    sl_SL_Manual?: NavArticlePermissions | undefined;
    sl_SL_Manual2?: NavArticlePermissions | undefined;
    sl_SL_Manual3?: NavArticlePermissions | undefined;
    bg_BG_Manual?: NavArticlePermissions | undefined;
    bg_BG_Manual2?: NavArticlePermissions | undefined;
    bg_BG_Manual3?: NavArticlePermissions | undefined;
    hr_HR_Manual?: NavArticlePermissions | undefined;
    hr_HR_Manual2?: NavArticlePermissions | undefined;
    hr_HR_Manual3?: NavArticlePermissions | undefined;
    et_EE_Manual?: NavArticlePermissions | undefined;
    et_EE_Manual2?: NavArticlePermissions | undefined;
    et_EE_Manual3?: NavArticlePermissions | undefined;
    is_IS_Manual?: NavArticlePermissions | undefined;
    is_IS_Manual2?: NavArticlePermissions | undefined;
    is_IS_Manual3?: NavArticlePermissions | undefined;
    lv_LV_Manual?: NavArticlePermissions | undefined;
    lv_LV_Manual2?: NavArticlePermissions | undefined;
    lv_LV_Manual3?: NavArticlePermissions | undefined;
    zh_CN_Manual?: NavArticlePermissions | undefined;
    zh_CN_Manual2?: NavArticlePermissions | undefined;
    zh_CN_Manual3?: NavArticlePermissions | undefined;
    th_TH_Manual?: NavArticlePermissions | undefined;
    th_TH_Manual2?: NavArticlePermissions | undefined;
    th_TH_Manual3?: NavArticlePermissions | undefined;
    he_IL_Manual?: NavArticlePermissions | undefined;
    he_IL_Manual2?: NavArticlePermissions | undefined;
    he_IL_Manual3?: NavArticlePermissions | undefined;
    fr_CA_Manual?: NavArticlePermissions | undefined;
    fr_CA_Manual2?: NavArticlePermissions | undefined;
    fr_CA_Manual3?: NavArticlePermissions | undefined;
    en_US_Manual?: NavArticlePermissions | undefined;
    en_US_Manual2?: NavArticlePermissions | undefined;
    en_US_Manual3?: NavArticlePermissions | undefined;
    es_US_Manual?: NavArticlePermissions | undefined;
    es_US_Manual2?: NavArticlePermissions | undefined;
    es_US_Manual3?: NavArticlePermissions | undefined;
    sk_SK_Manual?: NavArticlePermissions | undefined;
    sk_SK_Manual2?: NavArticlePermissions | undefined;
    sk_SK_Manual3?: NavArticlePermissions | undefined;
    en_GB_Quickguides?: NavArticlePermissions | undefined;
    da_DK_UserVideo?: NavArticlePermissions | undefined;
    da_DK_UserVideo2?: NavArticlePermissions | undefined;
    da_DK_UserVideo3?: NavArticlePermissions | undefined;
    en_GB_UserVideo?: NavArticlePermissions | undefined;
    en_GB_UserVideo2?: NavArticlePermissions | undefined;
    en_GB_UserVideo3?: NavArticlePermissions | undefined;
    en_UK_UserVideo?: NavArticlePermissions | undefined;
    en_UK_UserVideo2?: NavArticlePermissions | undefined;
    en_UK_UserVideo3?: NavArticlePermissions | undefined;
    de_DE_UserVideo?: NavArticlePermissions | undefined;
    de_DE_UserVideo2?: NavArticlePermissions | undefined;
    de_DE_UserVideo3?: NavArticlePermissions | undefined;
    nl_NL_UserVideo?: NavArticlePermissions | undefined;
    nl_NL_UserVideo2?: NavArticlePermissions | undefined;
    nl_NL_UserVideo3?: NavArticlePermissions | undefined;
    fr_FR_UserVideo?: NavArticlePermissions | undefined;
    fr_FR_UserVideo2?: NavArticlePermissions | undefined;
    fr_FR_UserVideo3?: NavArticlePermissions | undefined;
    sv_SE_UserVideo?: NavArticlePermissions | undefined;
    sv_SE_UserVideo2?: NavArticlePermissions | undefined;
    sv_SE_UserVideo3?: NavArticlePermissions | undefined;
    nb_NO_UserVideo?: NavArticlePermissions | undefined;
    nb_NO_UserVideo2?: NavArticlePermissions | undefined;
    nb_NO_UserVideo3?: NavArticlePermissions | undefined;
    fi_FI_UserVideo?: NavArticlePermissions | undefined;
    fi_FI_UserVideo2?: NavArticlePermissions | undefined;
    fi_FI_UserVideo3?: NavArticlePermissions | undefined;
    ru_RU_UserVideo?: NavArticlePermissions | undefined;
    ru_RU_UserVideo2?: NavArticlePermissions | undefined;
    ru_RU_UserVideo3?: NavArticlePermissions | undefined;
    ja_JP_UserVideo?: NavArticlePermissions | undefined;
    ja_JP_UserVideo2?: NavArticlePermissions | undefined;
    ja_JP_UserVideo3?: NavArticlePermissions | undefined;
    pl_PL_UserVideo?: NavArticlePermissions | undefined;
    pl_PL_UserVideo2?: NavArticlePermissions | undefined;
    pl_PL_UserVideo3?: NavArticlePermissions | undefined;
    es_ES_UserVideo?: NavArticlePermissions | undefined;
    es_ES_UserVideo2?: NavArticlePermissions | undefined;
    es_ES_UserVideo3?: NavArticlePermissions | undefined;
    pt_PT_UserVideo?: NavArticlePermissions | undefined;
    pt_PT_UserVideo2?: NavArticlePermissions | undefined;
    pt_PT_UserVideo3?: NavArticlePermissions | undefined;
    ko_KR_UserVideo?: NavArticlePermissions | undefined;
    ko_KR_UserVideo2?: NavArticlePermissions | undefined;
    ko_KR_UserVideo3?: NavArticlePermissions | undefined;
    it_IT_UserVideo?: NavArticlePermissions | undefined;
    it_IT_UserVideo2?: NavArticlePermissions | undefined;
    it_IT_UserVideo3?: NavArticlePermissions | undefined;
    hu_HU_UserVideo?: NavArticlePermissions | undefined;
    hu_HU_UserVideo2?: NavArticlePermissions | undefined;
    hu_HU_UserVideo3?: NavArticlePermissions | undefined;
    cs_CZ_UserVideo?: NavArticlePermissions | undefined;
    cs_CZ_UserVideo2?: NavArticlePermissions | undefined;
    cs_CZ_UserVideo3?: NavArticlePermissions | undefined;
    ro_RO_UserVideo?: NavArticlePermissions | undefined;
    ro_RO_UserVideo2?: NavArticlePermissions | undefined;
    ro_RO_UserVideo3?: NavArticlePermissions | undefined;
    el_GR_UserVideo?: NavArticlePermissions | undefined;
    el_GR_UserVideo2?: NavArticlePermissions | undefined;
    el_GR_UserVideo3?: NavArticlePermissions | undefined;
    tr_TR_UserVideo?: NavArticlePermissions | undefined;
    tr_TR_UserVideo2?: NavArticlePermissions | undefined;
    tr_TR_UserVideo3?: NavArticlePermissions | undefined;
    lt_LT_UserVideo?: NavArticlePermissions | undefined;
    lt_LT_UserVideo2?: NavArticlePermissions | undefined;
    lt_LT_UserVideo3?: NavArticlePermissions | undefined;
    sl_SL_UserVideo?: NavArticlePermissions | undefined;
    sl_SL_UserVideo2?: NavArticlePermissions | undefined;
    sl_SL_UserVideo3?: NavArticlePermissions | undefined;
    bg_BG_UserVideo?: NavArticlePermissions | undefined;
    bg_BG_UserVideo2?: NavArticlePermissions | undefined;
    bg_BG_UserVideo3?: NavArticlePermissions | undefined;
    hr_HR_UserVideo?: NavArticlePermissions | undefined;
    hr_HR_UserVideo2?: NavArticlePermissions | undefined;
    hr_HR_UserVideo3?: NavArticlePermissions | undefined;
    et_EE_UserVideo?: NavArticlePermissions | undefined;
    et_EE_UserVideo2?: NavArticlePermissions | undefined;
    et_EE_UserVideo3?: NavArticlePermissions | undefined;
    is_IS_UserVideo?: NavArticlePermissions | undefined;
    is_IS_UserVideo2?: NavArticlePermissions | undefined;
    is_IS_UserVideo3?: NavArticlePermissions | undefined;
    lv_LV_UserVideo?: NavArticlePermissions | undefined;
    lv_LV_UserVideo2?: NavArticlePermissions | undefined;
    lv_LV_UserVideo3?: NavArticlePermissions | undefined;
    zh_CN_UserVideo?: NavArticlePermissions | undefined;
    zh_CN_UserVideo2?: NavArticlePermissions | undefined;
    zh_CN_UserVideo3?: NavArticlePermissions | undefined;
    th_TH_UserVideo?: NavArticlePermissions | undefined;
    th_TH_UserVideo2?: NavArticlePermissions | undefined;
    th_TH_UserVideo3?: NavArticlePermissions | undefined;
    he_IL_UserVideo?: NavArticlePermissions | undefined;
    he_IL_UserVideo2?: NavArticlePermissions | undefined;
    he_IL_UserVideo3?: NavArticlePermissions | undefined;
    fr_CA_UserVideo?: NavArticlePermissions | undefined;
    fr_CA_UserVideo2?: NavArticlePermissions | undefined;
    fr_CA_UserVideo3?: NavArticlePermissions | undefined;
    en_US_UserVideo?: NavArticlePermissions | undefined;
    en_US_UserVideo2?: NavArticlePermissions | undefined;
    en_US_UserVideo3?: NavArticlePermissions | undefined;
    es_US_UserVideo?: NavArticlePermissions | undefined;
    es_US_UserVideo2?: NavArticlePermissions | undefined;
    es_US_UserVideo3?: NavArticlePermissions | undefined;
    sk_SK_UserVideo?: NavArticlePermissions | undefined;
    sk_SK_UserVideo2?: NavArticlePermissions | undefined;
    sk_SK_UserVideo3?: NavArticlePermissions | undefined;
    en_GB_Servicevideo1?: NavArticlePermissions | undefined;
    en_GB_Servicevideo2?: NavArticlePermissions | undefined;
    en_GB_Servicevideo3?: NavArticlePermissions | undefined;
    en_GB_Servicevideo4?: NavArticlePermissions | undefined;
    en_GB_Servicevideo5?: NavArticlePermissions | undefined;
    en_GB_Servicevideo6?: NavArticlePermissions | undefined;
    en_GB_SparePartsManualWW?: NavArticlePermissions | undefined;
}

export class NavArticlePermissions implements INavArticlePermissions {
    fieldValue?: string | undefined;
    canOverwrite!: boolean;
    canBeEmpty!: boolean;
    canOverwriteWithEmpty!: boolean;

    constructor(data?: INavArticlePermissions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldValue = _data["fieldValue"];
            this.canOverwrite = _data["canOverwrite"];
            this.canBeEmpty = _data["canBeEmpty"];
            this.canOverwriteWithEmpty = _data["canOverwriteWithEmpty"];
        }
    }

    static fromJS(data: any): NavArticlePermissions {
        data = typeof data === 'object' ? data : {};
        let result = new NavArticlePermissions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldValue"] = this.fieldValue;
        data["canOverwrite"] = this.canOverwrite;
        data["canBeEmpty"] = this.canBeEmpty;
        data["canOverwriteWithEmpty"] = this.canOverwriteWithEmpty;
        return data;
    }
}

export interface INavArticlePermissions {
    fieldValue?: string | undefined;
    canOverwrite: boolean;
    canBeEmpty: boolean;
    canOverwriteWithEmpty: boolean;
}

export class NavUnitTechnicalDto implements INavUnitTechnicalDto {
    unitId?: NavArticlePermissions | undefined;
    modelCode?: NavArticlePermissions | undefined;
    debtorNumberForBilling?: NavArticlePermissions | undefined;
    customer?: NavArticlePermissions | undefined;
    distributorCountry?: NavArticlePermissions | undefined;
    siteUser?: NavArticlePermissions | undefined;
    siteAddress?: NavArticlePermissions | undefined;
    siteCity?: NavArticlePermissions | undefined;
    sitePostalCode?: NavArticlePermissions | undefined;
    installationDate?: NavArticlePermissions | undefined;
    warrantyEndDate?: NavArticlePermissions | undefined;
    machineType?: NavArticlePermissions | undefined;
    containerSize?: NavArticlePermissions | undefined;

    constructor(data?: INavUnitTechnicalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitId = _data["unitId"] ? NavArticlePermissions.fromJS(_data["unitId"]) : <any>undefined;
            this.modelCode = _data["modelCode"] ? NavArticlePermissions.fromJS(_data["modelCode"]) : <any>undefined;
            this.debtorNumberForBilling = _data["debtorNumberForBilling"] ? NavArticlePermissions.fromJS(_data["debtorNumberForBilling"]) : <any>undefined;
            this.customer = _data["customer"] ? NavArticlePermissions.fromJS(_data["customer"]) : <any>undefined;
            this.distributorCountry = _data["distributorCountry"] ? NavArticlePermissions.fromJS(_data["distributorCountry"]) : <any>undefined;
            this.siteUser = _data["siteUser"] ? NavArticlePermissions.fromJS(_data["siteUser"]) : <any>undefined;
            this.siteAddress = _data["siteAddress"] ? NavArticlePermissions.fromJS(_data["siteAddress"]) : <any>undefined;
            this.siteCity = _data["siteCity"] ? NavArticlePermissions.fromJS(_data["siteCity"]) : <any>undefined;
            this.sitePostalCode = _data["sitePostalCode"] ? NavArticlePermissions.fromJS(_data["sitePostalCode"]) : <any>undefined;
            this.installationDate = _data["installationDate"] ? NavArticlePermissions.fromJS(_data["installationDate"]) : <any>undefined;
            this.warrantyEndDate = _data["warrantyEndDate"] ? NavArticlePermissions.fromJS(_data["warrantyEndDate"]) : <any>undefined;
            this.machineType = _data["machineType"] ? NavArticlePermissions.fromJS(_data["machineType"]) : <any>undefined;
            this.containerSize = _data["containerSize"] ? NavArticlePermissions.fromJS(_data["containerSize"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NavUnitTechnicalDto {
        data = typeof data === 'object' ? data : {};
        let result = new NavUnitTechnicalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitId"] = this.unitId ? this.unitId.toJSON() : <any>undefined;
        data["modelCode"] = this.modelCode ? this.modelCode.toJSON() : <any>undefined;
        data["debtorNumberForBilling"] = this.debtorNumberForBilling ? this.debtorNumberForBilling.toJSON() : <any>undefined;
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        data["distributorCountry"] = this.distributorCountry ? this.distributorCountry.toJSON() : <any>undefined;
        data["siteUser"] = this.siteUser ? this.siteUser.toJSON() : <any>undefined;
        data["siteAddress"] = this.siteAddress ? this.siteAddress.toJSON() : <any>undefined;
        data["siteCity"] = this.siteCity ? this.siteCity.toJSON() : <any>undefined;
        data["sitePostalCode"] = this.sitePostalCode ? this.sitePostalCode.toJSON() : <any>undefined;
        data["installationDate"] = this.installationDate ? this.installationDate.toJSON() : <any>undefined;
        data["warrantyEndDate"] = this.warrantyEndDate ? this.warrantyEndDate.toJSON() : <any>undefined;
        data["machineType"] = this.machineType ? this.machineType.toJSON() : <any>undefined;
        data["containerSize"] = this.containerSize ? this.containerSize.toJSON() : <any>undefined;
        return data;
    }
}

export interface INavUnitTechnicalDto {
    unitId?: NavArticlePermissions | undefined;
    modelCode?: NavArticlePermissions | undefined;
    debtorNumberForBilling?: NavArticlePermissions | undefined;
    customer?: NavArticlePermissions | undefined;
    distributorCountry?: NavArticlePermissions | undefined;
    siteUser?: NavArticlePermissions | undefined;
    siteAddress?: NavArticlePermissions | undefined;
    siteCity?: NavArticlePermissions | undefined;
    sitePostalCode?: NavArticlePermissions | undefined;
    installationDate?: NavArticlePermissions | undefined;
    warrantyEndDate?: NavArticlePermissions | undefined;
    machineType?: NavArticlePermissions | undefined;
    containerSize?: NavArticlePermissions | undefined;
}

export class NotificationDefinitionDto implements INotificationDefinitionDto {
    id!: number;
    unitIds?: number[] | undefined;
    controllerTypes?: NotificationControllerTypes | undefined;
    name?: string | undefined;
    selectedLanguage!: SelectedLanguage;
    isEditAllowed!: boolean;
    createdBy?: string | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: string | undefined;
    notificationUsers!: NotificationUserDto[];
    fillLevelSettings?: NotificationFillLevelSettingsDto[] | undefined;
    notificationAdvancedSettings?: NotificationAdvancedSettingDto[] | undefined;
    notificationTypes?: NotificationTypeDto[] | undefined;
    columnsSelected?: NotificationColumnSelectedDto[] | undefined;
    shouldNotifyByEmail!: boolean;
    shouldNotifyByPush!: boolean;

    constructor(data?: INotificationDefinitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.notificationUsers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["unitIds"])) {
                this.unitIds = [] as any;
                for (let item of _data["unitIds"])
                    this.unitIds!.push(item);
            }
            this.controllerTypes = _data["controllerTypes"] ? NotificationControllerTypes.fromJS(_data["controllerTypes"]) : <any>undefined;
            this.name = _data["name"];
            this.selectedLanguage = _data["selectedLanguage"];
            this.isEditAllowed = _data["isEditAllowed"];
            this.createdBy = _data["createdBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["notificationUsers"])) {
                this.notificationUsers = [] as any;
                for (let item of _data["notificationUsers"])
                    this.notificationUsers!.push(NotificationUserDto.fromJS(item));
            }
            if (Array.isArray(_data["fillLevelSettings"])) {
                this.fillLevelSettings = [] as any;
                for (let item of _data["fillLevelSettings"])
                    this.fillLevelSettings!.push(NotificationFillLevelSettingsDto.fromJS(item));
            }
            if (Array.isArray(_data["notificationAdvancedSettings"])) {
                this.notificationAdvancedSettings = [] as any;
                for (let item of _data["notificationAdvancedSettings"])
                    this.notificationAdvancedSettings!.push(NotificationAdvancedSettingDto.fromJS(item));
            }
            if (Array.isArray(_data["notificationTypes"])) {
                this.notificationTypes = [] as any;
                for (let item of _data["notificationTypes"])
                    this.notificationTypes!.push(NotificationTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["columnsSelected"])) {
                this.columnsSelected = [] as any;
                for (let item of _data["columnsSelected"])
                    this.columnsSelected!.push(NotificationColumnSelectedDto.fromJS(item));
            }
            this.shouldNotifyByEmail = _data["shouldNotifyByEmail"];
            this.shouldNotifyByPush = _data["shouldNotifyByPush"];
        }
    }

    static fromJS(data: any): NotificationDefinitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationDefinitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.unitIds)) {
            data["unitIds"] = [];
            for (let item of this.unitIds)
                data["unitIds"].push(item);
        }
        data["controllerTypes"] = this.controllerTypes ? this.controllerTypes.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["selectedLanguage"] = this.selectedLanguage;
        data["isEditAllowed"] = this.isEditAllowed;
        data["createdBy"] = this.createdBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.notificationUsers)) {
            data["notificationUsers"] = [];
            for (let item of this.notificationUsers)
                data["notificationUsers"].push(item.toJSON());
        }
        if (Array.isArray(this.fillLevelSettings)) {
            data["fillLevelSettings"] = [];
            for (let item of this.fillLevelSettings)
                data["fillLevelSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.notificationAdvancedSettings)) {
            data["notificationAdvancedSettings"] = [];
            for (let item of this.notificationAdvancedSettings)
                data["notificationAdvancedSettings"].push(item.toJSON());
        }
        if (Array.isArray(this.notificationTypes)) {
            data["notificationTypes"] = [];
            for (let item of this.notificationTypes)
                data["notificationTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.columnsSelected)) {
            data["columnsSelected"] = [];
            for (let item of this.columnsSelected)
                data["columnsSelected"].push(item.toJSON());
        }
        data["shouldNotifyByEmail"] = this.shouldNotifyByEmail;
        data["shouldNotifyByPush"] = this.shouldNotifyByPush;
        return data;
    }
}

export interface INotificationDefinitionDto {
    id: number;
    unitIds?: number[] | undefined;
    controllerTypes?: NotificationControllerTypes | undefined;
    name?: string | undefined;
    selectedLanguage: SelectedLanguage;
    isEditAllowed: boolean;
    createdBy?: string | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: string | undefined;
    notificationUsers: NotificationUserDto[];
    fillLevelSettings?: NotificationFillLevelSettingsDto[] | undefined;
    notificationAdvancedSettings?: NotificationAdvancedSettingDto[] | undefined;
    notificationTypes?: NotificationTypeDto[] | undefined;
    columnsSelected?: NotificationColumnSelectedDto[] | undefined;
    shouldNotifyByEmail: boolean;
    shouldNotifyByPush: boolean;
}

export class NotificationControllerTypes implements INotificationControllerTypes {
    balers?: string[] | undefined;
    compactors?: string[] | undefined;
    link?: string[] | undefined;
    shark?: string[] | undefined;
    containers?: string[] | undefined;

    constructor(data?: INotificationControllerTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["balers"])) {
                this.balers = [] as any;
                for (let item of _data["balers"])
                    this.balers!.push(item);
            }
            if (Array.isArray(_data["compactors"])) {
                this.compactors = [] as any;
                for (let item of _data["compactors"])
                    this.compactors!.push(item);
            }
            if (Array.isArray(_data["link"])) {
                this.link = [] as any;
                for (let item of _data["link"])
                    this.link!.push(item);
            }
            if (Array.isArray(_data["shark"])) {
                this.shark = [] as any;
                for (let item of _data["shark"])
                    this.shark!.push(item);
            }
            if (Array.isArray(_data["containers"])) {
                this.containers = [] as any;
                for (let item of _data["containers"])
                    this.containers!.push(item);
            }
        }
    }

    static fromJS(data: any): NotificationControllerTypes {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationControllerTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.balers)) {
            data["balers"] = [];
            for (let item of this.balers)
                data["balers"].push(item);
        }
        if (Array.isArray(this.compactors)) {
            data["compactors"] = [];
            for (let item of this.compactors)
                data["compactors"].push(item);
        }
        if (Array.isArray(this.link)) {
            data["link"] = [];
            for (let item of this.link)
                data["link"].push(item);
        }
        if (Array.isArray(this.shark)) {
            data["shark"] = [];
            for (let item of this.shark)
                data["shark"].push(item);
        }
        if (Array.isArray(this.containers)) {
            data["containers"] = [];
            for (let item of this.containers)
                data["containers"].push(item);
        }
        return data;
    }
}

export interface INotificationControllerTypes {
    balers?: string[] | undefined;
    compactors?: string[] | undefined;
    link?: string[] | undefined;
    shark?: string[] | undefined;
    containers?: string[] | undefined;
}

export class NotificationUserDto implements INotificationUserDto {
    id?: number | undefined;
    email?: string | undefined;
    selectedLanguage?: SelectedLanguage | undefined;

    constructor(data?: INotificationUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.selectedLanguage = _data["selectedLanguage"];
        }
    }

    static fromJS(data: any): NotificationUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["selectedLanguage"] = this.selectedLanguage;
        return data;
    }
}

export interface INotificationUserDto {
    id?: number | undefined;
    email?: string | undefined;
    selectedLanguage?: SelectedLanguage | undefined;
}

export class NotificationFillLevelSettingsDto implements INotificationFillLevelSettingsDto {
    notificationTypeId!: number;
    thresholdPercentage!: number;
    dayOfWeek!: DayOfWeek;
    machineType!: NotificationMachineType;

    constructor(data?: INotificationFillLevelSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationTypeId = _data["notificationTypeId"];
            this.thresholdPercentage = _data["thresholdPercentage"];
            this.dayOfWeek = _data["dayOfWeek"];
            this.machineType = _data["machineType"];
        }
    }

    static fromJS(data: any): NotificationFillLevelSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationFillLevelSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationTypeId"] = this.notificationTypeId;
        data["thresholdPercentage"] = this.thresholdPercentage;
        data["dayOfWeek"] = this.dayOfWeek;
        data["machineType"] = this.machineType;
        return data;
    }
}

export interface INotificationFillLevelSettingsDto {
    notificationTypeId: number;
    thresholdPercentage: number;
    dayOfWeek: DayOfWeek;
    machineType: NotificationMachineType;
}

export class NotificationAdvancedSettingDto implements INotificationAdvancedSettingDto {
    notificationTypeId!: number;
    comparerInput!: ComparerInput;
    comparisonOperator!: ComparisonOperator;
    comparisonValue?: string | undefined;
    notificationMessage?: string | undefined;
    machineType!: NotificationMachineType;

    constructor(data?: INotificationAdvancedSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationTypeId = _data["notificationTypeId"];
            this.comparerInput = _data["comparerInput"];
            this.comparisonOperator = _data["comparisonOperator"];
            this.comparisonValue = _data["comparisonValue"];
            this.notificationMessage = _data["notificationMessage"];
            this.machineType = _data["machineType"];
        }
    }

    static fromJS(data: any): NotificationAdvancedSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationAdvancedSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationTypeId"] = this.notificationTypeId;
        data["comparerInput"] = this.comparerInput;
        data["comparisonOperator"] = this.comparisonOperator;
        data["comparisonValue"] = this.comparisonValue;
        data["notificationMessage"] = this.notificationMessage;
        data["machineType"] = this.machineType;
        return data;
    }
}

export interface INotificationAdvancedSettingDto {
    notificationTypeId: number;
    comparerInput: ComparerInput;
    comparisonOperator: ComparisonOperator;
    comparisonValue?: string | undefined;
    notificationMessage?: string | undefined;
    machineType: NotificationMachineType;
}

export class NotificationTypeDto implements INotificationTypeDto {
    id!: number;
    name?: string | undefined;
    errorId?: number | undefined;
    machineType!: NotificationMachineType;
    severity!: StatusSeverity;

    constructor(data?: INotificationTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.errorId = _data["errorId"];
            this.machineType = _data["machineType"];
            this.severity = _data["severity"];
        }
    }

    static fromJS(data: any): NotificationTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["errorId"] = this.errorId;
        data["machineType"] = this.machineType;
        data["severity"] = this.severity;
        return data;
    }
}

export interface INotificationTypeDto {
    id: number;
    name?: string | undefined;
    errorId?: number | undefined;
    machineType: NotificationMachineType;
    severity: StatusSeverity;
}

export class NotificationColumnSelectedDto implements INotificationColumnSelectedDto {
    id!: number;
    columnName?: string | undefined;
    sortingIndex!: number;
    notificationDefinitionId!: number;

    constructor(data?: INotificationColumnSelectedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.columnName = _data["columnName"];
            this.sortingIndex = _data["sortingIndex"];
            this.notificationDefinitionId = _data["notificationDefinitionId"];
        }
    }

    static fromJS(data: any): NotificationColumnSelectedDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationColumnSelectedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["columnName"] = this.columnName;
        data["sortingIndex"] = this.sortingIndex;
        data["notificationDefinitionId"] = this.notificationDefinitionId;
        return data;
    }
}

export interface INotificationColumnSelectedDto {
    id: number;
    columnName?: string | undefined;
    sortingIndex: number;
    notificationDefinitionId: number;
}

export class OrderPickupDto implements IOrderPickupDto {
    unitId!: number;
    bales?: number | undefined;
    selectedLanguage!: SelectedLanguage;
    comment?: string | undefined;

    constructor(data?: IOrderPickupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitId = _data["unitId"];
            this.bales = _data["bales"];
            this.selectedLanguage = _data["selectedLanguage"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): OrderPickupDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderPickupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitId"] = this.unitId;
        data["bales"] = this.bales;
        data["selectedLanguage"] = this.selectedLanguage;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IOrderPickupDto {
    unitId: number;
    bales?: number | undefined;
    selectedLanguage: SelectedLanguage;
    comment?: string | undefined;
}

export class OrderPickupOnDateDto implements IOrderPickupOnDateDto {
    deviceId!: number;
    bales?: number | undefined;
    selectedLanguage!: SelectedLanguage;
    comment?: string | undefined;
    pickUpOnDate!: Date;

    constructor(data?: IOrderPickupOnDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.bales = _data["bales"];
            this.selectedLanguage = _data["selectedLanguage"];
            this.comment = _data["comment"];
            this.pickUpOnDate = _data["pickUpOnDate"] ? new Date(_data["pickUpOnDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderPickupOnDateDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderPickupOnDateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["bales"] = this.bales;
        data["selectedLanguage"] = this.selectedLanguage;
        data["comment"] = this.comment;
        data["pickUpOnDate"] = this.pickUpOnDate ? this.pickUpOnDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOrderPickupOnDateDto {
    deviceId: number;
    bales?: number | undefined;
    selectedLanguage: SelectedLanguage;
    comment?: string | undefined;
    pickUpOnDate: Date;
}

export class UnsubscribeNotificationDto implements IUnsubscribeNotificationDto {
    notificationDefinitionId!: number;
    userId?: string | undefined;

    constructor(data?: IUnsubscribeNotificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationDefinitionId = _data["notificationDefinitionId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UnsubscribeNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnsubscribeNotificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationDefinitionId"] = this.notificationDefinitionId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUnsubscribeNotificationDto {
    notificationDefinitionId: number;
    userId?: string | undefined;
}

export class NotificationUnitDto implements INotificationUnitDto {
    id!: number;
    serialNumber?: string | undefined;
    machineType?: NotificationMachineType | undefined;
    fillLevelDate?: Date | undefined;
    hasModem!: boolean;
    modem?: string | undefined;
    unitModel?: string | undefined;
    unitId?: string | undefined;
    unitsEmptied!: number;
    lastestChange?: Date | undefined;
    cyclesSinceLastOutput!: number;
    errorAndSeverities?: ErrorAndSeverity[] | undefined;
    controllerName?: string | undefined;
    unitTypeName?: string | undefined;
    devicePhoneNo?: string | undefined;
    ownerGroupId!: number;
    manufacturer?: string | undefined;
    containerSize?: number | undefined;
    customerUnitId?: string | undefined;
    homeLatitude?: string | undefined;
    homeLongitude?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    pickupSystem?: string | undefined;
    wasteTypeTranslationKey?: string | undefined;
    siteUser?: string | undefined;
    siteAddress?: string | undefined;
    siteDescription?: string | undefined;
    siteCity?: string | undefined;
    sitePostalCode?: string | undefined;
    ownershipTranslationKey?: string | undefined;
    installationDate?: Date | undefined;
    warrantyExpires?: Date | undefined;
    serviceContractTypeTranslationKey?: string | undefined;
    firmwareVersion!: number;
    lastService?: Date | undefined;
    nextService?: Date | undefined;
    totalRunningHours!: number;
    totalNumberOfCycles!: number;
    comments?: string | undefined;
    daysSinceInstalled?: any | undefined;
    signalStrength!: number;
    distributor?: string | undefined;
    distributorCountry?: string | undefined;
    uploadedDate!: Date;
    groupName?: string | undefined;
    collector?: string | undefined;
    baleStorageSize?: number | undefined;
    baleCountAtLastPickup?: number | undefined;
    countLinkedBalers?: number | undefined;
    automaticBaleCountReset?: boolean | undefined;
    totalBaleCountAtStorage?: number | undefined;
    fillLevel?: number | undefined;
    isOnline!: boolean;
    unitsEmptiedThirtyDays?: number | undefined;
    averageCyclesPerUnitEmptiedThirtyDays?: number | undefined;
    isBaler!: boolean;
    fullCounterAverage?: number | undefined;

    constructor(data?: INotificationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serialNumber = _data["serialNumber"];
            this.machineType = _data["machineType"];
            this.fillLevelDate = _data["fillLevelDate"] ? new Date(_data["fillLevelDate"].toString()) : <any>undefined;
            this.hasModem = _data["hasModem"];
            this.modem = _data["modem"];
            this.unitModel = _data["unitModel"];
            this.unitId = _data["unitId"];
            this.unitsEmptied = _data["unitsEmptied"];
            this.lastestChange = _data["lastestChange"] ? new Date(_data["lastestChange"].toString()) : <any>undefined;
            this.cyclesSinceLastOutput = _data["cyclesSinceLastOutput"];
            if (Array.isArray(_data["errorAndSeverities"])) {
                this.errorAndSeverities = [] as any;
                for (let item of _data["errorAndSeverities"])
                    this.errorAndSeverities!.push(ErrorAndSeverity.fromJS(item));
            }
            this.controllerName = _data["controllerName"];
            this.unitTypeName = _data["unitTypeName"];
            this.devicePhoneNo = _data["devicePhoneNo"];
            this.ownerGroupId = _data["ownerGroupId"];
            this.manufacturer = _data["manufacturer"];
            this.containerSize = _data["containerSize"];
            this.customerUnitId = _data["customerUnitId"];
            this.homeLatitude = _data["homeLatitude"];
            this.homeLongitude = _data["homeLongitude"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.pickupSystem = _data["pickupSystem"];
            this.wasteTypeTranslationKey = _data["wasteTypeTranslationKey"];
            this.siteUser = _data["siteUser"];
            this.siteAddress = _data["siteAddress"];
            this.siteDescription = _data["siteDescription"];
            this.siteCity = _data["siteCity"];
            this.sitePostalCode = _data["sitePostalCode"];
            this.ownershipTranslationKey = _data["ownershipTranslationKey"];
            this.installationDate = _data["installationDate"] ? new Date(_data["installationDate"].toString()) : <any>undefined;
            this.warrantyExpires = _data["warrantyExpires"] ? new Date(_data["warrantyExpires"].toString()) : <any>undefined;
            this.serviceContractTypeTranslationKey = _data["serviceContractTypeTranslationKey"];
            this.firmwareVersion = _data["firmwareVersion"];
            this.lastService = _data["lastService"] ? new Date(_data["lastService"].toString()) : <any>undefined;
            this.nextService = _data["nextService"] ? new Date(_data["nextService"].toString()) : <any>undefined;
            this.totalRunningHours = _data["totalRunningHours"];
            this.totalNumberOfCycles = _data["totalNumberOfCycles"];
            this.comments = _data["comments"];
            this.daysSinceInstalled = _data["daysSinceInstalled"];
            this.signalStrength = _data["signalStrength"];
            this.distributor = _data["distributor"];
            this.distributorCountry = _data["distributorCountry"];
            this.uploadedDate = _data["uploadedDate"] ? new Date(_data["uploadedDate"].toString()) : <any>undefined;
            this.groupName = _data["groupName"];
            this.collector = _data["collector"];
            this.baleStorageSize = _data["baleStorageSize"];
            this.baleCountAtLastPickup = _data["baleCountAtLastPickup"];
            this.countLinkedBalers = _data["countLinkedBalers"];
            this.automaticBaleCountReset = _data["automaticBaleCountReset"];
            this.totalBaleCountAtStorage = _data["totalBaleCountAtStorage"];
            this.fillLevel = _data["fillLevel"];
            this.isOnline = _data["isOnline"];
            this.unitsEmptiedThirtyDays = _data["unitsEmptiedThirtyDays"];
            this.averageCyclesPerUnitEmptiedThirtyDays = _data["averageCyclesPerUnitEmptiedThirtyDays"];
            this.isBaler = _data["isBaler"];
            this.fullCounterAverage = _data["fullCounterAverage"];
        }
    }

    static fromJS(data: any): NotificationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serialNumber"] = this.serialNumber;
        data["machineType"] = this.machineType;
        data["fillLevelDate"] = this.fillLevelDate ? this.fillLevelDate.toISOString() : <any>undefined;
        data["hasModem"] = this.hasModem;
        data["modem"] = this.modem;
        data["unitModel"] = this.unitModel;
        data["unitId"] = this.unitId;
        data["unitsEmptied"] = this.unitsEmptied;
        data["lastestChange"] = this.lastestChange ? this.lastestChange.toISOString() : <any>undefined;
        data["cyclesSinceLastOutput"] = this.cyclesSinceLastOutput;
        if (Array.isArray(this.errorAndSeverities)) {
            data["errorAndSeverities"] = [];
            for (let item of this.errorAndSeverities)
                data["errorAndSeverities"].push(item.toJSON());
        }
        data["controllerName"] = this.controllerName;
        data["unitTypeName"] = this.unitTypeName;
        data["devicePhoneNo"] = this.devicePhoneNo;
        data["ownerGroupId"] = this.ownerGroupId;
        data["manufacturer"] = this.manufacturer;
        data["containerSize"] = this.containerSize;
        data["customerUnitId"] = this.customerUnitId;
        data["homeLatitude"] = this.homeLatitude;
        data["homeLongitude"] = this.homeLongitude;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["pickupSystem"] = this.pickupSystem;
        data["wasteTypeTranslationKey"] = this.wasteTypeTranslationKey;
        data["siteUser"] = this.siteUser;
        data["siteAddress"] = this.siteAddress;
        data["siteDescription"] = this.siteDescription;
        data["siteCity"] = this.siteCity;
        data["sitePostalCode"] = this.sitePostalCode;
        data["ownershipTranslationKey"] = this.ownershipTranslationKey;
        data["installationDate"] = this.installationDate ? this.installationDate.toISOString() : <any>undefined;
        data["warrantyExpires"] = this.warrantyExpires ? this.warrantyExpires.toISOString() : <any>undefined;
        data["serviceContractTypeTranslationKey"] = this.serviceContractTypeTranslationKey;
        data["firmwareVersion"] = this.firmwareVersion;
        data["lastService"] = this.lastService ? this.lastService.toISOString() : <any>undefined;
        data["nextService"] = this.nextService ? this.nextService.toISOString() : <any>undefined;
        data["totalRunningHours"] = this.totalRunningHours;
        data["totalNumberOfCycles"] = this.totalNumberOfCycles;
        data["comments"] = this.comments;
        data["daysSinceInstalled"] = this.daysSinceInstalled;
        data["signalStrength"] = this.signalStrength;
        data["distributor"] = this.distributor;
        data["distributorCountry"] = this.distributorCountry;
        data["uploadedDate"] = this.uploadedDate ? this.uploadedDate.toISOString() : <any>undefined;
        data["groupName"] = this.groupName;
        data["collector"] = this.collector;
        data["baleStorageSize"] = this.baleStorageSize;
        data["baleCountAtLastPickup"] = this.baleCountAtLastPickup;
        data["countLinkedBalers"] = this.countLinkedBalers;
        data["automaticBaleCountReset"] = this.automaticBaleCountReset;
        data["totalBaleCountAtStorage"] = this.totalBaleCountAtStorage;
        data["fillLevel"] = this.fillLevel;
        data["isOnline"] = this.isOnline;
        data["unitsEmptiedThirtyDays"] = this.unitsEmptiedThirtyDays;
        data["averageCyclesPerUnitEmptiedThirtyDays"] = this.averageCyclesPerUnitEmptiedThirtyDays;
        data["isBaler"] = this.isBaler;
        data["fullCounterAverage"] = this.fullCounterAverage;
        return data;
    }
}

export interface INotificationUnitDto {
    id: number;
    serialNumber?: string | undefined;
    machineType?: NotificationMachineType | undefined;
    fillLevelDate?: Date | undefined;
    hasModem: boolean;
    modem?: string | undefined;
    unitModel?: string | undefined;
    unitId?: string | undefined;
    unitsEmptied: number;
    lastestChange?: Date | undefined;
    cyclesSinceLastOutput: number;
    errorAndSeverities?: ErrorAndSeverity[] | undefined;
    controllerName?: string | undefined;
    unitTypeName?: string | undefined;
    devicePhoneNo?: string | undefined;
    ownerGroupId: number;
    manufacturer?: string | undefined;
    containerSize?: number | undefined;
    customerUnitId?: string | undefined;
    homeLatitude?: string | undefined;
    homeLongitude?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    pickupSystem?: string | undefined;
    wasteTypeTranslationKey?: string | undefined;
    siteUser?: string | undefined;
    siteAddress?: string | undefined;
    siteDescription?: string | undefined;
    siteCity?: string | undefined;
    sitePostalCode?: string | undefined;
    ownershipTranslationKey?: string | undefined;
    installationDate?: Date | undefined;
    warrantyExpires?: Date | undefined;
    serviceContractTypeTranslationKey?: string | undefined;
    firmwareVersion: number;
    lastService?: Date | undefined;
    nextService?: Date | undefined;
    totalRunningHours: number;
    totalNumberOfCycles: number;
    comments?: string | undefined;
    daysSinceInstalled?: any | undefined;
    signalStrength: number;
    distributor?: string | undefined;
    distributorCountry?: string | undefined;
    uploadedDate: Date;
    groupName?: string | undefined;
    collector?: string | undefined;
    baleStorageSize?: number | undefined;
    baleCountAtLastPickup?: number | undefined;
    countLinkedBalers?: number | undefined;
    automaticBaleCountReset?: boolean | undefined;
    totalBaleCountAtStorage?: number | undefined;
    fillLevel?: number | undefined;
    isOnline: boolean;
    unitsEmptiedThirtyDays?: number | undefined;
    averageCyclesPerUnitEmptiedThirtyDays?: number | undefined;
    isBaler: boolean;
    fullCounterAverage?: number | undefined;
}

export class ErrorAndSeverity implements IErrorAndSeverity {
    errorId!: number;
    severity?: StatusSeverity | undefined;
    readableError?: string | undefined;

    constructor(data?: IErrorAndSeverity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorId = _data["errorId"];
            this.severity = _data["severity"];
            this.readableError = _data["readableError"];
        }
    }

    static fromJS(data: any): ErrorAndSeverity {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorAndSeverity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorId"] = this.errorId;
        data["severity"] = this.severity;
        data["readableError"] = this.readableError;
        return data;
    }
}

export interface IErrorAndSeverity {
    errorId: number;
    severity?: StatusSeverity | undefined;
    readableError?: string | undefined;
}

export class BramidanNotificationInfoWithNotifyInfo implements IBramidanNotificationInfoWithNotifyInfo {
    bramidanNotificationInfo?: BramidanNotificationInfo | undefined;
    notifyByEmail!: boolean;
    notifyByPush!: boolean;

    constructor(data?: IBramidanNotificationInfoWithNotifyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bramidanNotificationInfo = _data["bramidanNotificationInfo"] ? BramidanNotificationInfo.fromJS(_data["bramidanNotificationInfo"]) : <any>undefined;
            this.notifyByEmail = _data["notifyByEmail"];
            this.notifyByPush = _data["notifyByPush"];
        }
    }

    static fromJS(data: any): BramidanNotificationInfoWithNotifyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BramidanNotificationInfoWithNotifyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bramidanNotificationInfo"] = this.bramidanNotificationInfo ? this.bramidanNotificationInfo.toJSON() : <any>undefined;
        data["notifyByEmail"] = this.notifyByEmail;
        data["notifyByPush"] = this.notifyByPush;
        return data;
    }
}

export interface IBramidanNotificationInfoWithNotifyInfo {
    bramidanNotificationInfo?: BramidanNotificationInfo | undefined;
    notifyByEmail: boolean;
    notifyByPush: boolean;
}

export class BramidanNotificationInfo implements IBramidanNotificationInfo {
    notificationUsers?: NotificationUserDto[] | undefined;
    selectedLanguage!: SelectedLanguage;
    notificationDetails?: BramidanNotificationDetails | undefined;

    constructor(data?: IBramidanNotificationInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notificationUsers"])) {
                this.notificationUsers = [] as any;
                for (let item of _data["notificationUsers"])
                    this.notificationUsers!.push(NotificationUserDto.fromJS(item));
            }
            this.selectedLanguage = _data["selectedLanguage"];
            this.notificationDetails = _data["notificationDetails"] ? BramidanNotificationDetails.fromJS(_data["notificationDetails"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BramidanNotificationInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BramidanNotificationInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notificationUsers)) {
            data["notificationUsers"] = [];
            for (let item of this.notificationUsers)
                data["notificationUsers"].push(item.toJSON());
        }
        data["selectedLanguage"] = this.selectedLanguage;
        data["notificationDetails"] = this.notificationDetails ? this.notificationDetails.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBramidanNotificationInfo {
    notificationUsers?: NotificationUserDto[] | undefined;
    selectedLanguage: SelectedLanguage;
    notificationDetails?: BramidanNotificationDetails | undefined;
}

export class BramidanNotificationDetails implements IBramidanNotificationDetails {
    notificationEvents?: NotificationEvent[] | undefined;
    notificationUnit?: NotificationUnitDto | undefined;
    columnSelected?: NotificationColumnSelectedDto[] | undefined;
    notificationDefinitionName?: string | undefined;
    notificationDefinitionId!: number;

    constructor(data?: IBramidanNotificationDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["notificationEvents"])) {
                this.notificationEvents = [] as any;
                for (let item of _data["notificationEvents"])
                    this.notificationEvents!.push(NotificationEvent.fromJS(item));
            }
            this.notificationUnit = _data["notificationUnit"] ? NotificationUnitDto.fromJS(_data["notificationUnit"]) : <any>undefined;
            if (Array.isArray(_data["columnSelected"])) {
                this.columnSelected = [] as any;
                for (let item of _data["columnSelected"])
                    this.columnSelected!.push(NotificationColumnSelectedDto.fromJS(item));
            }
            this.notificationDefinitionName = _data["notificationDefinitionName"];
            this.notificationDefinitionId = _data["notificationDefinitionId"];
        }
    }

    static fromJS(data: any): BramidanNotificationDetails {
        data = typeof data === 'object' ? data : {};
        let result = new BramidanNotificationDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.notificationEvents)) {
            data["notificationEvents"] = [];
            for (let item of this.notificationEvents)
                data["notificationEvents"].push(item.toJSON());
        }
        data["notificationUnit"] = this.notificationUnit ? this.notificationUnit.toJSON() : <any>undefined;
        if (Array.isArray(this.columnSelected)) {
            data["columnSelected"] = [];
            for (let item of this.columnSelected)
                data["columnSelected"].push(item.toJSON());
        }
        data["notificationDefinitionName"] = this.notificationDefinitionName;
        data["notificationDefinitionId"] = this.notificationDefinitionId;
        return data;
    }
}

export interface IBramidanNotificationDetails {
    notificationEvents?: NotificationEvent[] | undefined;
    notificationUnit?: NotificationUnitDto | undefined;
    columnSelected?: NotificationColumnSelectedDto[] | undefined;
    notificationDefinitionName?: string | undefined;
    notificationDefinitionId: number;
}

export class NotificationEvent implements INotificationEvent {
    fillLevelSettings?: NotificationFillLevelSettingsDto | undefined;
    advancedNotificationSettings?: NotificationAdvancedSettingDto[] | undefined;
    notificationType?: NotificationTypeDto | undefined;
    customMessage?: string | undefined;
    baleStorageDto?: BaleStorageNotificationDto | undefined;
    pickUpOrderedAmount?: number | undefined;
    pickUpComment?: string | undefined;
    triggeredByUser?: string | undefined;
    pickUpOnDate?: Date | undefined;
    fillLevelWhenEmptied?: number | undefined;
    customXtelMessage?: string | undefined;

    constructor(data?: INotificationEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fillLevelSettings = _data["fillLevelSettings"] ? NotificationFillLevelSettingsDto.fromJS(_data["fillLevelSettings"]) : <any>undefined;
            if (Array.isArray(_data["advancedNotificationSettings"])) {
                this.advancedNotificationSettings = [] as any;
                for (let item of _data["advancedNotificationSettings"])
                    this.advancedNotificationSettings!.push(NotificationAdvancedSettingDto.fromJS(item));
            }
            this.notificationType = _data["notificationType"] ? NotificationTypeDto.fromJS(_data["notificationType"]) : <any>undefined;
            this.customMessage = _data["customMessage"];
            this.baleStorageDto = _data["baleStorageDto"] ? BaleStorageNotificationDto.fromJS(_data["baleStorageDto"]) : <any>undefined;
            this.pickUpOrderedAmount = _data["pickUpOrderedAmount"];
            this.pickUpComment = _data["pickUpComment"];
            this.triggeredByUser = _data["triggeredByUser"];
            this.pickUpOnDate = _data["pickUpOnDate"] ? new Date(_data["pickUpOnDate"].toString()) : <any>undefined;
            this.fillLevelWhenEmptied = _data["fillLevelWhenEmptied"];
            this.customXtelMessage = _data["customXtelMessage"];
        }
    }

    static fromJS(data: any): NotificationEvent {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fillLevelSettings"] = this.fillLevelSettings ? this.fillLevelSettings.toJSON() : <any>undefined;
        if (Array.isArray(this.advancedNotificationSettings)) {
            data["advancedNotificationSettings"] = [];
            for (let item of this.advancedNotificationSettings)
                data["advancedNotificationSettings"].push(item.toJSON());
        }
        data["notificationType"] = this.notificationType ? this.notificationType.toJSON() : <any>undefined;
        data["customMessage"] = this.customMessage;
        data["baleStorageDto"] = this.baleStorageDto ? this.baleStorageDto.toJSON() : <any>undefined;
        data["pickUpOrderedAmount"] = this.pickUpOrderedAmount;
        data["pickUpComment"] = this.pickUpComment;
        data["triggeredByUser"] = this.triggeredByUser;
        data["pickUpOnDate"] = this.pickUpOnDate ? this.pickUpOnDate.toISOString() : <any>undefined;
        data["fillLevelWhenEmptied"] = this.fillLevelWhenEmptied;
        data["customXtelMessage"] = this.customXtelMessage;
        return data;
    }
}

export interface INotificationEvent {
    fillLevelSettings?: NotificationFillLevelSettingsDto | undefined;
    advancedNotificationSettings?: NotificationAdvancedSettingDto[] | undefined;
    notificationType?: NotificationTypeDto | undefined;
    customMessage?: string | undefined;
    baleStorageDto?: BaleStorageNotificationDto | undefined;
    pickUpOrderedAmount?: number | undefined;
    pickUpComment?: string | undefined;
    triggeredByUser?: string | undefined;
    pickUpOnDate?: Date | undefined;
    fillLevelWhenEmptied?: number | undefined;
    customXtelMessage?: string | undefined;
}

export class BaleStorageNotificationDto extends BaleStorageDto implements IBaleStorageNotificationDto {
    baleCountAtLastPickup!: number;
    deviceSerialNumbers?: string[] | undefined;

    constructor(data?: IBaleStorageNotificationDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.baleCountAtLastPickup = _data["baleCountAtLastPickup"];
            if (Array.isArray(_data["deviceSerialNumbers"])) {
                this.deviceSerialNumbers = [] as any;
                for (let item of _data["deviceSerialNumbers"])
                    this.deviceSerialNumbers!.push(item);
            }
        }
    }

    static override fromJS(data: any): BaleStorageNotificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaleStorageNotificationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baleCountAtLastPickup"] = this.baleCountAtLastPickup;
        if (Array.isArray(this.deviceSerialNumbers)) {
            data["deviceSerialNumbers"] = [];
            for (let item of this.deviceSerialNumbers)
                data["deviceSerialNumbers"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IBaleStorageNotificationDto extends IBaleStorageDto {
    baleCountAtLastPickup: number;
    deviceSerialNumbers?: string[] | undefined;
}

export class NotificationHistoryDto implements INotificationHistoryDto {
    id!: number;
    unitId!: number;
    createdOn!: Date;
    stateChangeDateTime!: Date;
    emails?: string[] | undefined;
    notificationEvents?: NotificationEvent[] | undefined;

    constructor(data?: INotificationHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.unitId = _data["unitId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.stateChangeDateTime = _data["stateChangeDateTime"] ? new Date(_data["stateChangeDateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
            if (Array.isArray(_data["notificationEvents"])) {
                this.notificationEvents = [] as any;
                for (let item of _data["notificationEvents"])
                    this.notificationEvents!.push(NotificationEvent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotificationHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitId"] = this.unitId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["stateChangeDateTime"] = this.stateChangeDateTime ? this.stateChangeDateTime.toISOString() : <any>undefined;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        if (Array.isArray(this.notificationEvents)) {
            data["notificationEvents"] = [];
            for (let item of this.notificationEvents)
                data["notificationEvents"].push(item.toJSON());
        }
        return data;
    }
}

export interface INotificationHistoryDto {
    id: number;
    unitId: number;
    createdOn: Date;
    stateChangeDateTime: Date;
    emails?: string[] | undefined;
    notificationEvents?: NotificationEvent[] | undefined;
}

export class NotificationUserHistoryDto implements INotificationUserHistoryDto {
    notificationHistoryId!: number;
    createdOn!: Date;
    stateChangeDateTime!: Date;
    unitId!: number;
    serialnumber?: string | undefined;
    manufacturerId?: string | undefined;
    groupName?: string | undefined;
    unitModel?: string | undefined;
    notificationDefinitionDto?: NotificationDefinitionDto | undefined;
    notificationEvents?: NotificationEvent[] | undefined;

    constructor(data?: INotificationUserHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.notificationHistoryId = _data["notificationHistoryId"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.stateChangeDateTime = _data["stateChangeDateTime"] ? new Date(_data["stateChangeDateTime"].toString()) : <any>undefined;
            this.unitId = _data["unitId"];
            this.serialnumber = _data["serialnumber"];
            this.manufacturerId = _data["manufacturerId"];
            this.groupName = _data["groupName"];
            this.unitModel = _data["unitModel"];
            this.notificationDefinitionDto = _data["notificationDefinitionDto"] ? NotificationDefinitionDto.fromJS(_data["notificationDefinitionDto"]) : <any>undefined;
            if (Array.isArray(_data["notificationEvents"])) {
                this.notificationEvents = [] as any;
                for (let item of _data["notificationEvents"])
                    this.notificationEvents!.push(NotificationEvent.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NotificationUserHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationUserHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["notificationHistoryId"] = this.notificationHistoryId;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["stateChangeDateTime"] = this.stateChangeDateTime ? this.stateChangeDateTime.toISOString() : <any>undefined;
        data["unitId"] = this.unitId;
        data["serialnumber"] = this.serialnumber;
        data["manufacturerId"] = this.manufacturerId;
        data["groupName"] = this.groupName;
        data["unitModel"] = this.unitModel;
        data["notificationDefinitionDto"] = this.notificationDefinitionDto ? this.notificationDefinitionDto.toJSON() : <any>undefined;
        if (Array.isArray(this.notificationEvents)) {
            data["notificationEvents"] = [];
            for (let item of this.notificationEvents)
                data["notificationEvents"].push(item.toJSON());
        }
        return data;
    }
}

export interface INotificationUserHistoryDto {
    notificationHistoryId: number;
    createdOn: Date;
    stateChangeDateTime: Date;
    unitId: number;
    serialnumber?: string | undefined;
    manufacturerId?: string | undefined;
    groupName?: string | undefined;
    unitModel?: string | undefined;
    notificationDefinitionDto?: NotificationDefinitionDto | undefined;
    notificationEvents?: NotificationEvent[] | undefined;
}

export class OrderPickUpDateDto implements IOrderPickUpDateDto {
    pickUpdate?: Date | undefined;

    constructor(data?: IOrderPickUpDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pickUpdate = _data["pickUpdate"] ? new Date(_data["pickUpdate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrderPickUpDateDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrderPickUpDateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pickUpdate"] = this.pickUpdate ? this.pickUpdate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOrderPickUpDateDto {
    pickUpdate?: Date | undefined;
}

export class FileDirectoryDto implements IFileDirectoryDto {
    name?: string | undefined;
    fileDirectoryType!: FileDirectoryTypeEnum;
    fullPath?: string | undefined;
    fileDirectoryDtos?: FileDirectoryDto[] | undefined;

    constructor(data?: IFileDirectoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.fileDirectoryType = _data["fileDirectoryType"];
            this.fullPath = _data["fullPath"];
            if (Array.isArray(_data["fileDirectoryDtos"])) {
                this.fileDirectoryDtos = [] as any;
                for (let item of _data["fileDirectoryDtos"])
                    this.fileDirectoryDtos!.push(FileDirectoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FileDirectoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDirectoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["fileDirectoryType"] = this.fileDirectoryType;
        data["fullPath"] = this.fullPath;
        if (Array.isArray(this.fileDirectoryDtos)) {
            data["fileDirectoryDtos"] = [];
            for (let item of this.fileDirectoryDtos)
                data["fileDirectoryDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFileDirectoryDto {
    name?: string | undefined;
    fileDirectoryType: FileDirectoryTypeEnum;
    fullPath?: string | undefined;
    fileDirectoryDtos?: FileDirectoryDto[] | undefined;
}

export enum FileDirectoryTypeEnum {
    Folder = 0,
    File = 1,
}

export class ProfileDto implements IProfileDto {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    company?: string | undefined;
    jobtitle?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: string[] | undefined;
    universalRoles?: string[] | undefined;
    groups?: string[] | undefined;
    userImage?: string | undefined;

    constructor(data?: IProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.company = _data["company"];
            this.jobtitle = _data["jobtitle"];
            this.phoneNumber = _data["phoneNumber"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            if (Array.isArray(_data["universalRoles"])) {
                this.universalRoles = [] as any;
                for (let item of _data["universalRoles"])
                    this.universalRoles!.push(item);
            }
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(item);
            }
            this.userImage = _data["userImage"];
        }
    }

    static fromJS(data: any): ProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["company"] = this.company;
        data["jobtitle"] = this.jobtitle;
        data["phoneNumber"] = this.phoneNumber;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        if (Array.isArray(this.universalRoles)) {
            data["universalRoles"] = [];
            for (let item of this.universalRoles)
                data["universalRoles"].push(item);
        }
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["userImage"] = this.userImage;
        return data;
    }
}

export interface IProfileDto {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    company?: string | undefined;
    jobtitle?: string | undefined;
    phoneNumber?: string | undefined;
    roles?: string[] | undefined;
    universalRoles?: string[] | undefined;
    groups?: string[] | undefined;
    userImage?: string | undefined;
}

export class GetReleaseNoteDto implements IGetReleaseNoteDto {
    id!: number;
    title?: string | undefined;
    description?: string | undefined;
    isNew!: boolean;
    imageName?: string | undefined;
    createdDate!: Date;
    updatedDate!: Date;

    constructor(data?: IGetReleaseNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.isNew = _data["isNew"];
            this.imageName = _data["imageName"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetReleaseNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetReleaseNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["isNew"] = this.isNew;
        data["imageName"] = this.imageName;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IGetReleaseNoteDto {
    id: number;
    title?: string | undefined;
    description?: string | undefined;
    isNew: boolean;
    imageName?: string | undefined;
    createdDate: Date;
    updatedDate: Date;
}

export class ServiceToolDevicesDto implements IServiceToolDevicesDto {
    data?: DeviceAccessDto | undefined;
    signature?: string | undefined;
    signatureExpirationDate!: Date;

    constructor(data?: IServiceToolDevicesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.data = _data["data"] ? DeviceAccessDto.fromJS(_data["data"]) : <any>undefined;
            this.signature = _data["signature"];
            this.signatureExpirationDate = _data["signatureExpirationDate"] ? new Date(_data["signatureExpirationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceToolDevicesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceToolDevicesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["signature"] = this.signature;
        data["signatureExpirationDate"] = this.signatureExpirationDate ? this.signatureExpirationDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IServiceToolDevicesDto {
    data?: DeviceAccessDto | undefined;
    signature?: string | undefined;
    signatureExpirationDate: Date;
}

export class DeviceAccessDto implements IDeviceAccessDto {
    accessType?: string | undefined;
    accessDevices?: AccessDevicesDto[] | undefined;

    constructor(data?: IDeviceAccessDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessType = _data["accessType"];
            if (Array.isArray(_data["accessDevices"])) {
                this.accessDevices = [] as any;
                for (let item of _data["accessDevices"])
                    this.accessDevices!.push(AccessDevicesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeviceAccessDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceAccessDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessType"] = this.accessType;
        if (Array.isArray(this.accessDevices)) {
            data["accessDevices"] = [];
            for (let item of this.accessDevices)
                data["accessDevices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDeviceAccessDto {
    accessType?: string | undefined;
    accessDevices?: AccessDevicesDto[] | undefined;
}

export class AccessDevicesDto implements IAccessDevicesDto {
    serialNumber?: string | undefined;
    controllerType?: string | undefined;
    modemType?: string | undefined;
    isOnline!: boolean;

    constructor(data?: IAccessDevicesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"];
            this.controllerType = _data["controllerType"];
            this.modemType = _data["modemType"];
            this.isOnline = _data["isOnline"];
        }
    }

    static fromJS(data: any): AccessDevicesDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccessDevicesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        data["controllerType"] = this.controllerType;
        data["modemType"] = this.modemType;
        data["isOnline"] = this.isOnline;
        return data;
    }
}

export interface IAccessDevicesDto {
    serialNumber?: string | undefined;
    controllerType?: string | undefined;
    modemType?: string | undefined;
    isOnline: boolean;
}

export class SignalRConnectionInfoDto implements ISignalRConnectionInfoDto {
    connectionId?: string | undefined;
    machineId?: string | undefined;

    constructor(data?: ISignalRConnectionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectionId = _data["connectionId"];
            this.machineId = _data["machineId"];
        }
    }

    static fromJS(data: any): SignalRConnectionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SignalRConnectionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionId"] = this.connectionId;
        data["machineId"] = this.machineId;
        return data;
    }
}

export interface ISignalRConnectionInfoDto {
    connectionId?: string | undefined;
    machineId?: string | undefined;
}

export class ServiceToolOptionsDto implements IServiceToolOptionsDto {
    options?: string[] | undefined;

    constructor(data?: IServiceToolOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(item);
            }
        }
    }

    static fromJS(data: any): ServiceToolOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceToolOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item);
        }
        return data;
    }
}

export interface IServiceToolOptionsDto {
    options?: string[] | undefined;
}

export class ServiceToolControllerTypes implements IServiceToolControllerTypes {
    isJE846OrJE911!: boolean;
    isJE910!: boolean;
    isJE882OrJE982!: boolean;

    constructor(data?: IServiceToolControllerTypes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isJE846OrJE911 = _data["isJE846OrJE911"];
            this.isJE910 = _data["isJE910"];
            this.isJE882OrJE982 = _data["isJE882OrJE982"];
        }
    }

    static fromJS(data: any): ServiceToolControllerTypes {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceToolControllerTypes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isJE846OrJE911"] = this.isJE846OrJE911;
        data["isJE910"] = this.isJE910;
        data["isJE882OrJE982"] = this.isJE882OrJE982;
        return data;
    }
}

export interface IServiceToolControllerTypes {
    isJE846OrJE911: boolean;
    isJE910: boolean;
    isJE882OrJE982: boolean;
}

export class ServiceVideoDto implements IServiceVideoDto {
    id!: number;
    title?: string | undefined;
    vimeoVideoId?: string | undefined;
    machineTypes?: string[] | undefined;

    constructor(data?: IServiceVideoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.vimeoVideoId = _data["vimeoVideoId"];
            if (Array.isArray(_data["machineTypes"])) {
                this.machineTypes = [] as any;
                for (let item of _data["machineTypes"])
                    this.machineTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): ServiceVideoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceVideoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["vimeoVideoId"] = this.vimeoVideoId;
        if (Array.isArray(this.machineTypes)) {
            data["machineTypes"] = [];
            for (let item of this.machineTypes)
                data["machineTypes"].push(item);
        }
        return data;
    }
}

export interface IServiceVideoDto {
    id: number;
    title?: string | undefined;
    vimeoVideoId?: string | undefined;
    machineTypes?: string[] | undefined;
}

export class TableSettings extends ModelBaseId implements ITableSettings {
    settingsJson?: string | undefined;
    userId?: string | undefined;
    tableId!: TableId;
    revision?: number | undefined;
    settingsName?: string | undefined;
    isActive!: boolean;

    constructor(data?: ITableSettings) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.settingsJson = _data["settingsJson"];
            this.userId = _data["userId"];
            this.tableId = _data["tableId"];
            this.revision = _data["revision"];
            this.settingsName = _data["settingsName"];
            this.isActive = _data["isActive"];
        }
    }

    static override fromJS(data: any): TableSettings {
        data = typeof data === 'object' ? data : {};
        let result = new TableSettings();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingsJson"] = this.settingsJson;
        data["userId"] = this.userId;
        data["tableId"] = this.tableId;
        data["revision"] = this.revision;
        data["settingsName"] = this.settingsName;
        data["isActive"] = this.isActive;
        super.toJSON(data);
        return data;
    }
}

export interface ITableSettings extends IModelBaseId {
    settingsJson?: string | undefined;
    userId?: string | undefined;
    tableId: TableId;
    revision?: number | undefined;
    settingsName?: string | undefined;
    isActive: boolean;
}

export enum TableId {
    Machines = 0,
    Reports = 1,
    Histories = 2,
}

export class IoTHubDuplicateDecommissionDto implements IIoTHubDuplicateDecommissionDto {
    id!: number;
    serialNumber!: string;
    deviceIdOld!: string;
    modemOld?: string | undefined;
    deviceIdNew!: string;
    modemNew?: string | undefined;
    unitStateDeviceId?: string | undefined;

    constructor(data?: IIoTHubDuplicateDecommissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serialNumber = _data["serialNumber"];
            this.deviceIdOld = _data["deviceIdOld"];
            this.modemOld = _data["modemOld"];
            this.deviceIdNew = _data["deviceIdNew"];
            this.modemNew = _data["modemNew"];
            this.unitStateDeviceId = _data["unitStateDeviceId"];
        }
    }

    static fromJS(data: any): IoTHubDuplicateDecommissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new IoTHubDuplicateDecommissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serialNumber"] = this.serialNumber;
        data["deviceIdOld"] = this.deviceIdOld;
        data["modemOld"] = this.modemOld;
        data["deviceIdNew"] = this.deviceIdNew;
        data["modemNew"] = this.modemNew;
        data["unitStateDeviceId"] = this.unitStateDeviceId;
        return data;
    }
}

export interface IIoTHubDuplicateDecommissionDto {
    id: number;
    serialNumber: string;
    deviceIdOld: string;
    modemOld?: string | undefined;
    deviceIdNew: string;
    modemNew?: string | undefined;
    unitStateDeviceId?: string | undefined;
}

export class UnitsAdminDto implements IUnitsAdminDto {
    uploadedDate!: Date;

    constructor(data?: IUnitsAdminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.uploadedDate = _data["uploadedDate"] ? new Date(_data["uploadedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UnitsAdminDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitsAdminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uploadedDate"] = this.uploadedDate ? this.uploadedDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUnitsAdminDto {
    uploadedDate: Date;
}

export class UnitsDto extends UnitsAdminDto implements IUnitsDto {
    id!: number;
    signalStrength!: number;
    lastestChange?: Date | undefined;
    devicePhoneNo?: string | undefined;
    fillLevel?: number | undefined;
    unitId?: string | undefined;
    customerUnitId?: string | undefined;
    manufacturer?: string | undefined;
    unitModel?: string | undefined;
    controllerName?: string | undefined;
    firmwareVersion!: number;
    homeLatitude?: string | undefined;
    homeLongitude?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    trackerBatteryLevel?: number | undefined;
    pickupSystem?: string | undefined;
    wasteTypeTranslationKey?: string | undefined;
    serviceContractTypeTranslationKey?: string | undefined;
    collector?: string | undefined;
    distributor?: string | undefined;
    distributorCountry?: string | undefined;
    groupName?: string | undefined;
    siteUser?: string | undefined;
    siteAddress?: string | undefined;
    siteDescription?: string | undefined;
    siteCity?: string | undefined;
    sitePostalCode?: string | undefined;
    ownershipTranslationKey?: string | undefined;
    installationDate?: Date | undefined;
    warrantyExpires?: Date | undefined;
    lastService?: Date | undefined;
    nextService?: Date | undefined;
    unitsEmptied!: number;
    unitsEmptiedThirtyDays?: number | undefined;
    averageCyclesPerUnitEmptiedThirtyDays?: number | undefined;
    totalRunningHours!: number;
    totalNumberOfCycles!: number;
    unitTypeName?: string | undefined;
    errorAndSeverities?: ErrorAndSeverity[] | undefined;
    hasModem!: boolean;
    isOnline!: boolean;
    ownerGroupId!: number;
    cyclesSinceLastOutput!: number;
    pressSeries!: number;
    pressSeriesSinceLastOutput!: number;
    comments?: string | undefined;
    internalComment?: string | undefined;
    daysSinceInstalled?: number | undefined;
    containerSize?: number | undefined;
    modemName?: string | undefined;
    baleCountAtLastPickup?: number | undefined;
    totalBaleCountAtStorage?: number | undefined;
    baleStorageSize?: number | undefined;
    automaticBaleCountReset?: boolean | undefined;
    countLinkedBalers?: number | undefined;
    balesOnSite?: number | undefined;
    isBaler!: boolean;
    fullCounterAverage?: number | undefined;

    constructor(data?: IUnitsDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.signalStrength = _data["signalStrength"];
            this.lastestChange = _data["lastestChange"] ? new Date(_data["lastestChange"].toString()) : <any>undefined;
            this.devicePhoneNo = _data["devicePhoneNo"];
            this.fillLevel = _data["fillLevel"];
            this.unitId = _data["unitId"];
            this.customerUnitId = _data["customerUnitId"];
            this.manufacturer = _data["manufacturer"];
            this.unitModel = _data["unitModel"];
            this.controllerName = _data["controllerName"];
            this.firmwareVersion = _data["firmwareVersion"];
            this.homeLatitude = _data["homeLatitude"];
            this.homeLongitude = _data["homeLongitude"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.trackerBatteryLevel = _data["trackerBatteryLevel"];
            this.pickupSystem = _data["pickupSystem"];
            this.wasteTypeTranslationKey = _data["wasteTypeTranslationKey"];
            this.serviceContractTypeTranslationKey = _data["serviceContractTypeTranslationKey"];
            this.collector = _data["collector"];
            this.distributor = _data["distributor"];
            this.distributorCountry = _data["distributorCountry"];
            this.groupName = _data["groupName"];
            this.siteUser = _data["siteUser"];
            this.siteAddress = _data["siteAddress"];
            this.siteDescription = _data["siteDescription"];
            this.siteCity = _data["siteCity"];
            this.sitePostalCode = _data["sitePostalCode"];
            this.ownershipTranslationKey = _data["ownershipTranslationKey"];
            this.installationDate = _data["installationDate"] ? new Date(_data["installationDate"].toString()) : <any>undefined;
            this.warrantyExpires = _data["warrantyExpires"] ? new Date(_data["warrantyExpires"].toString()) : <any>undefined;
            this.lastService = _data["lastService"] ? new Date(_data["lastService"].toString()) : <any>undefined;
            this.nextService = _data["nextService"] ? new Date(_data["nextService"].toString()) : <any>undefined;
            this.unitsEmptied = _data["unitsEmptied"];
            this.unitsEmptiedThirtyDays = _data["unitsEmptiedThirtyDays"];
            this.averageCyclesPerUnitEmptiedThirtyDays = _data["averageCyclesPerUnitEmptiedThirtyDays"];
            this.totalRunningHours = _data["totalRunningHours"];
            this.totalNumberOfCycles = _data["totalNumberOfCycles"];
            this.unitTypeName = _data["unitTypeName"];
            if (Array.isArray(_data["errorAndSeverities"])) {
                this.errorAndSeverities = [] as any;
                for (let item of _data["errorAndSeverities"])
                    this.errorAndSeverities!.push(ErrorAndSeverity.fromJS(item));
            }
            this.hasModem = _data["hasModem"];
            this.isOnline = _data["isOnline"];
            this.ownerGroupId = _data["ownerGroupId"];
            this.cyclesSinceLastOutput = _data["cyclesSinceLastOutput"];
            this.pressSeries = _data["pressSeries"];
            this.pressSeriesSinceLastOutput = _data["pressSeriesSinceLastOutput"];
            this.comments = _data["comments"];
            this.internalComment = _data["internalComment"];
            this.daysSinceInstalled = _data["daysSinceInstalled"];
            this.containerSize = _data["containerSize"];
            this.modemName = _data["modemName"];
            this.baleCountAtLastPickup = _data["baleCountAtLastPickup"];
            this.totalBaleCountAtStorage = _data["totalBaleCountAtStorage"];
            this.baleStorageSize = _data["baleStorageSize"];
            this.automaticBaleCountReset = _data["automaticBaleCountReset"];
            this.countLinkedBalers = _data["countLinkedBalers"];
            this.balesOnSite = _data["balesOnSite"];
            this.isBaler = _data["isBaler"];
            this.fullCounterAverage = _data["fullCounterAverage"];
        }
    }

    static override fromJS(data: any): UnitsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["signalStrength"] = this.signalStrength;
        data["lastestChange"] = this.lastestChange ? this.lastestChange.toISOString() : <any>undefined;
        data["devicePhoneNo"] = this.devicePhoneNo;
        data["fillLevel"] = this.fillLevel;
        data["unitId"] = this.unitId;
        data["customerUnitId"] = this.customerUnitId;
        data["manufacturer"] = this.manufacturer;
        data["unitModel"] = this.unitModel;
        data["controllerName"] = this.controllerName;
        data["firmwareVersion"] = this.firmwareVersion;
        data["homeLatitude"] = this.homeLatitude;
        data["homeLongitude"] = this.homeLongitude;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["trackerBatteryLevel"] = this.trackerBatteryLevel;
        data["pickupSystem"] = this.pickupSystem;
        data["wasteTypeTranslationKey"] = this.wasteTypeTranslationKey;
        data["serviceContractTypeTranslationKey"] = this.serviceContractTypeTranslationKey;
        data["collector"] = this.collector;
        data["distributor"] = this.distributor;
        data["distributorCountry"] = this.distributorCountry;
        data["groupName"] = this.groupName;
        data["siteUser"] = this.siteUser;
        data["siteAddress"] = this.siteAddress;
        data["siteDescription"] = this.siteDescription;
        data["siteCity"] = this.siteCity;
        data["sitePostalCode"] = this.sitePostalCode;
        data["ownershipTranslationKey"] = this.ownershipTranslationKey;
        data["installationDate"] = this.installationDate ? this.installationDate.toISOString() : <any>undefined;
        data["warrantyExpires"] = this.warrantyExpires ? this.warrantyExpires.toISOString() : <any>undefined;
        data["lastService"] = this.lastService ? this.lastService.toISOString() : <any>undefined;
        data["nextService"] = this.nextService ? this.nextService.toISOString() : <any>undefined;
        data["unitsEmptied"] = this.unitsEmptied;
        data["unitsEmptiedThirtyDays"] = this.unitsEmptiedThirtyDays;
        data["averageCyclesPerUnitEmptiedThirtyDays"] = this.averageCyclesPerUnitEmptiedThirtyDays;
        data["totalRunningHours"] = this.totalRunningHours;
        data["totalNumberOfCycles"] = this.totalNumberOfCycles;
        data["unitTypeName"] = this.unitTypeName;
        if (Array.isArray(this.errorAndSeverities)) {
            data["errorAndSeverities"] = [];
            for (let item of this.errorAndSeverities)
                data["errorAndSeverities"].push(item.toJSON());
        }
        data["hasModem"] = this.hasModem;
        data["isOnline"] = this.isOnline;
        data["ownerGroupId"] = this.ownerGroupId;
        data["cyclesSinceLastOutput"] = this.cyclesSinceLastOutput;
        data["pressSeries"] = this.pressSeries;
        data["pressSeriesSinceLastOutput"] = this.pressSeriesSinceLastOutput;
        data["comments"] = this.comments;
        data["internalComment"] = this.internalComment;
        data["daysSinceInstalled"] = this.daysSinceInstalled;
        data["containerSize"] = this.containerSize;
        data["modemName"] = this.modemName;
        data["baleCountAtLastPickup"] = this.baleCountAtLastPickup;
        data["totalBaleCountAtStorage"] = this.totalBaleCountAtStorage;
        data["baleStorageSize"] = this.baleStorageSize;
        data["automaticBaleCountReset"] = this.automaticBaleCountReset;
        data["countLinkedBalers"] = this.countLinkedBalers;
        data["balesOnSite"] = this.balesOnSite;
        data["isBaler"] = this.isBaler;
        data["fullCounterAverage"] = this.fullCounterAverage;
        super.toJSON(data);
        return data;
    }
}

export interface IUnitsDto extends IUnitsAdminDto {
    id: number;
    signalStrength: number;
    lastestChange?: Date | undefined;
    devicePhoneNo?: string | undefined;
    fillLevel?: number | undefined;
    unitId?: string | undefined;
    customerUnitId?: string | undefined;
    manufacturer?: string | undefined;
    unitModel?: string | undefined;
    controllerName?: string | undefined;
    firmwareVersion: number;
    homeLatitude?: string | undefined;
    homeLongitude?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    trackerBatteryLevel?: number | undefined;
    pickupSystem?: string | undefined;
    wasteTypeTranslationKey?: string | undefined;
    serviceContractTypeTranslationKey?: string | undefined;
    collector?: string | undefined;
    distributor?: string | undefined;
    distributorCountry?: string | undefined;
    groupName?: string | undefined;
    siteUser?: string | undefined;
    siteAddress?: string | undefined;
    siteDescription?: string | undefined;
    siteCity?: string | undefined;
    sitePostalCode?: string | undefined;
    ownershipTranslationKey?: string | undefined;
    installationDate?: Date | undefined;
    warrantyExpires?: Date | undefined;
    lastService?: Date | undefined;
    nextService?: Date | undefined;
    unitsEmptied: number;
    unitsEmptiedThirtyDays?: number | undefined;
    averageCyclesPerUnitEmptiedThirtyDays?: number | undefined;
    totalRunningHours: number;
    totalNumberOfCycles: number;
    unitTypeName?: string | undefined;
    errorAndSeverities?: ErrorAndSeverity[] | undefined;
    hasModem: boolean;
    isOnline: boolean;
    ownerGroupId: number;
    cyclesSinceLastOutput: number;
    pressSeries: number;
    pressSeriesSinceLastOutput: number;
    comments?: string | undefined;
    internalComment?: string | undefined;
    daysSinceInstalled?: number | undefined;
    containerSize?: number | undefined;
    modemName?: string | undefined;
    baleCountAtLastPickup?: number | undefined;
    totalBaleCountAtStorage?: number | undefined;
    baleStorageSize?: number | undefined;
    automaticBaleCountReset?: boolean | undefined;
    countLinkedBalers?: number | undefined;
    balesOnSite?: number | undefined;
    isBaler: boolean;
    fullCounterAverage?: number | undefined;
}

export class UnitWithDocumentsDto implements IUnitWithDocumentsDto {
    id!: number;
    unitId?: string | undefined;
    userManual?: string | undefined;
    userManual2?: string | undefined;
    userManual3?: string | undefined;
    userVideo?: string | undefined;
    userVideo2?: string | undefined;
    userVideo3?: string | undefined;
    unitModelName?: string | undefined;
    modelImage?: string | undefined;
    hasModem!: boolean;
    isOnline!: boolean;

    constructor(data?: IUnitWithDocumentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.unitId = _data["unitId"];
            this.userManual = _data["userManual"];
            this.userManual2 = _data["userManual2"];
            this.userManual3 = _data["userManual3"];
            this.userVideo = _data["userVideo"];
            this.userVideo2 = _data["userVideo2"];
            this.userVideo3 = _data["userVideo3"];
            this.unitModelName = _data["unitModelName"];
            this.modelImage = _data["modelImage"];
            this.hasModem = _data["hasModem"];
            this.isOnline = _data["isOnline"];
        }
    }

    static fromJS(data: any): UnitWithDocumentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitWithDocumentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitId"] = this.unitId;
        data["userManual"] = this.userManual;
        data["userManual2"] = this.userManual2;
        data["userManual3"] = this.userManual3;
        data["userVideo"] = this.userVideo;
        data["userVideo2"] = this.userVideo2;
        data["userVideo3"] = this.userVideo3;
        data["unitModelName"] = this.unitModelName;
        data["modelImage"] = this.modelImage;
        data["hasModem"] = this.hasModem;
        data["isOnline"] = this.isOnline;
        return data;
    }
}

export interface IUnitWithDocumentsDto {
    id: number;
    unitId?: string | undefined;
    userManual?: string | undefined;
    userManual2?: string | undefined;
    userManual3?: string | undefined;
    userVideo?: string | undefined;
    userVideo2?: string | undefined;
    userVideo3?: string | undefined;
    unitModelName?: string | undefined;
    modelImage?: string | undefined;
    hasModem: boolean;
    isOnline: boolean;
}

export class FilterOptionDto implements IFilterOptionDto {
    unitGroups?: string[] | undefined;
    unitIds?: string[] | undefined;
    unitModels?: KeyValuePairOfStringAndString[] | undefined;
    status?: string[] | undefined;
    fillLevel?: number[] | undefined;
    wasteTypes?: string[] | undefined;
    containerSize?: number[] | undefined;

    constructor(data?: IFilterOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["unitGroups"])) {
                this.unitGroups = [] as any;
                for (let item of _data["unitGroups"])
                    this.unitGroups!.push(item);
            }
            if (Array.isArray(_data["unitIds"])) {
                this.unitIds = [] as any;
                for (let item of _data["unitIds"])
                    this.unitIds!.push(item);
            }
            if (Array.isArray(_data["unitModels"])) {
                this.unitModels = [] as any;
                for (let item of _data["unitModels"])
                    this.unitModels!.push(KeyValuePairOfStringAndString.fromJS(item));
            }
            if (Array.isArray(_data["status"])) {
                this.status = [] as any;
                for (let item of _data["status"])
                    this.status!.push(item);
            }
            if (Array.isArray(_data["fillLevel"])) {
                this.fillLevel = [] as any;
                for (let item of _data["fillLevel"])
                    this.fillLevel!.push(item);
            }
            if (Array.isArray(_data["wasteTypes"])) {
                this.wasteTypes = [] as any;
                for (let item of _data["wasteTypes"])
                    this.wasteTypes!.push(item);
            }
            if (Array.isArray(_data["containerSize"])) {
                this.containerSize = [] as any;
                for (let item of _data["containerSize"])
                    this.containerSize!.push(item);
            }
        }
    }

    static fromJS(data: any): FilterOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FilterOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.unitGroups)) {
            data["unitGroups"] = [];
            for (let item of this.unitGroups)
                data["unitGroups"].push(item);
        }
        if (Array.isArray(this.unitIds)) {
            data["unitIds"] = [];
            for (let item of this.unitIds)
                data["unitIds"].push(item);
        }
        if (Array.isArray(this.unitModels)) {
            data["unitModels"] = [];
            for (let item of this.unitModels)
                data["unitModels"].push(item.toJSON());
        }
        if (Array.isArray(this.status)) {
            data["status"] = [];
            for (let item of this.status)
                data["status"].push(item);
        }
        if (Array.isArray(this.fillLevel)) {
            data["fillLevel"] = [];
            for (let item of this.fillLevel)
                data["fillLevel"].push(item);
        }
        if (Array.isArray(this.wasteTypes)) {
            data["wasteTypes"] = [];
            for (let item of this.wasteTypes)
                data["wasteTypes"].push(item);
        }
        if (Array.isArray(this.containerSize)) {
            data["containerSize"] = [];
            for (let item of this.containerSize)
                data["containerSize"].push(item);
        }
        return data;
    }
}

export interface IFilterOptionDto {
    unitGroups?: string[] | undefined;
    unitIds?: string[] | undefined;
    unitModels?: KeyValuePairOfStringAndString[] | undefined;
    status?: string[] | undefined;
    fillLevel?: number[] | undefined;
    wasteTypes?: string[] | undefined;
    containerSize?: number[] | undefined;
}

export class KeyValuePairOfStringAndString implements IKeyValuePairOfStringAndString {
    key?: string | undefined;
    value?: string | undefined;

    constructor(data?: IKeyValuePairOfStringAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValuePairOfStringAndString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairOfStringAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IKeyValuePairOfStringAndString {
    key?: string | undefined;
    value?: string | undefined;
}

export class MoveUnitDto implements IMoveUnitDto {
    newGroupId!: number;
    unitIds?: number[] | undefined;

    constructor(data?: IMoveUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newGroupId = _data["newGroupId"];
            if (Array.isArray(_data["unitIds"])) {
                this.unitIds = [] as any;
                for (let item of _data["unitIds"])
                    this.unitIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MoveUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newGroupId"] = this.newGroupId;
        if (Array.isArray(this.unitIds)) {
            data["unitIds"] = [];
            for (let item of this.unitIds)
                data["unitIds"].push(item);
        }
        return data;
    }
}

export interface IMoveUnitDto {
    newGroupId: number;
    unitIds?: number[] | undefined;
}

export class CreateUnitDto implements ICreateUnitDto {
    serialNumber?: string | undefined;
    groupId!: number;
    unitModelId!: number;

    constructor(data?: ICreateUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serialNumber = _data["serialNumber"];
            this.groupId = _data["groupId"];
            this.unitModelId = _data["unitModelId"];
        }
    }

    static fromJS(data: any): CreateUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serialNumber"] = this.serialNumber;
        data["groupId"] = this.groupId;
        data["unitModelId"] = this.unitModelId;
        return data;
    }
}

export interface ICreateUnitDto {
    serialNumber?: string | undefined;
    groupId: number;
    unitModelId: number;
}

export class UnitDetailsDto implements IUnitDetailsDto {
    id!: number;
    signalStrength!: number;
    fillLevel?: number | undefined;
    baleStorageId?: number | undefined;
    baleStorageDevices?: number[] | undefined;
    baleStorageSize?: number | undefined;
    baleCountLastPickup?: number | undefined;
    totalBaleCountAtStorage?: number | undefined;
    automaticBaleCountReset?: boolean | undefined;
    balesOnSite?: number | undefined;
    unitId?: string | undefined;
    controllerName?: string | undefined;
    unitModelId?: number | undefined;
    siteUser?: string | undefined;
    lastestChange?: Date | undefined;
    pickupSystem?: string | undefined;
    unitPickupSystemId?: number | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    homeLatitude?: string | undefined;
    homeLongitude?: string | undefined;
    lastTrackerUpdate?: Date | undefined;
    totalRunningHours!: number;
    emptyCounter!: number;
    totalNumberOfCycles!: number;
    cyclesSinceLastOutput!: number;
    totalNumberOfPressSeries!: number;
    pressSeriesSinceLastOutput!: number;
    devicePhoneNo?: string | undefined;
    unitTypeName?: string | undefined;
    unitModelName?: string | undefined;
    collector?: string | undefined;
    comment?: string | undefined;
    internalComment?: string | undefined;
    distributor?: string | undefined;
    distributorCountry?: string | undefined;
    customerUnitId?: string | undefined;
    serviceContractTypeId?: number | undefined;
    wasteTypeId?: number | undefined;
    manufacturerId?: number | undefined;
    ownerGroupId?: number | undefined;
    ownershipId?: number | undefined;
    unitTypeId?: number | undefined;
    lastService?: Date | undefined;
    nextService?: Date | undefined;
    warrantyExpires?: Date | undefined;
    installationDate?: Date | undefined;
    siteCity?: string | undefined;
    sitePostalCode?: string | undefined;
    siteDescription?: string | undefined;
    siteAddress?: string | undefined;
    gpsLocation?: string | undefined;
    gpsHomeLocation?: string | undefined;
    errorAndSeverities?: ErrorAndSeverity[] | undefined;
    hasModem!: boolean;
    isOnline!: boolean;
    weightId?: string | undefined;
    currentWeight?: number | undefined;
    lastBaleOutput?: number | undefined;
    weightLastUpdate?: Date | undefined;
    weightAndDateData?: FloatAndDateMap[] | undefined;
    lastXBalesData?: FloatAndDateMap[] | undefined;
    containerSize!: number;
    unitDocument?: UnitDocument | undefined;
    pricePerEmptying?: number | undefined;
    pricePerEmptyingCurrency?: string | undefined;
    optimizationProjectEnabledFor!: RolesType;
    isBaler!: boolean;
    potentialLinkingMachines?: PotentialLinkingMachineDto[] | undefined;
    customXtelMessage?: string | undefined;
    extendedDistributor?: GetDebtorDto | undefined;
    isFavourite!: boolean;

    constructor(data?: IUnitDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.signalStrength = _data["signalStrength"];
            this.fillLevel = _data["fillLevel"];
            this.baleStorageId = _data["baleStorageId"];
            if (Array.isArray(_data["baleStorageDevices"])) {
                this.baleStorageDevices = [] as any;
                for (let item of _data["baleStorageDevices"])
                    this.baleStorageDevices!.push(item);
            }
            this.baleStorageSize = _data["baleStorageSize"];
            this.baleCountLastPickup = _data["baleCountLastPickup"];
            this.totalBaleCountAtStorage = _data["totalBaleCountAtStorage"];
            this.automaticBaleCountReset = _data["automaticBaleCountReset"];
            this.balesOnSite = _data["balesOnSite"];
            this.unitId = _data["unitId"];
            this.controllerName = _data["controllerName"];
            this.unitModelId = _data["unitModelId"];
            this.siteUser = _data["siteUser"];
            this.lastestChange = _data["lastestChange"] ? new Date(_data["lastestChange"].toString()) : <any>undefined;
            this.pickupSystem = _data["pickupSystem"];
            this.unitPickupSystemId = _data["unitPickupSystemId"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.homeLatitude = _data["homeLatitude"];
            this.homeLongitude = _data["homeLongitude"];
            this.lastTrackerUpdate = _data["lastTrackerUpdate"] ? new Date(_data["lastTrackerUpdate"].toString()) : <any>undefined;
            this.totalRunningHours = _data["totalRunningHours"];
            this.emptyCounter = _data["emptyCounter"];
            this.totalNumberOfCycles = _data["totalNumberOfCycles"];
            this.cyclesSinceLastOutput = _data["cyclesSinceLastOutput"];
            this.totalNumberOfPressSeries = _data["totalNumberOfPressSeries"];
            this.pressSeriesSinceLastOutput = _data["pressSeriesSinceLastOutput"];
            this.devicePhoneNo = _data["devicePhoneNo"];
            this.unitTypeName = _data["unitTypeName"];
            this.unitModelName = _data["unitModelName"];
            this.collector = _data["collector"];
            this.comment = _data["comment"];
            this.internalComment = _data["internalComment"];
            this.distributor = _data["distributor"];
            this.distributorCountry = _data["distributorCountry"];
            this.customerUnitId = _data["customerUnitId"];
            this.serviceContractTypeId = _data["serviceContractTypeId"];
            this.wasteTypeId = _data["wasteTypeId"];
            this.manufacturerId = _data["manufacturerId"];
            this.ownerGroupId = _data["ownerGroupId"];
            this.ownershipId = _data["ownershipId"];
            this.unitTypeId = _data["unitTypeId"];
            this.lastService = _data["lastService"] ? new Date(_data["lastService"].toString()) : <any>undefined;
            this.nextService = _data["nextService"] ? new Date(_data["nextService"].toString()) : <any>undefined;
            this.warrantyExpires = _data["warrantyExpires"] ? new Date(_data["warrantyExpires"].toString()) : <any>undefined;
            this.installationDate = _data["installationDate"] ? new Date(_data["installationDate"].toString()) : <any>undefined;
            this.siteCity = _data["siteCity"];
            this.sitePostalCode = _data["sitePostalCode"];
            this.siteDescription = _data["siteDescription"];
            this.siteAddress = _data["siteAddress"];
            this.gpsLocation = _data["gpsLocation"];
            this.gpsHomeLocation = _data["gpsHomeLocation"];
            if (Array.isArray(_data["errorAndSeverities"])) {
                this.errorAndSeverities = [] as any;
                for (let item of _data["errorAndSeverities"])
                    this.errorAndSeverities!.push(ErrorAndSeverity.fromJS(item));
            }
            this.hasModem = _data["hasModem"];
            this.isOnline = _data["isOnline"];
            this.weightId = _data["weightId"];
            this.currentWeight = _data["currentWeight"];
            this.lastBaleOutput = _data["lastBaleOutput"];
            this.weightLastUpdate = _data["weightLastUpdate"] ? new Date(_data["weightLastUpdate"].toString()) : <any>undefined;
            if (Array.isArray(_data["weightAndDateData"])) {
                this.weightAndDateData = [] as any;
                for (let item of _data["weightAndDateData"])
                    this.weightAndDateData!.push(FloatAndDateMap.fromJS(item));
            }
            if (Array.isArray(_data["lastXBalesData"])) {
                this.lastXBalesData = [] as any;
                for (let item of _data["lastXBalesData"])
                    this.lastXBalesData!.push(FloatAndDateMap.fromJS(item));
            }
            this.containerSize = _data["containerSize"];
            this.unitDocument = _data["unitDocument"] ? UnitDocument.fromJS(_data["unitDocument"]) : <any>undefined;
            this.pricePerEmptying = _data["pricePerEmptying"];
            this.pricePerEmptyingCurrency = _data["pricePerEmptyingCurrency"];
            this.optimizationProjectEnabledFor = _data["optimizationProjectEnabledFor"];
            this.isBaler = _data["isBaler"];
            if (Array.isArray(_data["potentialLinkingMachines"])) {
                this.potentialLinkingMachines = [] as any;
                for (let item of _data["potentialLinkingMachines"])
                    this.potentialLinkingMachines!.push(PotentialLinkingMachineDto.fromJS(item));
            }
            this.customXtelMessage = _data["customXtelMessage"];
            this.extendedDistributor = _data["extendedDistributor"] ? GetDebtorDto.fromJS(_data["extendedDistributor"]) : <any>undefined;
            this.isFavourite = _data["isFavourite"];
        }
    }

    static fromJS(data: any): UnitDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["signalStrength"] = this.signalStrength;
        data["fillLevel"] = this.fillLevel;
        data["baleStorageId"] = this.baleStorageId;
        if (Array.isArray(this.baleStorageDevices)) {
            data["baleStorageDevices"] = [];
            for (let item of this.baleStorageDevices)
                data["baleStorageDevices"].push(item);
        }
        data["baleStorageSize"] = this.baleStorageSize;
        data["baleCountLastPickup"] = this.baleCountLastPickup;
        data["totalBaleCountAtStorage"] = this.totalBaleCountAtStorage;
        data["automaticBaleCountReset"] = this.automaticBaleCountReset;
        data["balesOnSite"] = this.balesOnSite;
        data["unitId"] = this.unitId;
        data["controllerName"] = this.controllerName;
        data["unitModelId"] = this.unitModelId;
        data["siteUser"] = this.siteUser;
        data["lastestChange"] = this.lastestChange ? this.lastestChange.toISOString() : <any>undefined;
        data["pickupSystem"] = this.pickupSystem;
        data["unitPickupSystemId"] = this.unitPickupSystemId;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["homeLatitude"] = this.homeLatitude;
        data["homeLongitude"] = this.homeLongitude;
        data["lastTrackerUpdate"] = this.lastTrackerUpdate ? this.lastTrackerUpdate.toISOString() : <any>undefined;
        data["totalRunningHours"] = this.totalRunningHours;
        data["emptyCounter"] = this.emptyCounter;
        data["totalNumberOfCycles"] = this.totalNumberOfCycles;
        data["cyclesSinceLastOutput"] = this.cyclesSinceLastOutput;
        data["totalNumberOfPressSeries"] = this.totalNumberOfPressSeries;
        data["pressSeriesSinceLastOutput"] = this.pressSeriesSinceLastOutput;
        data["devicePhoneNo"] = this.devicePhoneNo;
        data["unitTypeName"] = this.unitTypeName;
        data["unitModelName"] = this.unitModelName;
        data["collector"] = this.collector;
        data["comment"] = this.comment;
        data["internalComment"] = this.internalComment;
        data["distributor"] = this.distributor;
        data["distributorCountry"] = this.distributorCountry;
        data["customerUnitId"] = this.customerUnitId;
        data["serviceContractTypeId"] = this.serviceContractTypeId;
        data["wasteTypeId"] = this.wasteTypeId;
        data["manufacturerId"] = this.manufacturerId;
        data["ownerGroupId"] = this.ownerGroupId;
        data["ownershipId"] = this.ownershipId;
        data["unitTypeId"] = this.unitTypeId;
        data["lastService"] = this.lastService ? this.lastService.toISOString() : <any>undefined;
        data["nextService"] = this.nextService ? this.nextService.toISOString() : <any>undefined;
        data["warrantyExpires"] = this.warrantyExpires ? this.warrantyExpires.toISOString() : <any>undefined;
        data["installationDate"] = this.installationDate ? this.installationDate.toISOString() : <any>undefined;
        data["siteCity"] = this.siteCity;
        data["sitePostalCode"] = this.sitePostalCode;
        data["siteDescription"] = this.siteDescription;
        data["siteAddress"] = this.siteAddress;
        data["gpsLocation"] = this.gpsLocation;
        data["gpsHomeLocation"] = this.gpsHomeLocation;
        if (Array.isArray(this.errorAndSeverities)) {
            data["errorAndSeverities"] = [];
            for (let item of this.errorAndSeverities)
                data["errorAndSeverities"].push(item.toJSON());
        }
        data["hasModem"] = this.hasModem;
        data["isOnline"] = this.isOnline;
        data["weightId"] = this.weightId;
        data["currentWeight"] = this.currentWeight;
        data["lastBaleOutput"] = this.lastBaleOutput;
        data["weightLastUpdate"] = this.weightLastUpdate ? this.weightLastUpdate.toISOString() : <any>undefined;
        if (Array.isArray(this.weightAndDateData)) {
            data["weightAndDateData"] = [];
            for (let item of this.weightAndDateData)
                data["weightAndDateData"].push(item.toJSON());
        }
        if (Array.isArray(this.lastXBalesData)) {
            data["lastXBalesData"] = [];
            for (let item of this.lastXBalesData)
                data["lastXBalesData"].push(item.toJSON());
        }
        data["containerSize"] = this.containerSize;
        data["unitDocument"] = this.unitDocument ? this.unitDocument.toJSON() : <any>undefined;
        data["pricePerEmptying"] = this.pricePerEmptying;
        data["pricePerEmptyingCurrency"] = this.pricePerEmptyingCurrency;
        data["optimizationProjectEnabledFor"] = this.optimizationProjectEnabledFor;
        data["isBaler"] = this.isBaler;
        if (Array.isArray(this.potentialLinkingMachines)) {
            data["potentialLinkingMachines"] = [];
            for (let item of this.potentialLinkingMachines)
                data["potentialLinkingMachines"].push(item.toJSON());
        }
        data["customXtelMessage"] = this.customXtelMessage;
        data["extendedDistributor"] = this.extendedDistributor ? this.extendedDistributor.toJSON() : <any>undefined;
        data["isFavourite"] = this.isFavourite;
        return data;
    }
}

export interface IUnitDetailsDto {
    id: number;
    signalStrength: number;
    fillLevel?: number | undefined;
    baleStorageId?: number | undefined;
    baleStorageDevices?: number[] | undefined;
    baleStorageSize?: number | undefined;
    baleCountLastPickup?: number | undefined;
    totalBaleCountAtStorage?: number | undefined;
    automaticBaleCountReset?: boolean | undefined;
    balesOnSite?: number | undefined;
    unitId?: string | undefined;
    controllerName?: string | undefined;
    unitModelId?: number | undefined;
    siteUser?: string | undefined;
    lastestChange?: Date | undefined;
    pickupSystem?: string | undefined;
    unitPickupSystemId?: number | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    homeLatitude?: string | undefined;
    homeLongitude?: string | undefined;
    lastTrackerUpdate?: Date | undefined;
    totalRunningHours: number;
    emptyCounter: number;
    totalNumberOfCycles: number;
    cyclesSinceLastOutput: number;
    totalNumberOfPressSeries: number;
    pressSeriesSinceLastOutput: number;
    devicePhoneNo?: string | undefined;
    unitTypeName?: string | undefined;
    unitModelName?: string | undefined;
    collector?: string | undefined;
    comment?: string | undefined;
    internalComment?: string | undefined;
    distributor?: string | undefined;
    distributorCountry?: string | undefined;
    customerUnitId?: string | undefined;
    serviceContractTypeId?: number | undefined;
    wasteTypeId?: number | undefined;
    manufacturerId?: number | undefined;
    ownerGroupId?: number | undefined;
    ownershipId?: number | undefined;
    unitTypeId?: number | undefined;
    lastService?: Date | undefined;
    nextService?: Date | undefined;
    warrantyExpires?: Date | undefined;
    installationDate?: Date | undefined;
    siteCity?: string | undefined;
    sitePostalCode?: string | undefined;
    siteDescription?: string | undefined;
    siteAddress?: string | undefined;
    gpsLocation?: string | undefined;
    gpsHomeLocation?: string | undefined;
    errorAndSeverities?: ErrorAndSeverity[] | undefined;
    hasModem: boolean;
    isOnline: boolean;
    weightId?: string | undefined;
    currentWeight?: number | undefined;
    lastBaleOutput?: number | undefined;
    weightLastUpdate?: Date | undefined;
    weightAndDateData?: FloatAndDateMap[] | undefined;
    lastXBalesData?: FloatAndDateMap[] | undefined;
    containerSize: number;
    unitDocument?: UnitDocument | undefined;
    pricePerEmptying?: number | undefined;
    pricePerEmptyingCurrency?: string | undefined;
    optimizationProjectEnabledFor: RolesType;
    isBaler: boolean;
    potentialLinkingMachines?: PotentialLinkingMachineDto[] | undefined;
    customXtelMessage?: string | undefined;
    extendedDistributor?: GetDebtorDto | undefined;
    isFavourite: boolean;
}

export class FloatAndDateMap implements IFloatAndDateMap {
    floatVal!: number;
    dateVal?: Date | undefined;

    constructor(data?: IFloatAndDateMap) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.floatVal = _data["floatVal"];
            this.dateVal = _data["dateVal"] ? new Date(_data["dateVal"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FloatAndDateMap {
        data = typeof data === 'object' ? data : {};
        let result = new FloatAndDateMap();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["floatVal"] = this.floatVal;
        data["dateVal"] = this.dateVal ? this.dateVal.toISOString() : <any>undefined;
        return data;
    }
}

export interface IFloatAndDateMap {
    floatVal: number;
    dateVal?: Date | undefined;
}

export class PotentialLinkingMachineDto implements IPotentialLinkingMachineDto {
    id!: number;
    serialNumber?: string | undefined;
    modelName?: string | undefined;
    wasteType?: string | undefined;

    constructor(data?: IPotentialLinkingMachineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serialNumber = _data["serialNumber"];
            this.modelName = _data["modelName"];
            this.wasteType = _data["wasteType"];
        }
    }

    static fromJS(data: any): PotentialLinkingMachineDto {
        data = typeof data === 'object' ? data : {};
        let result = new PotentialLinkingMachineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serialNumber"] = this.serialNumber;
        data["modelName"] = this.modelName;
        data["wasteType"] = this.wasteType;
        return data;
    }
}

export interface IPotentialLinkingMachineDto {
    id: number;
    serialNumber?: string | undefined;
    modelName?: string | undefined;
    wasteType?: string | undefined;
}

export class DropdownDataDto implements IDropdownDataDto {
    pickupSystems?: UnitPickupSystem[] | undefined;
    wasteTypes?: UnitWasteType[] | undefined;
    serviceContractTypes?: UnitServiceContractType[] | undefined;
    ownerShips?: UnitOwnership[] | undefined;
    manufacturers?: UnitManufacturer[] | undefined;
    unitModels?: UnitModel[] | undefined;
    unitTypes?: UnitType[] | undefined;
    containerSizes?: MachineNameContainerSizeDto[] | undefined;

    constructor(data?: IDropdownDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["pickupSystems"])) {
                this.pickupSystems = [] as any;
                for (let item of _data["pickupSystems"])
                    this.pickupSystems!.push(UnitPickupSystem.fromJS(item));
            }
            if (Array.isArray(_data["wasteTypes"])) {
                this.wasteTypes = [] as any;
                for (let item of _data["wasteTypes"])
                    this.wasteTypes!.push(UnitWasteType.fromJS(item));
            }
            if (Array.isArray(_data["serviceContractTypes"])) {
                this.serviceContractTypes = [] as any;
                for (let item of _data["serviceContractTypes"])
                    this.serviceContractTypes!.push(UnitServiceContractType.fromJS(item));
            }
            if (Array.isArray(_data["ownerShips"])) {
                this.ownerShips = [] as any;
                for (let item of _data["ownerShips"])
                    this.ownerShips!.push(UnitOwnership.fromJS(item));
            }
            if (Array.isArray(_data["manufacturers"])) {
                this.manufacturers = [] as any;
                for (let item of _data["manufacturers"])
                    this.manufacturers!.push(UnitManufacturer.fromJS(item));
            }
            if (Array.isArray(_data["unitModels"])) {
                this.unitModels = [] as any;
                for (let item of _data["unitModels"])
                    this.unitModels!.push(UnitModel.fromJS(item));
            }
            if (Array.isArray(_data["unitTypes"])) {
                this.unitTypes = [] as any;
                for (let item of _data["unitTypes"])
                    this.unitTypes!.push(UnitType.fromJS(item));
            }
            if (Array.isArray(_data["containerSizes"])) {
                this.containerSizes = [] as any;
                for (let item of _data["containerSizes"])
                    this.containerSizes!.push(MachineNameContainerSizeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DropdownDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new DropdownDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pickupSystems)) {
            data["pickupSystems"] = [];
            for (let item of this.pickupSystems)
                data["pickupSystems"].push(item.toJSON());
        }
        if (Array.isArray(this.wasteTypes)) {
            data["wasteTypes"] = [];
            for (let item of this.wasteTypes)
                data["wasteTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.serviceContractTypes)) {
            data["serviceContractTypes"] = [];
            for (let item of this.serviceContractTypes)
                data["serviceContractTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.ownerShips)) {
            data["ownerShips"] = [];
            for (let item of this.ownerShips)
                data["ownerShips"].push(item.toJSON());
        }
        if (Array.isArray(this.manufacturers)) {
            data["manufacturers"] = [];
            for (let item of this.manufacturers)
                data["manufacturers"].push(item.toJSON());
        }
        if (Array.isArray(this.unitModels)) {
            data["unitModels"] = [];
            for (let item of this.unitModels)
                data["unitModels"].push(item.toJSON());
        }
        if (Array.isArray(this.unitTypes)) {
            data["unitTypes"] = [];
            for (let item of this.unitTypes)
                data["unitTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.containerSizes)) {
            data["containerSizes"] = [];
            for (let item of this.containerSizes)
                data["containerSizes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDropdownDataDto {
    pickupSystems?: UnitPickupSystem[] | undefined;
    wasteTypes?: UnitWasteType[] | undefined;
    serviceContractTypes?: UnitServiceContractType[] | undefined;
    ownerShips?: UnitOwnership[] | undefined;
    manufacturers?: UnitManufacturer[] | undefined;
    unitModels?: UnitModel[] | undefined;
    unitTypes?: UnitType[] | undefined;
    containerSizes?: MachineNameContainerSizeDto[] | undefined;
}

export class MachineNameContainerSizeDto implements IMachineNameContainerSizeDto {
    machineName?: string | undefined;
    containerSize?: number[] | undefined;

    constructor(data?: IMachineNameContainerSizeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.machineName = _data["machineName"];
            if (Array.isArray(_data["containerSize"])) {
                this.containerSize = [] as any;
                for (let item of _data["containerSize"])
                    this.containerSize!.push(item);
            }
        }
    }

    static fromJS(data: any): MachineNameContainerSizeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MachineNameContainerSizeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["machineName"] = this.machineName;
        if (Array.isArray(this.containerSize)) {
            data["containerSize"] = [];
            for (let item of this.containerSize)
                data["containerSize"].push(item);
        }
        return data;
    }
}

export interface IMachineNameContainerSizeDto {
    machineName?: string | undefined;
    containerSize?: number[] | undefined;
}

export class LinkedUnitExtraInfoDto implements ILinkedUnitExtraInfoDto {
    id!: number;
    unitId?: string | undefined;
    unitModel?: string | undefined;
    groupName?: string | undefined;
    siteAddress?: string | undefined;
    siteCity?: string | undefined;
    siteUser?: string | undefined;
    unitTypeName?: string | undefined;
    controllerTypeName?: string | undefined;
    errors?: ErrorAndSeverity[] | undefined;

    constructor(data?: ILinkedUnitExtraInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.unitId = _data["unitId"];
            this.unitModel = _data["unitModel"];
            this.groupName = _data["groupName"];
            this.siteAddress = _data["siteAddress"];
            this.siteCity = _data["siteCity"];
            this.siteUser = _data["siteUser"];
            this.unitTypeName = _data["unitTypeName"];
            this.controllerTypeName = _data["controllerTypeName"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorAndSeverity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LinkedUnitExtraInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedUnitExtraInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitId"] = this.unitId;
        data["unitModel"] = this.unitModel;
        data["groupName"] = this.groupName;
        data["siteAddress"] = this.siteAddress;
        data["siteCity"] = this.siteCity;
        data["siteUser"] = this.siteUser;
        data["unitTypeName"] = this.unitTypeName;
        data["controllerTypeName"] = this.controllerTypeName;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILinkedUnitExtraInfoDto {
    id: number;
    unitId?: string | undefined;
    unitModel?: string | undefined;
    groupName?: string | undefined;
    siteAddress?: string | undefined;
    siteCity?: string | undefined;
    siteUser?: string | undefined;
    unitTypeName?: string | undefined;
    controllerTypeName?: string | undefined;
    errors?: ErrorAndSeverity[] | undefined;
}

export class MachineExcelQuery implements IMachineExcelQuery {
    filter?: FilterDto | undefined;
    machineIds?: number[] | undefined;

    constructor(data?: IMachineExcelQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"] ? FilterDto.fromJS(_data["filter"]) : <any>undefined;
            if (Array.isArray(_data["machineIds"])) {
                this.machineIds = [] as any;
                for (let item of _data["machineIds"])
                    this.machineIds!.push(item);
            }
        }
    }

    static fromJS(data: any): MachineExcelQuery {
        data = typeof data === 'object' ? data : {};
        let result = new MachineExcelQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        if (Array.isArray(this.machineIds)) {
            data["machineIds"] = [];
            for (let item of this.machineIds)
                data["machineIds"].push(item);
        }
        return data;
    }
}

export interface IMachineExcelQuery {
    filter?: FilterDto | undefined;
    machineIds?: number[] | undefined;
}

export class UnitImageDto implements IUnitImageDto {
    unitModelName?: string | undefined;
    unitId!: number;
    imageBase64?: string | undefined;

    constructor(data?: IUnitImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitModelName = _data["unitModelName"];
            this.unitId = _data["unitId"];
            this.imageBase64 = _data["imageBase64"];
        }
    }

    static fromJS(data: any): UnitImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitModelName"] = this.unitModelName;
        data["unitId"] = this.unitId;
        data["imageBase64"] = this.imageBase64;
        return data;
    }
}

export interface IUnitImageDto {
    unitModelName?: string | undefined;
    unitId: number;
    imageBase64?: string | undefined;
}

export class UnitWithLocationDto implements IUnitWithLocationDto {
    unitModel?: string | undefined;
    customerUnitId?: string | undefined;
    location?: string | undefined;
    siteUser?: string | undefined;
    wasteTypeTranslationKey?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    gpsLocation?: string | undefined;
    gpsLatitude?: string | undefined;
    gpsLongitude?: string | undefined;
    homeLatitude?: string | undefined;
    homeLongitude?: string | undefined;
    hasModem!: boolean;
    isOnline!: boolean;
    devicePhoneNo?: string | undefined;
    unitId?: string | undefined;
    warrantyExpires?: Date | undefined;
    ownershipTranslationKey?: string | undefined;
    serviceContractTypeTranslationKey?: string | undefined;
    updatedDate?: Date | undefined;
    machineGroupsName?: string | undefined;
    fillLevel?: number | undefined;
    errorAndSeverities?: ErrorAndSeverity[] | undefined;
    controllerName?: string | undefined;
    id!: number;
    ownerGroupId!: number;
    balesOnSite?: number | undefined;
    baleCountAtLastPickup?: number | undefined;
    totalBaleCountAtStorage?: number | undefined;
    baleStorageSize?: number | undefined;
    automaticBaleCountReset?: boolean | undefined;
    isBaler!: boolean;
    groupName?: string | undefined;

    constructor(data?: IUnitWithLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitModel = _data["unitModel"];
            this.customerUnitId = _data["customerUnitId"];
            this.location = _data["location"];
            this.siteUser = _data["siteUser"];
            this.wasteTypeTranslationKey = _data["wasteTypeTranslationKey"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.gpsLocation = _data["gpsLocation"];
            this.gpsLatitude = _data["gpsLatitude"];
            this.gpsLongitude = _data["gpsLongitude"];
            this.homeLatitude = _data["homeLatitude"];
            this.homeLongitude = _data["homeLongitude"];
            this.hasModem = _data["hasModem"];
            this.isOnline = _data["isOnline"];
            this.devicePhoneNo = _data["devicePhoneNo"];
            this.unitId = _data["unitId"];
            this.warrantyExpires = _data["warrantyExpires"] ? new Date(_data["warrantyExpires"].toString()) : <any>undefined;
            this.ownershipTranslationKey = _data["ownershipTranslationKey"];
            this.serviceContractTypeTranslationKey = _data["serviceContractTypeTranslationKey"];
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.machineGroupsName = _data["machineGroupsName"];
            this.fillLevel = _data["fillLevel"];
            if (Array.isArray(_data["errorAndSeverities"])) {
                this.errorAndSeverities = [] as any;
                for (let item of _data["errorAndSeverities"])
                    this.errorAndSeverities!.push(ErrorAndSeverity.fromJS(item));
            }
            this.controllerName = _data["controllerName"];
            this.id = _data["id"];
            this.ownerGroupId = _data["ownerGroupId"];
            this.balesOnSite = _data["balesOnSite"];
            this.baleCountAtLastPickup = _data["baleCountAtLastPickup"];
            this.totalBaleCountAtStorage = _data["totalBaleCountAtStorage"];
            this.baleStorageSize = _data["baleStorageSize"];
            this.automaticBaleCountReset = _data["automaticBaleCountReset"];
            this.isBaler = _data["isBaler"];
            this.groupName = _data["groupName"];
        }
    }

    static fromJS(data: any): UnitWithLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitWithLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitModel"] = this.unitModel;
        data["customerUnitId"] = this.customerUnitId;
        data["location"] = this.location;
        data["siteUser"] = this.siteUser;
        data["wasteTypeTranslationKey"] = this.wasteTypeTranslationKey;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["gpsLocation"] = this.gpsLocation;
        data["gpsLatitude"] = this.gpsLatitude;
        data["gpsLongitude"] = this.gpsLongitude;
        data["homeLatitude"] = this.homeLatitude;
        data["homeLongitude"] = this.homeLongitude;
        data["hasModem"] = this.hasModem;
        data["isOnline"] = this.isOnline;
        data["devicePhoneNo"] = this.devicePhoneNo;
        data["unitId"] = this.unitId;
        data["warrantyExpires"] = this.warrantyExpires ? this.warrantyExpires.toISOString() : <any>undefined;
        data["ownershipTranslationKey"] = this.ownershipTranslationKey;
        data["serviceContractTypeTranslationKey"] = this.serviceContractTypeTranslationKey;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["machineGroupsName"] = this.machineGroupsName;
        data["fillLevel"] = this.fillLevel;
        if (Array.isArray(this.errorAndSeverities)) {
            data["errorAndSeverities"] = [];
            for (let item of this.errorAndSeverities)
                data["errorAndSeverities"].push(item.toJSON());
        }
        data["controllerName"] = this.controllerName;
        data["id"] = this.id;
        data["ownerGroupId"] = this.ownerGroupId;
        data["balesOnSite"] = this.balesOnSite;
        data["baleCountAtLastPickup"] = this.baleCountAtLastPickup;
        data["totalBaleCountAtStorage"] = this.totalBaleCountAtStorage;
        data["baleStorageSize"] = this.baleStorageSize;
        data["automaticBaleCountReset"] = this.automaticBaleCountReset;
        data["isBaler"] = this.isBaler;
        data["groupName"] = this.groupName;
        return data;
    }
}

export interface IUnitWithLocationDto {
    unitModel?: string | undefined;
    customerUnitId?: string | undefined;
    location?: string | undefined;
    siteUser?: string | undefined;
    wasteTypeTranslationKey?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    gpsLocation?: string | undefined;
    gpsLatitude?: string | undefined;
    gpsLongitude?: string | undefined;
    homeLatitude?: string | undefined;
    homeLongitude?: string | undefined;
    hasModem: boolean;
    isOnline: boolean;
    devicePhoneNo?: string | undefined;
    unitId?: string | undefined;
    warrantyExpires?: Date | undefined;
    ownershipTranslationKey?: string | undefined;
    serviceContractTypeTranslationKey?: string | undefined;
    updatedDate?: Date | undefined;
    machineGroupsName?: string | undefined;
    fillLevel?: number | undefined;
    errorAndSeverities?: ErrorAndSeverity[] | undefined;
    controllerName?: string | undefined;
    id: number;
    ownerGroupId: number;
    balesOnSite?: number | undefined;
    baleCountAtLastPickup?: number | undefined;
    totalBaleCountAtStorage?: number | undefined;
    baleStorageSize?: number | undefined;
    automaticBaleCountReset?: boolean | undefined;
    isBaler: boolean;
    groupName?: string | undefined;
}

export class UnitManufacturerDto implements IUnitManufacturerDto {
    id!: number;
    name?: string | undefined;
    isDeletable!: boolean;

    constructor(data?: IUnitManufacturerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isDeletable = _data["isDeletable"];
        }
    }

    static fromJS(data: any): UnitManufacturerDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitManufacturerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isDeletable"] = this.isDeletable;
        return data;
    }
}

export interface IUnitManufacturerDto {
    id: number;
    name?: string | undefined;
    isDeletable: boolean;
}

export class UnitModelCodeDto implements IUnitModelCodeDto {
    id!: number;
    name?: string | undefined;

    constructor(data?: IUnitModelCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UnitModelCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitModelCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUnitModelCodeDto {
    id: number;
    name?: string | undefined;
}

export class UnitModelDto implements IUnitModelDto {
    id!: number;
    name?: string | undefined;
    isUserSelectable!: boolean;
    unitTypeId?: number | undefined;
    unitManufacturerId?: number | undefined;
    unitModelCodeId?: number | undefined;
    isDeletable!: boolean;
    containerDetailDtos?: ContainerDetailDto[] | undefined;

    constructor(data?: IUnitModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isUserSelectable = _data["isUserSelectable"];
            this.unitTypeId = _data["unitTypeId"];
            this.unitManufacturerId = _data["unitManufacturerId"];
            this.unitModelCodeId = _data["unitModelCodeId"];
            this.isDeletable = _data["isDeletable"];
            if (Array.isArray(_data["containerDetailDtos"])) {
                this.containerDetailDtos = [] as any;
                for (let item of _data["containerDetailDtos"])
                    this.containerDetailDtos!.push(ContainerDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UnitModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isUserSelectable"] = this.isUserSelectable;
        data["unitTypeId"] = this.unitTypeId;
        data["unitManufacturerId"] = this.unitManufacturerId;
        data["unitModelCodeId"] = this.unitModelCodeId;
        data["isDeletable"] = this.isDeletable;
        if (Array.isArray(this.containerDetailDtos)) {
            data["containerDetailDtos"] = [];
            for (let item of this.containerDetailDtos)
                data["containerDetailDtos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUnitModelDto {
    id: number;
    name?: string | undefined;
    isUserSelectable: boolean;
    unitTypeId?: number | undefined;
    unitManufacturerId?: number | undefined;
    unitModelCodeId?: number | undefined;
    isDeletable: boolean;
    containerDetailDtos?: ContainerDetailDto[] | undefined;
}

export class ContainerDetailDto implements IContainerDetailDto {
    id!: number;
    containerSize!: number;
    isDeletable!: boolean;

    constructor(data?: IContainerDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.containerSize = _data["containerSize"];
            this.isDeletable = _data["isDeletable"];
        }
    }

    static fromJS(data: any): ContainerDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["containerSize"] = this.containerSize;
        data["isDeletable"] = this.isDeletable;
        return data;
    }
}

export interface IContainerDetailDto {
    id: number;
    containerSize: number;
    isDeletable: boolean;
}

export class UnitReportDto implements IUnitReportDto {
    sumOfFilteredOutBalers!: number;
    sumOfFilteredOutCompactors!: number;
    sumOfOtherEquipment?: number | undefined;
    reportData?: ReportSingleUnitDto[] | undefined;

    constructor(data?: IUnitReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sumOfFilteredOutBalers = _data["sumOfFilteredOutBalers"];
            this.sumOfFilteredOutCompactors = _data["sumOfFilteredOutCompactors"];
            this.sumOfOtherEquipment = _data["sumOfOtherEquipment"];
            if (Array.isArray(_data["reportData"])) {
                this.reportData = [] as any;
                for (let item of _data["reportData"])
                    this.reportData!.push(ReportSingleUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UnitReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sumOfFilteredOutBalers"] = this.sumOfFilteredOutBalers;
        data["sumOfFilteredOutCompactors"] = this.sumOfFilteredOutCompactors;
        data["sumOfOtherEquipment"] = this.sumOfOtherEquipment;
        if (Array.isArray(this.reportData)) {
            data["reportData"] = [];
            for (let item of this.reportData)
                data["reportData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUnitReportDto {
    sumOfFilteredOutBalers: number;
    sumOfFilteredOutCompactors: number;
    sumOfOtherEquipment?: number | undefined;
    reportData?: ReportSingleUnitDto[] | undefined;
}

export class GraphReportDto implements IGraphReportDto {
    dates?: string[] | undefined;
    values?: number[] | undefined;

    constructor(data?: IGraphReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dates"])) {
                this.dates = [] as any;
                for (let item of _data["dates"])
                    this.dates!.push(item);
            }
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): GraphReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new GraphReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dates)) {
            data["dates"] = [];
            for (let item of this.dates)
                data["dates"].push(item);
        }
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        return data;
    }
}

export interface IGraphReportDto {
    dates?: string[] | undefined;
    values?: number[] | undefined;
}

export class TableReportDto implements ITableReportDto {
    dataset?: KeyValuePairOfStringAndString[] | undefined;

    constructor(data?: ITableReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dataset"])) {
                this.dataset = [] as any;
                for (let item of _data["dataset"])
                    this.dataset!.push(KeyValuePairOfStringAndString.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TableReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new TableReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dataset)) {
            data["dataset"] = [];
            for (let item of this.dataset)
                data["dataset"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITableReportDto {
    dataset?: KeyValuePairOfStringAndString[] | undefined;
}

export class UnitSelectedDto implements IUnitSelectedDto {
    id!: number;
    serialNumber?: string | undefined;
    ownerGroupId!: number;
    groupName?: string | undefined;
    modelName?: string | undefined;
    wasteTypeTranslationKey?: string | undefined;
    controllerName?: string | undefined;
    siteUser?: string | undefined;
    siteAddress?: string | undefined;
    siteCity?: string | undefined;
    sitePostalCode?: string | undefined;
    isBaler?: boolean | undefined;

    constructor(data?: IUnitSelectedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serialNumber = _data["serialNumber"];
            this.ownerGroupId = _data["ownerGroupId"];
            this.groupName = _data["groupName"];
            this.modelName = _data["modelName"];
            this.wasteTypeTranslationKey = _data["wasteTypeTranslationKey"];
            this.controllerName = _data["controllerName"];
            this.siteUser = _data["siteUser"];
            this.siteAddress = _data["siteAddress"];
            this.siteCity = _data["siteCity"];
            this.sitePostalCode = _data["sitePostalCode"];
            this.isBaler = _data["isBaler"];
        }
    }

    static fromJS(data: any): UnitSelectedDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitSelectedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serialNumber"] = this.serialNumber;
        data["ownerGroupId"] = this.ownerGroupId;
        data["groupName"] = this.groupName;
        data["modelName"] = this.modelName;
        data["wasteTypeTranslationKey"] = this.wasteTypeTranslationKey;
        data["controllerName"] = this.controllerName;
        data["siteUser"] = this.siteUser;
        data["siteAddress"] = this.siteAddress;
        data["siteCity"] = this.siteCity;
        data["sitePostalCode"] = this.sitePostalCode;
        data["isBaler"] = this.isBaler;
        return data;
    }
}

export interface IUnitSelectedDto {
    id: number;
    serialNumber?: string | undefined;
    ownerGroupId: number;
    groupName?: string | undefined;
    modelName?: string | undefined;
    wasteTypeTranslationKey?: string | undefined;
    controllerName?: string | undefined;
    siteUser?: string | undefined;
    siteAddress?: string | undefined;
    siteCity?: string | undefined;
    sitePostalCode?: string | undefined;
    isBaler?: boolean | undefined;
}

export class UnitStateHistoryDto implements IUnitStateHistoryDto {
    id!: string;
    incrementingCounterForSorting!: number;
    unitSerialNumber?: string | undefined;
    updatedDate!: Date;
    unitsEmptied!: number;
    totalRunningHours!: number;
    totalNumberOfCycles!: number;
    cyclesSinceLastOutput!: number;
    pressSeries!: number;
    pressSeriesSinceLastOutput!: number;
    errors?: ErrorAndSeverity[] | undefined;
    fillLevel!: number;
    balesOnSite?: number | undefined;
    baleStorageSize?: number | undefined;
    signalStrength!: number;
    weightLastOutput?: number | undefined;
    userDefinedWeight?: number | undefined;
    userDefinedComment?: string | undefined;
    hasModem!: boolean;
    isOnline!: boolean;
    cosmosTimestamp!: number;

    constructor(data?: IUnitStateHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.incrementingCounterForSorting = _data["incrementingCounterForSorting"];
            this.unitSerialNumber = _data["unitSerialNumber"];
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
            this.unitsEmptied = _data["unitsEmptied"];
            this.totalRunningHours = _data["totalRunningHours"];
            this.totalNumberOfCycles = _data["totalNumberOfCycles"];
            this.cyclesSinceLastOutput = _data["cyclesSinceLastOutput"];
            this.pressSeries = _data["pressSeries"];
            this.pressSeriesSinceLastOutput = _data["pressSeriesSinceLastOutput"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ErrorAndSeverity.fromJS(item));
            }
            this.fillLevel = _data["fillLevel"];
            this.balesOnSite = _data["balesOnSite"];
            this.baleStorageSize = _data["baleStorageSize"];
            this.signalStrength = _data["signalStrength"];
            this.weightLastOutput = _data["weightLastOutput"];
            this.userDefinedWeight = _data["userDefinedWeight"];
            this.userDefinedComment = _data["userDefinedComment"];
            this.hasModem = _data["hasModem"];
            this.isOnline = _data["isOnline"];
            this.cosmosTimestamp = _data["cosmosTimestamp"];
        }
    }

    static fromJS(data: any): UnitStateHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitStateHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["incrementingCounterForSorting"] = this.incrementingCounterForSorting;
        data["unitSerialNumber"] = this.unitSerialNumber;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
        data["unitsEmptied"] = this.unitsEmptied;
        data["totalRunningHours"] = this.totalRunningHours;
        data["totalNumberOfCycles"] = this.totalNumberOfCycles;
        data["cyclesSinceLastOutput"] = this.cyclesSinceLastOutput;
        data["pressSeries"] = this.pressSeries;
        data["pressSeriesSinceLastOutput"] = this.pressSeriesSinceLastOutput;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["fillLevel"] = this.fillLevel;
        data["balesOnSite"] = this.balesOnSite;
        data["baleStorageSize"] = this.baleStorageSize;
        data["signalStrength"] = this.signalStrength;
        data["weightLastOutput"] = this.weightLastOutput;
        data["userDefinedWeight"] = this.userDefinedWeight;
        data["userDefinedComment"] = this.userDefinedComment;
        data["hasModem"] = this.hasModem;
        data["isOnline"] = this.isOnline;
        data["cosmosTimestamp"] = this.cosmosTimestamp;
        return data;
    }
}

export interface IUnitStateHistoryDto {
    id: string;
    incrementingCounterForSorting: number;
    unitSerialNumber?: string | undefined;
    updatedDate: Date;
    unitsEmptied: number;
    totalRunningHours: number;
    totalNumberOfCycles: number;
    cyclesSinceLastOutput: number;
    pressSeries: number;
    pressSeriesSinceLastOutput: number;
    errors?: ErrorAndSeverity[] | undefined;
    fillLevel: number;
    balesOnSite?: number | undefined;
    baleStorageSize?: number | undefined;
    signalStrength: number;
    weightLastOutput?: number | undefined;
    userDefinedWeight?: number | undefined;
    userDefinedComment?: string | undefined;
    hasModem: boolean;
    isOnline: boolean;
    cosmosTimestamp: number;
}

export class UnitHistoryInfoDto implements IUnitHistoryInfoDto {
    id!: number;
    unitId?: string | undefined;
    ownerGroupId!: number;
    siteAddress?: string | undefined;
    devicePhoneNo?: string | undefined;
    siteUser?: string | undefined;
    siteCity?: string | undefined;
    sitePostalCode?: string | undefined;
    customerUnitId?: string | undefined;
    wasteType?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    fillLevel?: number | undefined;
    homeLatitude?: string | undefined;
    homeLongitude?: string | undefined;
    hasModem!: boolean;
    modemType?: string | undefined;
    isGen2!: boolean;
    isOnline!: boolean;
    isBaler!: boolean;
    unitTypeTranslationKey?: string | undefined;
    errorAndSeverities?: ErrorAndSeverity[] | undefined;

    constructor(data?: IUnitHistoryInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.unitId = _data["unitId"];
            this.ownerGroupId = _data["ownerGroupId"];
            this.siteAddress = _data["siteAddress"];
            this.devicePhoneNo = _data["devicePhoneNo"];
            this.siteUser = _data["siteUser"];
            this.siteCity = _data["siteCity"];
            this.sitePostalCode = _data["sitePostalCode"];
            this.customerUnitId = _data["customerUnitId"];
            this.wasteType = _data["wasteType"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.fillLevel = _data["fillLevel"];
            this.homeLatitude = _data["homeLatitude"];
            this.homeLongitude = _data["homeLongitude"];
            this.hasModem = _data["hasModem"];
            this.modemType = _data["modemType"];
            this.isGen2 = _data["isGen2"];
            this.isOnline = _data["isOnline"];
            this.isBaler = _data["isBaler"];
            this.unitTypeTranslationKey = _data["unitTypeTranslationKey"];
            if (Array.isArray(_data["errorAndSeverities"])) {
                this.errorAndSeverities = [] as any;
                for (let item of _data["errorAndSeverities"])
                    this.errorAndSeverities!.push(ErrorAndSeverity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UnitHistoryInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitHistoryInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["unitId"] = this.unitId;
        data["ownerGroupId"] = this.ownerGroupId;
        data["siteAddress"] = this.siteAddress;
        data["devicePhoneNo"] = this.devicePhoneNo;
        data["siteUser"] = this.siteUser;
        data["siteCity"] = this.siteCity;
        data["sitePostalCode"] = this.sitePostalCode;
        data["customerUnitId"] = this.customerUnitId;
        data["wasteType"] = this.wasteType;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["fillLevel"] = this.fillLevel;
        data["homeLatitude"] = this.homeLatitude;
        data["homeLongitude"] = this.homeLongitude;
        data["hasModem"] = this.hasModem;
        data["modemType"] = this.modemType;
        data["isGen2"] = this.isGen2;
        data["isOnline"] = this.isOnline;
        data["isBaler"] = this.isBaler;
        data["unitTypeTranslationKey"] = this.unitTypeTranslationKey;
        if (Array.isArray(this.errorAndSeverities)) {
            data["errorAndSeverities"] = [];
            for (let item of this.errorAndSeverities)
                data["errorAndSeverities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUnitHistoryInfoDto {
    id: number;
    unitId?: string | undefined;
    ownerGroupId: number;
    siteAddress?: string | undefined;
    devicePhoneNo?: string | undefined;
    siteUser?: string | undefined;
    siteCity?: string | undefined;
    sitePostalCode?: string | undefined;
    customerUnitId?: string | undefined;
    wasteType?: string | undefined;
    latitude?: string | undefined;
    longitude?: string | undefined;
    fillLevel?: number | undefined;
    homeLatitude?: string | undefined;
    homeLongitude?: string | undefined;
    hasModem: boolean;
    modemType?: string | undefined;
    isGen2: boolean;
    isOnline: boolean;
    isBaler: boolean;
    unitTypeTranslationKey?: string | undefined;
    errorAndSeverities?: ErrorAndSeverity[] | undefined;
}

export abstract class PressureChartDto implements IPressureChartDto {
    type!: PressureChartType;
    unitSerialNumber?: string | undefined;
    unitController!: UnitController;
    inputBitmask?: { [key: string]: Bitmask[]; } | undefined;
    outputBitmask?: { [key: string]: Bitmask[]; } | undefined;

    protected _discriminator: string;

    constructor(data?: IPressureChartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "PressureChartDto";
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.unitSerialNumber = _data["unitSerialNumber"];
            this.unitController = _data["unitController"];
            if (_data["inputBitmask"]) {
                this.inputBitmask = {} as any;
                for (let key in _data["inputBitmask"]) {
                    if (_data["inputBitmask"].hasOwnProperty(key))
                        (<any>this.inputBitmask)![key] = _data["inputBitmask"][key] ? _data["inputBitmask"][key].map((i: any) => Bitmask.fromJS(i)) : [];
                }
            }
            if (_data["outputBitmask"]) {
                this.outputBitmask = {} as any;
                for (let key in _data["outputBitmask"]) {
                    if (_data["outputBitmask"].hasOwnProperty(key))
                        (<any>this.outputBitmask)![key] = _data["outputBitmask"][key] ? _data["outputBitmask"][key].map((i: any) => Bitmask.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): PressureChartDto {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "BalerPressureChartDto") {
            let result = new BalerPressureChartDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "CompactorPressureChartDto") {
            let result = new CompactorPressureChartDto();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AugerPressureChartDto") {
            let result = new AugerPressureChartDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'PressureChartDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["type"] = this.type;
        data["unitSerialNumber"] = this.unitSerialNumber;
        data["unitController"] = this.unitController;
        if (this.inputBitmask) {
            data["inputBitmask"] = {};
            for (let key in this.inputBitmask) {
                if (this.inputBitmask.hasOwnProperty(key))
                    (<any>data["inputBitmask"])[key] = (<any>this.inputBitmask)[key];
            }
        }
        if (this.outputBitmask) {
            data["outputBitmask"] = {};
            for (let key in this.outputBitmask) {
                if (this.outputBitmask.hasOwnProperty(key))
                    (<any>data["outputBitmask"])[key] = (<any>this.outputBitmask)[key];
            }
        }
        return data;
    }
}

export interface IPressureChartDto {
    type: PressureChartType;
    unitSerialNumber?: string | undefined;
    unitController: UnitController;
    inputBitmask?: { [key: string]: Bitmask[]; } | undefined;
    outputBitmask?: { [key: string]: Bitmask[]; } | undefined;
}

export enum PressureChartType {
    Baler = 0,
    Compactor = 1,
    Auger = 2,
}

export enum UnitController {
    JE882 = 0,
    JE982 = 1,
    JE910 = 2,
    JE846 = 3,
    JE911 = 4,
    Unknown = 5,
}

export class Bitmask implements IBitmask {
    startTime!: Date;
    endTime?: Date | undefined;

    constructor(data?: IBitmask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] ? new Date(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Bitmask {
        data = typeof data === 'object' ? data : {};
        let result = new Bitmask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IBitmask {
    startTime: Date;
    endTime?: Date | undefined;
}

export class BalerPressureChartDto extends PressureChartDto implements IBalerPressureChartDto {
    type!: PressureChartType;
    oilPressure?: PressCycleValueOfInteger[] | undefined;
    strokePosition?: PressCycleValueOfInteger[] | undefined;

    constructor(data?: IBalerPressureChartDto) {
        super(data);
        this._discriminator = "BalerPressureChartDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["oilPressure"])) {
                this.oilPressure = [] as any;
                for (let item of _data["oilPressure"])
                    this.oilPressure!.push(PressCycleValueOfInteger.fromJS(item));
            }
            if (Array.isArray(_data["strokePosition"])) {
                this.strokePosition = [] as any;
                for (let item of _data["strokePosition"])
                    this.strokePosition!.push(PressCycleValueOfInteger.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): BalerPressureChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new BalerPressureChartDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.oilPressure)) {
            data["oilPressure"] = [];
            for (let item of this.oilPressure)
                data["oilPressure"].push(item.toJSON());
        }
        if (Array.isArray(this.strokePosition)) {
            data["strokePosition"] = [];
            for (let item of this.strokePosition)
                data["strokePosition"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IBalerPressureChartDto extends IPressureChartDto {
    type: PressureChartType;
    oilPressure?: PressCycleValueOfInteger[] | undefined;
    strokePosition?: PressCycleValueOfInteger[] | undefined;
}

export class PressCycleValueOfInteger implements IPressCycleValueOfInteger {
    value!: number;
    ts!: Date;

    constructor(data?: IPressCycleValueOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.ts = _data["ts"] ? new Date(_data["ts"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PressCycleValueOfInteger {
        data = typeof data === 'object' ? data : {};
        let result = new PressCycleValueOfInteger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["ts"] = this.ts ? this.ts.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPressCycleValueOfInteger {
    value: number;
    ts: Date;
}

export class CompactorPressureChartDto extends PressureChartDto implements ICompactorPressureChartDto {
    type!: PressureChartType;
    oilPressure?: PressCycleValueOfInteger[] | undefined;
    ramPosition?: PressCycleValueOfInteger[] | undefined;

    constructor(data?: ICompactorPressureChartDto) {
        super(data);
        this._discriminator = "CompactorPressureChartDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["oilPressure"])) {
                this.oilPressure = [] as any;
                for (let item of _data["oilPressure"])
                    this.oilPressure!.push(PressCycleValueOfInteger.fromJS(item));
            }
            if (Array.isArray(_data["ramPosition"])) {
                this.ramPosition = [] as any;
                for (let item of _data["ramPosition"])
                    this.ramPosition!.push(PressCycleValueOfInteger.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): CompactorPressureChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new CompactorPressureChartDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.oilPressure)) {
            data["oilPressure"] = [];
            for (let item of this.oilPressure)
                data["oilPressure"].push(item.toJSON());
        }
        if (Array.isArray(this.ramPosition)) {
            data["ramPosition"] = [];
            for (let item of this.ramPosition)
                data["ramPosition"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICompactorPressureChartDto extends IPressureChartDto {
    type: PressureChartType;
    oilPressure?: PressCycleValueOfInteger[] | undefined;
    ramPosition?: PressCycleValueOfInteger[] | undefined;
}

export class AugerPressureChartDto extends PressureChartDto implements IAugerPressureChartDto {
    type!: PressureChartType;
    augerMotorCurrent_mA?: PressCycleValueOfInteger[] | undefined;
    feeder1Current_mA?: PressCycleValueOfInteger[] | undefined;
    feeder2Current_mA?: PressCycleValueOfInteger[] | undefined;

    constructor(data?: IAugerPressureChartDto) {
        super(data);
        this._discriminator = "AugerPressureChartDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["augerMotorCurrent_mA"])) {
                this.augerMotorCurrent_mA = [] as any;
                for (let item of _data["augerMotorCurrent_mA"])
                    this.augerMotorCurrent_mA!.push(PressCycleValueOfInteger.fromJS(item));
            }
            if (Array.isArray(_data["feeder1Current_mA"])) {
                this.feeder1Current_mA = [] as any;
                for (let item of _data["feeder1Current_mA"])
                    this.feeder1Current_mA!.push(PressCycleValueOfInteger.fromJS(item));
            }
            if (Array.isArray(_data["feeder2Current_mA"])) {
                this.feeder2Current_mA = [] as any;
                for (let item of _data["feeder2Current_mA"])
                    this.feeder2Current_mA!.push(PressCycleValueOfInteger.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AugerPressureChartDto {
        data = typeof data === 'object' ? data : {};
        let result = new AugerPressureChartDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.augerMotorCurrent_mA)) {
            data["augerMotorCurrent_mA"] = [];
            for (let item of this.augerMotorCurrent_mA)
                data["augerMotorCurrent_mA"].push(item.toJSON());
        }
        if (Array.isArray(this.feeder1Current_mA)) {
            data["feeder1Current_mA"] = [];
            for (let item of this.feeder1Current_mA)
                data["feeder1Current_mA"].push(item.toJSON());
        }
        if (Array.isArray(this.feeder2Current_mA)) {
            data["feeder2Current_mA"] = [];
            for (let item of this.feeder2Current_mA)
                data["feeder2Current_mA"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IAugerPressureChartDto extends IPressureChartDto {
    type: PressureChartType;
    augerMotorCurrent_mA?: PressCycleValueOfInteger[] | undefined;
    feeder1Current_mA?: PressCycleValueOfInteger[] | undefined;
    feeder2Current_mA?: PressCycleValueOfInteger[] | undefined;
}

export class UnitCycleDto implements IUnitCycleDto {
    timestamp!: Date;
    id!: string;

    constructor(data?: IUnitCycleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UnitCycleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitCycleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUnitCycleDto {
    timestamp: Date;
    id: string;
}

export class UnitTypeDto implements IUnitTypeDto {
    id!: number;
    nameTranslationKey?: string | undefined;

    constructor(data?: IUnitTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nameTranslationKey = _data["nameTranslationKey"];
        }
    }

    static fromJS(data: any): UnitTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nameTranslationKey"] = this.nameTranslationKey;
        return data;
    }
}

export interface IUnitTypeDto {
    id: number;
    nameTranslationKey?: string | undefined;
}

export class UnitWeightDto implements IUnitWeightDto {
    unitId!: number;
    weighingSerialNumber?: string | undefined;
    isActive?: boolean | undefined;

    constructor(data?: IUnitWeightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitId = _data["unitId"];
            this.weighingSerialNumber = _data["weighingSerialNumber"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UnitWeightDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitWeightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitId"] = this.unitId;
        data["weighingSerialNumber"] = this.weighingSerialNumber;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IUnitWeightDto {
    unitId: number;
    weighingSerialNumber?: string | undefined;
    isActive?: boolean | undefined;
}

export class UserGroupPermissionsDto implements IUserGroupPermissionsDto {
    groupId!: number;
    userId?: string | undefined;
    roleType!: RolesType;
    isServiceTechnician!: boolean;
    isServiceToolCode!: boolean;
    isServiceTool!: boolean;
    isPartnerArea!: boolean;
    isAssemblyLine!: boolean;
    emailConfirmed?: boolean | undefined;

    constructor(data?: IUserGroupPermissionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupId = _data["groupId"];
            this.userId = _data["userId"];
            this.roleType = _data["roleType"];
            this.isServiceTechnician = _data["isServiceTechnician"];
            this.isServiceToolCode = _data["isServiceToolCode"];
            this.isServiceTool = _data["isServiceTool"];
            this.isPartnerArea = _data["isPartnerArea"];
            this.isAssemblyLine = _data["isAssemblyLine"];
            this.emailConfirmed = _data["emailConfirmed"];
        }
    }

    static fromJS(data: any): UserGroupPermissionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupPermissionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupId"] = this.groupId;
        data["userId"] = this.userId;
        data["roleType"] = this.roleType;
        data["isServiceTechnician"] = this.isServiceTechnician;
        data["isServiceToolCode"] = this.isServiceToolCode;
        data["isServiceTool"] = this.isServiceTool;
        data["isPartnerArea"] = this.isPartnerArea;
        data["isAssemblyLine"] = this.isAssemblyLine;
        data["emailConfirmed"] = this.emailConfirmed;
        return data;
    }
}

export interface IUserGroupPermissionsDto {
    groupId: number;
    userId?: string | undefined;
    roleType: RolesType;
    isServiceTechnician: boolean;
    isServiceToolCode: boolean;
    isServiceTool: boolean;
    isPartnerArea: boolean;
    isAssemblyLine: boolean;
    emailConfirmed?: boolean | undefined;
}

export class WasteHandlerDto implements IWasteHandlerDto {
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    unitId!: number;

    constructor(data?: IWasteHandlerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.unitId = _data["unitId"];
        }
    }

    static fromJS(data: any): WasteHandlerDto {
        data = typeof data === 'object' ? data : {};
        let result = new WasteHandlerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["unitId"] = this.unitId;
        return data;
    }
}

export interface IWasteHandlerDto {
    name?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    unitId: number;
}

export class WasteHandlersFileResult implements IWasteHandlersFileResult {
    fileName?: string | undefined;
    invalidUnitInfos?: WasteHandlersInvalidRowInfo[] | undefined;

    constructor(data?: IWasteHandlersFileResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            if (Array.isArray(_data["invalidUnitInfos"])) {
                this.invalidUnitInfos = [] as any;
                for (let item of _data["invalidUnitInfos"])
                    this.invalidUnitInfos!.push(WasteHandlersInvalidRowInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WasteHandlersFileResult {
        data = typeof data === 'object' ? data : {};
        let result = new WasteHandlersFileResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        if (Array.isArray(this.invalidUnitInfos)) {
            data["invalidUnitInfos"] = [];
            for (let item of this.invalidUnitInfos)
                data["invalidUnitInfos"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWasteHandlersFileResult {
    fileName?: string | undefined;
    invalidUnitInfos?: WasteHandlersInvalidRowInfo[] | undefined;
}

export class WasteHandlersInvalidRowInfo implements IWasteHandlersInvalidRowInfo {
    columnNames?: string[] | undefined;
    rowId?: string | undefined;

    constructor(data?: IWasteHandlersInvalidRowInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["columnNames"])) {
                this.columnNames = [] as any;
                for (let item of _data["columnNames"])
                    this.columnNames!.push(item);
            }
            this.rowId = _data["rowId"];
        }
    }

    static fromJS(data: any): WasteHandlersInvalidRowInfo {
        data = typeof data === 'object' ? data : {};
        let result = new WasteHandlersInvalidRowInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.columnNames)) {
            data["columnNames"] = [];
            for (let item of this.columnNames)
                data["columnNames"].push(item);
        }
        data["rowId"] = this.rowId;
        return data;
    }
}

export interface IWasteHandlersInvalidRowInfo {
    columnNames?: string[] | undefined;
    rowId?: string | undefined;
}

export class WasteHandlersDto implements IWasteHandlersDto {
    fileName!: string;
    rowId?: string | undefined;
    customerUnitId?: string | undefined;
    emptyingDate!: Date;
    weight!: number;
    weightUnit?: string | undefined;
    debtorNumber?: string | undefined;
    unitId?: string | undefined;

    constructor(data?: IWasteHandlersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.rowId = _data["rowId"];
            this.customerUnitId = _data["customerUnitId"];
            this.emptyingDate = _data["emptyingDate"] ? new Date(_data["emptyingDate"].toString()) : <any>undefined;
            this.weight = _data["weight"];
            this.weightUnit = _data["weightUnit"];
            this.debtorNumber = _data["debtorNumber"];
            this.unitId = _data["unitId"];
        }
    }

    static fromJS(data: any): WasteHandlersDto {
        data = typeof data === 'object' ? data : {};
        let result = new WasteHandlersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["rowId"] = this.rowId;
        data["customerUnitId"] = this.customerUnitId;
        data["emptyingDate"] = this.emptyingDate ? this.emptyingDate.toISOString() : <any>undefined;
        data["weight"] = this.weight;
        data["weightUnit"] = this.weightUnit;
        data["debtorNumber"] = this.debtorNumber;
        data["unitId"] = this.unitId;
        return data;
    }
}

export interface IWasteHandlersDto {
    fileName: string;
    rowId?: string | undefined;
    customerUnitId?: string | undefined;
    emptyingDate: Date;
    weight: number;
    weightUnit?: string | undefined;
    debtorNumber?: string | undefined;
    unitId?: string | undefined;
}

export class UnitMetadataDto implements IUnitMetadataDto {
    id!: number;
    manufacturerId?: number | undefined;
    unitId?: string | undefined;

    constructor(data?: IUnitMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.manufacturerId = _data["manufacturerId"];
            this.unitId = _data["unitId"];
        }
    }

    static fromJS(data: any): UnitMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["manufacturerId"] = this.manufacturerId;
        data["unitId"] = this.unitId;
        return data;
    }
}

export interface IUnitMetadataDto {
    id: number;
    manufacturerId?: number | undefined;
    unitId?: string | undefined;
}

export class UnitWasteManagementDto implements IUnitWasteManagementDto {
    /** Machine Identifier */
    deviceId!: number;
    /** EN: English, DA: Danish, FR: Français, DE: Deutsch */
    wasteType?: { [key: string]: string; } | undefined;
    /** EN: English, DA: Danish, FR: Français, DE: Deutsch */
    pickUpSystem?: { [key: string]: string; } | undefined;
    /** 0: Online, 1: Offline, 2: Online with warning, 3: Online with error, 4: Inactive */
    deviceStatus!: DeviceStatus;
    /** Machine Group Name */
    groupName?: string | undefined;
    errors?: number[] | undefined;
    /** Machine Address */
    address?: string | undefined;
    /** Machine Serial Number */
    unitId?: string | undefined;
    /** Machine Manufacturer Number */
    manufacturerId?: number | undefined;
    /** Machine Fill Level Percentage */
    fillLevelSanitizedPercent?: number | undefined;
    /** Machine Bales on Site (Balers Only) */
    balesOnSite?: number | undefined;
    /** Machine Bale Storage Size (Balers Only) */
    baleStorageSize?: number | undefined;
    /** Machine Last Service Date */
    lastService?: Date | undefined;
    /** Machine GPS Latitude */
    latitude?: string | undefined;
    /** Machine GPS Longitude */
    longitude?: string | undefined;
    /** Machine User Choosen Latitude */
    homeLatitude?: string | undefined;
    /** Machine User Choosen Longitude */
    homeLongitude?: string | undefined;

    constructor(data?: IUnitWasteManagementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
            if (_data["wasteType"]) {
                this.wasteType = {} as any;
                for (let key in _data["wasteType"]) {
                    if (_data["wasteType"].hasOwnProperty(key))
                        (<any>this.wasteType)![key] = _data["wasteType"][key];
                }
            }
            if (_data["pickUpSystem"]) {
                this.pickUpSystem = {} as any;
                for (let key in _data["pickUpSystem"]) {
                    if (_data["pickUpSystem"].hasOwnProperty(key))
                        (<any>this.pickUpSystem)![key] = _data["pickUpSystem"][key];
                }
            }
            this.deviceStatus = _data["deviceStatus"];
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            this.address = _data["address"];
            this.unitId = _data["unitId"];
            this.manufacturerId = _data["manufacturerId"];
            this.fillLevelSanitizedPercent = _data["fillLevelSanitizedPercent"];
            this.balesOnSite = _data["balesOnSite"];
            this.baleStorageSize = _data["baleStorageSize"];
            this.lastService = _data["lastService"] ? new Date(_data["lastService"].toString()) : <any>undefined;
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.homeLatitude = _data["homeLatitude"];
            this.homeLongitude = _data["homeLongitude"];
        }
    }

    static fromJS(data: any): UnitWasteManagementDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitWasteManagementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        if (this.wasteType) {
            data["wasteType"] = {};
            for (let key in this.wasteType) {
                if (this.wasteType.hasOwnProperty(key))
                    (<any>data["wasteType"])[key] = (<any>this.wasteType)[key];
            }
        }
        if (this.pickUpSystem) {
            data["pickUpSystem"] = {};
            for (let key in this.pickUpSystem) {
                if (this.pickUpSystem.hasOwnProperty(key))
                    (<any>data["pickUpSystem"])[key] = (<any>this.pickUpSystem)[key];
            }
        }
        data["deviceStatus"] = this.deviceStatus;
        data["groupName"] = this.groupName;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["address"] = this.address;
        data["unitId"] = this.unitId;
        data["manufacturerId"] = this.manufacturerId;
        data["fillLevelSanitizedPercent"] = this.fillLevelSanitizedPercent;
        data["balesOnSite"] = this.balesOnSite;
        data["baleStorageSize"] = this.baleStorageSize;
        data["lastService"] = this.lastService ? this.lastService.toISOString() : <any>undefined;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["homeLatitude"] = this.homeLatitude;
        data["homeLongitude"] = this.homeLongitude;
        return data;
    }
}

export interface IUnitWasteManagementDto {
    /** Machine Identifier */
    deviceId: number;
    /** EN: English, DA: Danish, FR: Français, DE: Deutsch */
    wasteType?: { [key: string]: string; } | undefined;
    /** EN: English, DA: Danish, FR: Français, DE: Deutsch */
    pickUpSystem?: { [key: string]: string; } | undefined;
    /** 0: Online, 1: Offline, 2: Online with warning, 3: Online with error, 4: Inactive */
    deviceStatus: DeviceStatus;
    /** Machine Group Name */
    groupName?: string | undefined;
    errors?: number[] | undefined;
    /** Machine Address */
    address?: string | undefined;
    /** Machine Serial Number */
    unitId?: string | undefined;
    /** Machine Manufacturer Number */
    manufacturerId?: number | undefined;
    /** Machine Fill Level Percentage */
    fillLevelSanitizedPercent?: number | undefined;
    /** Machine Bales on Site (Balers Only) */
    balesOnSite?: number | undefined;
    /** Machine Bale Storage Size (Balers Only) */
    baleStorageSize?: number | undefined;
    /** Machine Last Service Date */
    lastService?: Date | undefined;
    /** Machine GPS Latitude */
    latitude?: string | undefined;
    /** Machine GPS Longitude */
    longitude?: string | undefined;
    /** Machine User Choosen Latitude */
    homeLatitude?: string | undefined;
    /** Machine User Choosen Longitude */
    homeLongitude?: string | undefined;
}

export enum DeviceStatus {
    OK = 0,
    Offline = 1,
    Warning = 2,
    Error = 3,
}

export class UnitMetadataDtoV2 implements IUnitMetadataDtoV2 {
    unitId!: number;
    serialNumber?: string | undefined;

    constructor(data?: IUnitMetadataDtoV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitId = _data["unitId"];
            this.serialNumber = _data["serialNumber"];
        }
    }

    static fromJS(data: any): UnitMetadataDtoV2 {
        data = typeof data === 'object' ? data : {};
        let result = new UnitMetadataDtoV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitId"] = this.unitId;
        data["serialNumber"] = this.serialNumber;
        return data;
    }
}

export interface IUnitMetadataDtoV2 {
    unitId: number;
    serialNumber?: string | undefined;
}

export class UnitWasteManagementDtoV2 implements IUnitWasteManagementDtoV2 {
    unitId!: number;
    serialNumber?: string | undefined;
    groupName?: string | undefined;
    distributor?: string | undefined;
    wasteTypeTranslationKey?: string | undefined;
    pickUpSystemTranslationKey?: string | undefined;
    deviceStatus!: DeviceStatus2;
    fillLevelPct?: number | undefined;
    /** Bales on Site (Balers Only) */
    balesOnSite?: number | undefined;
    /** Bale Storage Size (Balers Only) */
    baleStorageSize?: number | undefined;
    lastService?: Date | undefined;
    /** GPS Latitude */
    latitude?: string | undefined;
    /** GPS Longitude */
    longitude?: string | undefined;
    /** User Choosen Latitude */
    homeLatitude?: string | undefined;
    /** User Choosen Longitude */
    homeLongitude?: string | undefined;
    connectionStatus!: OnlineStatus;
    signalStrengthPct?: number | undefined;
    lastUpdated?: Date | undefined;
    manufacturerName?: string | undefined;
    modelName?: string | undefined;
    controllerName?: string | undefined;
    controllerFirmwareVersion!: number;
    collectorName?: string | undefined;
    siteCity?: string | undefined;
    siteAddress?: string | undefined;
    sitePostalCode?: string | undefined;
    siteDescription?: string | undefined;
    siteUser?: string | undefined;
    ownershipTranslationKey?: string | undefined;
    installationDate?: Date | undefined;
    warrantyExpirationDate?: Date | undefined;
    serviceContractTypeTranslationKey?: string | undefined;
    nextServiceDate?: Date | undefined;
    totalNumberOfEmptyings?: number | undefined;
    avgCyclesPerEmptying30Days?: number | undefined;
    numberOfEmptyings30Days?: number | undefined;
    motorRunSec?: number | undefined;
    pressCycles?: number | undefined;
    pressSeries?: number | undefined;
    pressSeriesSinceEmpty?: number | undefined;
    pressCyclesSinceEmpty?: number | undefined;
    weightSerialNumber?: string | undefined;
    currentWeight?: number | undefined;
    lastBaleOutput?: number | undefined;
    weightLastUpdate?: Date | undefined;
    /** User provided comment for the unit */
    comment?: string | undefined;
    totalNumberOfDaysSinceInstallation?: number | undefined;
    avgEmptyingsPerDay?: number | undefined;
    /** See the provided PDF documentation for a complete list of possible errors */
    errorsReadable?: string[] | undefined;

    constructor(data?: IUnitWasteManagementDtoV2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitId = _data["unitId"];
            this.serialNumber = _data["serialNumber"];
            this.groupName = _data["groupName"];
            this.distributor = _data["distributor"];
            this.wasteTypeTranslationKey = _data["wasteTypeTranslationKey"];
            this.pickUpSystemTranslationKey = _data["pickUpSystemTranslationKey"];
            this.deviceStatus = _data["deviceStatus"];
            this.fillLevelPct = _data["fillLevelPct"];
            this.balesOnSite = _data["balesOnSite"];
            this.baleStorageSize = _data["baleStorageSize"];
            this.lastService = _data["lastService"] ? new Date(_data["lastService"].toString()) : <any>undefined;
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.homeLatitude = _data["homeLatitude"];
            this.homeLongitude = _data["homeLongitude"];
            this.connectionStatus = _data["connectionStatus"];
            this.signalStrengthPct = _data["signalStrengthPct"];
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : <any>undefined;
            this.manufacturerName = _data["manufacturerName"];
            this.modelName = _data["modelName"];
            this.controllerName = _data["controllerName"];
            this.controllerFirmwareVersion = _data["controllerFirmwareVersion"];
            this.collectorName = _data["collectorName"];
            this.siteCity = _data["siteCity"];
            this.siteAddress = _data["siteAddress"];
            this.sitePostalCode = _data["sitePostalCode"];
            this.siteDescription = _data["siteDescription"];
            this.siteUser = _data["siteUser"];
            this.ownershipTranslationKey = _data["ownershipTranslationKey"];
            this.installationDate = _data["installationDate"] ? new Date(_data["installationDate"].toString()) : <any>undefined;
            this.warrantyExpirationDate = _data["warrantyExpirationDate"] ? new Date(_data["warrantyExpirationDate"].toString()) : <any>undefined;
            this.serviceContractTypeTranslationKey = _data["serviceContractTypeTranslationKey"];
            this.nextServiceDate = _data["nextServiceDate"] ? new Date(_data["nextServiceDate"].toString()) : <any>undefined;
            this.totalNumberOfEmptyings = _data["totalNumberOfEmptyings"];
            this.avgCyclesPerEmptying30Days = _data["avgCyclesPerEmptying30Days"];
            this.numberOfEmptyings30Days = _data["numberOfEmptyings30Days"];
            this.motorRunSec = _data["motorRunSec"];
            this.pressCycles = _data["pressCycles"];
            this.pressSeries = _data["pressSeries"];
            this.pressSeriesSinceEmpty = _data["pressSeriesSinceEmpty"];
            this.pressCyclesSinceEmpty = _data["pressCyclesSinceEmpty"];
            this.weightSerialNumber = _data["weightSerialNumber"];
            this.currentWeight = _data["currentWeight"];
            this.lastBaleOutput = _data["lastBaleOutput"];
            this.weightLastUpdate = _data["weightLastUpdate"] ? new Date(_data["weightLastUpdate"].toString()) : <any>undefined;
            this.comment = _data["comment"];
            this.totalNumberOfDaysSinceInstallation = _data["totalNumberOfDaysSinceInstallation"];
            this.avgEmptyingsPerDay = _data["avgEmptyingsPerDay"];
            if (Array.isArray(_data["errorsReadable"])) {
                this.errorsReadable = [] as any;
                for (let item of _data["errorsReadable"])
                    this.errorsReadable!.push(item);
            }
        }
    }

    static fromJS(data: any): UnitWasteManagementDtoV2 {
        data = typeof data === 'object' ? data : {};
        let result = new UnitWasteManagementDtoV2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitId"] = this.unitId;
        data["serialNumber"] = this.serialNumber;
        data["groupName"] = this.groupName;
        data["distributor"] = this.distributor;
        data["wasteTypeTranslationKey"] = this.wasteTypeTranslationKey;
        data["pickUpSystemTranslationKey"] = this.pickUpSystemTranslationKey;
        data["deviceStatus"] = this.deviceStatus;
        data["fillLevelPct"] = this.fillLevelPct;
        data["balesOnSite"] = this.balesOnSite;
        data["baleStorageSize"] = this.baleStorageSize;
        data["lastService"] = this.lastService ? this.lastService.toISOString() : <any>undefined;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["homeLatitude"] = this.homeLatitude;
        data["homeLongitude"] = this.homeLongitude;
        data["connectionStatus"] = this.connectionStatus;
        data["signalStrengthPct"] = this.signalStrengthPct;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>undefined;
        data["manufacturerName"] = this.manufacturerName;
        data["modelName"] = this.modelName;
        data["controllerName"] = this.controllerName;
        data["controllerFirmwareVersion"] = this.controllerFirmwareVersion;
        data["collectorName"] = this.collectorName;
        data["siteCity"] = this.siteCity;
        data["siteAddress"] = this.siteAddress;
        data["sitePostalCode"] = this.sitePostalCode;
        data["siteDescription"] = this.siteDescription;
        data["siteUser"] = this.siteUser;
        data["ownershipTranslationKey"] = this.ownershipTranslationKey;
        data["installationDate"] = this.installationDate ? this.installationDate.toISOString() : <any>undefined;
        data["warrantyExpirationDate"] = this.warrantyExpirationDate ? this.warrantyExpirationDate.toISOString() : <any>undefined;
        data["serviceContractTypeTranslationKey"] = this.serviceContractTypeTranslationKey;
        data["nextServiceDate"] = this.nextServiceDate ? this.nextServiceDate.toISOString() : <any>undefined;
        data["totalNumberOfEmptyings"] = this.totalNumberOfEmptyings;
        data["avgCyclesPerEmptying30Days"] = this.avgCyclesPerEmptying30Days;
        data["numberOfEmptyings30Days"] = this.numberOfEmptyings30Days;
        data["motorRunSec"] = this.motorRunSec;
        data["pressCycles"] = this.pressCycles;
        data["pressSeries"] = this.pressSeries;
        data["pressSeriesSinceEmpty"] = this.pressSeriesSinceEmpty;
        data["pressCyclesSinceEmpty"] = this.pressCyclesSinceEmpty;
        data["weightSerialNumber"] = this.weightSerialNumber;
        data["currentWeight"] = this.currentWeight;
        data["lastBaleOutput"] = this.lastBaleOutput;
        data["weightLastUpdate"] = this.weightLastUpdate ? this.weightLastUpdate.toISOString() : <any>undefined;
        data["comment"] = this.comment;
        data["totalNumberOfDaysSinceInstallation"] = this.totalNumberOfDaysSinceInstallation;
        data["avgEmptyingsPerDay"] = this.avgEmptyingsPerDay;
        if (Array.isArray(this.errorsReadable)) {
            data["errorsReadable"] = [];
            for (let item of this.errorsReadable)
                data["errorsReadable"].push(item);
        }
        return data;
    }
}

export interface IUnitWasteManagementDtoV2 {
    unitId: number;
    serialNumber?: string | undefined;
    groupName?: string | undefined;
    distributor?: string | undefined;
    wasteTypeTranslationKey?: string | undefined;
    pickUpSystemTranslationKey?: string | undefined;
    deviceStatus: DeviceStatus2;
    fillLevelPct?: number | undefined;
    /** Bales on Site (Balers Only) */
    balesOnSite?: number | undefined;
    /** Bale Storage Size (Balers Only) */
    baleStorageSize?: number | undefined;
    lastService?: Date | undefined;
    /** GPS Latitude */
    latitude?: string | undefined;
    /** GPS Longitude */
    longitude?: string | undefined;
    /** User Choosen Latitude */
    homeLatitude?: string | undefined;
    /** User Choosen Longitude */
    homeLongitude?: string | undefined;
    connectionStatus: OnlineStatus;
    signalStrengthPct?: number | undefined;
    lastUpdated?: Date | undefined;
    manufacturerName?: string | undefined;
    modelName?: string | undefined;
    controllerName?: string | undefined;
    controllerFirmwareVersion: number;
    collectorName?: string | undefined;
    siteCity?: string | undefined;
    siteAddress?: string | undefined;
    sitePostalCode?: string | undefined;
    siteDescription?: string | undefined;
    siteUser?: string | undefined;
    ownershipTranslationKey?: string | undefined;
    installationDate?: Date | undefined;
    warrantyExpirationDate?: Date | undefined;
    serviceContractTypeTranslationKey?: string | undefined;
    nextServiceDate?: Date | undefined;
    totalNumberOfEmptyings?: number | undefined;
    avgCyclesPerEmptying30Days?: number | undefined;
    numberOfEmptyings30Days?: number | undefined;
    motorRunSec?: number | undefined;
    pressCycles?: number | undefined;
    pressSeries?: number | undefined;
    pressSeriesSinceEmpty?: number | undefined;
    pressCyclesSinceEmpty?: number | undefined;
    weightSerialNumber?: string | undefined;
    currentWeight?: number | undefined;
    lastBaleOutput?: number | undefined;
    weightLastUpdate?: Date | undefined;
    /** User provided comment for the unit */
    comment?: string | undefined;
    totalNumberOfDaysSinceInstallation?: number | undefined;
    avgEmptyingsPerDay?: number | undefined;
    /** See the provided PDF documentation for a complete list of possible errors */
    errorsReadable?: string[] | undefined;
}

export enum DeviceStatus2 {
    OK = "OK",
    Offline = "Offline",
    Warning = "Warning",
    Error = "Error",
}

export enum OnlineStatus {
    Offline = "Offline",
    Online = "Online",
    NoModem = "NoModem",
}

export class CreateXtelUnitTrackerDto implements ICreateXtelUnitTrackerDto {
    unitId!: number;
    trackerId?: string | undefined;
    isActive!: boolean;
    message?: string | undefined;

    constructor(data?: ICreateXtelUnitTrackerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitId = _data["unitId"];
            this.trackerId = _data["trackerId"];
            this.isActive = _data["isActive"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): CreateXtelUnitTrackerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateXtelUnitTrackerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitId"] = this.unitId;
        data["trackerId"] = this.trackerId;
        data["isActive"] = this.isActive;
        data["message"] = this.message;
        return data;
    }
}

export interface ICreateXtelUnitTrackerDto {
    unitId: number;
    trackerId?: string | undefined;
    isActive: boolean;
    message?: string | undefined;
}

export class GetXtelUnitTrackerDto implements IGetXtelUnitTrackerDto {
    unitId!: number;
    trackerId?: string | undefined;
    isActive!: boolean;

    constructor(data?: IGetXtelUnitTrackerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitId = _data["unitId"];
            this.trackerId = _data["trackerId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): GetXtelUnitTrackerDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetXtelUnitTrackerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitId"] = this.unitId;
        data["trackerId"] = this.trackerId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IGetXtelUnitTrackerDto {
    unitId: number;
    trackerId?: string | undefined;
    isActive: boolean;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

// This class is copied to api.ts when running codegen.